
import React, { Component } from 'react';

//All of our API calls
import * as Actions from '../actions/action';

//Stores all of our API responses
import Store from '../stores/store';
import FileUpload from '../components/FileUpload.js';
import TypingAnimation from '../components/TypingAnimation.js';

//These are all our styles (font-awesome + our global css)
import '../styles/fonts/FontAwesome6/css/all.css';
import '../styles/global.css';

import databay3Logo from '../images/Databay3Logo.png'; // Adjust the path based on your project structure


//Allows us to pull from the query-string any parameters
import * as qs from 'query-string';
import * as stringSimilarity from 'string-similarity';
//import * as imageToBase64 from 'image-to-base64';
import ReactDOM from 'react-dom';

//Allows us to direct inject html
import ReactHtmlParser from 'react-html-parser';

import AccessGroups from '../components/AccessGroups.js';
import msalApp from "./authConfig";


//Allows us to create tinyMCEs
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/code';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/wordcount';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import { Editor } from '@tinymce/tinymce-react';

//import { PublicClientApplication } from "@azure/msal-browser";

import * as Msal from "msal";

//import SelectSearch from 'react-select-search';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        //This is how we get the query string parameters passed into this app.
        var hash = this.props.location.hash;
        var parsed = qs.parse(this.props.location.search);
        var searchTerm = "";
        var singleResult = "";

        if (hash.startsWith("#/search/")) {
            hash = hash.replace("#/search/", "");
            hash = hash.split("?")[0];
            searchTerm = hash;
            searchTerm = decodeURI(searchTerm);
        }
        else if (hash.startsWith("#/result/")) {
            hash = hash.replace("#/result/", "");
            hash = hash.split("/")[1];
            hash = hash.split("?")[0];
            singleResult = hash;
        }
        else if (hash.startsWith("#/searchResult/")) {
            hash = hash.replace("#/searchResult/", "");
            hash = hash.split("?")[0];
            searchTerm = hash.split("/")[0];
            searchTerm = decodeURIComponent(searchTerm);
            singleResult = hash.split("/")[1];
        }
        var spoofUser = "";
        var spoofDomain = "AAMC";
        var siteMode = "databayprd";

        var isEpicUser = false;
        var isSpoofedEpicUser = false;
        var isHyperDriveUser = false;
        var username = "";
        var domain = "AAMC";
        var domainRaw = "";
        var cryptHash = "";
        console.log(parsed);
        if (parsed["username"] != null && parsed["domain"] != null && parsed["cryptHash"] != null) {
            isEpicUser = true;
            username = parsed["username"];
            domain = "AAMC";
            cryptHash = parsed["cryptHash"];


            domainRaw = parsed["domain"];


            if (parsed["domain"] == "100000") {
                domain = "AAMC";
            }
            else if (parsed["domain"] == "200000") {
                domain = "DCH";
            }
        }
        else if (parsed["username"] != null && parsed["domain"] != null && parsed["spoofEpicUser"] != null) {
            isEpicUser = true;
            isSpoofedEpicUser = true;
            username = parsed["username"];
            domain = parsed["domain"];
        }
        else if (parsed["spoofUser"] != null || parsed["spoofDomain"] != null) {

            if (parsed["spoofUser"] != null) {
                //Loads department based on the deptId that is passed in via the querystring.
                spoofUser = parsed["spoofUser"];
            }

            if (parsed["spoofDomain"] != null) {
                //Loads department based on the deptId that is passed in via the querystring.
                spoofDomain = parsed["spoofDomain"];
            }

        }

        if (parsed["UserID"] != null) {
            isEpicUser = true;
            isHyperDriveUser = true;
            username = parsed["UserID"];
            domain = "AAMC";
        }

        if (parsed["siteMode"] != null) {
            //Loads department based on the deptId that is passed in via the querystring.
            if (['databayprd', 'databaydev', 'databayccnprd', 'databayccndev'].includes(parsed["siteMode"].toLowerCase())) {
                siteMode = parsed["siteMode"];
            }
        }


        if (process.env.REACT_APP_HYPERDRIVE_MODE === 'true') {
            isEpicUser = true;
            isHyperDriveUser = true;
        }
        else {
        }

        //This is the state that is universally used by this app.
        this.state = {
            //global state code to be used to know if the site has been fully loaded, provide a execution of X after initial load only, and also to have a site status incase you need to temporarily disable the site, etc.
            accessToken: null,
            drag: false,
            initialLoad: true,
            postLoadExecution: false,
            siteStatus: {},

            epicUsername: username,
            epicDomainRaw: domain,
            epicDomain: domain,
            epicCryptHash: cryptHash,
            isEpicUser: isEpicUser,
            isSpoofedEpicUser: isSpoofedEpicUser,
            isHyperDriveUser: isHyperDriveUser,
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            showMetricGoalsCurrent: true,
            showMetricGoalsFuture: true,
            showMetricGoalsPast: true,

            hash: hash,
            ignoreHashChange: false,
            searchTerm: searchTerm,
            searchRelationshipTerm: "",
            currentSearchText: searchTerm,
            singleResult: singleResult,
            singleResultImage: "",
            parentResult: "",
            parentName: "",
            parentType: "",
            parentAssociatedChild: "",
            currentTabLocation: "",
            requestReason: "",
            siteMode: siteMode,
            loadingRelationships: false,
            loadingFile: false,
            //site specific state info

            user_ListInfo: {},
            user_CreatorListInfo: {},

            user_AccountInfo: {},
            user_SpoofAccountInfo: {},
            user_LayoutInfo: {},
            user_LayoutLeft: "",
            user_LayoutMiddle: "",
            user_LayoutRight: "",
            user_InterfaceColumns: "",
            user_Theme: "",
            user_FavoritesInfo: {},
            user_SharedInfo: {},
            user_NavigationHistory_Forward: {},
            user_NavigationHistory_Backward: {},
            user_SearchHistory: [],
            user_RatingsInfo: {},
            user_LocationInfo: {},
            user_HighScoreInfo: {},
            user_TopUsersHighScoreInfo: {},
            user_PermissionListInfo: {},
            user_UsersWithPermissionsListInfo: {},
            user_permissionFilter: "",
            user_permissionDepartment: "",
            user_modalPermissionLevel: "",

            user_permissionLevel: "",

            aamc_WeatherInfo: {},
            dcmc_WeatherInfo: {},

            employee_IntellisenseInfo: {},

            reports_Top10: {},
            reports_Newest10: {},

            filterResourceType: "Report & Report Category",
            filterReportType: "",
            filterQRSYear: "",
            filterRankType: "",
            resource_IntellisenseInfo: {},
            resource_IntellisenseTagInfo: {},
            resource_IntellisenseReportAndMetricLinkInfo: {},
            resource_IntellisenseReportAndMetricLink_UniqueReportsInfo: [],
            resource_CustomTagInfo: [],
            resource_TopReportsInfo: {},
            resource_TopTagsInfo: {},
            resource_TopRatedReportsInfo: {},
            resource_NewestReportsInfo: {},
            resource_IntellisenseHeaderMouseOverIndex: 0,
            resource_IntellisenseHeaderMouseOverValue: 0,
            resource_IntellisenseHeaderSearchIndex: 0,
            resource_IntellisenseBodySearchIndex: 0,
            resource_IntellisenseMax: 0,
            resource_ImageUpload: null,
            resource_ImageInfo: {},
            resource_BuildThumbImageInfo: {},
            resource_BuildImageInfo: {},
            resource_BuildRelationshipInfo: {},
            resource_BuildCCNAttributeInfo: {},
            resource_BuildAPGoalsInfo: {},
            resource_BuildAPActionsInfo: {},
            resource_BuildAPTeamInfo: {},
            resource_BuildAPLogInfo: {},
            resource_BuildMetricOwnerInfo: {},
            resource_BuildMetricGoalsInfo: {},
            resource_BuildDisplaysInInfo: {},
            resource_BuildSearchDisplaysInInfo: {},
            resource_BuildTagInfo: {},
            resource_relationshipNameFilter: "",
            resource_shareFilter: "",
            resource_shareDepartment: "",
            resource_editMode: false,
            resource_editFileMode: false,
            resource_ReportTypeListInfo: {},
            resource_QRSYearListInfo: {},
            resource_ResourceTypeListInfo: {},
            resource_RankListInfo: {},
            resource_NotificationListInfo: {},
            resource_RelationshipInfo: {},

            resource_editGoal_GoalId: "",
            resource_editGoal_GoalName: "",
            resource_editGoal_GoalLocation: "",
            resource_editGoal_GoalValue: "",
            resource_editGoal_GoalValueType: "",
            resource_editGoal_ExpectedCompletion: "",
            resource_editGoal_StartDate: "",

            resource_addActionPlanItem_ItemType: "",

            resource_modalRank_idRank: "",
            resource_modalRank_rankName: "",
            resource_modalRank_hexBackgroundColor: "",
            resource_modalRank_points: "",
            resource_modalRank_isFilterable: "",
            resource_modalRank_isInAllResults: "",
            resource_modalRank_description: "",


            resource_addRelationship_ResourceList: {},
            resource_addRelationship_ResourceTypeFilter: "",
            resource_addRelationship_ReportTypeFilter: "",

            resource_StoredDatabayPrd_IntellisenseInfo: {},
            resource_StoredDatabayDev_IntellisenseInfo: {},
            resource_StoredDatabayCCNPrd_IntellisenseInfo: {},
            resource_StoredDatabayCCNDev_IntellisenseInfo: {},

            resource_createReportType: "",
            resource_createQRSYear: "",
            resource_createEpicReportsCount: 1,
            resource_editReportType: "",
            resource_editQRSYear: "",
            resource_editEpicReportsCount: 1,

            resource_fileUploaded: false,

            hyperdrive_initiate: true,
            hyperdrive_token: "",

            JIRAsubject: "",
            JIRAresourceName: "",
            JIRAresourceType: "",
            JIRAreportType: "",
            JIRAmessageType: "",
        }

        console.log(this.state);

        console.log("isEpicUser " + isEpicUser);
        console.log("isSpoofedEpicUser " + isSpoofedEpicUser);
        console.log("isHyperDriveUser " + isHyperDriveUser);
        console.log("process.env.REACT_APP_HYPERDRIVE_MODE " + process.env.REACT_APP_HYPERDRIVE_MODE);
        //This should be the kickoff action that starts the entire site.
        //If there is a issue prior to this we should just error and stop processing here.
        if (isEpicUser && !isSpoofedEpicUser && !isHyperDriveUser) {
            Actions.getEpicUserAccountInfo(username, domain, cryptHash);
        } 
        else if (isEpicUser && !isSpoofedEpicUser && isHyperDriveUser) {
            Actions.getEpicHyperdriveUserAccountInfo(username, domain);
        }
        else if (isSpoofedEpicUser) {
            Actions.getSpoofedEpicUserAccountInfo(username, domain);
        }
        else if (parsed["spoofUser"] != null) {
            Actions.getSpoofedUserAccountInfo(spoofUser, spoofDomain);
        }
        else {
            //alert("Initial Launch Call");
            //alert(msalApp.getAccount());
            if (msalApp.getAccount()) {
                // User is already logged in
                //alert("Step 1 Success");
                const account = msalApp.getAccount();
                //alert("Account got: "+account);
                const authenticatedUsername = account.userName; // Get the username from the account object
                //alert("Username got: " + account);
                //alert("Calling validate Access");
                Actions.validateAccess();
                //alert("Calling getExternalUserAccountInfo");
                Actions.getExternalUserAccountInfo(authenticatedUsername);
            }
            else {
                //alert("Step 2 Success");

                msalApp
                    .loginRedirect()
                    .then((response) => {
                        // Handle successful sign-in
                        console.log("User signed in", response);
                        //alert("Success Logging in" + response);
                        //alert("Redirecting");
                        window.location.href = "https://databay.aahs.org/api/App/validateAccess";
                    })
                    .catch((error) => {
                        alert("Error signing in" + error);
                        // Handle sign-in error
                       // alert("Error signing in" +error);
                    });
            }
            //Actions.getUserAccountInfo();
        }
        //Actions.getOptimizedResourceIntellisenseInfo();



                /*
                    //This should be the kickoff action that starts the entire site.
                    //If there is a issue prior to this we should just error and stop processing here.
                    if (isEpicUser) {
                        Actions.getEpicUserAccountInfo(username, domain, cryptHash);
                    }
                    else if (parsed["spoof"] != null) {
                        Actions.getSpoofedUserAccountInfo(spoofUser, spoofDomain);
                    }
                    else {
                        Actions.getUserAccountInfo();
                    }
                    //Actions.getOptimizedResourceIntellisenseInfo();
                */


        //document.title = "Betabay";
        document.title = "Databay";
    }

    //These are triggered when the store gets populated
    componentDidMount() {
        Store.on("Response_User_ListInfo_Updated", this.updateUserListInfo.bind(this));
        Store.on("Response_User_CreatorListInfo_Updated", this.updateUserCreatorListInfo.bind(this));
        Store.on("Response_User_AccountInfo_Updated", this.updateUserAccountInfo.bind(this));
        Store.on("Response_Resource_IntellisenseInfo_Updated", this.updateResourceIntellisenseInfo.bind(this));
        Store.on("Response_Resource_ListByTypeInfo_Updated", this.updateResourceListByTypeInfo.bind(this));
        Store.on("Response_Resource_RelationshipInfo_Updated", this.updateResourceRelationshipInfo.bind(this));
        Store.on("Response_SingleResource_RelationshipChange_Updated", this.reloadResourceRelationshipInfo.bind(this));
        Store.on("Response_User_FavoritesInfo_Updated", this.updateUserFavoritesInfo.bind(this));
        Store.on("Response_User_SharedInfo_Updated", this.updateUserSharedInfo.bind(this));
        Store.on("Response_User_LayoutInfo_Updated", this.updateUserLayoutInfo.bind(this));
        Store.on("Response_User_PermissionListInfo_Updated", this.updateUserPermissionListInfo.bind(this));
        Store.on("Response_User_PermissionsUpdated", this.repullUserPermissions.bind(this));
        Store.on("Response_User_UsersWithPermissionsListInfo_Updated", this.updateUsersWithPermissionsListInfo.bind(this));
        Store.on("Response_User_ThemeInfo_Updated", this.repullUserLayoutInfo.bind(this));
        Store.on("Response_User_FavoritesInfo_Changed", this.pullUserFavoritesInfo.bind(this));
        Store.on("Response_User_RatingsInfo_Updated", this.updateUserRatingsInfo.bind(this));
        Store.on("Response_User_RatingsInfo_Changed", this.pullUserRatingsInfo.bind(this));
        Store.on("Response_User_HighScoreInfo_Updated", this.updateUserHighScoreInfo.bind(this));
        Store.on("Response_User_TopUsersHighScoreInfo_Updated", this.updateUserTopUsersHighScoreInfo.bind(this));
        Store.on("Response_Resource_ReportTypeListInfo_Updated", this.updateResourceReportTypeListInfo.bind(this));
        Store.on("Response_Resource_QRSYearListInfo_Updated", this.updateResourceQRSYearListInfo.bind(this));
        Store.on("Response_Resource_ResourceTypeListInfo_Updated", this.updateResourceResourceTypeListInfo.bind(this));
        Store.on("Response_Resource_TopReportsInfo_Updated", this.updateResourceTopReportsInfo.bind(this));
        Store.on("Response_Resource_TopTagsInfo_Updated", this.updateResourceTopTagsInfo.bind(this));
        Store.on("Response_Resource_TopRatedReportsInfo_Updated", this.updateResourceTopRatedReportsInfo.bind(this));
        Store.on("Response_Resource_NewestReportsInfo_Updated", this.updateResourceNewestReportsInfo.bind(this));
        Store.on("Response_Resource_Thumb_ImageInfo_Updated", this.updateResourceThumbImageInfo.bind(this));
        Store.on("Response_Resource_TagInfo_Updated", this.updateResourceTagInfo.bind(this));
        Store.on("Response_Resource_ReportAndMetricLinkInfo_Updated", this.updateResourceReportAndMetricLinkInfo.bind(this));
        Store.on("Response_Resource_ImageInfo_Changed", this.pullResourceImageInfo.bind(this));
        Store.on("Response_Resource_ImageInfo_Removed", this.pullSingleResourceImageInfo.bind(this));
        Store.on("Response_Resource_RankListInfo_Updated", this.updateResourceRankListInfo.bind(this));
        Store.on("Response_Resource_Rank_Updated", this.repullResourceRankListInfo.bind(this));
        Store.on("Response_Resource_SingleSync_Updated", this.repullAllResources.bind(this));
        Store.on("Response_Resource_SingleResource_Updated", this.updateSingleResource.bind(this));
        Store.on("Response_Resource_ManualAllSync_Updated", this.repullAllResources.bind(this));
        Store.on("Response_SingleResource_ImageInfo_Updated", this.updateSingleResourceImageInfo.bind(this));
        Store.on("Response_SingleResource_RelationshipInfo_Updated", this.updateSingleResourceRelationshipInfo.bind(this));
        Store.on("Response_SingleResource_APGoalsInfo_Updated", this.updateSingleResourceAPGoalsInfo.bind(this));
        Store.on("Response_SingleResource_APActionsInfo_Updated", this.updateSingleResourceAPActionsInfo.bind(this));
        Store.on("Response_SingleResource_APTeamInfo_Updated", this.updateSingleResourceAPTeamInfo.bind(this));
        Store.on("Response_SingleResource_MetricOwnerInfo_Updated", this.updateSingleResourceMetricOwnerInfo.bind(this));
        Store.on("Response_SingleResource_MetricOwnerRemoval_Updated", this.reloadResourceMetricOwnerInfo.bind(this));
        Store.on("Response_SingleResource_MetricGoalsInfo_Updated", this.updateSingleResourceMetricGoalsInfo.bind(this));
        Store.on("Response_SingleResource_MetricGoalsChange_Updated", this.reloadResourceMetricGoalsInfo.bind(this));

        Store.on("Response_SingleResource_APLogInfo_Updated", this.updateSingleResourceAPLogInfo.bind(this));
        Store.on("Response_SingleResource_CCNAttributeInfo_Updated", this.updateSingleResourceCCNAttributeInfo.bind(this));
        Store.on("Response_SingleResource_DisplaysInInfo_Updated", this.updateSingleResourceDisplaysInInfo.bind(this));
        Store.on("Response_SingleResource_TagInfo_Updated", this.updateSingleResourceTagInfo.bind(this));
        Store.on("Response_SingleResource_TagChange_Updated", this.reloadResourceTagInfo.bind(this));
        Store.on("Response_Resource_DisplaysInInfo_Updated", this.updateResourceDisplaysInInfo.bind(this));
        Store.on("Response_SingleResource_ModifySingleResource_Updated", this.repullAllResources.bind(this));
        Store.on("Response_SingleResource_CreateSingleResource_Updated", this.repullSingleResourcefromCreate.bind(this));
        Store.on("Response_User_Viewed_Resource", this.repullTopReportsInfo.bind(this));
        Store.on("Response_Validation_Failed", this.showValidationPage.bind(this));


        Store.on("Response_File_Uploaded", this.fileUploaded.bind(this));

        window.addEventListener("hashchange", this.updateHash.bind(this));
        window.addEventListener('dragenter', this.handleDragIn)
        window.addEventListener('dragleave', this.handleDragOut)
        window.addEventListener('dragover', this.handleDrag)
        window.addEventListener('drop', this.handleDrop)

        setInterval(this.animateFish.bind(this), Math.floor(Math.random() * 5000) + 20000);

        this.searchTimer = null;


        if (process.env.REACT_APP_HYPERDRIVE_MODE === 'true') {
            //Listener for Epic to respond
            window.addEventListener("message", this.handleEpicHyperDriveMessage, false);

            //Post a message to the parent window
            console.log("Initiate Handshake");
            window.parent.postMessage(
                { action: "Epic.Clinical.Informatics.Web.InitiateHandshake" },
                "*"
            );
        }

    }


    animateFish = () => {

        var fishContainer = this.refs["fishContainer"];
        var fish = this.refs["fish"];
        if (fishContainer && fish) {

            var x = Math.floor(Math.random() * (window.innerWidth - fishContainer.offsetWidth));

            fishContainer.style.left = x + "px";
            fish.classList.remove("fish-fall");
            fish.classList.add("fish-jump");

            setTimeout(function () {
                fish.classList.remove("fish-jump");
                fish.classList.add("fish-fall");
            }, 500);
        }
    }

    //These functions are called by componentDidMount
    updateHash = () => {
        if (window.location.hash != this.state.hash) {

            var hash = window.location.hash;
            var searchTerm = "";
            var singleResult = "";

            if (hash.startsWith("#/search/")) {
                hash = hash.replace("#/search/", "");
                hash = hash.split("?")[0];
                searchTerm = hash;
                searchTerm = decodeURI(searchTerm);
            }
            else if (hash.startsWith("#/result/")) {
                hash = hash.replace("#/result/", "");
                hash = hash.split("/")[1];
                hash = hash.split("?")[0];
                singleResult = hash;
            }
            else if (hash.startsWith("#/searchResult/")) {
                hash = hash.replace("#/searchResult/", "");
                hash = hash.split("?")[0];
                searchTerm = hash.split("/")[0];
                searchTerm = decodeURIComponent(searchTerm);
                singleResult = hash.split("/")[1];
            }


            if (this.refs["bodySearch_Input"]) {
                this.refs["bodySearch_Input"].value = searchTerm;
            }
            if (this.refs["headerSearch_Input"]) {
                this.refs["headerSearch_Input"].value = searchTerm;
            }

            this.setState({
                hash: hash,
                searchTerm: searchTerm,
                currentSearchText: searchTerm,
                singleResult: singleResult,
                showResourceRanking: false,
                showUserPermissions: false,
                showAccessGroups: false,
                showRanks: false,
                showCreate: false,
                showGame: false,
                showNotifications: false,
                currentTabLocation: "",
                requestReason: "",
                resource_editMode: false,
                resource_editFileMode: false
            })

            if (this.refs["requestAccessReasonText"]) {
                this.refs["requestAccessReasonText"].value = "";
            }
        }
    }


    updateFilterToAll = () => {
        this.setState({
            filterReportType: "",
            filterResourceType: "All"
        });
    }

    updateFilterToReport = () => {
        this.setState({
            filterReportType: "",
            filterResourceType: "Report"
        });
    }

    updateFilterToMetric = () => {
        this.setState({
            filterReportType: "",
            filterResourceType: "Metric"
        });
    }

    checkSearchRelationships = (bodyObjects) => {
        if (Object.values(bodyObjects).length > 0) {
            var vals = "";
            var count = 0;

            if (this.state.searchRelationshipTerm != this.state.searchTerm) {


                for (var key in bodyObjects) {
                    if (count > 0) {
                        vals = vals + ", ";
                    }
                    vals = vals + bodyObjects[key]["externalId"];
                    count = count + 1;
                }
                //Actions.getResourceDisplaysIn(vals)

                this.setState({
                    searchRelationshipTerm: this.state.searchTerm
                });
            }
        }

    }

    //These functions are called by componentDidMount
    updateUserAccountInfo = () => {

        var userAccountInfoResponse = Store.getUser_AccountInfo()

        if (this.state.isEpicUser) {
            userAccountInfoResponse["permissionLevel"] = "";
        }

        this.setState({
            user_AccountInfo: userAccountInfoResponse
        })

        Actions.getUserLayoutInfo(userAccountInfoResponse["idUser"]);
        Actions.getUserRatingsInfo();
        //Actions.getUserListInfo();

        if (userAccountInfoResponse["permissionLevel"] == "" || this.state.isEpicUser) {
            this.setState({
                siteMode: "databayprd"
            })

            if (this.state.singleResult.length > 0) {

                this.setState({
                    loadingRelationships: true
                })
                Actions.getSingleResourceImages(this.state.singleResult);
                Actions.getSingleResourceRelationships(this.state.singleResult, "databayprd");
                Actions.getSingleResourceTagInfo(this.state.singleResult);

                Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);

                Actions.getSingleResourceMetricOwner(this.state.singleResult);
                Actions.getSingleResourceMetricGoals(this.state.singleResult);
                //Actions.getSingleResourceDisplaysIn(this.state.singleResult, "databayprd");
                Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
            }

            //Actions.getQuickResourceIntellisenseInfo("databayprd");
            Actions.getResourceIntellisenseInfo("databayprd");
            Actions.getResourceRelationshipInfo("databayprd");
            Actions.getResourceTagInfo();
            Actions.getReportsAndMetricLinkInfo();
            if (!this.state.isEpicUser || this.state.isHyperDriveUser) {
                Actions.getUserListInfo();
                Actions.getTopReportsInfo();
                Actions.getTopRatedReportsInfo();
                Actions.getTopTagsInfo();
                Actions.getNewestReportsInfo();

            }
            Actions.getUserFavoritesInfo(userAccountInfoResponse["idUser"]);
            Actions.getUserSharedInfo(userAccountInfoResponse["idUser"]);
        }
        else {

            Actions.getUserCreatorListInfo();
            Actions.getReportTypeListInfo();
            Actions.getQRSYearListInfo();
            Actions.getRankListInfo();
            Actions.getResourceTypeListInfo(this.state.siteMode);

            if (userAccountInfoResponse["permissionLevel"] == "siteAdministrator") {
                Actions.getUserPermissionListInfo();
                Actions.getUsersWithPermissionsListInfo();
            }

            if (this.state.siteMode == "databayprd") {
                if (this.state.singleResult.length > 0) {
                    Actions.getSingleResourceImages(this.state.singleResult);
                    Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceTagInfo(this.state.singleResult);

                    Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceMetricOwner(this.state.singleResult);
                    Actions.getSingleResourceMetricGoals(this.state.singleResult);
                    //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                    Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
                }

                //Actions.getQuickResourceIntellisenseInfo("databayprd");
                Actions.getResourceIntellisenseInfo("databayprd");
                Actions.getResourceRelationshipInfo("databayprd");
                Actions.getResourceTagInfo();
                Actions.getReportsAndMetricLinkInfo();
                Actions.getUserListInfo();
                Actions.getTopReportsInfo();
                Actions.getTopRatedReportsInfo();
                Actions.getTopTagsInfo();
                Actions.getNewestReportsInfo();
                Actions.getUserFavoritesInfo(userAccountInfoResponse["idUser"]);
                Actions.getUserSharedInfo(userAccountInfoResponse["idUser"]);

            }
            else if (this.state.siteMode == "databaydev" && (userAccountInfoResponse["permissionLevel"] == "siteAdministrator" || userAccountInfoResponse["permissionLevel"] == "contentAdministrator")) {
                if (this.state.singleResult.length > 0) {
                    Actions.getSingleResourceImages(this.state.singleResult);
                    Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceTagInfo(this.state.singleResult);
                    Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
                    //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceMetricOwner(this.state.singleResult);
                    Actions.getSingleResourceMetricGoals(this.state.singleResult);
                    //Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
                }

                Actions.getQuickResourceIntellisenseInfo("databaydev");
                Actions.getResourceIntellisenseInfo("databaydev");
                Actions.getResourceRelationshipInfo("databaydev");
            }
            else if (this.state.siteMode == "databayccnprd") {
                if (this.state.singleResult.length > 0) {
                    Actions.getSingleResourceImages(this.state.singleResult);
                    Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceTagInfo(this.state.singleResult);

                    Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceCCNAttributes(this.state.singleResult);
                    //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceMetricOwner(this.state.singleResult);
                    Actions.getSingleResourceMetricGoals(this.state.singleResult);
                    //Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
                }

                Actions.getResourceIntellisenseInfo("databayccnprd");
                Actions.getResourceRelationshipInfo("databayccnprd");
            }
            else if (this.state.siteMode == "databayccndev") {
                if (this.state.singleResult.length > 0) {
                    Actions.getSingleResourceImages(this.state.singleResult);
                    Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceTagInfo(this.state.singleResult);

                    Actions.getSingleResourceAPGoals(this.state.singleResult);
                    Actions.getSingleResourceAPActions(this.state.singleResult);
                    Actions.getSingleResourceAPTeam(this.state.singleResult);
                    Actions.getSingleResourceAPLog(this.state.singleResult);
                    Actions.getSingleResourceCCNAttributes(this.state.singleResult);
                    //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceMetricOwner(this.state.singleResult);
                    Actions.getSingleResourceMetricGoals(this.state.singleResult);
                    //Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
                }

                Actions.getResourceIntellisenseInfo("databayccndev");
                Actions.getResourceRelationshipInfo("databayccndev");
            }
            else {
                this.setState({
                    siteMode: "databayprd"
                })
                if (this.state.singleResult.length > 0) {
                    Actions.getSingleResourceImages(this.state.singleResult);
                    Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceTagInfo(this.state.singleResult);

                    Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
                    //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                    Actions.getSingleResourceMetricOwner(this.state.singleResult);
                    Actions.getSingleResourceMetricGoals(this.state.singleResult);
                    Actions.addResourceView(this.state.user_AccountInfo.idUser, this.state.singleResult);
                }

                Actions.getResourceIntellisenseInfo("databayprd");
                Actions.getResourceRelationshipInfo("databayprd");
                Actions.getUserListInfo();
            }
        }

        /*

        var userLocationInfoResponse = Actions.getLocationInfo();
        this.setState({
            user_LocationInfo: userLocationInfoResponse
        })

        console.log(userLocationInfoResponse);

        if (userLocationInfoResponse.postal != undefined) {

        }

        */

        var userWeatherInfoAAMCResponse = Actions.getWeatherInfoByZip("21401"); //2001 Medical Parkway Annapolis, Maryland 21401
        var userWeatherInfoDCMCResponse = Actions.getWeatherInfoByZip("20706"); //8118 Good Luck RoadLanham, Maryland 20706
        if (userWeatherInfoAAMCResponse != undefined) {
            //alert(21401 + " " + userWeatherInfoAAMCResponse.weather[0].description);
            //This needs to use the above info to put in AAMC / DCMC location information.
            this.setState({
                aamc_WeatherInfo: userWeatherInfoAAMCResponse
            })

        }
        if (userWeatherInfoDCMCResponse != undefined) {
            //alert(20706 + " " + userWeatherInfoDCMCResponse.weather[0].description);
            //This needs to use the above info to put in AAMC / DCMC location information.
            this.setState({
                dcmc_WeatherInfo: userWeatherInfoDCMCResponse
            })
        }

        if (this.state.singleResult != "") {

        }
        else if (this.state.searchTerm != "") {

        }
    }

    updateUserListInfo = () => {

        var userListInfoResponse = Store.getUser_ListInfo()
        this.setState({
            user_ListInfo: userListInfoResponse
        })
    }

    updateUserCreatorListInfo = () => {

        var userCreatorListInfoResponse = Store.getUser_CreatorListInfo()
        this.setState({
            user_CreatorListInfo: userCreatorListInfoResponse
        })
    }


    pullUserFavoritesInfo = () => {

        Actions.getUserFavoritesInfo(this.state.user_AccountInfo.idUser);
    }

    pullResourceImageInfo = () => {

        if (this.state.singleResult != "") {
            Actions.getSingleResourceImages(this.state.singleResult);
        }
        else {
            Actions.getResourceImages();
        }
    }

    pullSingleResourceImageInfo = () => {

        if (this.state.singleResult != "") {
            Actions.getSingleResourceImages(this.state.singleResult);
        }

    }

    pullUserRatingsInfo = () => {

        Actions.getUserRatingsInfo();
        Actions.getTopRatedReportsInfo();
    }


    updateUserRatingsInfo = () => {

        var userRatingsInfoResponse = Store.getUser_RatingsInfo()
        this.setState({
            user_RatingsInfo: userRatingsInfoResponse
        })

    }


    updateUserHighScoreInfo = () => {

        var userHighScoreInfoResponse = Store.getUser_HighScoreInfo()
        this.setState({
            user_HighScoreInfo: userHighScoreInfoResponse
        })

        if (this.state.showGame) {
            setTimeout(() => {
                Actions.getUserHighScores(this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername);
            }, 3000);
        }


    }


    updateUserTopUsersHighScoreInfo = () => {

        var userTopUsersHighScoreInfoResponse = Store.getUser_TopUsersHighScoreInfo()
        this.setState({
            user_TopUsersHighScoreInfo: userTopUsersHighScoreInfoResponse
        })
        if (this.state.showGame) {
            setTimeout(() => {
                Actions.getTopUsersHighScores();
            }, 3000);
        }

    }

    updateResourceTagInfo = () => {

        var resourceTagInfoResponse = Store.getResource_TagInfo()
        var currentResourceTags = Object.values(this.state.resource_IntellisenseTagInfo);
        var storedResourceTags = Object.values(resourceTagInfoResponse);
        var uniqueTags = [];
        uniqueTags = [...new Set(storedResourceTags.map(item => item.tag))];
        this.setState({
            resource_IntellisenseTagInfo: uniqueTags,
            resource_BuildTagInfo: resourceTagInfoResponse
        })
    }

    updateResourceReportAndMetricLinkInfo = () => {

        var resourceReportAndMetricLinkInfoResponse = Store.getResource_ReportAndMetricLinkInfo()
        var currentResourceReportAndMetricLink = Object.values(this.state.resource_IntellisenseReportAndMetricLinkInfo);
        var storedResourceReportAndMetricLink = Object.values(resourceReportAndMetricLinkInfoResponse);
        var uniqueExternalIds = [];
        uniqueExternalIds = [...new Set(storedResourceReportAndMetricLink.map(item => item.sourceExternalId))];

        if (storedResourceReportAndMetricLink != currentResourceReportAndMetricLink) {

            this.setState({
                resource_IntellisenseReportAndMetricLinkInfo: storedResourceReportAndMetricLink,
                resource_IntellisenseReportAndMetricLink_UniqueReportsInfo: uniqueExternalIds,
            })

        }
    }

    updateResourceThumbImageInfo = () => {

        var resourceThumbImageInfoResponse = Store.getResource_ThumbImageInfo()
        var currentResourceImages = Object.values(this.state.resource_BuildThumbImageInfo);

        if (Object.values(currentResourceImages).length > 0) {

            if (resourceThumbImageInfoResponse != null) {
                if (Object.values(resourceThumbImageInfoResponse).length > 0) {

                    //currentResourceImages = currentResourceImages.filter(e => e.externalId != this.state.singleResult);

                    Object.values(resourceThumbImageInfoResponse).forEach(imageValue => {

                        if (Object.values(currentResourceImages).some(e => e.externalId == imageValue['externalId'] && e.imageBase64_thumb == imageValue['imageBase64_thumb'])) {

                        }
                        else {
                            currentResourceImages.push(imageValue);
                        }

                    });

                    this.setState({
                        resource_BuildThumbImageInfo: currentResourceImages
                    })

                }
                else {

                }
            }
        }
        else {
            this.setState({
                resource_BuildThumbImageInfo: resourceThumbImageInfoResponse
            })
        }
    }

    updateSingleResourceImageInfo = () => {

        var singleResourceImageInfoResponse = Store.getSingleResource_ImageInfo()

        var currentResourceImages = Object.values(this.state.resource_BuildImageInfo);
        if (singleResourceImageInfoResponse != null) {
            if (Object.values(singleResourceImageInfoResponse).length > 0) {

                var thisSingleResource = currentResourceImages.filter(e => e.externalId == this.state.singleResult);
                currentResourceImages = currentResourceImages.filter(e => e.externalId != this.state.singleResult);

                const array2Sorted = thisSingleResource.slice().sort();
                if (Object.values(singleResourceImageInfoResponse).length == Object.values(thisSingleResource).length && Object.values(singleResourceImageInfoResponse).slice().sort().every(function (value, index) {
                    return value.imageBase64 == array2Sorted[index].imageBase64;
                })) {
                }
                else {

                    Object.values(singleResourceImageInfoResponse).forEach(imageValue => {

                        currentResourceImages.push(imageValue);

                        this.setState({
                            resource_BuildImageInfo: currentResourceImages
                        })

                    });

                }
            }
            else {

                currentResourceImages = currentResourceImages.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildImageInfo: currentResourceImages
                })
            }
        }

    }


    updateSingleResourceRelationshipInfo = () => {

        var singleResourceRelationshipInfoResponse = Store.getSingleResource_RelationshipInfo()

        this.setState({
            loadingRelationships: false
        })

        var currentResourceRelationships = Object.values(this.state.resource_BuildRelationshipInfo);
        if (singleResourceRelationshipInfoResponse != null) {
            if (Object.values(singleResourceRelationshipInfoResponse).length > 0) {

                currentResourceRelationships = currentResourceRelationships.filter(e => e.sourceExternalId != this.state.singleResult);

                Object.values(singleResourceRelationshipInfoResponse).forEach(relationshipValue => {


                    currentResourceRelationships.push(relationshipValue);

                    this.setState({
                        resource_BuildRelationshipInfo: currentResourceRelationships
                    })

                });
            }
            else {

                currentResourceRelationships = currentResourceRelationships.filter(e => e.sourceExternalId != this.state.singleResult);

                this.setState({
                    resource_BuildRelationshipInfo: currentResourceRelationships
                })
            }
        }

    }

    updateSingleResourceAPGoalsInfo = () => {

        var singleResourceAPGoalsInfoResponse = Store.getSingleResource_APGoalsInfo()

        var currentResourceAPGoals = Object.values(this.state.resource_BuildAPGoalsInfo);
        if (singleResourceAPGoalsInfoResponse != null) {
            if (Object.values(singleResourceAPGoalsInfoResponse).length > 0) {

                currentResourceAPGoals = currentResourceAPGoals.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceAPGoalsInfoResponse).forEach(APGoalsValue => {


                    currentResourceAPGoals.push(APGoalsValue);

                    this.setState({
                        resource_BuildAPGoalsInfo: currentResourceAPGoals
                    })

                });
            }
            else {

                currentResourceAPGoals = currentResourceAPGoals.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildAPGoalsInfo: currentResourceAPGoals
                })
            }
        }


    }

    updateSingleResourceAPActionsInfo = () => {

        var singleResourceAPActionsInfoResponse = Store.getSingleResource_APActionsInfo()

        var currentResourceAPActions = Object.values(this.state.resource_BuildAPActionsInfo);
        if (singleResourceAPActionsInfoResponse != null) {
            if (Object.values(singleResourceAPActionsInfoResponse).length > 0) {

                currentResourceAPActions = currentResourceAPActions.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceAPActionsInfoResponse).forEach(APActionsValue => {


                    currentResourceAPActions.push(APActionsValue);

                    this.setState({
                        resource_BuildAPActionsInfo: currentResourceAPActions
                    })

                });
            }
            else {

                currentResourceAPActions = currentResourceAPActions.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildAPActionsInfo: currentResourceAPActions
                })
            }
        }


    }

    updateSingleResourceAPTeamInfo = () => {

        var singleResourceAPTeamInfoResponse = Store.getSingleResource_APTeamInfo()

        var currentResourceAPTeam = Object.values(this.state.resource_BuildAPTeamInfo);
        if (singleResourceAPTeamInfoResponse != null) {
            if (Object.values(singleResourceAPTeamInfoResponse).length > 0) {

                currentResourceAPTeam = currentResourceAPTeam.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceAPTeamInfoResponse).forEach(APTeamValue => {


                    currentResourceAPTeam.push(APTeamValue);

                    this.setState({
                        resource_BuildAPTeamInfo: currentResourceAPTeam
                    })

                });
            }
            else {

                currentResourceAPTeam = currentResourceAPTeam.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildAPTeamInfo: currentResourceAPTeam
                })
            }
        }


    }


    updateSingleResourceMetricOwnerInfo = () => {

        var singleResourceMetricOwnerInfoResponse = Store.getSingleResource_MetricOwnerInfo()

        var currentResourceMetricOwner = Object.values(this.state.resource_BuildMetricOwnerInfo);
        if (singleResourceMetricOwnerInfoResponse != null) {
            if (Object.values(singleResourceMetricOwnerInfoResponse).length > 0) {

                currentResourceMetricOwner = currentResourceMetricOwner.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceMetricOwnerInfoResponse).forEach(MetricOwnerValue => {


                    currentResourceMetricOwner.push(MetricOwnerValue);

                    this.setState({
                        resource_BuildMetricOwnerInfo: currentResourceMetricOwner
                    })

                });
            }
            else {

                currentResourceMetricOwner = currentResourceMetricOwner.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildMetricOwnerInfo: currentResourceMetricOwner
                })
            }
        }


    }



    updateSingleResourceMetricGoalsInfo = () => {

        var singleResourceMetricGoalsInfoResponse = Store.getSingleResource_MetricGoalsInfo()

        var currentResourceMetricGoals = Object.values(this.state.resource_BuildMetricGoalsInfo);
        if (singleResourceMetricGoalsInfoResponse != null) {
            if (Object.values(singleResourceMetricGoalsInfoResponse).length > 0) {

                currentResourceMetricGoals = currentResourceMetricGoals.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceMetricGoalsInfoResponse).forEach(MetricGoalsValue => {


                    currentResourceMetricGoals.push(MetricGoalsValue);

                    this.setState({
                        resource_BuildMetricGoalsInfo: currentResourceMetricGoals
                    })

                });
            }
            else {

                currentResourceMetricGoals = currentResourceMetricGoals.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildMetricGoalsInfo: currentResourceMetricGoals
                })
            }
        }


    }

    updateSingleResourceAPLogInfo = () => {

        var singleResourceAPLogInfoResponse = Store.getSingleResource_APLogInfo()

        var currentResourceAPLog = Object.values(this.state.resource_BuildAPLogInfo);
        if (singleResourceAPLogInfoResponse != null) {
            if (Object.values(singleResourceAPLogInfoResponse).length > 0) {

                currentResourceAPLog = currentResourceAPLog.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceAPLogInfoResponse).forEach(APLogValue => {


                    currentResourceAPLog.push(APLogValue);

                    this.setState({
                        resource_BuildAPLogInfo: currentResourceAPLog
                    })

                });
            }
            else {

                currentResourceAPLog = currentResourceAPLog.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildAPLogInfo: currentResourceAPLog
                })
            }
        }


    }


    updateSingleResourceCCNAttributeInfo = () => {

        var singleResourceCCNAttributeInfoResponse = Store.getSingleResource_CCNAttributeInfo()

        var currentResourceCCNAttributes = Object.values(this.state.resource_BuildCCNAttributeInfo);
        if (singleResourceCCNAttributeInfoResponse != null) {
            if (Object.values(singleResourceCCNAttributeInfoResponse).length > 0) {

                currentResourceCCNAttributes = currentResourceCCNAttributes.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceCCNAttributeInfoResponse).forEach(ccnAttributesValue => {


                    currentResourceCCNAttributes.push(ccnAttributesValue);

                    this.setState({
                        resource_BuildCCNAttributeInfo: currentResourceCCNAttributes
                    })

                });
            }
            else {

                currentResourceCCNAttributes = currentResourceCCNAttributes.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildCCNAttributeInfo: currentResourceCCNAttributes
                })
            }
        }


    }


    updateSingleResourceDisplaysInInfo = () => {

        var singleResourceDisplaysInInfoResponse = Store.getSingleResource_DisplaysInInfo()

        var currentResourceDisplaysIns = Object.values(this.state.resource_BuildDisplaysInInfo);
        if (singleResourceDisplaysInInfoResponse != null) {
            if (Object.values(singleResourceDisplaysInInfoResponse).length > 0) {

                currentResourceDisplaysIns = currentResourceDisplaysIns.filter(e => e.relationshipExternalId != this.state.singleResult);

                Object.values(singleResourceDisplaysInInfoResponse).forEach(displaysInValue => {


                    currentResourceDisplaysIns.push(displaysInValue);

                    this.setState({
                        resource_BuildDisplaysInInfo: currentResourceDisplaysIns
                    })

                });
            }
            else {

                currentResourceDisplaysIns = currentResourceDisplaysIns.filter(e => e.relationshipExternalId != this.state.singleResult);

                this.setState({
                    resource_BuildDisplaysInInfo: currentResourceDisplaysIns
                })
            }
        }

    }




    updateSingleResourceTagInfo = () => {

        var singleResourceTagInfoResponse = Store.getSingleResource_TagInfo()

        var currentResourceTags = Object.values(this.state.resource_BuildTagInfo);
        if (singleResourceTagInfoResponse != null) {
            if (Object.values(singleResourceTagInfoResponse).length > 0) {

                currentResourceTags = currentResourceTags.filter(e => e.externalId != this.state.singleResult);

                Object.values(singleResourceTagInfoResponse).forEach(tagValue => {


                    currentResourceTags.push(tagValue);

                    this.setState({
                        resource_BuildTagInfo: currentResourceTags
                    })

                });
            }
            else {

                currentResourceTags = currentResourceTags.filter(e => e.externalId != this.state.singleResult);

                this.setState({
                    resource_BuildTagInfo: currentResourceTags
                })
            }
        }

    }


    updateResourceDisplaysInInfo = () => {

        var resourceDisplaysInInfoResponse = Store.getResource_DisplaysInInfo()

        var currentResourceDisplaysIns = Object.values(this.state.resource_BuildDisplaysInInfo);
        if (resourceDisplaysInInfoResponse != null) {
            if (Object.values(resourceDisplaysInInfoResponse).length > 0) {


                for (var key in resourceDisplaysInInfoResponse) {

                    currentResourceDisplaysIns = currentResourceDisplaysIns.filter(e => e.relationshipExternalId != resourceDisplaysInInfoResponse[key]["relationshipExternalId"]);

                }

                Object.values(resourceDisplaysInInfoResponse).forEach(displaysInValue => {

                    currentResourceDisplaysIns.push(displaysInValue);

                    this.setState({
                        resource_BuildDisplaysInInfo: currentResourceDisplaysIns
                    })

                });

            }
            else {

            }
        }

    }




    repullUserLayoutInfo = () => {

        Actions.getUserLayoutInfo(this.state.user_AccountInfo.idUser);

    }


    repullUserPermissions = () => {

        Actions.getUserPermissionListInfo();
        Actions.getUsersWithPermissionsListInfo();

    }


    updateUserPermissionListInfo = () => {

        var userPermissionListInfoResponse = Store.getUser_PermissionListInfo()
        this.setState({
            user_PermissionListInfo: userPermissionListInfoResponse
        })

    }


    updateUsersWithPermissionsListInfo = () => {

        var usersWithPermissionsListInfoResponse = Store.getUser_UsersWithPermissionsListInfo()
        this.setState({
            user_UsersWithPermissionsListInfo: usersWithPermissionsListInfoResponse
        })

    }


    updateUserLayoutInfo = () => {

        var userLayoutInfoResponse = Store.getUser_LayoutInfo()
        this.setState({
            user_LayoutInfo: userLayoutInfoResponse,
            user_LayoutLeft: userLayoutInfoResponse["homeLeftContent"],
            user_LayoutMiddle: userLayoutInfoResponse["homeMiddleContent"],
            user_LayoutRight: userLayoutInfoResponse["homeRightContent"],
            user_InterfaceColumns: userLayoutInfoResponse["interfaceColumns"],
            user_Theme: userLayoutInfoResponse["theme"]
        })

        this._updateTimeBasedTheme();

    }

    updateUserFavoritesInfo = () => {

        var userFavoritesInfoResponse = Store.getUser_FavoritesInfo()
        this.setState({
            user_FavoritesInfo: userFavoritesInfoResponse
        })

    }

    updateUserSharedInfo = () => {

        var userSharedInfoResponse = Store.getUser_SharedInfo()

        if (JSON.stringify(userSharedInfoResponse) == JSON.stringify(this.state.user_SharedInfo)) {
        }
        else {
            this.setState({
                user_SharedInfo: userSharedInfoResponse
            })

        }

        //Also Update Weather

        var userWeatherInfoAAMCResponse = Actions.getWeatherInfoByZip("21401"); //2001 Medical Parkway Annapolis, Maryland 21401
        var userWeatherInfoDCMCResponse = Actions.getWeatherInfoByZip("20706"); //8118 Good Luck Road Lanham, Maryland 20706
        if (userWeatherInfoAAMCResponse != undefined) {
            //alert(21401 + " " + userWeatherInfoAAMCResponse.weather[0].description);
            //This needs to use the above info to put in AAMC / DCMC location information.
            this.setState({
                aamc_WeatherInfo: userWeatherInfoAAMCResponse
            })

        }
        if (userWeatherInfoDCMCResponse != undefined) {
            //alert(20706 + " " + userWeatherInfoDCMCResponse.weather[0].description);
            //This needs to use the above info to put in AAMC / DCMC location information.
            this.setState({
                dcmc_WeatherInfo: userWeatherInfoDCMCResponse
            })
        }

        //gets shared info every 5 minutes
        setTimeout(() => {
            Actions.getUserSharedInfo(this.state.user_AccountInfo.idUser);
        }, 300000);

    }


    updateResourceListByTypeInfo = () => {

        var resourceListResponse = Store.getResource_ListByTypeInfo()
        this.setState({
            resource_addRelationship_ResourceList: resourceListResponse
        })
    }

    updateSingleResource = () => {
        var resourceSingleResourceResponse = Store.getResource_SingleResourceInfo()

        var resourceMode = "databayprd";
        const prodStatuses = new Set(['Accepted', 'Candidate']);
        const devStatuses = new Set(['Disabled', 'Obsolete', 'Under Development', 'Relationship Ready', 'Under Review']);
        const ccnResources = new Set(['CCN Business Lead', 'CCN CME Program', 'CCN EMR System', 'CCN Practice', 'CCN Practice Manager', 'CCN Provider', 'CCN Provider Specialty', 'CCN Value Based Contract']);
        if (ccnResources.has(resourceSingleResourceResponse['resourceType']) && prodStatuses.has(resourceSingleResourceResponse['externalStatus'])) {
            resourceMode = "databayccnprd";
        }
        else if (ccnResources.has(resourceSingleResourceResponse['resourceType']) && devStatuses.has(resourceSingleResourceResponse['externalStatus'])) {
            resourceMode = "databayccndev";
        }
        else if (!ccnResources.has(resourceSingleResourceResponse['resourceType']) && prodStatuses.has(resourceSingleResourceResponse['externalStatus'])) {
            resourceMode = "databayprd";
        }
        else if (!ccnResources.has(resourceSingleResourceResponse['resourceType']) && devStatuses.has(resourceSingleResourceResponse['externalStatus'])) {
            resourceMode = "databaydev";
        }


        if (resourceMode == this.state.siteMode && resourceSingleResourceResponse.length>0) {

            switch (this.state.siteMode) {
                case "databayprd":

                    if (Object.values(this.state.resource_IntellisenseInfo).some(e => e['externalId'] == resourceSingleResourceResponse['externalId'])) {
                        Object.values(this.state.resource_IntellisenseInfo)
                            .filter(value => (value['externalId']).toString().toLowerCase() == this.state.singleResult.toLowerCase())
                            .forEach(value => {
                                value = resourceSingleResourceResponse;
                            });
                    }
                    else {
                        this.state.resource_IntellisenseInfo[this.state.resource_IntellisenseInfo.length] = resourceSingleResourceResponse;
                    }


                    break;
                case "databaydev":

                    if (Object.values(this.state.resource_IntellisenseInfo).some(e => e['externalId'] == resourceSingleResourceResponse['externalId'])) {
                        Object.values(this.state.resource_IntellisenseInfo)
                            .filter(value => (value['externalId']).toString().toLowerCase() == this.state.singleResult.toLowerCase())
                            .forEach(value => {
                                value = resourceSingleResourceResponse;
                            });
                    }
                    else {
                        this.state.resource_IntellisenseInfo[this.state.resource_IntellisenseInfo.length] = resourceSingleResourceResponse;
                    }


                    this.setState({
                        resource_StoredDatabayDev_IntellisenseInfo: this.state.resource_IntellisenseInfo
                    })


                    break;
                case "databayccnprd":

                    if (Object.values(this.state.resource_IntellisenseInfo).some(e => e['externalId'] == resourceSingleResourceResponse['externalId'])) {
                        Object.values(this.state.resource_IntellisenseInfo)
                            .filter(value => (value['externalId']).toString().toLowerCase() == this.state.singleResult.toLowerCase())
                            .forEach(value => {
                                value = resourceSingleResourceResponse;
                            });
                    }
                    else {
                        this.state.resource_IntellisenseInfo[this.state.resource_IntellisenseInfo.length] = resourceSingleResourceResponse;
                    }

                    this.setState({
                        resource_StoredDatabayCCNPrd_IntellisenseInfo: this.state.resource_IntellisenseInfo
                    })

                    break;
                case "databayccndev":

                    if (Object.values(this.state.resource_IntellisenseInfo).some(e => e['externalId'] == resourceSingleResourceResponse['externalId'])) {
                        Object.values(this.state.resource_IntellisenseInfo)
                            .filter(value => (value['externalId']).toString().toLowerCase() == this.state.singleResult.toLowerCase())
                            .forEach(value => {
                                value = resourceSingleResourceResponse;
                            });
                    }
                    else {
                        this.state.resource_IntellisenseInfo[this.state.resource_IntellisenseInfo.length] = resourceSingleResourceResponse;
                    }


                    this.setState({
                        resource_StoredDatabayCCNDev_IntellisenseInfo: this.state.resource_IntellisenseInfo
                    })

                    break;
            }
            if (this.state.singleResult == "" && this.state.currentSearchText != "" && this.state.fileUploaded) {

                this.setState({
                    fileUploaded: false
                })
                this._beginSearch();
            }

        }
        else {

        }
    }

    updateResourceIntellisenseInfo = () => {

        var resourceIntellisenseResponse = Store.getResource_IntellisenseInfo()

        this.setState({
            resource_IntellisenseInfo: resourceIntellisenseResponse
        })

        if (this.state.singleResult != "") {
            Actions.getSingleResourceImages(this.state.singleResult);
        }
        else {
        }

        Actions.getResourceImages();

        //Actions.getResourceFullImages();
    }

    updateResourceRelationshipInfo = () => {

        var resourceRelationshipResponse = Store.getResource_RelationshipInfo()
        this.setState({
            resource_RelationshipInfo: resourceRelationshipResponse
        })

    }

    reloadResourceRelationshipInfo = () => {

        if (this.state.singleResult.length > 0) {

            Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceTagInfo(this.state.singleResult);
            Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
            //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceMetricOwner(this.state.singleResult);
            Actions.getSingleResourceMetricGoals(this.state.singleResult);

        }

    }

    reloadResourceMetricOwnerInfo = () => {

        if (this.state.singleResult.length > 0) {

            Actions.getSingleResourceMetricOwner(this.state.singleResult);

        }
    }

    reloadResourceMetricGoalsInfo = () => {

        if (this.state.singleResult.length > 0) {

            Actions.getSingleResourceMetricGoals(this.state.singleResult);

        }
    }

    reloadResourceTagInfo = () => {


        if (this.state.singleResult.length > 0) {

            Actions.getSingleResourceTagInfo(this.state.singleResult);
            Actions.getResourceTagInfo();
            //Actions.getTopTagsInfo();
        }

    }

    reloadResourceReportAndMetricLinkInfo = () => {


        if (this.state.singleResult.length > 0) {

            Actions.getReportsAndMetricLinkInfo();

        }

    }

    repullAllResources = () => {

        if (this.state.singleResult.length > 0) {
            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
            Actions.getSingleResource(this.state.singleResult);
            Actions.getSingleResourceImages(this.state.singleResult);
            Actions.getSingleResourceRelationships(this.state.singleResult, this.state.siteMode);
            Actions.getSingleResourceTagInfo(this.state.singleResult);
            if (this.state.siteMode == "databayprd" || this.state.siteMode == "databaydev") {
                Actions.getSingleResourceAPGoals(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPActions(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPTeam(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceAPLog(this.state.singleResult, this.state.siteMode);
                //Actions.getSingleResourceDisplaysIn(this.state.singleResult, this.state.siteMode);
                Actions.getSingleResourceMetricOwner(this.state.singleResult);
                Actions.getSingleResourceMetricGoals(this.state.singleResult);
            }
            if (this.state.siteMode == "databayccnprd" || this.state.siteMode == "databayccndev") {
                Actions.getSingleResourceCCNAttributes(this.state.singleResult, this.state.siteMode);
            }
            Actions.getResourceIntellisenseInfo(this.state.siteMode);
        }
        else {
            Actions.getResourceIntellisenseInfo(this.state.siteMode);
        }
        Actions.getResourceRelationshipInfo(this.state.siteMode);

    }

    repullSingleResourcefromCreate = () => {

        //NEED TO REPULL SINGLE RESOURCE IF ON THE SAME MODE

        var singleResource_ExternalIdResponse = Store.getSingleResource_CreateInfo();
        if (singleResource_ExternalIdResponse["externalId"].toString().length > 0) {
            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
            Actions.getSingleResource(singleResource_ExternalIdResponse["externalId"].toString());
        }

        if (window.confirm("Your resource has been created would you like to view it?")) {
            this._showSingleResult(singleResource_ExternalIdResponse["externalId"], singleResource_ExternalIdResponse["resourceName"]);
        }

    }

    repullResourceRankListInfo = () => {

        Actions.getRankListInfo();
        //Actions.getQuickResourceIntellisenseInfo(this.state.siteMode);
        Actions.getResourceIntellisenseInfo(this.state.siteMode);
        Actions.getResourceRelationshipInfo(this.state.siteMode);

    }

    updateResourceRankListInfo = () => {

        var resourceRankListResponse = Store.getResource_ResourceRankListInfo()
        this.setState({
            resource_RankListInfo: resourceRankListResponse
        })

    }

    updateResourceReportTypeListInfo = () => {

        var resourceReportTypeListResponse = Store.getResource_ReportTypeListInfo()
        this.setState({
            resource_ReportTypeListInfo: resourceReportTypeListResponse
        })

    }

    updateResourceQRSYearListInfo = () => {

        var resourceQRSYearListResponse = Store.getResource_QRSYearListInfo()
        this.setState({
            resource_QRSYearListInfo: resourceQRSYearListResponse
        })

    }

    updateResourceResourceTypeListInfo = () => {

        var resourceResourceTypeListResponse = Store.getResource_ResourceTypeListInfo()
        this.setState({
            resource_ResourceTypeListInfo: resourceResourceTypeListResponse
        })

    }

    showValidationPage = () => {
        var currentUrl = window.location.href;
        var redirectUrl = "";
        //alert("Entering Show Validation");
        //alert("Entering Login Popup");
        //alert(msalApp.getAccount());
        if (msalApp.getAccount()) {
            //alert("Step 3 Success");

            var hostname = window.location.hostname;

            // Check if the URL starts with "http://localhost" or "https://localhost"
            if (hostname == "localhost") {
                // Do something for localhost (e.g., set a variable to 'x')
                window.location.href = window.location.origin + "/api/App/validateAccess";
            }
            else {
                window.location.href = window.location.origin + "/api/App/validateAccess";
            }

        }
        else {
            //alert("Step 4 Success");

        msalApp
            .loginRedirect()
            .then((response) => {
                //alert("Step 5 Success");
                // Handle successful sign-in
                //alert("User signed in validation page message:", response);
                console.log("User signed in", response);
            })
            .catch((error) => {
                //alert("Step 6 Success");
                // Handle sign-in error
                console.error("Error signing in", error);
            });

        }

    }

    repullTopReportsInfo = () => {

        if (this.state.siteMode == "databayprd") {
            Actions.getTopReportsInfo();
        }

    }

    repullTopTagsInfo = () => {

        if (this.state.siteMode == "databayprd") {
            Actions.getTopTagsInfo();
        }

    }

    updateResourceTopReportsInfo = () => {

        var resourceTopReportsResponse = Store.getResource_TopReportsInfo()
        this.setState({
            resource_TopReportsInfo: resourceTopReportsResponse
        })

    }

    updateResourceTopTagsInfo = () => {

        var resourceTopTagsResponse = Store.getResource_TopTagsInfo()
        this.setState({
            resource_TopTagsInfo: resourceTopTagsResponse
        })

    }

    updateResourceTopRatedReportsInfo = () => {

        var resourceTopRatedReportsResponse = Store.getResource_TopRatedReportsInfo()
        this.setState({
            resource_TopRatedReportsInfo: resourceTopRatedReportsResponse
        })

    }


    updateResourceNewestReportsInfo = () => {

        var resourceNewestReportsResponse = Store.getResource_NewestReportsInfo()
        this.setState({
            resource_NewestReportsInfo: resourceNewestReportsResponse
        })

    }

    handleEpicHyperDriveMessage = (event) => {
        console.log(event.data);
        if (this.state.hyperdrive_initiate && event.data.token) {
            var token = event.data.token;
            this.setState({
                hyperdrive_token: token,
                hyperdrive_initiate: false,
                isHyperDriveUser: true
            });
        }
        else {

            if (event.data.error && event.data.error.length > 0) {
                alert(event.data.error);
            }
            else {
                console.log(event);
            }
            //parse any errors or mesages back from Epic

        }

    }

    fileUploaded = () => {

        this._hideOverlays();
        this.setState({
            resource_fileUploaded: true
        })
        var resourceSingleResourceResponse = Store.getActionGroupFileUploadedInfo()
        if (resourceSingleResourceResponse["externalId"]) {
            if (window.confirm("Your resource has been created would you like to view it?")) {
                this._showSingleResult(resourceSingleResourceResponse["externalId"], resourceSingleResourceResponse["resourceName"]);
            }
        }
    }

    handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    handleDragIn = (e) => {
        this.setState({ loadingFile: true })
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter++
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ drag: true })
        }
    }

    handleDragOut = (e) => {
        this.setState({ loadingFile: true })
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter--
        if (this.dragCounter == 0) {
            this.setState({ drag: false })
        }
    }

    handleDrop = (e) => {
        this.setState({ loadingFile: true })
        e.preventDefault()
        //e.stopPropagation()
        this.setState({ drag: false })
        var myState = this;

        if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator" && !this.state.isEpicUser) || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev'))) {

            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {

                let items = e.dataTransfer.files;
                for (let i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf("text/csv") != -1 && this.state.singleResult != "") {
                        const fileReader = new FileReader();

                        fileReader.readAsText(items[i]);

                        fileReader.onload = function () {
                            const dataset = fileReader.result;
                            const result = dataset.split('\n').map(data => data.split(','));
                            var myName = items[i].name;
                            var myType = myName.split('.').pop();
                            for (let i = 0; i < result.length; i++) {
                                if (result[i].length == 2) {
                                    Actions.importCSVGoal(this.state.singleResult, myName, result[i][0], result[i][1], this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername)
                                }
                            }
                        };
                    }
                    else if (items[i].type.indexOf("image") != -1) {
                        //document.getElementById("instructions").style.visibility = "hidden";
                        //image
                        //var file = items[i].getAsFile();
                        //var reader = new FileReader();
                        //var target = reader.readAsDataURL(items[i]);

                        let reader = new FileReader();
                        reader.fileName = items[i].name;

                        reader.onload = function (e) {
                            //console.log(reader.result); // Logs an error if there was one
                            //Need to add to the database here
                            var myName = e.target.fileName;
                            var myType = myName.split('.').pop();
                            var original_finalBase64 = "";
                            var thumb_finalBase64 = "";
                            let img = new Image();
                            img.src = reader.result;
                            img.onload = () => {

                                let original_canvas = document.createElement('canvas')
                                const original_MAX_WIDTH = 800
                                const original_MAX_HEIGHT = 600
                                let original_width = img.width
                                let original_height = img.height

                                if (original_width > original_height) {
                                    if (original_width > original_MAX_WIDTH) {
                                        original_height *= original_MAX_WIDTH / original_width
                                        original_width = original_MAX_WIDTH
                                    }
                                } else {
                                    if (original_height > original_MAX_HEIGHT) {
                                        original_width *= original_MAX_HEIGHT / original_height
                                        original_height = original_MAX_HEIGHT
                                    }
                                }
                                original_canvas.width = original_width
                                original_canvas.height = original_height
                                let original_ctx = original_canvas.getContext('2d')
                                original_ctx.drawImage(img, 0, 0, original_width, original_height)
                                original_finalBase64 = original_canvas.toDataURL('image/jpeg', .9);

                                let canvas = document.createElement('canvas')
                                const MAX_WIDTH = 143
                                const MAX_HEIGHT = 64
                                let width = img.width
                                let height = img.height

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width
                                        width = MAX_WIDTH
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height
                                        height = MAX_HEIGHT
                                    }
                                }
                                canvas.width = width
                                canvas.height = height
                                let ctx = canvas.getContext('2d')
                                ctx.drawImage(img, 0, 0, width, height)
                                thumb_finalBase64 = canvas.toDataURL('image/jpeg', .5);

                                Actions.addResourceImage(myState.state.user_AccountInfo.idUser, myState.state.singleResult, myName, myType, thumb_finalBase64, original_finalBase64)

                            }
                        }

                        var target = reader.readAsDataURL(items[i]);

                    }
                    else if (!this.state.showAccessGroups){
                        this._toggleUpload();
                    }
                }

                e.dataTransfer.clearData()
                this.dragCounter = 0
            }

        }
        else if (!this.state.showAccessGroups) {
            this._toggleUpload();
        }
        this.setState({ loadingFile: false })
    }




    _headerSearchFocus() {
        ReactDOM.findDOMNode(this.refs["headerSearch_Input"]).focus();
    }

    _resourceFilterUpdated() {
        this.setState({
            resource_relationshipNameFilter: this.refs["resourceFilterName_Input"].value,
        })
        if (this.refs["resourceFilterName_Input"].value.length > 3) {

            if (this.refs["resourceFilterName_Input"].value != "" || this.refs["reportTypeFilter"].value != "") {
                Actions.getResourceListByType(this.state.siteMode, this.refs["resourceFilterName_Input"].value, this.refs["resourceTypeFilter"].value, this.refs["reportTypeFilter"].value);
            }

        }
    }


    _shareFilterUpdated() {
        this.refs["modal_share_employee"].value = "";
        this.setState({
            resource_shareFilter: this.refs["shareFilterName_Input"].value,
        })

    }


    _shareDepartmentFilterUpdated() {
        this.refs["modal_share_employee"].value = "";
        this.setState({
            resource_shareDepartment: this.refs["shareFilterDepartment_Input"].value,
        })

    }


    _permissionFilterUpdated() {
        this.refs["modal_permission_employee"].value = "";
        this.setState({
            user_permissionFilter: this.refs["permissionFilterName_Input"].value,
        })

    }


    _permissionDepartmentFilterUpdated() {
        this.refs["modal_permission_employee"].value = "";
        this.setState({
            user_permissionDepartment: this.refs["permissionFilterDepartment_Input"].value,
        })

    }

    _addRelationshipAndUpdateRelationshipResourceFilter(resourceType) {
        this.refs["reportTypeFilter"].value = "";
        this.refs["resourceTypeFilter"].value = resourceType;

        if (this.refs["modal_addRelationship_resource"] != undefined) {
            this.refs["modal_addRelationship_resource"].value = "";
        }

        if (this.refs["addRelationshipFilterResourceType_Input"] != undefined) {
            this.refs["addRelationshipFilterResourceType_Input"].value = "";
        }

        if (this.refs["addRelationshipFilterReportType_Input"] != undefined) {
            this.refs["addRelationshipFilterReportType_Input"].value = "";
        }

        this.setState({
            resource_addRelationship_ResourceTypeFilter: resourceType,
            resource_addRelationship_ReportTypeFilter: "",
            resource_relationshipNameFilter: ""
        })
        Actions.getResourceListByType(this.state.siteMode, "", resourceType, "");

        this.refs["resourceTypeFilter"].value = resourceType;
        this.refs["reportTypeFilter"].value = "";


        this.refs["modal_overlay"].className = "modal_expanded";
        this.refs["modal_container_overlay"].className = "modal_container_expanded";
        this.refs["modal_addRelationship_overlay"].className = "modal_addRelationship_expanded";
        this.refs["modal_addRelationship_header"].className = "modal_addRelationship_header_expanded";
    }


    _relationshipResourceFilterUpdated() {
        this.refs["reportTypeFilter"].value = "";
        this.setState({
            resource_addRelationship_ResourceTypeFilter: this.refs["resourceTypeFilter"].value,
            resource_addRelationship_ReportTypeFilter: "",
            resource_relationshipNameFilter: this.refs["resourceFilterName_Input"].value
        })

        if (this.refs["resourceFilterName_Input"].value.length > 3) {

            Actions.getResourceListByType(this.state.siteMode, this.refs["resourceFilterName_Input"].value, this.refs["resourceTypeFilter"].value, this.refs["reportTypeFilter"].value);
        }
    }

    _relationshipReportFilterUpdated() {
        this.refs["resourceTypeFilter"].value = "Report";
        this.setState({
            resource_addRelationship_ResourceTypeFilter: "Report",
            resource_addRelationship_ReportTypeFilter: this.refs["reportTypeFilter"].value,
            resource_relationshipNameFilter: this.refs["resourceFilterName_Input"].value
        })

        if (this.refs["resourceFilterName_Input"].value.length > 3) {

            Actions.getResourceListByType(this.state.siteMode, this.refs["resourceFilterName_Input"].value, this.refs["resourceTypeFilter"].value, this.refs["reportTypeFilter"].value);
        }
    }



    _headerSearchTermUpdated() {
        if (this.refs["bodySearch_Input"] != undefined) {
            this.refs["bodySearch_Input"].value = this.refs["headerSearch_Input"].value;
        }
        this.setState({
            searchTerm: this.refs["headerSearch_Input"].value,
            currentSearchText: this.refs["headerSearch_Input"].value,
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            parentResult: "",
            parentType: "",
            parentAssociatedChild: "",
            filterReportType: "",
            filterQRSYear: "",
            filterRankType: "",
            filterResourceType: "Report & Report Category"
        })
        this._beginSearch();
    }



    _updateSearchTerm(searchTerm) {

        if (this.refs["headerSearch_Input"] != undefined) {
            this.refs["headerSearch_Input"].value = searchTerm;
        }
        if (this.refs["bodySearch_Input"] != undefined) {
            this.refs["bodySearch_Input"].value = searchTerm;
        }
        this.setState({
            searchTerm: searchTerm,
            currentSearchText: searchTerm,
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            parentResult: "",
            parentName: "",
            parentType: "",
            parentAssociatedChild: "",
            filterReportType: "",
            filterQRSYear: "",
            filterRankType: "",
            filterResourceType: "Report & Report Category"
        })

        this._beginSearch();

    }


    _bodySearchTermUpdated() {
        let that = this;
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function () {
            that._triggerBodySearchChange()
        }, 300);
    }

    _triggerBodySearchChange() {
        if (this.refs["headerSearch_Input"] != undefined) {
            this.refs["headerSearch_Input"].value = this.refs["bodySearch_Input"].value;
        }
        this.setState({
            searchTerm: this.refs["bodySearch_Input"].value,
            currentSearchText: this.refs["bodySearch_Input"].value,
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            parentResult: "",
            parentName: "",
            parentType: "",
            parentAssociatedChild: "",
            filterReportType: "",
            filterQRSYear: "",
            filterRankType: "",
            filterResourceType: "Report & Report Category",
            searchTerm: this.refs["bodySearch_Input"].value,
            hash: "#/searchResult/" + encodeURIComponent(this.refs["bodySearch_Input"].value) + "/",
            ignoreHashChange: true
        })

        window.location.hash = "#/searchResult/" + encodeURIComponent(this.refs["bodySearch_Input"].value) + "/";
    }

    _handleHeaderKeyDown(key) {
        if (key == "Enter") {

            if (this.state.resource_IntellisenseHeaderSearchIndex > 0) {
                this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex)].className = "resource_Intellisense";
                this.refs["headerSearch_Input"].value = this.refs["resource_Intellisense_Value_" + this.state.resource_IntellisenseHeaderSearchIndex].defaultValue;
            }
            this.setState({
                resource_IntellisenseHeaderSearchIndex: 0
            })
            var inputValue = this.refs["headerSearch_Input"].value.toString();

            var history = this.state.user_SearchHistory;

            history = Object.values(history).filter(value => (value).toString().toLowerCase() != inputValue.toLowerCase());

            history.push(inputValue);

            this.setState({ user_SearchHistory: history });

            if (this.state.resource_IntellisenseHeaderSearchIndex > 0) {
                if (this.refs["resource_Intellisense_Type_" + this.state.resource_IntellisenseHeaderSearchIndex].defaultValue == "singleResult") {
                    this._showSingleResult(this.refs["resource_Intellisense_ExternalId_" + this.state.resource_IntellisenseHeaderSearchIndex].defaultValue, this.refs["resource_Intellisense_Value_" + this.state.resource_IntellisenseHeaderSearchIndex].defaultValue);
                }
                else if (this.refs["resource_Intellisense_Type_" + this.state.resource_IntellisenseHeaderSearchIndex].defaultValue == "history") {
                    this._headerSearchTermUpdated();
                    this._beginSearch();
                }
            }
        }
        else if (key == "ArrowUp NEED TO FIX GOES IN ODD ORDER") {
            if ((this.state.resource_IntellisenseHeaderSearchIndex - 1) >= 0) {
                if (this.state.resource_IntellisenseHeaderSearchIndex != 0) {
                    this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex).toString()].className = "resource_Intellisense";
                }
                if (this.state.resource_IntellisenseHeaderSearchIndex - 1 != 0) {
                    this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex - 1).toString()].className = "resource_Intellisense_Selected";
                    this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex - 1).toString()].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    console.log(this.refs["resource_Intellisense_Value_" + (this.state.resource_IntellisenseHeaderSearchIndex - 1).toString()].defaultValue);

                }

                this.setState({
                    resource_IntellisenseHeaderSearchIndex: (this.state.resource_IntellisenseHeaderSearchIndex - 1)
                })
            }
        }
        else if (key == "ArrowDown NEED TO FIX GOES IN ODD ORDER") {
            if ((this.state.resource_IntellisenseHeaderSearchIndex + 1) <= this.refs["intellisenseCount"].value) {
                if (this.state.resource_IntellisenseHeaderSearchIndex != 0) {
                    this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex).toString()].className = "resource_Intellisense";
                }
                this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex + 1).toString()].className = "resource_Intellisense_Selected";
                this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex + 1).toString()].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                console.log(this.refs["resource_Intellisense_Value_" + (this.state.resource_IntellisenseHeaderSearchIndex + 1).toString()].defaultValue);

                this.setState({
                    resource_IntellisenseHeaderSearchIndex: (this.state.resource_IntellisenseHeaderSearchIndex + 1)
                })
            }
        }
        else if (key == "ArrowLeft" || key == "ArrowRight") {
        }
        else {
            if (this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex).toString()] != undefined) {
                this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex).toString()].className = "resource_Intellisense";
            }
            this.setState({
                resource_IntellisenseHeaderSearchIndex: 0,
                resource_IntellisenseHeaderMouseOverIndex: 0
            })
        }
    }

    _handleBodyKeyDown(key) {
        /*
         TODO: Resolve issue with refs when going up and down.
         Need to find a way to index all
         */
    }

    _hideHeaderIntellisense() {
        if (this.refs["intellisenseHeaderListInfo_Container"] != undefined) {
            this.refs["intellisenseHeaderListInfo_Container"].className = "intellisenseHeaderListInfo_Hidden";
            this.refs["headerSearch_Input"].className = "headerSearch_Input_Hidden";
            this.refs["logoSubmit"].className = "logoSubmit_Hidden fal fa-arrow-alt-right";
        }

        if (this.state.resource_IntellisenseHeaderSearchIndex != 0) {
            this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderSearchIndex)].className = "resource_Intellisense";
            this.setState({
                resource_IntellisenseHeaderSearchIndex: 0
            })
        }


        if (this.state.resource_IntellisenseHeaderMouseOverIndex != 0) {
            this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderMouseOverIndex)].className = "resource_Intellisense";
            this.refs["headerSearch_Input"].value = this.state.resource_IntellisenseHeaderMouseOverValue;

            var inputValue = this.state.resource_IntellisenseHeaderMouseOverValue;;

            var history = this.state.user_SearchHistory;

            history = Object.values(history).filter(value => (value).toString().toLowerCase() != inputValue.toLowerCase());

            history.push(inputValue);

            this.setState({
                user_SearchHistory: history
            });

            this._headerSearchTermUpdated();
            this._beginSearch();
        }

    }

    _showHeaderIntellisense() {
        if (this.refs["intellisenseHeaderListInfo_Container"] != undefined) {
            this.refs["intellisenseHeaderListInfo_Container"].className = "intellisenseHeaderListInfo_Container";
            this.refs["headerSearch_Input"].className = "headerSearch_Input";
            this.refs["logoSubmit"].className = "logoSubmit fal fa-arrow-alt-right";
        }
        this.refs["intellisenseTop"].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        this.setState({
            resource_IntellisenseHeaderSearchIndex: 0,
            resource_IntellisenseHeaderMouseOverIndex: 0
        })
    }

    _handleSimilarMouseClick(value) {

        this._hideOverlays();

        this.refs["headerSearch_Input"].value = value;

        var inputValue = value;

        var history = this.state.user_SearchHistory;

        history = Object.values(history).filter(value => (value).toString().toLowerCase() != inputValue.toLowerCase());

        history.push(inputValue);

        this.setState({
            user_SearchHistory: history
        });

        this._headerSearchTermUpdated();
        this._beginSearch();

    }

    _filterResources(value) {

        this.setState({
            filterReportType: "",
            filterResourceType: value
        });

    }

    _filterReports(value) {
        if (value == "") {
            this.setState({
                filterReportType: "",
                filterResourceType: "Report & Report Category",
                filterQRSYear: ""
            });
        }
        else {
            this.setState({
                filterReportType: value,
                filterResourceType: "Report",
                filterQRSYear: ""
            });
        }
    }

    _filterQRSYears(value) {
        if (value == "") {
            this.setState({
                filterQRSYear: ""
            });
        }
        else {
            this.setState({
                filterResourceType: "Quality & Research Symposium",
                filterQRSYear: value
            });
        }
    }

    _filterRanks(value) {
        if (value == "") {
            this.setState({
                filterRankType: ""
            });
        }
        else {
            this.setState({
                filterRankType: value
            });
        }
    }

    _handleMouseOver(mouseOverIndex, value) {
        this.setState({
            resource_IntellisenseHeaderMouseOverIndex: mouseOverIndex,
            resource_IntellisenseHeaderMouseOverValue: value
        })
        console.log(mouseOverIndex);
        console.log(value);
    }

    _handleMouseOut() {
        this.setState({
            resource_IntellisenseHeaderMouseOverIndex: 0,
            resource_IntellisenseHeaderMouseOverValue: ""
        })
        console.log(0);
        console.log("");
    }

    _handleMouseClick() {

        this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderMouseOverIndex)].className = "resource_Intellisense";
        this.refs["headerSearch_Input"].value = this.state.resource_IntellisenseHeaderMouseOverValue;

        var inputValue = this.state.resource_IntellisenseHeaderMouseOverValue;

        var history = this.state.user_SearchHistory;

        history = Object.values(history).filter(value => (value).toString().toLowerCase() != inputValue.toLowerCase());

        history.push(inputValue);

        this.setState({
            user_SearchHistory: history
        });

        this._headerSearchTermUpdated();
        this._beginSearch();

    }


    _handleSingleResultMouseClick(externalId, resrouceName) {

        this.refs["resource_Intellisense_" + (this.state.resource_IntellisenseHeaderMouseOverIndex)].className = "resource_Intellisense";
        this.refs["headerSearch_Input"].value = this.state.resource_IntellisenseHeaderMouseOverValue;

        var inputValue = this.state.resource_IntellisenseHeaderMouseOverValue;

        var history = this.state.user_SearchHistory;

        history = Object.values(history).filter(value => (value).toString().toLowerCase() != inputValue.toLowerCase());

        history.push(inputValue);

        this.setState({
            user_SearchHistory: history
        });

        this._showSingleResultWithSearch(externalId, resrouceName, resrouceName);

    }



    _updateTimeBasedTheme() {
        var theme = this.state.user_Theme;
        var date = new Date();
        var hours = date.getHours();
        switch (hours) {
            case (0):
            case (1):
            case (2):
            case (3):
            case (4):
                //latenight shift
                this.refs["Home"].className = "Home " + theme + " Latenight";
                break;
            case (5):
            case (6):
            case (7):
            case (8):
                //dawn
                this.refs["Home"].className = "Home " + theme + " Dawn";
                break;
            case (9):
            case (10):
            case (11):
                //morning
                this.refs["Home"].className = "Home " + theme + " Morning";
                break;
            case (12):
                //noon
                this.refs["Home"].className = "Home " + theme + " Noon";
                break;
            case (13):
            case (14):
            case (15):
                //afternoon
                this.refs["Home"].className = "Home " + theme + " Afternoon";
                break;
            case (16):
            case (17):
                //evening
                this.refs["Home"].className = "Home " + theme + " Evening";
                break;
            case (18):
            case (19):
                //dusk
                this.refs["Home"].className = "Home " + theme + " Dusk";
                break;
            case (20):
            case (21):
            case (22):
            case (23):
                //dusk
                this.refs["Home"].className = "Home " + theme + " Night";
                break;

        }

        setTimeout(() => {
            this._updateTimeBasedTheme();
        }, 50000);
    }



    _resourceIntellisenseClicked() {

    }

    _resourceHistoryClicked() {

    }


    _hideBodyIntellisense() {
    }

    _showBodyIntellisense() {
    }

    _updateActionPlanItem() {
        if (this.refs["actionPlanItemChanger"].value != "") {

            this.refs["actionPlanItem_Goal_Title"].className = "hidden";
            this.refs["actionPlanItem_Goal_Description"].className = "hidden";
            this.refs["actionPlanItem_Goal_EstCompletionDate"].className = "hidden";


            this.refs["actionPlanItem_Action_LinkedGoal"].className = "hidden";
            this.refs["actionPlanItem_Action_Title"].className = "hidden";
            this.refs["actionPlanItem_Action_Description"].className = "hidden";
            this.refs["actionPlanItem_Action_NumHoursExpected"].className = "hidden";


            this.refs["actionPlanItem_Log_LinkedGoal"].className = "hidden";
            this.refs["actionPlanItem_Log_LinkedAction"].className = "hidden";
            this.refs["actionPlanItem_Log_NumHoursExpected"].className = "hidden";
            this.refs["actionPlanItem_Log_Description"].className = "hidden";


            this.refs["actionPlanItem_Team_LinkedUser"].className = "hidden";
            this.refs["actionPlanItem_Team_Designation"].className = "hidden";



            this.setState({
                resource_addActionPlanItem_ItemType: this.refs["actionPlanItemChanger"].value
            });


            switch (this.refs["actionPlanItemChanger"].value) {
                case ("LinkedResource"):
                    break;
                case ("Goal"):
                    this.refs["actionPlanItem_Goal_Title"].className = "";
                    this.refs["actionPlanItem_Goal_Description"].className = "";
                    this.refs["actionPlanItem_Goal_EstCompletionDate"].className = "";
                    break;
                case ("Action"):
                    this.refs["actionPlanItem_Action_LinkedGoal"].className = "";
                    this.refs["actionPlanItem_Action_Title"].className = "";
                    this.refs["actionPlanItem_Action_Description"].className = "";
                    this.refs["actionPlanItem_Action_NumHoursExpected"].className = "";
                    break;
                case ("Log"):
                    this.refs["actionPlanItem_Log_LinkedGoal"].className = "";
                    this.refs["actionPlanItem_Log_LinkedAction"].className = "";
                    this.refs["actionPlanItem_Log_NumHoursExpected"].className = "";
                    this.refs["actionPlanItem_Log_Description"].className = "";
                    break;
                case ("Team"):
                    this.refs["actionPlanItem_Team_LinkedUser"].className = "";
                    this.refs["actionPlanItem_Team_Designation"].className = "";
                    break;
            }

        }
        else {
            //hide all
        }
    }

    _updateTheme() {
        this._hideOverlays();

        var theme = this.state.user_Theme;
        var date = new Date();
        var hours = date.getHours();
        switch (hours) {
            case (0):
            case (1):
            case (2):
            case (3):
            case (4):
                //latenight shift
                this.refs["Home"].className = "Home " + theme + " Latenight";
                break;
            case (5):
            case (6):
            case (7):
            case (8):
                //dawn
                this.refs["Home"].className = "Home " + theme + " Dawn";
                break;
            case (9):
            case (10):
            case (11):
                //morning
                this.refs["Home"].className = "Home " + theme + " Morning";
                break;
            case (12):
                //noon
                this.refs["Home"].className = "Home " + theme + " Noon";
                break;
            case (13):
            case (14):
            case (15):
                //afternoon
                this.refs["Home"].className = "Home " + theme + " Afternoon";
                break;
            case (16):
            case (17):
                //evening
                this.refs["Home"].className = "Home " + theme + " Evening";
                break;
            case (18):
            case (19):
                //dusk
                this.refs["Home"].className = "Home " + theme + " Dusk";
                break;
            case (20):
            case (21):
            case (22):
            case (23):
                //dusk
                this.refs["Home"].className = "Home " + theme + " Night";
                break;

        }

        Actions.updateUserThemeInfo(this.state.user_AccountInfo.idUser, this.refs["themeChanger"].value);
    }

    _toggleMenu() {
        this._hideOverlays();
        if (this.refs["menu_overlay"].className == "menu_expanded" || this.refs["menu_overlay"].className == "menu_expanded_admin") {
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
        }
        else {
            if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator" && !this.state.isEpicUser) || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev'))) {
                this.refs["menu_overlay"].className = "menu_expanded_admin";
            }
            else {
                this.refs["menu_overlay"].className = "menu_expanded";
            }
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu_Selected fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";


            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }



    _toggleWeather() {
        this._hideOverlays();
        if (this.refs["weather_overlay"].className == "weather_expanded") {
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["overlay"].className = "overlay_hidden";
        }
        else {
            this.refs["weather_overlay"].className = "weather_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleMode() {
        this._hideOverlays();
        if (this.refs["mode_overlay"].className == "mode_expanded") {
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["overlay"].className = "overlay_hidden";
        }
        else {
            this.refs["mode_overlay"].className = "mode_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }


    _toggleProfile() {
        this._hideOverlays();
        if (this.refs["profile_overlay"].className == "profile_expanded") {
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
        }
        else {
            this.refs["profile_overlay"].className = "profile_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information_Selected";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleFavorites() {
        this._hideOverlays();
        if (this.refs["favorites_overlay"].className == "favorites_expanded") {
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
        }
        else {
            this.refs["favorites_overlay"].className = "favorites_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites_Selected fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";


            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }

            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleTop10() {
        this._hideOverlays();
        if (this.refs["top10_overlay"].className == "top10_expanded") {
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";

        }
        else {
            this.refs["top10_overlay"].className = "top10_expanded";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10_Selected fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }


    _toggleShared() {
        this._hideOverlays();

        if (this.refs["shared_overlay"].className == "shared_expanded") {
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";

        }
        else {
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["shared_overlay"].className = "shared_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["logoShared"].className = "logoShared_Selected fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleTopRated10() {
        this._hideOverlays();

        if (this.refs["topRated10_overlay"].className == "topRated10_expanded") {
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";

        }
        else {
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_expanded";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoTopRated10"].className = "logoTopRated10_Selected fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleTopTags() {
        this._hideOverlays();

        if (this.refs["topTags_overlay"].className == "topTags_expanded") {
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";

        }
        else {
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags_Selected fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";

            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleSupport() {
        this._hideOverlays();

        if (this.refs["support_overlay"].className == "support_expanded") {
            this.refs["support_overlay"].className = "support_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";

        }
        else {
            this.refs["support_overlay"].className = "support_expanded";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoSupport"].className = "logoSupport_Selected fal fa-question-circle";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _toggleUpload() {
        this._hideOverlays();

        if (this.refs["upload_overlay"].className == "upload_expanded") {
            this.refs["upload_overlay"].className = "upload_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";

        }
        else {
            this.refs["upload_overlay"].className = "upload_expanded";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["logoUpload"].className = "logoUpload_Selected fal fa-cloud-arrow-up";
            this.refs["support_overlay"].className = "support_hidden";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
        }
    }

    _toggleNewest10() {
        this._hideOverlays();

        if (this.refs["newest10_overlay"].className == "newest10_expanded") {
            this.refs["newest10_overlay"].className = "newest10_hidden";
            this.refs["overlay"].className = "overlay_hidden";
            this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
        }
        else {
            this.refs["newest10_overlay"].className = "newest10_expanded";
            this.refs["overlay"].className = "overlay_expanded";
            this.refs["profile_overlay"].className = "profile_hidden";
            this.refs["menu_overlay"].className = "menu_hidden";
            this.refs["mode_overlay"].className = "mode_hidden";
            this.refs["favorites_overlay"].className = "favorites_hidden";
            this.refs["weather_overlay"].className = "weather_hidden";
            this.refs["top10_overlay"].className = "top10_hidden";
            this.refs["topRated10_overlay"].className = "topRated10_hidden";
            this.refs["topTags_overlay"].className = "topTags_hidden";
            this.refs["shared_overlay"].className = "shared_hidden";
            this.refs["logoShared"].className = "logoShared fal fa-handshake";
            this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
            this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
            this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
            this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
            this.refs["logoNewest10"].className = "logoNewest10_Selected fal fa-newspaper";
            this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
            this.refs["logoMenu"].className = "logoMenu fal fa-bars";
            this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
            this.refs["support_overlay"].className = "support_hidden";
            if (!this.state.isHyperDriveUser) {
                this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
            }
            this.refs["upload_overlay"].className = "upload_hidden";
        }
    }

    _showLayoutSelectorLeft() {
        if (this.refs["layoutSelectionLeft"].className == "layoutSelection") {
            this._hideOverlays();
        }
        else {
            this._hideOverlays();
            this.refs["layoutSelectionLeft"].className = "layoutSelection";
            this.refs["overlay"].className = "overlay_expanded";
        }
    }

    _updateResourceType() {
        if (this.refs["edit_singleResource_ResourceType"].value == "Report") {
            this.refs["edit_singleResource_ReportType"].value = "";
            this.refs["edit_singleResource_ReportType"].className = "edit_singleResource_ReportType";
            this.refs["singleResource_ReportType_dash"].className = "singleResource_ReportType_dash";
            this.refs["edit_singleResource_ReportType"].value = "";
            this.refs["editReportLocationText"].innerHTML = "Report Location";
            this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
            this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
            this.refs["edit_singleResource_ReportLocation"].placeholder = "Please Enter a Report Type";
        }
        else if (this.refs["edit_singleResource_ResourceType"].value == "Quality & Research Symposium") {
            this.refs["edit_singleResource_ReportType"].value = "";
            this.refs["edit_singleResource_ReportType"].className = "hidden";
            this.refs["edit_singleResource_ReportType_dash"].className = "hidden";
            this.refs["edit_singleResource_QRSYear"].value = "";
            this.refs["edit_singleResource_QRSYear"].className = "edit_singleResource_QRSYear";
            this.refs["edit_singleResource_QRSYear_dash"].className = "edit_singleResource_QRSYear_dash";
            this.refs["singleResultButton_edit_Preview"].className = "hidden";
            this.refs["singleResultButton_edit_SaveChanges"].className = "singleResultButton_Create singleButton";
            this.refs["edit_singleResource_ReportLocation_Container"].className = "hidden";
        }
        else {
            this.refs["edit_singleResource_ReportType"].value = "";
            this.refs["edit_singleResource_ReportType"].className = "hidden";
            this.refs["singleResource_ReportType_dash"].className = "hidden";
            this.refs["editReportLocationText"].innerHTML = "Report Location";
            this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
            this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
            this.refs["edit_singleResource_ReportLocation"].placeholder = "Please Enter a Report Type";
        }
    }

    _updateReportType() {
        this.setState({
            resource_editReportType: this.refs["edit_singleResource_ReportType"].value
        });
        if (this.refs["edit_singleResource_ReportType"].value != "") {
            this.refs["edit_singleResource_ReportLocation_Container"].className = "edit_singleResource_ReportLocation_Container";

            if (this.refs["edit_singleResource_ReportType"].value == "Excel Dashboard") {
                this.refs["editReportLocationText"].innerHTML = "Report Location";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\junkview_reports\\AR_Report\\AR_Report.xlsm";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "File") {
                this.refs["editReportLocationText"].innerHTML = "Network Location";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "\\\\aamcqlikview\\Tutorial\\Qlikview-Word-Basics.doc";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Website") {
                this.refs["editReportLocationText"].innerHTML = "Website URL";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "https://webappstest.aahs.org/ProviderGeo/";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Microsoft Report") {
                this.refs["editReportLocationText"].innerHTML = "Network Location";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\Decision_Support\\AAMC_Summary_Shoulder_Replacement_Metrics.pdf";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Qlikview Dashboard") {
                this.refs["editReportLocationText"].innerHTML = "Website URL";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "http://aamcqlikview/QvAJAXZfc/opendoc.htm?document=Outpatient.qvw&amp;host=QVS%40aamcqlikview";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Qliksense Application") {
                this.refs["editReportLocationText"].innerHTML = "Website URL";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "https://dataviz.aahs.org/sense/app/eb9edb7c-a64f-4c66-abd1-35a48c39a728/overview";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Radar Dashboard") {
                this.refs["editReportLocationText"].innerHTML = "Epic IDM Number";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "100022";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Epic-Slicer Dicer") {
                this.refs["editReportLocationText"].innerHTML = "Epic Record ID";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "1";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Epic-Crystal Report") {
                this.refs["editReportLocationText"].innerHTML = "HGR | HGT | Report Name";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "";
                this.refs["edit_singleResource_ReportLocation"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "edit_singleResource_ReportLocation_MultiReport";
            }
            else if (this.refs["edit_singleResource_ReportType"].value == "Reporting Workbench") {
                this.refs["editReportLocationText"].innerHTML = "HGR | HGT | Report Name";
                this.refs["edit_singleResource_ReportLocation"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "edit_singleResource_ReportLocation_MultiReport";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "";
            }
            else {
                this.refs["editReportLocationText"].innerHTML = "Report Location";
                this.refs["edit_singleResource_ReportLocation"].className = "edit_singleResource_ReportLocation";
                this.refs["edit_singleResource_ReportLocation_MultiReport"].className = "hidden";
                this.refs["edit_singleResource_ReportLocation"].placeholder = "";
            }
        }
        else {
            this.refs["edit_singleResource_ReportLocation_Container"].className = "hidden";
        }
    }



    _updateQRSYear() {
        this.setState({
            resource_editQRSYear: this.refs["edit_singleResource_QRSYear"].value
        });
        if (this.refs["edit_singleResource_QRSYear"].value != "") {

        }
        else {

        }
    }


    _updateCreateResourceType() {
        if (this.refs["create_singleResource_ResourceType"].value == "Report") {
            this.refs["create_singleResource_ReportType"].value = "";
            this.refs["create_singleResource_ReportType"].className = "create_singleResource_ReportType";
            this.refs["create_singleResource_ReportType_dash"].className = "create_singleResource_ReportType_dash";
            this.refs["create_singleResource_QRSYear"].value = "";
            this.refs["create_singleResource_QRSYear"].className = "hidden";
            this.refs["create_singleResource_QRSYear_dash"].className = "hidden";
            this.refs["singleResultButton_Create_Preview"].className = "hidden";
            this.refs["create_singleResource_ReportType"].value = "";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create singleButton";
            this.refs["create_singleResource_ReportLocation_Container"].className = "hidden";
        }
        else if (this.refs["create_singleResource_ResourceType"].value == "Quality & Research Symposium") {
            this.refs["create_singleResource_ReportType"].value = "";
            this.refs["create_singleResource_ReportType"].className = "hidden";
            this.refs["create_singleResource_ReportType_dash"].className = "hidden";
            this.refs["create_singleResource_QRSYear"].value = "";
            this.refs["create_singleResource_QRSYear"].className = "create_singleResource_QRSYear";
            this.refs["create_singleResource_QRSYear_dash"].className = "create_singleResource_QRSYear_dash";
            this.refs["singleResultButton_Create_Preview"].className = "hidden";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create singleButton";
            this.refs["create_singleResource_ReportLocation_Container"].className = "hidden";

            this.refs["singleResultButton_Create_Preview"].className = "singleResultButton_Create";
            this.refs["create_singleResource_ReportLocation_Container"].className = "create_singleResource_ReportLocation_Container";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create";
        }
        else {
            this.refs["create_singleResource_ReportType"].value = "";
            this.refs["create_singleResource_ReportType"].className = "hidden";
            this.refs["create_singleResource_ReportType_dash"].className = "hidden";
            this.refs["create_singleResource_QRSYear"].value = "";
            this.refs["create_singleResource_QRSYear"].className = "hidden";
            this.refs["create_singleResource_QRSYear_dash"].className = "hidden";
            this.refs["singleResultButton_Create_Preview"].className = "hidden";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create singleButton";
            this.refs["create_singleResource_ReportLocation_Container"].className = "hidden";
        }
    }

    _updateCreateReportType() {

        this.setState({
            resource_createReportType: this.refs["create_singleResource_ReportType"].value
        });
        if (this.refs["create_singleResource_ReportType"].value != "") {
            this.refs["singleResultButton_Create_Preview"].className = "singleResultButton_Create";
            this.refs["create_singleResource_ReportLocation_Container"].className = "create_singleResource_ReportLocation_Container";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create";

        }
        else {
            this.refs["singleResultButton_Create_Preview"].className = "hidden";
            this.refs["create_singleResource_ReportLocation_Container"].className = "hidden";
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create singleButton";
        }
    }


    _updateCreateQRSYear() {

        this.setState({
            resource_createQRSYear: this.refs["create_singleResource_QRSYear"].value
        });
        if (this.refs["create_singleResource_QRSYear"].value != "") {
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create";
        }
        else {
            this.refs["singleResultButton_Create_SaveChanges"].className = "singleResultButton_Create singleButton";
        }
    }


    _updateLayoutSelectorLeft(layoutName) {
        this._showLayoutSelectorLeft();
        this.setState({
            user_LayoutLeft: layoutName
        });
        Actions.updateLayoutContentInfo(this.state.user_AccountInfo.idUser, layoutName, this.state.user_LayoutMiddle, this.state.user_LayoutRight, this.state.user_InterfaceColumns)

    }


    _updateLayoutSelectorMiddle(layoutName) {
        this._showLayoutSelectorMiddle();
        this.setState({
            user_LayoutMiddle: layoutName
        });

        Actions.updateLayoutContentInfo(this.state.user_AccountInfo.idUser, this.state.user_LayoutLeft, layoutName, this.state.user_LayoutRight, this.state.user_InterfaceColumns)
    }


    _updateLayoutSelectorRight(layoutName) {
        this._showLayoutSelectorRight();
        this.setState({
            user_LayoutRight: layoutName
        });

        Actions.updateLayoutContentInfo(this.state.user_AccountInfo.idUser, this.state.user_LayoutLeft, this.state.user_LayoutMiddle, layoutName, this.state.user_InterfaceColumns)

    }

    _updateLayoutInterfaceColumns(interfaceColumns) {

        this.setState({
            user_InterfaceColumns: interfaceColumns
        });

        Actions.updateLayoutContentInfo(this.state.user_AccountInfo.idUser, this.state.user_LayoutLeft, this.state.user_LayoutMiddle, this.state.user_LayoutRight, interfaceColumns)

    }

    _showLayoutSelectorMiddle() {
        if (this.refs["layoutSelectionMiddle"].className == "layoutSelection") {
            this._hideOverlays();
        }
        else {
            this._hideOverlays();
            this.refs["layoutSelectionMiddle"].className = "layoutSelection";
            this.refs["overlay"].className = "overlay_expanded";
        }
    }


    _showLayoutSelectorRight() {
        if (this.refs["layoutSelectionRight"].className == "layoutSelection") {
            this._hideOverlays();
        }
        else {
            this._hideOverlays();
            this.refs["layoutSelectionRight"].className = "layoutSelection";
            this.refs["overlay"].className = "overlay_expanded";
        }
    }
    _noEditMode() {

        this._hideOverlays();
        this._editMode(false);
        alert("Cannot edit this resource directly.");
    }



    _editFileMode(enableDisableFlag) {

        this._hideOverlays();

        if (enableDisableFlag) {
            this.refs["resource_body_singleResult"].className = "edit_singleResource_Body";
            this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML = this.refs["singleResource_ContentBody_Description_HTML"].innerHTML;

            this.refs["edit_singleResource_ReportType"].value = this.refs["singleResource_ReportType"].innerHTML;
            this.refs["edit_singleResource_ReportLocation"].value = this.refs["singleResource_ReportLocation"].innerHTML;
            this.refs["edit_singleResource_ResourceType"].value = this.refs["singleResource_ResourceType"].innerHTML;
            this.refs["edit_singleResource_ResourceName"].value = this.refs["singleResource_ResourceName"].innerHTML;
            this.refs["edit_externalStatusChanger"].value = this.refs["edit_detailsExternalStatusLabel"].innerHTML;
            if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Disabled") {
                this.refs["edit_syncsExternallyChanger"].value = "False";
            }
            else if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Enabled") {
                this.refs["edit_syncsExternallyChanger"].value = "True";
            }
            this.refs["edit_singleResource_Rank"].value = this.refs["edit_detailsResourceRankLabel_Text"].innerHTML;

            this.setState({
                resource_editMode: true,
                resource_editFileMode: true
            })
        }
        else {
            this.refs["resource_body_singleResult"].className = "singleResource_Body";

            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
        }

    }

    _editMode(enableDisableFlag) {

        this._hideOverlays();

        if (enableDisableFlag) {
            this.refs["resource_body_singleResult"].className = "edit_singleResource_Body";
            this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML = this.refs["singleResource_ContentBody_Description_HTML"].innerHTML;

            this.refs["edit_singleResource_ReportType"].value = this.refs["singleResource_ReportType"].innerHTML;
            this.refs["edit_singleResource_ReportLocation"].value = this.refs["singleResource_ReportLocation"].innerHTML;
            this.refs["edit_singleResource_ResourceType"].value = this.refs["singleResource_ResourceType"].innerHTML;
            this.refs["edit_singleResource_ResourceName"].value = this.refs["singleResource_ResourceName"].innerHTML;
            this.refs["edit_externalStatusChanger"].value = this.refs["edit_detailsExternalStatusLabel"].innerHTML;
            if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Disabled") {
                this.refs["edit_syncsExternallyChanger"].value = "False";
            }
            else if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Enabled") {
                this.refs["edit_syncsExternallyChanger"].value = "True";
            }
            this.refs["edit_singleResource_Rank"].value = this.refs["edit_detailsResourceRankLabel_Text"].innerHTML;

            this.setState({
                resource_editMode: true,
                resource_editFileMode: false
            })
        }
        else {
            this.refs["resource_body_singleResult"].className = "singleResource_Body";

            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
        }

    }

    _saveResourceChanges() {
        var changeCount = 0;
        var originalLocations = this.refs["singleResource_ReportLocation"].innerHTML;
        var newLocations = "";

        //ATTEMPT TO SET ORIGINAL CONTENT
        if (this.refs["edit_singleResource_ResourceName"].value != this.refs["singleResource_ResourceName"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_singleResource_Rank"].value != this.refs["edit_detailsResourceRankLabel_Text"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_singleResource_ResourceType"].value != this.refs["singleResource_ResourceType"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_singleResource_ResourceType"].value == "Report") {
            if (this.refs["edit_singleResource_ReportType"].value != this.refs["singleResource_ReportType"].innerHTML) {
                changeCount++;
            }
        }

        if (this.refs["edit_singleResource_ResourceType"].value == "Quality & Research Symposium") {
            if (this.refs["edit_singleResource_QRSYear"].value != this.refs["singleResource_QRSYear"].innerHTML) {
                changeCount++;
            }
        }

        if (this.refs["edit_singleResource_ReportLocation"].value != this.refs["singleResource_ReportLocation"].innerHTML) {
            changeCount++;
        }

        if (this.refs["singleResource_Editor"].currentContent != this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML) {
            changeCount++;
        }

        if (this.refs["userCreatorChanger"].value != this.refs["detailsCreatedByLabel"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_externalStatusChanger"].value != this.refs["edit_detailsExternalStatusLabel"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_syncsExternallyChanger"].value != this.refs["edit_detailsSyncResourcesLabel"].innerHTML) {
            changeCount++;
        }
        if (this.refs["edit_singleResource_ResourceType"].value == "Report" && (this.refs["edit_singleResource_ReportType"].value == "Reporting Workbench" || this.refs["edit_singleResource_ReportType"].value == "Epic-Crystal Report")) {
            if (this.refs["edit_singleResource_ReportLocation_Count"].value >= 0) {

                for (var iterator = 1; iterator <= this.refs["edit_singleResource_ReportLocation_Count"].value; iterator++) {

                    if (iterator > 1) {
                        newLocations = newLocations + "~";
                    }

                    newLocations = "HGR:" + this.refs["edit_singleResource_ReportLocation_HGR_" + iterator].value + "|HGT:" + this.refs["edit_singleResource_ReportLocation_HGT_" + iterator].value + "|NAME:" + this.refs["edit_singleResource_ReportLocation_NAME_" + iterator].value;

                }

            }
            if (originalLocations != newLocations) {
                changeCount++;
            }
        }

        //ORIGINALCONTENT
        //alert(this.refs["singleResource_Editor"].currentContent);
        //UPDATEDCONTENT
        //alert(this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML)

        if (changeCount > 0) {
            if (window.confirm("Are you sure you would like to update / unsync this resource?")) {
                this.refs["singleResource_ResourceName"].innerHTML = this.refs["edit_singleResource_ResourceName"].value;

                this.refs["singleResource_ResourceType"].innerHTML = this.refs["edit_singleResource_ResourceType"].value;
                this.refs["edit_detailsSyncResourcesLabel"].innerHTML = "Disabled";
                this.refs["edit_detailsSyncResourcesLabel"].className = "edit_detailsSyncResourcesLabel DisabledSync";
                this.refs["edit_detailsExternalStatusLabel"].innerHTML = this.refs["edit_externalStatusChanger"].value;
                if (this.refs["edit_singleResource_ResourceType"].value == "Report") {
                    if (this.refs["edit_singleResource_ReportType"].value.length > 0) {

                        this.refs["singleResource_ReportType"].innerHTML = this.refs["edit_singleResource_ReportType"].value;
                        this.refs["singleResource_ReportTypeDash"].innerHTML = "-";
                        if (this.refs["edit_singleResource_ReportType"].value == "Reporting Workbench" || this.refs["edit_singleResource_ReportType"].value == "Epic-Crystal Report") {
                            this.refs["singleResource_ReportLocation"].innerHTML = newLocations;
                        }
                        else if (this.refs["edit_singleResource_ReportType"].value == "Radar Dashboard") {
                            this.refs["singleResource_ReportLocation"].innerHTML = this.refs["edit_singleResource_ReportLocation"].value;
                            newLocations = "IDM:" + this.refs["edit_singleResource_ReportLocation"].value;
                        }
                        else {
                            this.refs["singleResource_ReportLocation"].innerHTML = this.refs["edit_singleResource_ReportLocation"].value;
                            newLocations = this.refs["edit_singleResource_ReportLocation"].value;
                        }

                    }
                    else {
                        this.refs["singleResource_ReportType"].innerHTML = "";
                        this.refs["singleResource_ReportLocation"].innerHTML = "";
                        newLocations = "";
                    }
                }
                else if (this.refs["edit_singleResource_ResourceType"].value == "Quality & Research Symposium") {
                    this.refs["singleResource_ReportLocation"].innerHTML = this.refs["edit_singleResource_ReportLocation"].value;
                    newLocations = this.refs["edit_singleResource_ReportLocation"].value;
                }
                else {
                    this.refs["singleResource_ReportType"].innerHTML = "";
                    this.refs["singleResource_ReportTypeDash"].innerHTML = "";
                    this.refs["singleResource_ReportLocation"].innerHTML = "";
                    newLocations = "";
                }
                if (this.refs["edit_singleResource_ResourceType"].value == "Quality & Research Symposium") {
                    if (this.refs["edit_singleResource_QRSYear"].value.length > 0) {

                        this.refs["singleResource_QRSYear"].innerHTML = this.refs["edit_singleResource_QRSYear"].value;
                        this.refs["singleResource_QRSYearDash"].innerHTML = "-";
                    }
                    else {
                        this.refs["singleResource_QRSYear"].innerHTML = "";
                    }
                }
                else {
                    this.refs["singleResource_QRSYear"].innerHTML = "";
                    this.refs["singleResource_QRSYearDash"].innerHTML = "";
                }
                this.refs["singleResource_ContentBody_Description_HTML"].innerHTML = this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML;
                if (this.refs["edit_singleResource_Rank"].value == "") {
                    this.refs["edit_detailsResourceRankLabel_Text"].innerHTML = "None";
                    this.refs["edit_detailsResourceRankLabel_Icon"].className = "rankIcon_None";

                }
                else {
                    this.refs["edit_detailsResourceRankLabel_Text"].innerHTML = this.refs["edit_singleResource_Rank"].value;
                    this.refs["edit_detailsResourceRankLabel_Icon"].className = "rankIcon_" + this.refs["edit_singleResource_Rank"].value;
                }

                if (this.refs["edit_singleResource_Rank"].value == "") {
                    this.refs["singleResource_RankContainer"].className = "singleResource_NoRankContainer";
                    this.refs["largeRankIcon"].className = "largeRankIcon__None";
                    this.refs["rankFontAwesomeIcon"].className = "";
                }
                else {
                    this.refs["singleResource_RankContainer"].className = "singleResource_RankContainer";
                    this.refs["largeRankIcon"].className = "largeRankIcon_" + this.refs["edit_singleResource_Rank"].value;
                    this.refs["rankFontAwesomeIcon"].className = "fal fa-trophy";
                }


                //NEED TO UPDATE TO ALLOW FOR US TO PASS THE REPORT LOCATION, REPORT STATUS
                Actions.modifySingleResource(this.state.singleResult, this.refs["edit_singleResource_ResourceName"].value, this.refs["edit_singleResource_ResourceType"].value, this.refs["edit_singleResource_ReportType"].value, this.refs["edit_singleResource_QRSYear"].value, newLocations, this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML, (this.refs["userCreatorChanger"].value).split(" ")[0], (this.refs["userCreatorChanger"].value).split(" ")[1], this.state.user_AccountInfo.firstName, this.state.user_AccountInfo.lastName, this.refs["edit_externalStatusChanger"].value, this.refs["edit_singleResource_Rank"].value)

                if (this.state.siteMode == "databayccnprd" || this.state.siteMode == "databayccndev") {

                    var epoch_CCNFY18HCIPDateCompleted = "";
                    if ((this.refs["edit_singleResource_CCNFY18HCIPDateCompleted"].value).length > 0) {
                        epoch_CCNFY18HCIPDateCompleted = ((new Date(this.refs["edit_singleResource_CCNFY18HCIPDateCompleted"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNFY18HCIPDateCompleted"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNFY18HCIPDateCompleted"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY18HCIPDateCompleted))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY18HCIPDateCompleted))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY18HCIPDateCompleted))).getUTCFullYear());
                    }
                    else {
                        this.refs["singleResource_CCNFY18HCIPDateCompleted"].innerHTML = "";
                    }
                    var epoch_CCNFY19HCIPDateCompleted = "";
                    if ((this.refs["edit_singleResource_CCNFY19HCIPDateCompleted"].value).length > 0) {
                        epoch_CCNFY19HCIPDateCompleted = ((new Date(this.refs["edit_singleResource_CCNFY19HCIPDateCompleted"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNFY19HCIPDateCompleted"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNFY19HCIPDateCompleted"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY19HCIPDateCompleted))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY19HCIPDateCompleted))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY19HCIPDateCompleted))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNFY19HCIPDateCompleted"].innerHTML = "";
                    }
                    var epoch_CCNFY20HCIPDateCompleted = "";
                    if ((this.refs["edit_singleResource_CCNFY20HCIPDateCompleted"].value).length > 0) {
                        epoch_CCNFY20HCIPDateCompleted = ((new Date(this.refs["edit_singleResource_CCNFY20HCIPDateCompleted"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNFY20HCIPDateCompleted"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNFY20HCIPDateCompleted"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20HCIPDateCompleted))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20HCIPDateCompleted))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20HCIPDateCompleted))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNFY20HCIPDateCompleted"].innerHTML = "";
                    }
                    var epoch_CCNFY20ECIPDateCompleted = "";
                    if ((this.refs["edit_singleResource_CCNFY20ECIPDateCompleted"].value).length > 0) {
                        epoch_CCNFY20ECIPDateCompleted = ((new Date(this.refs["edit_singleResource_CCNFY20ECIPDateCompleted"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNFY20ECIPDateCompleted"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNFY20ECIPDateCompleted"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20ECIPDateCompleted))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20ECIPDateCompleted))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNFY20ECIPDateCompleted))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNFY20ECIPDateCompleted"].innerHTML = "";
                    }
                    var epoch_CCNPAReceivedDate = "";
                    if ((this.refs["edit_singleResource_CCNPAReceivedDate"].value).length > 0) {
                        epoch_CCNPAReceivedDate = ((new Date(this.refs["edit_singleResource_CCNPAReceivedDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNPAReceivedDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNPAReceivedDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNPAReceivedDate"].innerHTML = "";
                    }
                    var epoch_CCNPAReturnedDate = "";
                    if ((this.refs["edit_singleResource_CCNPAReturnedDate"].value).length > 0) {
                        epoch_CCNPAReturnedDate = ((new Date(this.refs["edit_singleResource_CCNPAReturnedDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNPAReturnedDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNPAReturnedDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReturnedDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReturnedDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReturnedDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNPAReturnedDate"].innerHTML = "";
                    }
                    var epoch_CCNPAReceivedDatePracticeLevel = "";
                    if ((this.refs["edit_singleResource_CCNPAReceivedDatePracticeLevel"].value).length > 0) {
                        epoch_CCNPAReceivedDatePracticeLevel = ((new Date(this.refs["edit_singleResource_CCNPAReceivedDatePracticeLevel"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNPAReceivedDatePracticeLevel"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNPAReceivedDatePracticeLevel"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDatePracticeLevel))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDatePracticeLevel))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNPAReceivedDatePracticeLevel))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNPAReceivedDatePracticeLevel"].innerHTML = "";
                    }
                    var epoch_CCNCCNCredentialedDate = "";
                    if ((this.refs["edit_singleResource_CCNCCNCredentialedDate"].value).length > 0) {
                        epoch_CCNCCNCredentialedDate = ((new Date(this.refs["edit_singleResource_CCNCCNCredentialedDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNCCNCredentialedDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNCCNCredentialedDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNCredentialedDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNCredentialedDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNCredentialedDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNCCNCredentialedDate"].innerHTML = "";
                    }
                    var epoch_CCNCCNTerminationDate = "";
                    if ((this.refs["edit_singleResource_CCNCCNTerminationDate"].value).length > 0) {
                        epoch_CCNCCNTerminationDate = ((new Date(this.refs["edit_singleResource_CCNCCNTerminationDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNCCNTerminationDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNCCNTerminationDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNTerminationDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNTerminationDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCCNTerminationDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNCCNTerminationDate"].innerHTML = "";
                    }
                    var epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate = "";
                    if ((this.refs["edit_singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate"].value).length > 0) {
                        epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate = ((new Date(this.refs["edit_singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate"].innerHTML = "";
                    }
                    var epoch_CCNCIGNAEnrollmentDate = "";
                    if ((this.refs["edit_singleResource_CCNCIGNAEnrollmentDate"].value).length > 0) {
                        epoch_CCNCIGNAEnrollmentDate = ((new Date(this.refs["edit_singleResource_CCNCIGNAEnrollmentDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNCIGNAEnrollmentDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNCIGNAEnrollmentDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNCIGNAEnrollmentDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCIGNAEnrollmentDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNCIGNAEnrollmentDate))).getUTCFullYear());

                    }
                    else {
                        this.refs["singleResource_CCNCIGNAEnrollmentDate"].innerHTML = "";
                    }
                    var epoch_CCNECIPEnrollmentDate = "";
                    if ((this.refs["edit_singleResource_CCNECIPEnrollmentDate"].value).length > 0) {
                        epoch_CCNECIPEnrollmentDate = ((new Date(this.refs["edit_singleResource_CCNECIPEnrollmentDate"].value)).getTime() - (new Date(this.refs["edit_singleResource_CCNECIPEnrollmentDate"].value)).getMilliseconds()) + ((new Date()).getTimezoneOffset() * 60000);
                        this.refs["singleResource_CCNECIPEnrollmentDate"].innerHTML = ((new Date((new Date(0)).setMilliseconds(epoch_CCNECIPEnrollmentDate))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNECIPEnrollmentDate))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(epoch_CCNECIPEnrollmentDate))).getUTCFullYear());
                    }
                    else {
                        this.refs["singleResource_CCNECIPEnrollmentDate"].innerHTML = "";
                    }



                    this.refs["singleResource_CCNFirstName"].innerHTML = this.refs["edit_singleResource_CCNFirstName"].value;
                    this.refs["singleResource_CCNLastName"].innerHTML = this.refs["edit_singleResource_CCNLastName"].value;
                    this.refs["singleResource_CCNTitle"].innerHTML = this.refs["edit_singleResource_CCNTitle"].value;
                    this.refs["singleResource_CCNEmail"].innerHTML = this.refs["edit_singleResource_CCNEmail"].value;
                    this.refs["singleResource_CCNPhoneNumber"].innerHTML = this.refs["edit_singleResource_CCNPhoneNumber"].value;
                    this.refs["singleResource_CCNNPINumber"].innerHTML = this.refs["edit_singleResource_CCNNPINumber"].value;
                    this.refs["singleResource_CCNCellPhoneNumber"].innerHTML = this.refs["edit_singleResource_CCNCellPhoneNumber"].value;
                    this.refs["singleResource_CCNAddress"].innerHTML = this.refs["edit_singleResource_CCNAddress"].value;
                    this.refs["singleResource_CCNCity"].innerHTML = this.refs["edit_singleResource_CCNCity"].value;
                    this.refs["singleResource_CCNState"].innerHTML = this.refs["edit_singleResource_CCNState"].value;
                    this.refs["singleResource_CCNZipCode"].innerHTML = this.refs["edit_singleResource_CCNZipCode"].value;
                    this.refs["singleResource_CCNPCP"].innerHTML = this.refs["edit_singleResource_CCNPCP"].value;
                    this.refs["singleResource_CCNMDPCP"].innerHTML = this.refs["edit_singleResource_CCNMDPCP"].value;
                    this.refs["singleResource_CCNMDPCPPracticeId"].innerHTML = this.refs["edit_singleResource_CCNMDPCPPracticeId"].value;
                    this.refs["singleResource_CCNpracticeId"].innerHTML = this.refs["edit_singleResource_CCNpracticeId"].value;
                    this.refs["singleResource_CCNpracticeNPI"].innerHTML = this.refs["edit_singleResource_CCNpracticeNPI"].value;
                    this.refs["singleResource_CCNpracticePhoneNumber"].innerHTML = this.refs["edit_singleResource_CCNpracticePhoneNumber"].value;
                    this.refs["singleResource_CCNEPICDeptName"].innerHTML = this.refs["edit_singleResource_CCNEPICDeptName"].value;
                    this.refs["singleResource_CCNemployedOrIndependent"].innerHTML = this.refs["edit_singleResource_CCNemployedOrIndependent"].value;
                    this.refs["singleResource_CCNCertificationStatus"].innerHTML = this.refs["edit_singleResource_CCNCertificationStatus"].value;
                    this.refs["singleResource_CCNHaloStatus"].innerHTML = this.refs["edit_singleResource_CCNHaloStatus"].value;
                    this.refs["singleResource_CCNMSOStatus"].innerHTML = this.refs["edit_singleResource_CCNMSOStatus"].value;
                    this.refs["singleResource_CCNEVIPSPrimarySpecialty"].innerHTML = this.refs["edit_singleResource_CCNEVIPSPrimarySpecialty"].value;
                    this.refs["singleResource_CCNTIN"].innerHTML = this.refs["edit_singleResource_CCNTIN"].value;
                    this.refs["singleResource_CCNACO"].innerHTML = this.refs["edit_singleResource_CCNACO"].value;

                    //Convert all of the dates back from their editable value to display properly.


                    Actions.modifySingleResourceCCNAttributes(this.state.singleResult,
                        this.refs["edit_singleResource_CCNFirstName"].value,
                        this.refs["edit_singleResource_CCNLastName"].value,
                        this.refs["edit_singleResource_CCNTitle"].value,
                        this.refs["edit_singleResource_CCNEmail"].value,
                        this.refs["edit_singleResource_CCNPhoneNumber"].value,
                        this.refs["edit_singleResource_CCNNPINumber"].value,
                        this.refs["edit_singleResource_CCNCellPhoneNumber"].value,
                        this.refs["edit_singleResource_CCNAddress"].value,
                        this.refs["edit_singleResource_CCNCity"].value,
                        this.refs["edit_singleResource_CCNState"].value,
                        this.refs["edit_singleResource_CCNZipCode"].value,
                        this.refs["edit_singleResource_CCNPCP"].value,
                        this.refs["edit_singleResource_CCNMDPCP"].value,
                        this.refs["edit_singleResource_CCNMDPCPPracticeId"].value,
                        this.refs["edit_singleResource_CCNpracticeId"].value,
                        this.refs["edit_singleResource_CCNpracticeNPI"].value,
                        this.refs["edit_singleResource_CCNpracticePhoneNumber"].value,
                        this.refs["edit_singleResource_CCNEPICDeptName"].value,
                        this.refs["edit_singleResource_CCNemployedOrIndependent"].value,
                        this.refs["edit_singleResource_CCNCertificationStatus"].value,
                        this.refs["edit_singleResource_CCNHaloStatus"].value,
                        this.refs["edit_singleResource_CCNMSOStatus"].value,
                        this.refs["edit_singleResource_CCNEVIPSPrimarySpecialty"].value,
                        epoch_CCNFY18HCIPDateCompleted,
                        epoch_CCNFY19HCIPDateCompleted,
                        epoch_CCNFY20HCIPDateCompleted,
                        epoch_CCNFY20ECIPDateCompleted,
                        epoch_CCNPAReceivedDate,
                        epoch_CCNPAReturnedDate,
                        epoch_CCNPAReceivedDatePracticeLevel,
                        epoch_CCNCCNCredentialedDate,
                        epoch_CCNCCNTerminationDate,
                        epoch_CCNCareFirstMedicareAdvantagePlanEnrollmentDate,
                        epoch_CCNCIGNAEnrollmentDate,
                        epoch_CCNECIPEnrollmentDate,
                        this.refs["edit_singleResource_CCNTIN"].value,
                        this.refs["edit_singleResource_CCNACO"].value);


                }

                const prodStatuses = new Set(['Accepted', 'Candidate']);
                const devStatuses = new Set(['Disabled', 'Obsolete', 'Under Development', 'Relationship Ready', 'Under Review']);
                //const ccnResources = new Set(['CCN Business Lead', 'CCN CME Program', 'CCN EMR System', 'CCN Practice', 'CCN Practice Manager', 'CCN Provider', 'CCN Value Based Contract']);

                if (prodStatuses.has(this.refs["edit_externalStatusChanger"].value)) {
                    if (this.state.siteMode == "databayprd" || this.state.siteMode == "databayccnprd") {

                    }
                    else {
                        if (this.state.siteMode == "databaydev") {
                            if (window.confirm("Would you like to open Databay Production to view your resource?")) {
                                this._changeMode("databayprd");
                            }
                        }
                        else if (this.state.siteMode == "databayccndev") {
                            if (window.confirm("Would you like to open CCN Production to view your resource?")) {
                                this._changeMode("databayccnprd");
                            }
                        }
                    }
                }
                else if (devStatuses.has(this.refs["edit_externalStatusChanger"].value)) {
                    if (this.state.siteMode == "databaydev" || this.state.siteMode == "databayccndev") {

                    }
                    else {

                        if (this.state.siteMode == "databayprd") {
                            if (window.confirm("Would you like to open Databay Development to view your resource?")) {
                                this._changeMode("databaydev");
                            }
                        }
                        else if (this.state.siteMode == "databayccnprd") {
                            if (window.confirm("Would you like to open CCN Development to view your resource?")) {
                                this._changeMode("databayccndev");
                            }
                        }

                    }
                }

                this._editMode(false);
            }
            else {
            }
        }
    }


    _createResource() {
        var errorCount = 0;

        if (this.refs["create_singleResource_ResourceName"].value.length == 0) {
            errorCount++;
        }
        if (this.refs["create_singleResource_ResourceType"].value.length == 0) {
            errorCount++;
        }
        if (this.refs["create_externalStatusChanger"].value.length == 0) {
            errorCount++;
        }
        if (this.refs["create_singleResource_ResourceType"].value == "Report") {
            if (this.refs["create_singleResource_ReportType"].value.length == 0) {
                errorCount++;
            }
            else {
                if (this.refs["create_singleResource_ReportType"].value == "Epic-Crystal Report" || this.refs["create_singleResource_ReportType"].value == "Reporting Workbench") {
                    if (this.refs["create_singleResource_ReportLocation_HGR_1"].value.length == 0 || this.refs["create_singleResource_ReportLocation_HGT_1"].value.length == 0 || this.refs["create_singleResource_ReportLocation_NAME_1"].value.length == 0) {
                        errorCount++;
                    }
                }
                else {
                    if (this.refs["create_singleResource_ReportLocation"].value.length == 0) {
                        errorCount++;
                    }
                }
            }
        }
        if (this.refs["create_singleResource_ResourceType"].value == "Quality & Research Symposium") {
            if (this.refs["create_singleResource_QRSYear"].value.length == 0) {
                errorCount++;
            }
            else {

            }
        }

        if (this.refs["singleResource_Creator"].editor.contentDocument.body.innerHTML == "") {
            errorCount++;
        }

        if (errorCount == 0) {
            if (window.confirm("Are you sure you would like to create this new resource?")) {
                //Gather up your resources

                //NEED TO UPDATE TO ALLOW FOR US TO PASS THE REPORT LOCATION, REPORT STATUS

                var reportLocation = this.refs["create_singleResource_ReportLocation"].value;
                if (this.refs["create_singleResource_ReportType"].value == "Epic-Crystal Report" || this.refs["create_singleResource_ReportType"].value == "Reporting Workbench") {
                    reportLocation = "";
                    for (var iterator = 1; iterator <= this.state.resource_createEpicReportsCount; iterator++) {
                        if (iterator > 1) {
                            reportLocation = reportLocation + "~";
                        }
                        if (this.refs["create_singleResource_ReportLocation_HGR_" + iterator].value.length > 0 && this.refs["create_singleResource_ReportLocation_HGT_" + iterator].value.length > 0 && this.refs["create_singleResource_ReportLocation_NAME_" + iterator].value.length > 0) {
                            reportLocation = reportLocation + "HGR:" + this.refs["create_singleResource_ReportLocation_HGR_" + iterator].value + "|HGT:" + this.refs["create_singleResource_ReportLocation_HGT_" + iterator].value + "|NAME:" + this.refs["create_singleResource_ReportLocation_NAME_" + iterator].value;
                        }

                    }
                }

                if (this.refs["create_singleResource_ReportType"].value == "Radar Dashboard") {
                    reportLocation = "IDM:" + this.refs["create_singleResource_ReportLocation"].value;
                }

                Actions.createSingleResource(this.refs["create_singleResource_ResourceName"].value, this.refs["create_singleResource_ResourceType"].value, this.refs["create_singleResource_ReportType"].value, this.refs["create_singleResource_QRSYear"].value, reportLocation, this.refs["create_externalStatusChanger"].value, this.refs["singleResource_Creator"].editor.contentDocument.body.innerHTML, this.state.user_AccountInfo.firstName, this.state.user_AccountInfo.lastName);

                var resourceMode = "databayprd";
                const prodStatuses = new Set(['Accepted', 'Candidate']);
                const devStatuses = new Set(['Disabled', 'Obsolete', 'Under Development', 'Relationship Ready', 'Under Review']);
                const ccnResources = new Set(['CCN Business Lead', 'CCN CME Program', 'CCN EMR System', 'CCN Practice', 'CCN Practice Manager', 'CCN Provider', 'CCN Value Based Contract']);
                if (ccnResources.has(this.refs["create_singleResource_ResourceType"].value) && prodStatuses.has(this.refs["create_externalStatusChanger"].value)) {
                    resourceMode = "databayccnprd";
                }
                else if (ccnResources.has(this.refs["create_singleResource_ResourceType"].value) && devStatuses.has(this.refs["create_externalStatusChanger"].value)) {
                    resourceMode = "databayccndev";
                }
                else if (!ccnResources.has(this.refs["create_singleResource_ResourceType"].value) && prodStatuses.has(this.refs["create_externalStatusChanger"].value)) {
                    resourceMode = "databayprd";
                }
                else if (!ccnResources.has(this.refs["create_singleResource_ResourceType"].value) && devStatuses.has(this.refs["create_externalStatusChanger"].value)) {
                    resourceMode = "databaydev";
                }


                if (resourceMode == this.state.siteMode) {
                    this._redirectHome();
                }
                else {
                    if (this.state.siteMode == "databayprd") {
                        if (window.confirm("Would you like to open Databay Development to view your resource?")) {
                            this._changeMode('databaydev');
                        }
                    }
                    else if (this.state.siteMode == "databaydev") {
                        if (window.confirm("Would you like to open Databay Production to view your resource?")) {
                            this._changeMode('databayprd');
                        }
                    }
                    else if (this.state.siteMode == "databayccnprd") {
                        if (window.confirm("Would you like to open Databay CCN Development to view your resource?")) {
                            this._changeMode('databayccndev');
                        }
                    }
                    else if (this.state.siteMode == "databayccndev") {
                        if (window.confirm("Would you like to open Databay CCN Production to view your resource?")) {
                            this._changeMode('databayccnprd');
                        }
                    }
                }

            }
            else {
            }
        }
        else {
            alert("Please fill out the form completely.");
        }
    }


    _cancelResourceChanges() {
        var changeCount = 0;

        //ATTEMPT TO SET ORIGINAL CONTENT
        if (this.refs["edit_singleResource_ResourceName"].value != this.refs["singleResource_ResourceName"].innerHTML) {
            changeCount++;
        }
        if (this.refs["edit_singleResource_ResourceType"].value != this.refs["singleResource_ResourceType"].innerHTML) {
            changeCount++;
        }
        if (this.refs["edit_singleResource_ResourceType"].value == "Report") {
            if (this.refs["edit_singleResource_ReportType"].value != this.refs["singleResource_ReportType"].innerHTML) {
                changeCount++;
            }
        }
        if (this.refs["edit_singleResource_ReportLocation"].value != this.refs["singleResource_ReportLocation"].innerHTML) {
            changeCount++;
        }
        if (this.refs["singleResource_Editor"].currentContent != this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML) {
            changeCount++;
        }


        if (this.refs["edit_externalStatusChanger"].value != this.refs["edit_detailsExternalStatusLabel"].innerHTML) {
            changeCount++;
        }

        if (this.refs["edit_syncsExternallyChanger"].value != this.refs["edit_detailsSyncResourcesLabel"].innerHTML) {
            changeCount++;
        }
        //ORIGINALCONTENT
        //alert(this.refs["singleResource_Editor"].currentContent);
        //UPDATEDCONTENT
        //alert(this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML)

        if (changeCount > 0) {
            if (window.confirm("Are you sure you would like to cancel and lose your changes you have made?")) {
                this.refs["singleResource_Editor"].editor.contentDocument.body.innerHTML = this.refs["singleResource_ContentBody_Description_HTML"].innerHTML;

                this.refs["edit_singleResource_ReportType"].value = this.refs["singleResource_ReportType"].innerHTML;
                this.refs["edit_singleResource_ReportLocation"].value = this.refs["singleResource_ReportLocation"].innerHTML;
                this.refs["edit_singleResource_ResourceType"].value = this.refs["singleResource_ResourceType"].innerHTML;
                this.refs["edit_singleResource_ResourceName"].value = this.refs["singleResource_ResourceName"].innerHTML;
                this.refs["edit_externalStatusChanger"].value = this.refs["edit_detailsExternalStatusLabel"].innerHTML;
                if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Disabled") {
                    this.refs["edit_syncsExternallyChanger"].value = "False";
                }
                else if (this.refs["edit_detailsSyncResourcesLabel"].innerHTML == "Enabled") {
                    this.refs["edit_syncsExternallyChanger"].value = "True";
                }
                this.refs["edit_singleResource_Rank"].value = this.refs["edit_detailsResourceRankLabel_Text"].innerHTML;

                this._editMode(false);
            }
            else {
            }
        }
        else {
            this._editMode(false);
        }
    }

    _removeUserPermission(ADUsername, UserDomain) {
        if (window.confirm("Are you sure you would like to remove this user's permissions?")) {
            Actions.removeUserPermission(ADUsername, UserDomain);
        }
    }


    _removeRank(idRank) {
        if (window.confirm("Are you sure you would like to remove this rank from Databay? NOTE: This will remove this rank from all resources.")) {
            Actions.removeRank(idRank);
        }
    }

    _editRank() {

        //Need to add code to edit the rank given the filled in fields

    }


    _addRank() {

        //Need to add code to create the rank given the filled in fields

    }

    _addUserPermission() {

        var permissionLevel = this.state.user_modalPermissionLevel;
        if (this.refs["modal_permission_employee"].value != "") {
            this._hideOverlays();
            Object.values(this.refs["modal_permission_employee"].selectedOptions).forEach(element => {
                Actions.addUserPermission(element["value"], permissionLevel);
            });

            this.refs["modal_permission_employee"].value = "";
        }
        else {
            alert("Please enter the required information.")
        }


    }

    _showModalPermission(permissionLevel) {
        this.setState({
            user_modalPermissionLevel: permissionLevel,
            user_permissionFilter: "",
            user_permissionDepartment: ""
        });
        this._showModalOverlay("permission");
    }


    _showEditModalRank(idRank, rankName, hexBackgroundColor, points, isFilterable, isInAllResults, description) {
        this.setState({
            resource_modalRank_idRank: idRank,
            resource_modalRank_rankName: rankName,
            resource_modalRank_hexBackgroundColor: hexBackgroundColor,
            resource_modalRank_points: points,
            resource_modalRank_isFilterable: isFilterable,
            resource_modalRank_isInAllResults: isInAllResults,
            resource_modalRank_description: description
        });
        this._showModalOverlay("rank");
    }

    _showAddModalRank() {
        this.setState({
            resource_modalRank_idRank: "",
            resource_modalRank_rankName: "",
            resource_modalRank_hexBackgroundColor: "",
            resource_modalRank_points: "",
            resource_modalRank_isFilterable: "",
            resource_modalRank_isInAllResults: "",
            resource_modalRank_description: ""
        });
        this._showModalOverlay("rank");
    }

    _showEditGoal(goalId, goalName, goalLocation, goalValue, goalValueType, goalExpectedCompletion, goalStartDate) {
        const d = new Date(goalExpectedCompletion);
        var day = d.getDate();
        var month = d.getMonth() + 1;
        var year = d.getFullYear();
        var monthText = month.toString();
        var dayText = day.toString();
        if (day < 10) {
            dayText = "0" + day;
        }
        if (month < 10) {
            monthText = "0" + month;
        }
        var startDateValue = "";
        if (goalStartDate == "") {
            startDateValue = "";
        }
        else {

            const sd = new Date(goalStartDate);
            var startDay = sd.getDate();
            var startMonth = sd.getMonth() + 1;
            var startYear = sd.getFullYear();
            var startMonthText = startMonth.toString();
            var startDayText = startDay.toString();
            if (startDay < 10) {
                startDayText = "0" + startDay;
            }
            if (startMonth < 10) {
                startMonthText = "0" + startMonth;
            }
            startDateValue = startYear + "-" + startMonthText + "-" + startDayText;

        }
        this.setState({
            resource_editGoal_GoalId: goalId,
            resource_editGoal_GoalName: goalName,
            resource_editGoal_GoalLocation: goalLocation,
            resource_editGoal_GoalValue: goalValue,
            resource_editGoal_GoalValueType: goalValueType,
            resource_editGoal_ExpectedCompletion: year + "-" + monthText + "-" + dayText,
            resource_editGoal_StartDate: startDateValue,
        });


        this._showModalOverlay("editGoal");
    }

    _updateGoal() {

        var modal_editGoal_GoalName = this.refs["modal_editGoal_GoalName"].value;
        var modal_editGoal_GoalLocation = this.refs["modal_editGoal_GoalLocation"].value;
        var modal_editGoal_GoalValue = this.refs["modal_editGoal_GoalValue"].value;
        var modal_editGoal_GoalValueType = this.refs["modal_editGoal_GoalValueType"].value;
        var modal_editGoal_GoalExpectedCompletionDate = this.refs["modal_editGoal_GoalExpectedCompletionDate"].value;
        var modal_editGoal_GoalStartDate = this.refs["modal_editGoal_GoalStartDate"].value;

        if (modal_editGoal_GoalName == "") {
            modal_editGoal_GoalName = "Untitled";
        }
        if (modal_editGoal_GoalLocation == "") {
            modal_editGoal_GoalLocation = "Luminis Health";
        }
        if (modal_editGoal_GoalValueType == "") {
            modal_editGoal_GoalValueType = "Units";
        }
        Actions.modifySingleResourceMetricGoals(this.state.resource_editGoal_GoalId, modal_editGoal_GoalName, modal_editGoal_GoalValue, modal_editGoal_GoalValueType, modal_editGoal_GoalLocation, modal_editGoal_GoalExpectedCompletionDate, modal_editGoal_GoalStartDate, "", "", this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername)
        this._hideOverlays();
    }


    _launchEpicSlicerDicer(param1) {
        console.log("_launchEpicSlicerDicer");
        console.log("isEpicUser:" + this.state.isEpicUser);
        console.log("isHyperDriveUser:" + this.state.isHyperDriveUser);
        console.log("param1:" + param1);

        if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
            window.open("EpicACT:BI_SLICERDICER,RunParams:StartingPopulationId=" + param1, '_blank');
        }
        else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
            console.log(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_SLICERDICER',
                        Parameters: { ReportID: param1 },
                    },
                },
                '*'
            );
            window.parent.postMessage(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_SLICERDICER',
                        Parameters: { ReportID: param1 },
                    },
                },
                '*'
            );
        }
        else {
            alert("Epic-Slicer Dicer is only available in Hyperspace / HyperDrive.");
        }
    }

    _launchEpicCrystalReport(param1, param2, reportName) {
        console.log("_launchEpicCrystalReport");
        console.log("isEpicUser:" + this.state.isEpicUser);
        console.log("isHyperDriveUser:" + this.state.isHyperDriveUser);
        console.log("param1:" + param1);
        console.log("param2:" + param2);
        console.log("reportName:" + reportName);

        if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
            window.open("EpicAct:editrwreport,RunParams:3||AC_RW_STATUS|" + param1 + "|" + param2 + "|0", '_blank');
        }
        else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
            console.log(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_AC_RW_STATUS',
                        Parameters: { ReportID: param1, ReportModelToLaunch: param2 },
                    },
                },
                '*'
            );
            window.parent.postMessage(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_AC_RW_STATUS',
                        Parameters: { ReportID: param1, ReportModelToLaunch: param2 },
                    },
                },
                '*'
            );
        }
        else {
            alert("Epic-Crystal Report(s) are only available in Hyperspace / HyperDrive.");
        }
    }

    _launchRadarDashboard(param1, reportName) {

        console.log("_launchRadarDashboard");
        console.log("isEpicUser:" + this.state.isEpicUser);
        console.log("isHyperDriveUser:" + this.state.isHyperDriveUser);
        console.log("param1:" + param1);
        console.log("reportName:" + reportName);

        if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
            window.open("EpicAct:WM_DASHBOARD_LAUNCHER,RunParams" + param1, '_blank');
        }
        else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
            console.log(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_WM_DASHBOARD_LAUNCHER',
                        Parameters: { DashboardId: param1 },
                    },
                },
                '*'
            );
            window.parent.postMessage(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_WM_DASHBOARD_LAUNCHER',
                        Parameters: { DashboardId: param1 },
                    },
                },
                '*'
            );
        }
        else {
            alert("Radar Dashboard Report(s) are only available in Hyperspace / HyperDrive.");
        }
    }

    _launchReportingWorkbench(param1, param2, reportName) {

        console.log("_launchReportingWorkbench");
        console.log("isEpicUser:" + this.state.isEpicUser);
        console.log("isHyperDriveUser:" + this.state.isHyperDriveUser);
        console.log("param1:" + param1);
        console.log("param2:" + param2);
        console.log("reportName:" + reportName);

        if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
            window.open("EpicAct:AC_RW_STATUS,RunParams:" + param1 + "|" + param2, '_blank');
        }
        else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
            console.log(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_AC_RW_STATUS',
                        Parameters: { ReportID: param1, ReportModelToLaunch: param2 },
                    },
                },
                '*'
            );
            window.parent.postMessage(
                {
                    token: this.state.hyperdrive_token,
                    action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                    args: {
                        ActivityKey: 'DATABAY_CST_AC_RW_STATUS',
                        Parameters: { ReportID: param1, ReportModelToLaunch: param2 },
                    },
                },
                '*'
            );
        }
        else {
            alert("Reporting Workbench Report(s) are only available in Hyperspace / HyperDrive.");
        }
    }

    _showModalOverlay(modalContentType) {

        this._hideOverlays();
        //this.refs["modal_overlay"].className = "modal_expanded";
        //this.refs["modal_container_overlay"].className = "modal_container_expanded";

        switch (modalContentType) {
            case 'JIRA':
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_JIRA_overlay"].className = "modal_JIRA_expanded";
                this.refs["modal_JIRA_header"].className = "modal_JIRA_header_expanded";
                break;
            case 'feedback':
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_feedback_overlay"].className = "modal_feedback_expanded";
                this.refs["modal_feedback_header"].className = "modal_feedback_header_expanded";
                break;
            case 'view':
                var resourceType = "";
                var reportType = "";
                var resourceRepository = "";
                Object.values(this.state.resource_IntellisenseInfo)
                    .filter(value => (value['externalId']).toString().toLowerCase() == this.state.singleResult.toLowerCase())
                    .forEach(value => {
                        resourceType = (value['resourceType']).toString();
                        reportType = (value['reportType']).toString();
                        resourceRepository = (value['resourceRepository']).toString();

                        if ((value['reportLocation']).toString().length > 0) {
                            if (reportType == 'Qliksense Application' || reportType == 'Website' || reportType == 'Qlikview Dashboard') {
                                if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
                                    window.open("epicact:WM_WEB_BROWSER,RunParams:" + (value['reportLocation']).toString().toLowerCase(), '_blank');
                                }
                                else {

                                    window.open((value['reportLocation']).toString(), '_blank');
                                }
                            }
                            else if (reportType == 'Excel Dashboard' || reportType == 'Microsoft Report' || reportType == 'File') {
                                if (resourceRepository == "fileUpload") {
                                    Actions.getActionGroupFileEligibilityAndDownload((value['externalId']).toString(), this.state.user_AccountInfo.idUser);
                                }
                                else {
                                    // Assuming value['reportLocation'] contains the file path
                                    var filePath = "file:///" + (value['reportLocation']).toString().replace(/\\\\/g, "\\\\").toLowerCase();

                                    // Create an anchor tag
                                    var a = document.createElement('a');
                                    a.href = filePath;
                                    a.textContent = ' '; // Set the text inside the anchor
                                    //a.style.display = 'none'; // Hide the anchor element

                                    // Append to the body and trigger a click
                                    document.body.appendChild(a);
                                    //a.click();

                                    // Remove the anchor element from the body
                                    //document.body.removeChild(a);

                                    //window.open("file:///"+(value['reportLocation']).toString().replace(/\\\\/g, "\\\\").toLowerCase(), '_blank');
                                }

                            }
                            else if (reportType == 'Radar Dashboard') {
                                //SHOW MODAL ; delimited

                                //this.refs["modal_overlay"].className = "modal_expanded";
                                //this.refs["modal_container_overlay"].className = "modal_container_expanded";
                                //this.refs["modal_view_overlay"].className = "modal_request_expanded";
                                //this.refs["modal_view_header"].className = "modal_request_header_expanded";

                                if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
                                    var rd_RegEx1 = /IDM:(\d+)/
                                    var rd_Matches = rd_RegEx1.exec(value['reportLocation'].replace(/\s+/g, ''));
                                    window.open("epicact:WM_DASHBOARD_LAUNCHER,RunParams:" + rd_Matches[1], '_blank');
                                }
                                else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
                                    var rd_RegEx1 = /IDM:(\d+)/
                                    var rd_Matches = rd_RegEx1.exec(value['reportLocation'].replace(/\s+/g, ''));

                                    console.log("inlineLaunchRadarDashboard");
                                    console.log("DATABAY_CST_WM_DASHBOARD_LAUNCHER");
                                    console.log("isEpicUser:" + this.state.isEpicUser);
                                    console.log("isHyperDriveUser:" + this.state.isHyperDriveUser);
                                    console.log("param1:" + rd_Matches[1]);

                                    console.log(
                                        {
                                            token: this.state.hyperdrive_token,
                                            action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                                            args: {
                                                ActivityKey: 'DATABAY_CST_WM_DASHBOARD_LAUNCHER',
                                                Parameters: { DashboardId: rd_Matches[1] },
                                            },
                                        },
                                        '*'
                                    );
                                    window.parent.postMessage(
                                        {
                                            token: this.state.hyperdrive_token,
                                            action: 'Epic.Clinical.Informatics.Web.LaunchActivity',
                                            args: {
                                                ActivityKey: 'DATABAY_CST_WM_DASHBOARD_LAUNCHER',
                                                Parameters: { DashboardId: rd_Matches[1] },
                                            },
                                        },
                                        '*'
                                    );
                                }
                                else {
                                    alert("Radar Dashboard Report(s) are only available in Hyperspace / HyperDrive.");
                                }

                            }
                            else if (reportType == 'Reporting Workbench') {
                                //SHOW MODAL ; delimited

                                if (this.state.isEpicUser) {
                                    this.refs["modal_overlay"].className = "modal_expanded";
                                    this.refs["modal_container_overlay"].className = "modal_container_expanded";
                                    this.refs["modal_view_overlay"].className = "modal_request_expanded";
                                    this.refs["modal_view_header"].className = "modal_request_header_expanded";
                                }
                                else {
                                    alert("Reporting Workbench Report(s) are only available in Hyperspace / HyperDrive.");
                                }
                                //var rw_RegEx1 = /HGR:(\d+)\|HGT:(\d+)\|NAME:(.*)/

                                //var rw_Matches = rw_RegEx1.exec(value['reportLocation'])

                                //window.open("EpicAct:AC_RW_STATUS,RunParams:" + rw_Matches[1] + "|" + rw_Matches[2], '_blank');
                            }
                            else if (reportType == 'Epic-Crystal Report') {
                                //SHOW MODAL ; delimited
                                if (this.state.isEpicUser) {

                                    this.refs["modal_overlay"].className = "modal_expanded";
                                    this.refs["modal_container_overlay"].className = "modal_container_expanded";
                                    this.refs["modal_view_overlay"].className = "modal_request_expanded";
                                    this.refs["modal_view_header"].className = "modal_request_header_expanded";

                                }
                                else {
                                    alert("Epic-Crystal Report(s) are only available in Hyperspace / HyperDrive.");
                                }
                                //var rw_RegEx1 = /HGR:(\d+)\|HGT:(\d+)\|NAME:(.*)/

                                //var rw_Matches = rw_RegEx1.exec(value['reportLocation'])

                                //window.open("EpicAct:AC_RW_STATUS,RunParams:" + rw_Matches[1] + "|" + rw_Matches[2], '_blank');
                            }
                            else if (reportType == 'Epic-Slicer Dicer') {
                                //SHOW MODAL ; delimited
                                if (this.state.isEpicUser) {

                                    this.refs["modal_overlay"].className = "modal_expanded";
                                    this.refs["modal_container_overlay"].className = "modal_container_expanded";
                                    this.refs["modal_view_overlay"].className = "modal_request_expanded";
                                    this.refs["modal_view_header"].className = "modal_request_header_expanded";

                                }
                                else {
                                    alert("Epic-Slicer Dicer is only available in Hyperspace / HyperDrive.");
                                }
                                //var rw_RegEx1 = /HGR:(\d+)\|HGT:(\d+)\|NAME:(.*)/

                                //var rw_Matches = rw_RegEx1.exec(value['reportLocation'])

                                //window.open("EpicAct:AC_RW_STATUS,RunParams:" + rw_Matches[1] + "|" + rw_Matches[2], '_blank');
                            }
                            else {
                                window.open((value['reportLocation']).toString().toLowerCase(), '_blank');
                                console.log((value['reportLocation']).toString().toLowerCase());
                            }
                        }
                        else {
                            window.open('https://dataviz.aahs.org/sense/app/' + (value['externalId']).toString().toLowerCase(), '_blank');
                        }

                    });
                break;
            case 'preview':
                var resourceType = "";
                var reportType = "";
                var reportLocation = "";
                resourceType = this.refs["create_singleResource_ResourceType"].value;
                reportType = this.refs["create_singleResource_ReportType"].value;
                reportLocation = this.refs["create_singleResource_ReportLocation"].value;

                if ((reportLocation).toString().length > 0) {
                    if (reportType == 'Qliksense Application' || reportType == 'Website' || reportType == 'Qlikview Dashboard') {
                        window.open((reportLocation).toString().toLowerCase(), '_blank');
                    }
                    else if (reportType == 'Excel Dashboard' || reportType == 'Microsoft Report' || reportType == 'File') {
                        window.open("file:///" + (reportLocation).toString().replace(/\\\\/g, "\\\\").toLowerCase(), '_blank');
                    }
                    else if (reportType == 'Radar Dashboard' || reportType == 'Reporting Workbench' || reportType == 'Epic-Crystal Reports' || reportType == 'Epic-Slicer Dicer') {
                        alert('Preview not available, these reports are only available in Hyperspace / HyperDrive.');
                    }
                    else {
                        window.open(reportLocation.toString().toLowerCase(), '_blank');
                        console.log(reportLocation.toString().toLowerCase());
                    }
                }
                else {
                    alert('Please enter a report location to preview.');
                }

                break;
            case 'request':
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_request_overlay"].className = "modal_request_expanded";
                this.refs["modal_request_header"].className = "modal_request_header_expanded";
                break;
            case 'help':
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_help_overlay"].className = "modal_help_expanded";
                this.refs["modal_help_header"].className = "modal_help_header_expanded";
                break;
            case 'permission':

                if (this.refs["modal_permission_employee"] != undefined) {
                    this.refs["modal_permission_employee"].value = "";
                }

                if (this.refs["permissionFilterDepartment_Input"] != undefined) {
                    this.refs["permissionFilterDepartment_Input"].value = "";
                }

                if (this.refs["permissionFilterName_Input"] != undefined) {
                    this.refs["permissionFilterName_Input"].value = "";
                }

                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_permission_overlay"].className = "modal_permission_expanded";
                this.refs["modal_permission_header"].className = "modal_permission_header_expanded";
                break;
            case 'rank':


                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_rank_overlay"].className = "modal_rank_expanded";
                this.refs["modal_rank_header"].className = "modal_rank_header_expanded";
                break;
            case 'share':
                if (this.state.siteMode == "databayprd") {

                    this.setState({
                        resource_shareFilter: "",
                        resource_shareDepartment: ""
                    });

                    if (this.refs["modal_share_employee"] != undefined) {
                        this.refs["modal_share_employee"].value = "";
                    }

                    if (this.refs["shareFilterDepartment_Input"] != undefined) {
                        this.refs["shareFilterDepartment_Input"].value = "";
                    }

                    if (this.refs["shareFilterName_Input"] != undefined) {
                        this.refs["shareFilterName_Input"].value = "";
                    }

                    this.refs["modal_overlay"].className = "modal_expanded";
                    this.refs["modal_container_overlay"].className = "modal_container_expanded";
                    this.refs["modal_share_overlay"].className = "modal_share_expanded";
                    this.refs["modal_share_header"].className = "modal_share_header_expanded";
                }
                else {
                    alert("This feature only available in Databay Production, please change your site mode.");
                }
                break;
            case 'addRelationship':
                var resourceType = "";


                if (this.refs["resourceTypeFilter"] != undefined) {
                    this.refs["resourceTypeFilter"].value = "";
                }
                if (this.refs["reportTypeFilter"] != undefined) {
                    this.refs["reportTypeFilter"].value = "";
                }
                if (this.refs["modal_relationship_resources"] != undefined) {
                    this.refs["modal_relationship_resources"].value = "";
                }

                if (this.refs["modal_relationship_resources"] != undefined) {
                    this.refs["modal_relationship_resources"].value = "";
                }
                resourceType = ((this.state.currentTabLocation).split("_").join(" ")).toString();
                this.setState({
                    resource_addRelationship_ResourceList: {},
                    resource_addRelationship_ResourceTypeFilter: resourceType,
                    resource_addRelationship_ReportTypeFilter: ""
                });

                this.refs["resourceTypeFilter"].value = ((this.state.currentTabLocation).split("_").join(" ")).toString();
                this.refs["reportTypeFilter"].value = "";

                if (this.refs["modal_addRelationship_resource"] != undefined) {
                    this.refs["modal_addRelationship_resource"].value = "";
                }

                if (this.refs["addRelationshipFilterResourceType_Input"] != undefined) {
                    this.refs["addRelationshipFilterResourceType_Input"].value = "";
                }

                if (this.refs["addRelationshipFilterReportType_Input"] != undefined) {
                    this.refs["addRelationshipFilterReportType_Input"].value = "";
                }

                if (resourceType != "" && resourceType != "Details" && resourceType != "Overview" ) {

                    Actions.getResourceListByType(this.state.siteMode, "", resourceType, "");

                }
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_addRelationship_overlay"].className = "modal_addRelationship_expanded";
                this.refs["modal_addRelationship_header"].className = "modal_addRelationship_header_expanded";
                break;
            case 'editGoal':
                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_editGoal_overlay"].className = "modal_editGoal_expanded";
                this.refs["modal_editGoal_header"].className = "modal_editGoal_header_expanded";
                break;

            case 'addActionPlanItem':

                this.setState({
                    resource_addActionPlanItem_ItemType: ""
                });

                //Goals
                this.refs["actionPlanItem_Goal_Title"].className = "hidden";
                this.refs["actionPlanItem_Goal_Description"].className = "hidden";
                this.refs["actionPlanItem_Goal_EstCompletionDate"].className = "hidden";

                //Actions
                this.refs["actionPlanItem_Action_LinkedGoal"].className = "hidden";
                this.refs["actionPlanItem_Action_Title"].className = "hidden";
                this.refs["actionPlanItem_Action_Description"].className = "hidden";
                this.refs["actionPlanItem_Action_NumHoursExpected"].className = "hidden";

                //Log
                this.refs["actionPlanItem_Log_LinkedGoal"].className = "hidden";
                this.refs["actionPlanItem_Log_LinkedAction"].className = "hidden";
                this.refs["actionPlanItem_Log_NumHoursExpected"].className = "hidden";
                this.refs["actionPlanItem_Log_Description"].className = "hidden";

                //Team
                this.refs["actionPlanItem_Team_LinkedUser"].className = "hidden";
                this.refs["actionPlanItem_Team_Designation"].className = "hidden";


                this.refs["actionPlanItemChanger"].value = "";

                this.refs["modal_overlay"].className = "modal_expanded";
                this.refs["modal_container_overlay"].className = "modal_container_expanded";
                this.refs["modal_addActionPlanItem_overlay"].className = "modal_addActionPlanItem_expanded";
                this.refs["modal_addActionPlanItem_header"].className = "modal_addActionPlanItem_header_expanded";
                break;
        }

    }

    _shareResource(singleResourceExternalId, singleResourceName, singleResourceType) {
        if (this.refs["modal_share_employee"].value != "") {
            this._hideOverlays();
            Object.values(this.refs["modal_share_employee"].selectedOptions).forEach(element => {
                Actions.addUserShare(this.state.user_AccountInfo.idUser, this.state.user_AccountInfo.firstName, this.state.user_AccountInfo.lastName, this.state.user_AccountInfo.email, element["value"], singleResourceExternalId, singleResourceName, singleResourceType);

            });
            this.setState({
                user_stateState: "pending"
            });

            this.refs["modal_share_employee"].value = "";
            alert("This resource has been shared successfully.")
        }
        else {
            alert("Please enter the required information.")
        }


    }

    _addCustomTagToList() {
        if ((this.refs["modal_relationship_TagName"].value.toString()).length >= 2 && this.refs["modal_relationship_TagName"].value.indexOf(' ') == -1) {
            var updatedCustomTagInfo = this.state.resource_CustomTagInfo;
            var newTag = this.refs["modal_relationship_TagName"].value;
            if ((updatedCustomTagInfo).indexOf(newTag) == -1) {
                updatedCustomTagInfo.push(newTag);
            }
            this.setState({
                resource_CustomTagInfo: updatedCustomTagInfo.sort()
            })
            this.refs["modal_relationship_TagName"].value = "";
        }
        else {
            alert("Please enter a tag with atleast 3 characters and no spaces.")
        }
    }


    _addRelationship(singleResourceExternalId, singleResourceName, singleResourceType) {

        if (this.refs["resourceTypeFilter"].value == "Tags") {
            var updateCount = 0;
            Object.values(this.refs["modal_relationship_TagSelectboxValues"].selectedOptions).forEach(element => {
                updateCount = updateCount + 1;
            });

            if (updateCount == 0) {
                alert("Please select atleast one tag.")
            }
            else {
                this._hideOverlays();
                this.setState({
                    resource_addRelationship_ResourceList: {},
                    resource_addRelationship_ResourceTypeFilter: "",
                    resource_addRelationship_ReportTypeFilter: "",
                    resource_relationshipNameFilter: ""
                })
                this.refs["resourceTypeFilter"].value = "";
                this.refs["reportTypeFilter"].value = "";
                this.refs["resourceFilterName_Input"].value = "";

                Object.values(this.refs["modal_relationship_TagSelectboxValues"].selectedOptions).forEach(element => {
                    Actions.createSingleResourceTag(singleResourceExternalId, element["value"], this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername);
                });

                Actions.getSingleResourceTagInfo(this.state.singleResult);
                Actions.getResourceTagInfo();
                Actions.getReportsAndMetricLinkInfo();
                this.refs["modal_relationship_TagSelectboxValues"].value = "";
                alert("This tags have been added successfully.")

            }
        }
        else if (this.refs["resourceTypeFilter"].value == "Metric Owner") {

            if (this.refs["modal_user_relationship_resources"].value != "") {
                var updateCount = 0;
                Object.values(this.refs["modal_user_relationship_resources"].selectedOptions).forEach(element => {
                    Actions.createSingleResourceMetricOwner(singleResourceExternalId, element["value"], "Owner", this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername);
                    updateCount = updateCount + 1;
                });
                if (updateCount == 0) {
                    alert("Please select atleast one user.")
                }
                else {
                    this._hideOverlays();
                    this.setState({
                        resource_addRelationship_ResourceList: {},
                        resource_addRelationship_ResourceTypeFilter: "",
                        resource_addRelationship_ReportTypeFilter: "",
                        resource_relationshipNameFilter: ""
                    })
                    this.refs["resourceTypeFilter"].value = "";
                    this.refs["reportTypeFilter"].value = "";
                    this.refs["modal_user_relationship_resources"].value = "";
                    this.refs["resourceFilterName_Input"].value = "";

                    alert("This resource's owner(s) has been added successfully.")
                    Actions.getSingleResourceMetricOwner(this.state.singleResult, this.state.siteMode);

                }
            }
            else {
                alert("Please enter the required information.")
            }


        }
        else if (this.refs["resourceTypeFilter"].value == "Metric Goals") {

            if (this.refs["modal_relationship_GoalValue"].value != "" && this.refs["modal_relationship_GoalExpectedCompletionDate"].value != "") {
                this._hideOverlays();

                var modal_relationship_GoalName = this.refs["modal_relationship_GoalName"].value;
                var modal_relationship_GoalLocation = this.refs["modal_relationship_GoalLocation"].value;
                var modal_relationship_GoalValue = this.refs["modal_relationship_GoalValue"].value;
                var modal_relationship_GoalValueType = this.refs["modal_relationship_GoalValueType"].value;
                var modal_relationship_GoalExpectedCompletionDate = this.refs["modal_relationship_GoalExpectedCompletionDate"].value;
                var modal_relationship_GoalStartDate = this.refs["modal_relationship_GoalStartDate"].value;

                if (modal_relationship_GoalName == "") {
                    modal_relationship_GoalName = "Untitled";
                }
                if (modal_relationship_GoalLocation == "") {
                    modal_relationship_GoalLocation = "Luminis Health";
                }
                if (modal_relationship_GoalValueType == "") {
                    modal_relationship_GoalValueType = "Units";
                }

                Actions.createSingleResourceMetricGoals(singleResourceExternalId, modal_relationship_GoalName, modal_relationship_GoalValue, modal_relationship_GoalValueType, modal_relationship_GoalLocation, modal_relationship_GoalExpectedCompletionDate, modal_relationship_GoalStartDate, this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername);

                this.setState({
                    resource_addRelationship_ResourceList: {},
                    resource_addRelationship_ResourceTypeFilter: "",
                    resource_addRelationship_ReportTypeFilter: "",
                    resource_relationshipNameFilter: ""
                })
                this.refs["resourceTypeFilter"].value = "";
                this.refs["reportTypeFilter"].value = "";
                this.refs["modal_relationship_GoalName"].value = "";
                this.refs["modal_relationship_GoalLocation"].value = "Luminis Health";
                this.refs["modal_relationship_GoalValue"].value = "";
                this.refs["modal_relationship_GoalValueType"].value = "";
                this.refs["modal_relationship_GoalExpectedCompletionDate"].value = "";
                this.refs["modal_relationship_GoalStartDate"].value = "";
                this.refs["resourceFilterName_Input"].value = "";

                alert("This resource's goal has been added successfully.")
                Actions.getSingleResourceMetricGoals(this.state.singleResult);

            }
            else {
                alert("Please enter the required information.")
            }


        }
        else {

            if (this.refs["modal_relationship_resources"].value != "") {
                this._hideOverlays();
                var updateCount = 0;
                Object.values(this.refs["modal_relationship_resources"].selectedOptions).forEach(element => {
                    Actions.addSingleResourceRelationship(this.state.singleResult, element["value"]);
                    updateCount = updateCount + 1;
                });
                if (updateCount == 0) {
                    alert("Please select atleast one resource.")
                }
                else {
                    this.setState({
                        resource_addRelationship_ResourceList: {},
                        resource_addRelationship_ResourceTypeFilter: "",
                        resource_addRelationship_ReportTypeFilter: "",
                        resource_relationshipNameFilter: ""
                    })
                    this.refs["resourceTypeFilter"].value = "";
                    this.refs["reportTypeFilter"].value = "";
                    this.refs["modal_relationship_resources"].value = "";
                    this.refs["resourceFilterName_Input"].value = "";

                    alert("This resource's relationship(s) has been added successfully.")
                }
            }
            else {
                alert("Please enter the required information.")
            }


        }

    }

    _submitRequestAccess(singleResourceExternalId, singleResourceName, singleResourceType, singleResourceReportType) {

        if (this.refs["requestAccessReasonText"].value != "") {
            this._hideOverlays();
            Actions.addResourceAccessRequest(this.state.user_AccountInfo.idUser, this.state.user_AccountInfo.firstName, this.state.user_AccountInfo.lastName, this.state.user_AccountInfo.email, this.state.user_AccountInfo.ADUsername, this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.jobName, singleResourceExternalId, singleResourceName, singleResourceType, singleResourceReportType, this.refs["requestAccessReasonText"].value);
            this.refs["requestAccessReasonText"].value = "";
            alert("Your request has been submitted successfully.")
        }
        else {
            alert("Please enter the required information.")
        }

    }


    _submitFeedback() {

        if (this.refs["feedbackText"].value != "") {
            this._hideOverlays();
            Actions.sendFeedback(this.state.user_AccountInfo.idUser, this.state.user_AccountInfo.firstName, this.state.user_AccountInfo.lastName, this.state.user_AccountInfo.email, this.state.user_AccountInfo.ADUsername, this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.jobName, this.refs["feedbackText"].value);
            this.refs["requestAccessReasonText"].value = "";
            alert("Your feedback has been sent, thank you.")
        }
        else {
            alert("Please enter the required information.")
        }

    }



    _hideOverlays() {
        if (this.refs["layoutSelectionLeft"] != undefined) {
            this.refs["layoutSelectionLeft"].className = "layoutSelectionHidden";
        }
        if (this.refs["layoutSelectionMiddle"] != undefined) {
            this.refs["layoutSelectionMiddle"].className = "layoutSelectionHidden";
        }
        if (this.refs["layoutSelectionRight"] != undefined) {
            this.refs["layoutSelectionRight"].className = "layoutSelectionHidden";
        }
        this.refs["mode_overlay"].className = "mode_hidden";
        this.refs["menu_overlay"].className = "menu_hidden";
        this.refs["profile_overlay"].className = "profile_hidden";
        this.refs["favorites_overlay"].className = "favorites_hidden";
        this.refs["weather_overlay"].className = "weather_hidden";
        this.refs["top10_overlay"].className = "top10_hidden";
        this.refs["topRated10_overlay"].className = "topRated10_hidden";
        this.refs["topTags_overlay"].className = "topTags_hidden";
        this.refs["newest10_overlay"].className = "newest10_hidden";
        this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
        this.refs["overlay"].className = "overlay_hidden";
        this.refs["shared_overlay"].className = "shared_hidden";
        this.refs["logoShared"].className = "logoShared fal fa-handshake";
        this.refs["logoFavorites"].className = "logoFavorites fal fa-star";
        this.refs["logoTop10"].className = "logoTop10 fal fa-file-chart-line";
        this.refs["logoTopRated10"].className = "logoTopRated10 fal fa-thumbs-up";
        this.refs["logoTopTags"].className = "logoTopTags fal fa-hashtag";
        this.refs["logoNewest10"].className = "logoNewest10 fal fa-newspaper";
        this.refs["loggedInUser_Information"].className = "loggedInUser_Information";
        this.refs["logoMenu"].className = "logoMenu fal fa-bars";
        this.refs["logoSupport"].className = "logoSupport fal fa-question-circle";
        this.refs["support_overlay"].className = "support_hidden";

        if (!this.state.isHyperDriveUser) {
            this.refs["logoUpload"].className = "logoUpload fal fa-cloud-arrow-up";
        }

        this.refs["upload_overlay"].className = "upload_hidden";
        this.refs["modal_overlay"].className = "modal_hidden";
        this.refs["modal_container_overlay"].className = "modal_container_hidden";
        this.refs["modal_image_overlay"].className = "modal_image_hidden";
        this.refs["modal_image_header"].className = "modal_image_header_hidden";
        this.refs["modal_feedback_overlay"].className = "modal_feedback_hidden";
        this.refs["modal_feedback_header"].className = "modal_feedback_header_hidden";
        this.refs["modal_JIRA_overlay"].className = "modal_JIRA_hidden";
        this.refs["modal_JIRA_header"].className = "modal_JIRA_header_hidden";
        this.refs["modal_view_overlay"].className = "modal_view_hidden";
        this.refs["modal_view_header"].className = "modal_view_header_hidden";
        this.refs["modal_request_overlay"].className = "modal_request_hidden";
        this.refs["modal_request_header"].className = "modal_request_header_hidden";
        this.refs["modal_help_overlay"].className = "modal_help_hidden";
        this.refs["modal_help_header"].className = "modal_help_header_hidden";
        this.refs["modal_share_overlay"].className = "modal_share_hidden";
        this.refs["modal_share_header"].className = "modal_share_header_hidden";
        this.refs["modal_permission_overlay"].className = "modal_permission_hidden";
        this.refs["modal_permission_header"].className = "modal_permission_header_hidden";
        this.refs["modal_rank_overlay"].className = "modal_rank_hidden";
        this.refs["modal_rank_header"].className = "modal_rank_header_hidden";
        this.refs["modal_addRelationship_header"].className = "modal_addRelationship_header_hidden";
        this.refs["modal_addRelationship_overlay"].className = "modal_addRelationship_hidden";
        this.refs["modal_editGoal_header"].className = "modal_editGoal_header_hidden";
        this.refs["modal_editGoal_overlay"].className = "modal_editGoal_hidden";
        this.refs["modal_addActionPlanItem_header"].className = "modal_addActionPlanItem_header_hidden";
        this.refs["modal_addActionPlanItem_overlay"].className = "modal_addActionPlanItem_hidden";
    }



    _beginSearch() {
        if (this.state.searchTerm != this.refs["headerSearch_Input"].value) {

            this.setState({
                searchTerm: this.refs["headerSearch_Input"].value
            })

            this.setState({
                hash: "#/searchResult/" + encodeURIComponent(this.refs["headerSearch_Input"].value) + "/",
                ignoreHashChange: true
            })
            window.location.hash = "#/searchResult/" + encodeURIComponent(this.refs["headerSearch_Input"].value) + "/";

        }
    }

    _openExternalURL(externalURL) {
        window.open((externalURL).toString().toLowerCase(), '_blank');
    }

    _createJIRAMessage(messageSubject) {
        this.setState({
            JIRAsubject: messageSubject,
            JIRAresourceName: "",
            JIRAresourceType: "",
            JIRAreportType: "",
            JIRAmessageType: "message"
        })
        this._hideOverlays();
        this._showModalOverlay("JIRA");
    }


    _createJIRARequest(messageSubject,resourceName,resourceType,reportType) {
        this.setState({
            JIRAsubject: messageSubject,
            JIRAresourceName: resourceName,
            JIRAresourceType: resourceType,
            JIRAreportType: reportType,
            JIRAmessageType: "resource"
        })
        this._hideOverlays();
        this._showModalOverlay("JIRA");
    }

    _submitJIRAMessage() {

        var JIRAsubject = this.state.JIRAsubject;
        if (this.state.JIRAresourceName != "" && this.state.resourceType != "") {

            JIRAsubject = JIRAsubject + " | Resource: " + this.state.JIRAresourceName + " | Resource Type: " + this.state.resourceType;

            if (this.state.JIRAreportType != "") {
                JIRAsubject = JIRAsubject + " | Report Type: " + this.state.JIRAreportType;
            }
        }
        var JIRAMessageText = "";
        var JIRAContactNumber = this.refs["JIRAContactNumber"].value;
        var JIRAContactFirstName = this.refs["JIRAFirstName"].value;
        var JIRAContactLastName = this.refs["JIRALastName"].value;

        JIRAMessageText = JIRAMessageText + "Logged In User's Name: " + this.state.user_AccountInfo.firstName + " " + this.state.user_AccountInfo.lastName + "\n";
        JIRAMessageText = JIRAMessageText + "Logged In User's Email: " + this.state.user_AccountInfo.email + "\n";
        JIRAMessageText = JIRAMessageText + "Submitted User's Name: " + JIRAContactFirstName + " " + JIRAContactLastName + "\n";
        JIRAMessageText = JIRAMessageText + "Current URL: " + window.location.href + "\n";
        if (this.state.JIRAmessageType == "resource") {

            JIRAMessageText = JIRAMessageText + "Resource Name: " + this.state.JIRAresourceName + "\n";
            JIRAMessageText = JIRAMessageText + "Resource Type: " + this.state.JIRAresourceType + "\n";

            if (this.state.JIRAresourceType == "Report") {

                JIRAMessageText = JIRAMessageText + "Report Type: " + this.state.JIRAreportType + "\n";

            }
        }

        JIRAMessageText = JIRAMessageText + "\n" + "Message: " + "\n" + this.refs["JIRAMessageText"].value;

        if (JIRAContactNumber != "" && JIRAMessageText != "") {

            this._hideOverlays();
            Actions.postJIRATicket(this.state.user_AccountInfo.idUser, JIRAContactFirstName, JIRAContactLastName, this.state.user_AccountInfo.email, JIRAContactNumber, this.state.user_AccountInfo.ADUsername, this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.jobName, JIRAsubject, JIRAMessageText)

            this.refs["JIRAMessageText"].value = "";

            alert("Your ticket has been submitted, LUMI will contact you via Microsoft Teams and an Email will be sent, thank you.")
        }
        else if (JIRAContactNumber == "") {

            alert("Please enter a contact number for support to use to reach out to you.");

        }
        else if (JIRAMessageText == "") {

            alert("Please enter descriptive text to help further explain your support request.");

        }

    }

    _addEpicReport() {

        this.setState({
            resource_createEpicReportsCount: this.state.resource_createEpicReportsCount + 1
        })

    }

    _removeEpicReport() {

        this.setState({
            resource_createEpicReportsCount: this.state.resource_createEpicReportsCount - 1
        })

    }

    _addEditEpicReport() {

        this.setState({
            resource_editEpicReportsCount: this.state.resource_editEpicReportsCount + 1
        })

    }

    _removeEditEpicReport() {

        this.setState({
            resource_editEpicReportsCount: this.state.resource_editEpicReportsCount - 1
        })

    }

    _showSingleResult(externalId, resrouceName) {
        if (this.state.singleResult != externalId) {
            this._navigateToTab("Description");
            this._hideOverlays();
            this.setState({
                singleResult: externalId,
                showResourceRanking: false,
                showUserPermissions: false,
                showAccessGroups: false,
                showRanks: false,
                showCreate: false,
                showGame: false,
                showNotifications: false,
                parentResult: "",
                parentName: "",
                parentType: "",
                parentAssociatedChild: "",
                currentTabLocation: "",
                requestReason: "",
                resource_editMode: false,
                resource_editFileMode: false,
                showMetricGoalsCurrent: true,
                showMetricGoalsFuture: true,
                showMetricGoalsPast: true,
            })
            this.refs["requestAccessReasonText"].value = "";

            this.refs["headerSearch_Input"].value = resrouceName;
            this.refs["bodySearch_Input"].value = resrouceName;

            this.setState({
                searchTerm: "",
                currentSearchText: ""
            })

            this.setState({
                hash: "#/searchResult//" + externalId,
                ignoreHashChange: true
            })
        }
        this._navigateToTab("Description");
        window.location.hash = "#/searchResult//" + externalId;
        this.setState({
            resource_editMode: false,
            resource_editFileMode: false
        })
        Actions.getSingleResource(externalId);
        Actions.getSingleResourceImages(externalId);
        //display loading for relationships
        this.setState({
            loadingRelationships: true
        })
        Actions.getSingleResourceRelationships(externalId, this.state.siteMode);
        Actions.getSingleResourceTagInfo(externalId);

        Actions.getSingleResourceAPGoals(externalId, this.state.siteMode);
        Actions.getSingleResourceAPActions(externalId, this.state.siteMode);
        Actions.getSingleResourceAPTeam(externalId, this.state.siteMode);
        Actions.getSingleResourceAPLog(externalId, this.state.siteMode);
        Actions.getSingleResourceMetricOwner(this.state.singleResult);
        Actions.getSingleResourceMetricGoals(this.state.singleResult);

        //Actions.getSingleResourceDisplaysIn(externalId, this.state.siteMode);
        if (this.state.siteMode == "databayprd") {
            Actions.addResourceView(this.state.user_AccountInfo.idUser, externalId);
        }

        if (this.state.siteMode == "databayccnprd" || this.state.siteMode == "databayccndev") {
            Actions.getSingleResourceCCNAttributes(externalId, this.state.siteMode);
        }
    }

    //TODO: Changed to externalId but needs type.
    _showSingleResultWithSearch(externalId, resrouceName, searchValue) {
        if (this.state.singleResult != externalId) {
            this._navigateToTab("Description");

            this._hideOverlays();
            this.setState({
                singleResult: externalId,
                showResourceRanking: false,
                showUserPermissions: false,
                showAccessGroups: false,
                showRanks: false,
                showCreate: false,
                showGame: false,
                showNotifications: false,
                parentResult: "",
                parentName: "",
                parentType: "",
                parentAssociatedChild: "",
                currentTabLocation: "",
                requestReason: "",
                resource_editMode: false,
                resource_editFileMode: false
            })
            this.refs["requestAccessReasonText"].value = "";

            this.refs["headerSearch_Input"].value = searchValue;
            this.refs["bodySearch_Input"].value = searchValue;

            this.setState({
                searchTerm: searchValue,
                currentSearchText: searchValue
            })

            this.setState({
                hash: "#/searchResult/" + searchValue + "/" + externalId,
                ignoreHashChange: true
            })
            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
            Actions.getSingleResource(externalId);
            Actions.getSingleResourceImages(externalId);
            //display loading for relationships
            this.setState({
                loadingRelationships: true
            })
            Actions.getSingleResourceRelationships(externalId, this.state.siteMode);
            Actions.getSingleResourceTagInfo(externalId);

            Actions.getSingleResourceAPGoals(externalId, this.state.siteMode);
            Actions.getSingleResourceAPActions(externalId, this.state.siteMode);
            Actions.getSingleResourceAPTeam(externalId, this.state.siteMode);
            Actions.getSingleResourceAPLog(externalId, this.state.siteMode);
            //Actions.getSingleResourceDisplaysIn(externalId, this.state.siteMode);
            Actions.getSingleResourceMetricOwner(externalId);
            Actions.getSingleResourceMetricGoals(externalId);

            if (this.state.siteMode == "databayprd") {
                Actions.addResourceView(this.state.user_AccountInfo.idUser, externalId);
            }

            if (this.state.siteMode == "databayccnprd" || this.state.siteMode == "databayccndev") {
                Actions.getSingleResourceCCNAttributes(externalId, this.state.siteMode);
            }
        }

        this._navigateToTab("Description");
        window.location.hash = "#/searchResult/" + searchValue + "/" + externalId;

    }

    _singleResultRemoveRelationship(sourceExternalId, sourceName, sourceType, externalId, resrouceName, searchValue) {
        if (window.confirm("Are you sure you would like to remove this relationship / unsync this resource?")) {
            Actions.removeSingleResourceRelationship(sourceExternalId, externalId);
        }
    }


    _singleResultRemoveTag(externalId, tag) {
        if (window.confirm("Are you sure you would like to remove this tag '" + tag + "' from this resource?")) {
            Actions.removeSingleResourceTag(externalId, tag);
        }
    }

    _showSingleResultWithReportCategorySearch(sourceExternalId, sourceName, sourceType, externalId, resrouceName, searchValue) {
        if (this.state.singleResult != externalId) {
            this._navigateToTab("Description");

            this._hideOverlays();
            this.setState({
                singleResult: externalId,
                showResourceRanking: false,
                showUserPermissions: false,
                showAccessGroups: false,
                showRanks: false,
                showCreate: false,
                showGame: false,
                showNotifications: false,
                parentResult: sourceExternalId,
                parentName: sourceName,
                parentType: sourceType,
                parentAssociatedChild: externalId,
                currentTabLocation: "",
                requestReason: "",
                resource_editMode: false,
                resource_editFileMode: false
            })
            this.refs["requestAccessReasonText"].value = "";

            this.refs["headerSearch_Input"].value = searchValue;
            this.refs["bodySearch_Input"].value = searchValue;

            this.setState({
                searchTerm: searchValue,
                currentSearchText: searchValue
            })

            this.setState({
                hash: "#/searchResult/" + searchValue + "/" + externalId,
                ignoreHashChange: true
            })
            this.setState({
                resource_editMode: false,
                resource_editFileMode: false
            })
            Actions.getSingleResource(externalId);
            Actions.getSingleResourceImages(externalId);
            //display loading for relationships
            this.setState({
                loadingRelationships: true
            })
            Actions.getSingleResourceRelationships(externalId, this.state.siteMode);
            Actions.getSingleResourceTagInfo(externalId);
            //Actions.getSingleResourceDisplaysIn(externalId, this.state.siteMode);

            if (this.state.siteMode == "databayprd") {
                Actions.addResourceView(this.state.user_AccountInfo.idUser, externalId);

                Actions.getSingleResourceMetricOwner(externalId);
                Actions.getSingleResourceMetricGoals(externalId);
            }

            if (this.state.siteMode == "databayccnprd" || this.state.siteMode == "databayccndev") {
                Actions.getSingleResourceCCNAttributes(externalId, this.state.siteMode);
            }
        }

        this._navigateToTab("Description");
        window.location.hash = "#/searchResult/" + searchValue + "/" + externalId;

    }

    _changeMode(mode) {
        this.props.history.push({
            pathname: '/',
            search: "?" + new URLSearchParams({ siteMode: mode }).toString()
        })
        this._hideOverlays();
        if (this.refs["bodySearch_Input"] != undefined) {
            this.refs["bodySearch_Input"].value = "";
        }
        if (this.refs["headerSearch_Input"] != undefined) {
            this.refs["headerSearch_Input"].value = "";
        }
        this.setState({
            currentSearchText: "",
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            reportCategoryResult: "",
            hash: "#/searchResult//",
            siteMode: mode,
            filterResourceType: "Report & Report Category",
            filterReportType: "",
            filterRankType: "",
            resource_IntellisenseInfo: {},
            resource_RelationshipInfo: {}
        })
        window.location.hash = "#/searchResult//"
        this._beginSearch();

        Actions.getResourceTypeListInfo(mode);

        if (mode == "databayprd") {
            this.setState({
                resource_IntellisenseInfo: this.state.resource_StoredDatabayPrd_IntellisenseInfo
            })
            Actions.getResourceIntellisenseInfo("databayprd");
            Actions.getResourceRelationshipInfo("databayprd");
            Actions.getUserListInfo();
            Actions.getTopReportsInfo();
            Actions.getTopTagsInfo();
            Actions.getTopRatedReportsInfo();
            Actions.getNewestReportsInfo();
            Actions.getUserFavoritesInfo(this.state.user_AccountInfo.idUser);
            Actions.getUserSharedInfo(this.state.user_AccountInfo.idUser);
        }
        else if (mode == "databaydev") {
            this.setState({
                resource_IntellisenseInfo: this.state.resource_StoredDatabayDev_IntellisenseInfo
            })
            Actions.getResourceIntellisenseInfo("databaydev");
            Actions.getResourceRelationshipInfo("databaydev");
        }
        else if (mode == "databayccnprd") {
            this.setState({
                resource_IntellisenseInfo: this.state.resource_StoredDatabayCCNPrd_IntellisenseInfo
            })
            Actions.getResourceIntellisenseInfo("databayccnprd");
            Actions.getResourceRelationshipInfo("databayccnprd");
        }
        else if (mode == "databayccndev") {
            this.setState({
                resource_IntellisenseInfo: this.state.resource_StoredDatabayCCNDev_IntellisenseInfo
            })
            Actions.getResourceIntellisenseInfo("databayccndev");
            Actions.getResourceRelationshipInfo("databayccndev");
        }
        else {
            this.setState({
                siteMode: "databayprd",
                resource_IntellisenseInfo: this.state.resource_StoredDatabayPrd_IntellisenseInfo
            })
            Actions.getResourceIntellisenseInfo("databayprd");
            Actions.getResourceRelationshipInfo("databayprd");
            Actions.getUserListInfo();
            Actions.getTopReportsInfo();
            Actions.getTopTagsInfo();
            Actions.getTopRatedReportsInfo();
            Actions.getNewestReportsInfo();
            Actions.getUserFavoritesInfo(this.state.user_AccountInfo.idUser);
            Actions.getUserSharedInfo(this.state.user_AccountInfo.idUser);
        }


    }

    _userLogin() {

        if (msalApp.getAccount()) {
            // User is already logged in
            Actions.getUserAccountInfo();
        } else {
            // User is not logged in, initiate login
            msalApp
                .loginRedirect()
                .then((response) => {
                    // Handle successful sign-in
                    console.log("User signed in", response);
                    window.location.href = "https://databay.aahs.org/api/App/validateAccess";
                })
                .catch((error) => {
                    // Handle sign-in error
                    console.error("Error signing in", error);
                });
        }

    }

    _redirectHome() {
        this._hideOverlays();
        if (this.refs["bodySearch_Input"] != undefined) {
            this.refs["bodySearch_Input"].value = "";
        }
        if (this.refs["headerSearch_Input"] != undefined) {
            this.refs["headerSearch_Input"].value = "";
        }
        this.setState({
            currentSearchText: "",
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            reportCategoryResult: "",
            hash: "#/searchResult//"
        })
        window.location.hash = "#/searchResult//"
        this._beginSearch();
    }

    _redirectToSearch(searchTerm) {
        if (this.refs["bodySearch_Input"] != undefined) {
            this.refs["bodySearch_Input"].value = searchTerm;
        }
        if (this.refs["headerSearch_Input"] != undefined) {
            this.refs["headerSearch_Input"].value = searchTerm;
        }

        this.setState({
            searchTerm: searchTerm,
            currentSearchText: searchTerm,
            singleResult: "",
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            reportCategoryResult: "",
            hash: "#/searchResult/" + searchTerm + "/"
        })

        window.location.hash = "#/searchResult/" + searchTerm + "/"

        this._beginSearch();
    }

    _showSubImage(imageBase64, imageCount) {
        if (this.refs["mainImage_SingleResource"] != undefined) {
            this.refs["mainImage_SingleResource"].src = imageBase64;
        }
    }

    _showMainImageModal(imageBase64) {

        this.setState({
            singleResultImage: this.refs["mainImage_SingleResource"].src
        })

        this._hideOverlays();
        this.refs["modal_overlay"].className = "modal_expanded";
        this.refs["modal_container_overlay"].className = "modal_container_expanded";

        this.refs["modal_image_overlay"].className = "modal_image_expanded";
        this.refs["modal_image_header"].className = "modal_image_header_expanded";

    }

    _removeSubImage(imageBase64, externalId) {

        Actions.removeResourceImage(externalId, imageBase64);
        if (this.refs["mainImage_SingleResource"] != undefined) {
            if (this.refs["mainImage_SingleResource"].src == imageBase64) {
                this.refs["mainImage_SingleResource"].src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            }
        }

    }

    _removeUserFavorite(externalId) {
        Actions.removeUserFavorite(this.state.user_AccountInfo.idUser, externalId);
    }

    _addUserFavorite(externalId) {
        Actions.addUserFavorite(this.state.user_AccountInfo.idUser, externalId);
    }


    _upvoteResource(externalId) {
        Actions.upvoteResource(this.state.user_AccountInfo.idUser, externalId);
    }

    _downvoteResource(externalId) {
        Actions.downvoteResource(this.state.user_AccountInfo.idUser, externalId);
    }

    _removeResourceVote(externalId) {
        Actions.removeResourceVote(this.state.user_AccountInfo.idUser, externalId);
    }


    _removeMetricOwner(idExternalResource_MetricOwner) {
        if (window.confirm("Are you sure you would like to remove this owner?")) {
            Actions.removeSingleResourceMetricOwner(idExternalResource_MetricOwner);
        }
    }

    _removeMetricGoal(idExternalResource_MetricGoal) {
        if (window.confirm("Are you sure you would like to remove this goal?")) {
            Actions.removeSingleResourceMetricGoals(idExternalResource_MetricGoal);
        }
    }

    _editMetricGoal(idExternalResource_MetricGoal) {
        if (window.confirm("Are you sure you would like to remove this goal?")) {
            Actions.removeSingleResourceMetricGoals(idExternalResource_MetricGoal);
        }
    }

    _dropCanvasDragOver(externalId) {

        //alert(1);

    }

    _resyncSingleResource(externalId) {

        Actions.resyncSingleResource(externalId);

    }

    _showCreateResource() {

        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: true,
            showGame: false,
            showNotifications: false,
            resource_createReportType: "",
        })

    }

    _showMyNotifications() {

        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: true,
            resource_createReportType: "",
        })

    }

    _showUserPermissions() {

        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: false,
            showUserPermissions: true,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            resource_createReportType: "",
        })

    }

    _showAccessGroups() {

        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: true,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            resource_createReportType: "",
        })

    }

    _showResourceRanking() {

        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: true,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: false,
            showNotifications: false,
            resource_createReportType: "",
        })

    }

    _showGameResource() {

        Actions.getUserHighScores(this.state.user_AccountInfo.UserDomain, this.state.user_AccountInfo.ADUsername);
        Actions.getTopUsersHighScores();
        this._hideOverlays();
        this._redirectHome();
        this.setState({
            showResourceRanking: false,
            showUserPermissions: false,
            showAccessGroups: false,
            showRanks: false,
            showCreate: false,
            showGame: true,
            showNotifications: false
        })

    }



    _saveCalInvite() {
        // Create the .ics URL
        var teamsLinkURL = `https://teams.microsoft.com/l/meetup-join/19%3Ameeting_ZTYwN2UwZGMtYWRiMS00ODdjLTg3MjctMTQzYzNlMjIxNDJi%40thread.v2/0?context={"Tid"%3A"8cb7de09-a9b2-435c-b453-2c06a1cb5b6c"%2C"Oid"%3A"7af2554d-0314-474a-853d-bb794aff88c6"}`;
        var nextTues = new Date();
        nextTues.setDate(nextTues.getDate() + (2 + 7 - nextTues.getDay()) % 7);

        var nextWed = new Date();
        nextWed.setDate(nextWed.getDate() + (2 + 7 - nextWed.getDay()) % 7);


        var createStartDate = new Date();

        if (nextWed < nextTues) {
            createStartDate = nextWed;
        }
        else {
            createStartDate = nextTues;
        }

        var announcementStartTimeCheck = '12:00:00';
        var announcementEndTimeCheck = '13:00:00';


        var announcementStartDateTimeCheck = new Date(createStartDate.getTime());
        announcementStartDateTimeCheck.setHours(announcementStartTimeCheck.split(":")[0]);
        announcementStartDateTimeCheck.setMinutes(announcementStartTimeCheck.split(":")[1]);
        announcementStartDateTimeCheck.setSeconds(announcementStartTimeCheck.split(":")[2]);

        var announcementEndDateTimeCheck = new Date(createStartDate.getTime());
        announcementEndDateTimeCheck.setHours(announcementEndTimeCheck.split(":")[0]);
        announcementEndDateTimeCheck.setMinutes(announcementEndTimeCheck.split(":")[1]);
        announcementEndDateTimeCheck.setSeconds(announcementEndTimeCheck.split(":")[2]);

        var createEndDate = new Date();
        var createTitle = "IS-Analytics Open Online Office Hours Reminder"
        var createDescription = teamsLinkURL;
        var createLocation = "Microsoft Teams";

        let url = [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "BEGIN:VEVENT",
            "DTSTART:" + this._formatDate(announcementStartDateTimeCheck),
            "DTEND:" + this._formatDate(announcementEndDateTimeCheck),
            "SUMMARY:" + createTitle,
            "DESCRIPTION:" + createDescription,
            "LOCATION:" + createLocation,
            "BEGIN:VALARM",
            "TRIGGER:-PT15M",
            "REPEAT:1",
            "DURATION:PT15M",
            "ACTION:DISPLAY",
            "DESCRIPTION:Reminder",
            "END:VALARM",
            "END:VEVENT",
            "END:VCALENDAR"
        ].join("\n");

        let blob = new Blob([url], { type: 'text/calendar;charset=utf-8' });

        if (/msie\s|trident\/|edge\//i.test(window.navigator.userAgent)) {
            // Open/Save link in IE and Edge
            window.navigator.msSaveBlob(blob, 'ISAnalyticsOpenOfficeHoursReminder.ics');
        } else {
            // Open/Save link in Modern Browsers
            window.open(encodeURI("data:text/calendar;charset=utf8," + url));
        }
        alert("Please open the downloaded outlook event file to add to your calendar a reminder, thanks and see you there!")
    }

    _formatDate(dateString) {
        let dateTime = new Date(dateString);
        return [
            dateTime.getUTCFullYear(),
            this._pad(dateTime.getUTCMonth() + 1),
            this._pad(dateTime.getUTCDate()),
            "T",
            this._pad(dateTime.getUTCHours()),
            this._pad(dateTime.getUTCMinutes()) + "00Z"
        ].join("");
    }

    _pad(num) {
        // Ensure date values are double digits
        return num < 10 ? "0" + num : num;
    }

    _openOfficeHours() {


        var teamsLinkURL = `https://teams.microsoft.com/l/meetup-join/19%3Ameeting_ZTYwN2UwZGMtYWRiMS00ODdjLTg3MjctMTQzYzNlMjIxNDJi%40thread.v2/0?context={"Tid"%3A"8cb7de09-a9b2-435c-b453-2c06a1cb5b6c"%2C"Oid"%3A"7af2554d-0314-474a-853d-bb794aff88c6"}`;
        window.open(teamsLinkURL);


    }



    _manualResyncAllResources() {

        Actions.manualResyncAllResources(this.state.user_AccountInfo.idUser);
        alert("A Complete Sync has been requested." + "\n" + "You may leave this page.")
    }

    _navigateToTab(tabName) {
        if (this.refs["singleResource_NavTab_Description"] != undefined) {

            if (this.state.currentTabLocation == "") {
                this.refs["singleResource_NavTab_Description"].className = "navTab notSelectedTab";
                this.refs["singleResource_ContentBody_Description"].className = "singleResource_ContentBody_Description hidden";
            }
            else {
                if (this.refs["singleResource_NavTab_" + this.state.currentTabLocation] != undefined && this.refs["singleResource_ContentBody_" + this.state.currentTabLocation] != undefined) {
                    this.refs["singleResource_NavTab_" + this.state.currentTabLocation].className = "navTab notSelectedTab";
                    this.refs["singleResource_ContentBody_" + this.state.currentTabLocation].className = "tabContentBody singleResource_ContentBody_" + this.state.currentTabLocation + " hidden";
                }
                else {
                    this.setState({
                        currentTabLocation: "Description"
                    })
                    this.refs["singleResource_NavTab_Description"].className = "navTab notSelectedTab";
                    this.refs["singleResource_ContentBody_Description"].className = "singleResource_ContentBody_Description hidden";
                }
            }

            if (this.refs["singleResource_ContentBody_" + tabName] != undefined) {
                this.refs["singleResource_ContentBody_" + tabName].className = "tabContentBody singleResource_ContentBody_" + tabName;
                this.refs["singleResource_NavTab_" + tabName].className = "navTab selectedTab";
            }

        }
        this.setState({
            currentTabLocation: tabName
        })
    }


    _showHideMetricList(listName) {
        if (listName == "Current") {

            if (this.state.showMetricGoalsCurrent) {

                this.setState({
                    showMetricGoalsCurrent: false
                })
            }
            else {
                this.setState({
                    showMetricGoalsCurrent: true
                })
            }
        }
        else if (listName == "Future") {

            if (this.state.showMetricGoalsFuture) {

                this.setState({
                    showMetricGoalsFuture: false
                })
            }
            else {
                this.setState({
                    showMetricGoalsFuture: true
                })
            }
        }
        else if (listName == "Past") {

            if (this.state.showMetricGoalsPast) {

                this.setState({
                    showMetricGoalsPast: false
                })
            }
            else {
                this.setState({
                    showMetricGoalsPast: true
                })
            }
        }

    }

    _redirectToReportCategory(externalId) {

    }

    render() {
        var isIE = false;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        var trident = ua.indexOf('Trident/');
        var edge = ua.indexOf('Edge/');

        if (msie > 0 || trident > 0 || edge > 0) {
            isIE = true;
        }

        // Detect if embedded in an app
        var isInApp = (window.self !== window.top);

        // Usage
        if (isIE) {
            console.log('Using Internet Explorer (IE)');
        } else {
            console.log('Not using Internet Explorer (IE)');
        }

        if (isInApp) {
            console.log('Embedded in an app');
        } else {
            console.log('Not embedded in an app');
        }
        //Often times this can get ambiguous between items so if you stick with myState then you know you are always
        var myState = this;

        //What I do is create these arrays, which allow me to easily add parts of the page to, then the array itself is just dumped to the page and all of the inner page elements to it render.
        //The arrays can basically hold any / all of your html.
        var headerLogoInfo;
        headerLogoInfo = [];

        var headerProfileInfo;
        headerProfileInfo = [];

        var searchInput;
        searchInput = [];

        var historyMatchListing;
        historyMatchListing = [];

        var historyStartsWithListing;
        historyStartsWithListing = [];

        var historyExactListing;
        historyExactListing = [];

        var intellisenseAllResultsRankListing;
        intellisenseAllResultsRankListing = [];

        var intellisenseRankListing;
        intellisenseRankListing = [];

        var intellisenseMatchListing;
        intellisenseMatchListing = [];

        var intellisenseStartsWithListing;
        intellisenseStartsWithListing = [];

        var intellisenseExactListing;
        intellisenseExactListing = [];

        var intellisenseAllPartialListing;
        intellisenseAllPartialListing = [];

        var intellisenseSomePartialListing;
        intellisenseSomePartialListing = [];


        var bodySingleResultListing;
        bodySingleResultListing = [];

        var bodyAllResultsRankListing;
        bodyAllResultsRankListing = [];

        var bodyRankListing;
        bodyRankListing = [];

        var bodyMatchListing;
        bodyMatchListing = [];

        var bodyStartsWithListing;
        bodyStartsWithListing = [];

        var bodyExactListing;
        bodyExactListing = [];

        var bodyAllPartialListing;
        bodyAllPartialListing = [];

        var bodySomePartialListing;
        bodySomePartialListing = [];

        var bodySimilarListing;
        bodySimilarListing = [];

        var similarListLowercase;
        similarListLowercase = [];

        var similarList;
        similarList = [];

        var similarTagListLowercase;
        similarTagListLowercase = [];

        var similarTagList;
        similarTagList = [];

        var bodyList;
        bodyList = [];

        var bodyTagList;
        bodyTagList = [];

        var bodySimilarList;
        bodySimilarList = [];


        var intellisenseList;
        intellisenseList = [];

        var searchBodyInput;
        searchBodyInput = [];

        var headerWeather;
        headerWeather = [];

        var headerMenu;
        headerMenu = [];

        var headerModeOverlay;
        headerModeOverlay = [];

        var headerMenuOverlay;
        headerMenuOverlay = [];

        var headerWeatherContent;
        headerWeatherContent = [];

        var headerWeatherOverlay;
        headerWeatherOverlay = [];

        var modalOverLay;
        modalOverLay = [];

        var modalHeader;
        modalHeader = [];

        var modalContent;
        modalContent = [];

        var headerProfileOverlay;
        headerProfileOverlay = [];

        var headerFavoritesOverlay;
        headerFavoritesOverlay = [];

        var headerSharedOverlay;
        headerSharedOverlay = [];

        var headerTop10Overlay;
        headerTop10Overlay = [];

        var headerTopTagsOverlay;
        headerTopTagsOverlay = [];

        var headerTopRated10Overlay;
        headerTopRated10Overlay = [];

        var headerSupportOverlay;
        headerSupportOverlay = [];

        var headerUploadOverlay;
        headerUploadOverlay = [];

        var headerNewest10Overlay;
        headerNewest10Overlay = [];

        var headerAddRelationshipOverlay;
        headerAddRelationshipOverlay = [];

        var headerOverlay;
        headerOverlay = [];

        var headerSearch;
        headerSearch = [];

        var resultHeader;
        resultHeader = [];

        var bodyInfo;
        bodyInfo = [];

        var bodyContent;
        bodyContent = [];

        var homeExtras;
        homeExtras = [];

        var resultContent;
        resultContent = [];

        var singleResultContent;
        singleResultContent = [];

        var isHomepage = false;
        if (this.state.searchTerm == "" && this.state.singleResult == "" && this.state.showUserPermissions == false && this.state.showAccessGroups == false && this.state.showRanks == false && this.state.showCreate == false && this.state.showNotifications == false && this.state.showResourceRanking == false && this.state.showGame == false) {
            isHomepage = true;
        }

        var singleResult = this.state.singleResult;

        var singleResultType = "";

        var showResourceRanking = this.state.showResourceRanking;

        var showUserPermissions = this.state.showUserPermissions;

        var showAccessGroups = this.state.showAccessGroups;

        var showRanks = this.state.showRanks;

        var showCreate = this.state.showCreate;

        var showNotifications = this.state.showNotifications;

        var showGame = this.state.showGame;

        var searchText = this.state.currentSearchText ? this.state.currentSearchText.trim() : "";

        var searchTextLength = this.state.currentSearchText ? this.state.currentSearchText.trim().length : 0;

        var user_ListInfo = this.state.user_ListInfo;
        var total_User_ListInfo_Elements = Object.keys(user_ListInfo).length;

        var resource_addRelationship_ResourceList = this.state.resource_addRelationship_ResourceList;
        var total_Resource_addRelationship_ResourceList_Elements = Object.keys(resource_addRelationship_ResourceList).length;



        var user_CreatorListInfo = this.state.user_CreatorListInfo;
        var total_User_CreatorListInfo_Elements = Object.keys(user_CreatorListInfo).length;

        var resource_ResourceTypeListInfo = this.state.resource_ResourceTypeListInfo;
        var total_Resource_ResourceTypeListInfo_Elements = Object.keys(resource_ResourceTypeListInfo).length;

        var resource_ReportTypeListInfo = this.state.resource_ReportTypeListInfo;
        var total_Resource_ReportTypeListInfo_Elements = Object.keys(resource_ReportTypeListInfo).length;

        var resource_QRSYearListInfo = this.state.resource_QRSYearListInfo;
        var total_Resource_QRSYearListInfo_Elements = Object.keys(resource_QRSYearListInfo).length;

        var resource_RankListInfo = this.state.resource_RankListInfo;
        var total_Resource_RankListInfo_Elements = Object.keys(resource_RankListInfo).length;

        var resource_NotificationListInfo = this.state.resource_NotificationListInfo;
        var total_Resource_NotificationListInfo_Elements = Object.keys(resource_NotificationListInfo).length;



        var user_AccountInfo = this.state.user_AccountInfo;
        var total_User_AccountInfo_Properties = Object.keys(user_AccountInfo).length;

        var user_LayoutInfo = this.state.user_LayoutInfo;
        var total_User_LayoutInfo_Properties = Object.keys(user_LayoutInfo).length;

        var user_LayoutLeft = this.state.user_LayoutLeft;
        //var total_User_LayoutLeft_Properties = Object.keys(user_LayoutLeft).length;

        var user_LayoutMiddle = this.state.user_LayoutMiddle;
        //var total_User_LayoutMiddle_Properties = Object.keys(user_LayoutMiddle).length;

        var user_LayoutRight = this.state.user_LayoutRight;
        //var total_User_LayoutRight_Properties = Object.keys(user_LayoutRight).length;

        var user_FavoritesInfo = this.state.user_FavoritesInfo;
        var total_User_FavoritesInfo_Elements = Object.keys(user_FavoritesInfo).length;

        var user_RatingsInfo = this.state.user_RatingsInfo;
        var total_User_RatingsInfo_Elements = Object.keys(user_RatingsInfo).length;

        var user_RatingsInfo = this.state.user_RatingsInfo;
        var total_User_RatingsInfo_Elements = Object.keys(user_RatingsInfo).length;

        var user_PermissionListInfo = this.state.user_PermissionListInfo;
        var total_User_PermissionListInfo_Elements = Object.keys(user_PermissionListInfo).length;

        var user_UsersWithPermissionsListInfo = this.state.user_UsersWithPermissionsListInfo;
        var total_User_UsersWithPermissionsListInfo_Elements = Object.keys(user_UsersWithPermissionsListInfo).length;

        var user_HighScoreInfo = this.state.user_HighScoreInfo;
        var total_User_HighScoreInfo_Elements = Object.keys(user_HighScoreInfo).length;

        var user_TopUsersHighScoreInfo = this.state.user_TopUsersHighScoreInfo;
        var total_User_TopUsersHighScoreInfo_Elements = Object.keys(user_TopUsersHighScoreInfo).length;

        var resource_IntellisenseInfo = this.state.resource_IntellisenseInfo;
        var total_Resource_IntellisenseInfo_Elements = Object.keys(resource_IntellisenseInfo).length;

        var resource_IntellisenseTagInfo = this.state.resource_IntellisenseTagInfo;
        var total_Resource_IntellisenseTagInfo_Elements = Object.keys(resource_IntellisenseTagInfo).length;

        var resource_CustomTagInfo = this.state.resource_CustomTagInfo;

        var resource_BuildTagInfo = this.state.resource_BuildTagInfo;
        var total_Resource_BuildTagInfo_Elements = Object.keys(resource_BuildTagInfo).length;


        var resource_ImageInfo = this.state.resource_ImageInfo;
        var total_Resource_ImageInfo_Elements = Object.keys(resource_ImageInfo).length;

        var resource_BuildThumbImageInfo = this.state.resource_BuildThumbImageInfo;
        //var total_Resource_BuildThumbImageInfo_Elements = Object.keys(resource_BuildThumbImageInfo).length;

        var resource_BuildImageInfo = this.state.resource_BuildImageInfo;
        var total_Resource_BuildImageInfo_Elements = Object.keys(resource_BuildImageInfo).length;

        var resource_BuildRelationshipInfo = this.state.resource_BuildRelationshipInfo;
        var total_Resource_BuildRelationshipInfo_Elements = Object.keys(resource_BuildRelationshipInfo).length;

        var resource_BuildAPGoalsInfo = this.state.resource_BuildAPGoalsInfo;
        var total_Resource_BuildAPGoalsInfo_Elements = Object.keys(resource_BuildAPGoalsInfo).length;

        var resource_BuildAPActionsInfo = this.state.resource_BuildAPActionsInfo;
        var total_Resource_BuildAPActionsInfo_Elements = Object.keys(resource_BuildAPActionsInfo).length;

        var resource_BuildAPTeamInfo = this.state.resource_BuildAPTeamInfo;
        var total_Resource_BuildAPTeamInfo_Elements = Object.keys(resource_BuildAPTeamInfo).length;

        var resource_BuildAPLogInfo = this.state.resource_BuildAPLogInfo;
        var total_Resource_BuildAPLogInfo_Elements = Object.keys(resource_BuildAPLogInfo).length;

        var resource_BuildMetricOwnerInfo = this.state.resource_BuildMetricOwnerInfo;
        var total_Resource_MetricOwnerTeamInfo_Elements = Object.keys(resource_BuildMetricOwnerInfo).length;

        var resource_BuildMetricGoalsInfo = this.state.resource_BuildMetricGoalsInfo;
        var total_Resource_BuildMetricGoalsInfo_Elements = Object.keys(resource_BuildMetricGoalsInfo).length;

        var resource_BuildCCNAttributeInfo = this.state.resource_BuildCCNAttributeInfo;
        var total_Resource_BuildCCNAttributeInfo_Elements = Object.keys(resource_BuildCCNAttributeInfo).length;

        var resource_BuildDisplaysInInfo = this.state.resource_BuildDisplaysInInfo;
        var total_Resource_BuildDisplaysInInfo_Elements = Object.keys(resource_BuildDisplaysInInfo).length;

        var resource_TopReportsInfo = this.state.resource_TopReportsInfo;
        var total_Resource_TopReportsInfo_Elements = Object.keys(resource_TopReportsInfo).length;

        var resource_TopTagsInfo = this.state.resource_TopTagsInfo;
        var total_Resource_TopTagsInfo_Elements = Object.keys(resource_TopTagsInfo).length;

        var user_SharedInfo = this.state.user_SharedInfo;
        var total_User_SharedInfo_Elements = Object.keys(user_SharedInfo).length;

        var resource_TopRatedReportsInfo = this.state.resource_TopRatedReportsInfo;
        var total_Resource_TopRatedReportsInfo_Elements = Object.keys(resource_TopRatedReportsInfo).length;

        var resource_NewestReportsInfo = this.state.resource_NewestReportsInfo;
        var total_Resource_NewestReportsInfo_Elements = Object.keys(resource_NewestReportsInfo).length;

        var user_SearchHistoryInfo = this.state.user_SearchHistory;
        var total_user_SearchHistoryInfo_Elements = Object.keys(resource_IntellisenseInfo).length;


        var resultResourceTypeFilterList;
        resultResourceTypeFilterList = [];

        var resultReportTypeFilterList;
        resultReportTypeFilterList = [];

        var resultQRSYearFilterList;
        resultQRSYearFilterList = [];

        var resultRankFilterList;
        resultRankFilterList = [];

        var displayResourceTypeFilterList;
        displayResourceTypeFilterList = [];

        var displayResourceTypeFilterSelected;
        displayResourceTypeFilterSelected = [];

        var displayReportTypeFilterList;
        displayReportTypeFilterList = [];

        var displayReportTypeFilterSelected;
        displayReportTypeFilterSelected = [];

        var displayQRSYearFilterList;
        displayQRSYearFilterList = [];

        var displayQRSYearFilterSelected;
        displayQRSYearFilterSelected = [];

        var displayRankFilterSelected;
        displayRankFilterSelected = [];

        var displayRankFilterList;
        displayRankFilterList = [];

        var favoritesList;
        favoritesList = [];

        var sharedReportsList;
        sharedReportsList = [];

        var topReportsList;
        topReportsList = [];

        var topTagsList;
        topTagsList = [];

        var topRatedReportsList;
        topRatedReportsList = [];

        var supportList;
        supportList = [];

        var uploadList;
        uploadList = [];

        var newestReportsList;
        newestReportsList = [];

        var favoritesBodyList;
        favoritesBodyList = [];

        var topReportsBodyList;
        topReportsBodyList = [];

        var topTagsBodyList;
        topTagsBodyList = [];

        var sharedReportsBodyList;
        sharedReportsBodyList = [];

        var topRatedReportsBodyList;
        topRatedReportsBodyList = [];

        var topTagsBodyList;
        topTagsBodyList = [];

        var supportBodyList;
        supportBodyList = [];

        var newestReportsBodyList;
        newestReportsBodyList = [];


        var dateStartSearch = new Date();

        var dateEndSearch = new Date();


        var filterResourceType = this.state.filterResourceType;
        var filterReportType = this.state.filterReportType;
        var filterQRSYear = this.state.filterQRSYear;
        var filterRankType = this.state.filterRankType;

        var logoTitle = <span className="logoTitle">Databay</span>;
        var logoSubTitle = "";
        var modeButton = <span className="modeButton"></span>;

        headerLogoInfo.push(
            <div className="logo_Container" key="logo_Container" title="Databay" alt="Databay" ><span className="logoImages"><img className="logoDB3_Loading" src={databay3Logo} /><i className="logoFlag_Loading fas fa-pennant"></i><i className="logoImage_Loading fas fa-signal-alt"></i></span>{logoTitle}{logoSubTitle}<i className="logoHome fas fa-circle-notch fa-spin"></i></div>
        );

        bodyContent.push(
            <div className="loadingSpinner" key="loadingSpinner"><i className="fas fa-circle-notch fa-spin"></i></div>
        );
        if (this.state.isHyperDriveUser && !isInApp) {
            total_User_AccountInfo_Properties = 0;
            headerLogoInfo = (
                <div className="logo_Container" key="logo_Container" title="Databay" alt="Databay" >
                    <span className="logoImages"><img className="logoDB3_Loading" src={databay3Logo} /><i className="logoFlag_Loading fas fa-pennant"></i><i className="logoImage_Loading fas fa-signal-alt"></i></span>
                    {logoTitle}{logoSubTitle}
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                    <div className="loadingUserInfo">
                        <span className="typing-text">Hyperdrive Access Only </span>
                        <span className="typing-cursor">_</span>
                    </div>
                </div>
            );
        }
        else if (this.state.isHyperDriveUser && this.state.hyperdrive_token == '') {
            headerLogoInfo = (
                <div className="logo_Container" key="logo_Container" title="Databay" alt="Databay" >
                    <span className="logoImages"><img className="logoDB3_Loading" src={databay3Logo} /><i className="logoFlag_Loading fas fa-pennant"></i><i className="logoImage_Loading fas fa-signal-alt"></i></span>
                    {logoTitle}{logoSubTitle}
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                    <div className="loadingUserInfo">
                        <span className="typing-text">loading user info </span>
                        <span className="typing-cursor">_</span>
                    </div>
                </div>
            );
        }
        else if (total_User_AccountInfo_Properties == 0) {
            headerLogoInfo = (
                <div className="logo_Container" key="logo_Container" title="Databay" alt="Databay" >
                    <span className="logoImages"><img className="logoDB3_Loading" src={databay3Logo} /><i className="logoFlag_Loading fas fa-pennant"></i><i className="logoImage_Loading fas fa-signal-alt"></i></span>
                    {logoTitle}{logoSubTitle}
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                    <div className="loadingUserInfo">
                        <span className="typing-text">loading user info </span>
                        <span className="typing-cursor">_</span>
                    </div>
                </div>
            );

        }
        else if (total_User_AccountInfo_Properties > 0 && total_Resource_IntellisenseInfo_Elements == 0) {
            headerLogoInfo = (
                <div className="logo_Container" key="logo_Container" title="Databay" alt="Databay" >
                    <span className="logoImages"><img className="logoDB3_Loading" src={databay3Logo} /><i className="logoFlag_Loading fas fa-pennant"></i><i className="logoImage_Loading fas fa-signal-alt"></i></span>
                    {logoTitle}{logoSubTitle}
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                    <TypingAnimation/>
                </div>
            );
        }


        if (total_User_AccountInfo_Properties > 0 && total_Resource_IntellisenseInfo_Elements > 0) {

            searchInput.push(<input className="headerSearch_Input_Hidden" ref="headerSearch_Input" type="text" defaultValue={this.state.searchTerm} onFocus={this._showHeaderIntellisense.bind(this)} onBlur={this._hideHeaderIntellisense.bind(this)} onChange={this._headerSearchTermUpdated.bind(this)} onKeyDown={event => this._handleHeaderKeyDown(event.key)} ></input>);
            searchBodyInput.push(<input className="bodySearch_Input" ref="bodySearch_Input" type="text" placeholder="Search Reports, Business Terms, Metrics..." defaultValue={this.state.searchTerm} onFocus={this._showBodyIntellisense.bind(this)} onBlur={this._hideBodyIntellisense.bind(this)} onChange={this._bodySearchTermUpdated.bind(this)} onKeyDown={event => this._handleBodyKeyDown(event.key)}></input>);

            bodyContent = [];

            logoTitle = <span className="logoTitle" onClick={this._redirectHome.bind(this)}><span title="Databay" alt="Databay" className="logoTitle_Text">Databay</span><span title="Betabay" alt="Betabay" className="betaLogoTitle_Text">Betabay</span></span>;

            if (this.state.user_AccountInfo.permissionLevel != '' && !this.state.isEpicUser) {

                //logoSubTitle = <span className="logoSubTitle">{this.state.user_AccountInfo.permissionLevel}</span>;
                var logoSubTitleMode = "";


                switch (this.state.siteMode) {
                    case "databaydev":
                        logoSubTitleMode = "Developement";
                        break;
                    case "databayccnprd":
                        logoSubTitleMode = "CCN Production";
                        break;
                    case "databayccndev":
                        logoSubTitleMode = "CCN Developement";
                        break;
                    default:
                        logoSubTitleMode = "Production";
                }

                logoSubTitle = <span className="logoSubTitle">{logoSubTitleMode}</span>;

                modeButton = <span className="modeButton"><i className="logoTitle_modeButton fas fa-sort-down"></i></span>
                logoTitle = <span ref="logoTitle_withPermission" className="logoTitle_withPermission" title="Change Mode" alt="Change Mode" onClick={this._toggleMode.bind(this)}><span className="logoTitle_Text">Databay</span><span title="Betabay" alt="Betabay" className="betaLogoTitle_Text"></span>{modeButton}{logoSubTitle}</span>;

            }


            headerLogoInfo = [];


            headerLogoInfo.push(
                <div className="logo_Container" key="logo_Container">
                    <span className="logoImages" onClick={this._redirectHome.bind(this)}>
                        <div className="waveLogoContainer">
                            <svg className="wavesLogo" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                                <defs>
                                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                                </defs>
                                <g className="parallax">
                                    <use xlinkHref="#gentle-wave" x="48" y="0" fill="transparent" stroke="white" />
                                    <use xlinkHref="#gentle-wave" x="48" y="3" fill="transparent" stroke="white" />
                                    <use xlinkHref="#gentle-wave" x="48" y="5" fill="transparent" stroke="white" />
                                    <use xlinkHref="#gentle-wave" x="48" y="3" fill="#6a6a6a" stroke="white" />
                                </g>
                            </svg>
                        </div>
                        <img className="logoDB3" src={databay3Logo} alt="Databay 3" />
                        <i className="logoFlag fas fa-pennant"></i>
                        <i className="logoImage fas fa-signal-alt" title="Databay" alt="Databay"></i>
                    </span>
                    {logoTitle}
                    <i ref="backButton" className="logoLink_Dim far fa-chevron-left" title="Navigate Back" alt="Navigate Back"></i>
                    <i onClick={this._redirectHome.bind(this)} title="Navigate Home" alt="Navigate Home" className="logoHome fal fa-home-lg"></i>
                    <i title="Navigate Forward" alt="Navigate Forward" ref="forwardButton" className="logoLinkRight_Dim far fa-chevron-right"></i>
                    <span className="logoSeparator"></span>
                </div>
            );

            if (this.state.siteMode == "databayprd" && (this.state.isHyperDriveUser)) {

                headerLogoInfo.push(
                    <div className="buttons_Container" key="buttons_Container">
                        <i title="My Favorites" alt="My Favorites" ref="logoFavorites" className="logoFavorites fal fa-star" onClick={this._toggleFavorites.bind(this)}></i>
                        <i title="Shared Resources" alt="Shared Resources" ref="logoShared" className="logoShared fal fa-handshake" onClick={this._toggleShared.bind(this)}></i>
                        <span className="logoPersonalSeparator"></span>
                        <i title="Most Viewed Reports" alt="Most Viewed Reports" ref="logoTop10" className="logoTop10 fal fa-file-chart-line" onClick={this._toggleTop10.bind(this)}></i>
                        <i title="Latest Reports" alt="Latest Reports" ref="logoNewest10" className="logoNewest10 fal fa-newspaper" onClick={this._toggleNewest10.bind(this)}></i>
                        <i title="Top Rated Reports" alt="Top Rated Reports" ref="logoTopRated10" className="logoTopRated10 fal fa-thumbs-up" onClick={this._toggleTopRated10.bind(this)}></i>
                        <i title="Top Resource Tags" alt="Top Resource Tags" ref="logoTopTags" className="logoTopTags fal fa-hashtag" onClick={this._toggleTopTags.bind(this)}></i>
                        <span className="logoUploaderSeparator hidden"></span>
                        <i title="Create Asset" alt="Create Asset" ref="logoUpload" className="logoUpload hidden fal fa-cloud-arrow-up" onClick={this._toggleUpload.bind(this)}></i>
                        <span className="hyperdriveSupportSeparator"></span>
                        <span className="hyperdriveLogoSupport">
                            <i title="Support" alt="Support" ref="logoSupport" className="logoSupport fal fa-question-circle" onClick={this._toggleSupport.bind(this)}></i>
                        </span>
                    </div>
                );
            }
            else if (this.state.siteMode == "databayprd" && (!this.state.isEpicUser || !this.state.isHyperDriveUser)) {

                headerLogoInfo.push(
                    <div className="buttons_Container" key="buttons_Container">
                        <i title="My Favorites" alt="My Favorites" ref="logoFavorites" className="logoFavorites fal fa-star" onClick={this._toggleFavorites.bind(this)}></i>
                        <i title="Shared Resources" alt="Shared Resources" ref="logoShared" className="logoShared fal fa-handshake" onClick={this._toggleShared.bind(this)}></i>
                        <span className="logoPersonalSeparator"></span>
                        <i title="Most Viewed Reports" alt="Most Viewed Reports" ref="logoTop10" className="logoTop10 fal fa-file-chart-line" onClick={this._toggleTop10.bind(this)}></i>
                        <i title="Latest Reports" alt="Latest Reports" ref="logoNewest10" className="logoNewest10 fal fa-newspaper" onClick={this._toggleNewest10.bind(this)}></i>
                        <i title="Top Rated Reports" alt="Top Rated Reports" ref="logoTopRated10" className="logoTopRated10 fal fa-thumbs-up" onClick={this._toggleTopRated10.bind(this)}></i>
                        <i title="Top Resource Tags" alt="Top Resource Tags" ref="logoTopTags" className="logoTopTags fal fa-hashtag" onClick={this._toggleTopTags.bind(this)}></i>
                        <span className="logoUploaderSeparator"></span>
                        <i title="Create Asset" alt="Create Asset" ref="logoUpload" className="logoUpload fal fa-cloud-arrow-up" onClick={this._toggleUpload.bind(this)}></i>
                        <span className="logoSupportSeparator"></span>
                        <i title="Support" alt="Support" ref="logoSupport" className="logoSupport fal fa-question-circle" onClick={this._toggleSupport.bind(this)}></i>
                    </div>
                );
            }
            else if (this.state.siteMode == "databayprd" && (this.state.isEpicUser || this.state.isHyperDriveUser)) {

                headerLogoInfo.push(
                    <div className="buttons_Container" key="buttons_Container">
                        <i title="My Favorites" alt="My Favorites" ref="logoFavorites" className="logoFavorites fal fa-star" onClick={this._toggleFavorites.bind(this)}></i>
                        <i title="Shared Resources" alt="Shared Resources" ref="logoShared" className="logoShared fal fa-handshake" onClick={this._toggleShared.bind(this)}></i>
                        <span className="hidden">
                            <i title="Most Viewed Reports" alt="Most Viewed Reports" ref="logoTop10" className="hidden logoTop10 fal fa-file-chart-line" onClick={this._toggleTop10.bind(this)}></i>
                            <i title="Latest Reports" alt="Latest Reports" ref="logoNewest10" className="hidden logoNewest10 fal fa-newspaper" onClick={this._toggleNewest10.bind(this)}></i>
                            <i title="Top Rated Reports" alt="Top Rated Reports" ref="logoTopRated10" className="hidden logoTopRated10 fal fa-thumbs-up" onClick={this._toggleTopRated10.bind(this)}></i>
                            <i title="Top Resource Tags" alt="Top Resource Tags" ref="logoTopTags" className="hidden logoTopTags fal fa-hashtag" onClick={this._toggleTopTags.bind(this)}></i>
                            <span className="hidden logoUploaderSeparator"></span>
                            <i title="Create Asset" alt="Create Asset" ref="logoUpload" className="hidden logoUpload fal fa-cloud-arrow-up" onClick={this._toggleUpload.bind(this)}></i>
                        </span>
                        <span className="epicSupportSeparator logoSupportSeparator"></span>
                        <span className="epicLogoSupport">
                            <i title="Support" alt="Support" ref="logoSupport" className="logoSupport fal fa-question-circle" onClick={this._toggleSupport.bind(this)}></i>
                        </span>
                    </div>
                );
            }
            else {
                headerLogoInfo.push(
                    <div className="hidden" key="buttons_Container">
                        <i title="My Favorites" alt="My Favorites" ref="logoFavorites" className="logoFavorites fal fa-star" onClick={this._toggleFavorites.bind(this)}></i>
                        <i title="Shared Resources" alt="Shared Resources" ref="logoShared" className="logoShared fal fa-handshake" onClick={this._toggleShared.bind(this)}></i>
                        <span className="logoPersonalSeparator"></span>
                        <i title="Most Viewed Reports" alt="Most Viewed Reports" ref="logoTop10" className="logoTop10 fal fa-file-chart-line" onClick={this._toggleTop10.bind(this)}></i>
                        <i title="Latest Reports" alt="Latest Reports" ref="logoNewest10" className="logoNewest10 fal fa-newspaper" onClick={this._toggleNewest10.bind(this)}></i>
                        <i title="Top Rated Reports" alt="Top Rated Reports" ref="logoTopRated10" className="logoTopRated10 fal fa-thumbs-up" onClick={this._toggleTopRated10.bind(this)}></i>
                        <i title="Top Resource Tags" alt="Top Resource Tags" ref="logoTopTags" className="logoTopTags fal fa-hashtag" onClick={this._toggleTopTags.bind(this)}></i>
                        <span className="logoUploaderSeparator"></span>
                        <i title="Create Asset" alt="Create Asset" ref="logoUpload" className="hidden logoUpload fal fa-cloud-arrow-up" onClick={this._toggleUpload.bind(this)}></i>
                        <span className="logoSupportSeparator"></span>
                        <i title="Support" alt="Support" ref="logoSupport" className="logoSupport fal fa-question-circle" onClick={this._toggleSupport.bind(this)}></i>
                    </div>
                );
            }


            headerProfileInfo.push(
                <span className="loggedInUser_Information" ref="loggedInUser_Information" onClick={this._toggleProfile.bind(this)}><div className="loggedInUser_Initials" key="loggedInUser_Initials" alt={user_AccountInfo.firstName + ' ' + user_AccountInfo.lastName} title={user_AccountInfo.firstName + ' ' + user_AccountInfo.lastName}>{user_AccountInfo.firstName.charAt(0)}{user_AccountInfo.lastName.charAt(0)}</div></span>
            );

            headerMenu.push(
                <div className="logoMenu_Container">
                    <span className="logoSeparator"></span>
                    <i ref="logoMenu" alt="Menu" title="Menu" className="logoMenu fal fa-bars" onClick={this._toggleMenu.bind(this)}></i>
                </div>
            );


            if ((!this.state.isEpicUser || this.state.isHyperDriveUser) && Object.keys(this.state.aamc_WeatherInfo).length > 0 && (this.state.user_AccountInfo.UserDomain == 'aamc' || this.state.user_AccountInfo.UserDomain == 'luminis')) {

                var weatherIcon = [];

                if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "01d") {
                    weatherIcon.push(<i className="weatherIcon fal fa-sun"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "01n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-moon"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "02d") {
                    weatherIcon.push(<i className="weatherIcon fal fa-sun-cloud"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "02n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-moon-cloud"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "03d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "03n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-clouds"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "04d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "04n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-smoke"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "09d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "09n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-showers"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "10d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "10n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-rain"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "11d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "11n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-thunderstorm"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "13d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "13n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-snow"></i>);
                }
                else if ((this.state.aamc_WeatherInfo.weather[0].icon).toString() == "50d" || (this.state.aamc_WeatherInfo.weather[0].icon).toString() == "50n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-fog"></i>);
                }

                var weatherDescription = (this.state.aamc_WeatherInfo.weather[0].description).toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                var weatherTemperature = (Math.round(this.state.aamc_WeatherInfo.main.temp * 2) / 2);

                headerWeather.push(
                    <div onMouseOver={this._toggleWeather.bind(this)} onClick={this._toggleWeather.bind(this)} onMouseOut={this._hideOverlays.bind(this)} className="logoWeather_Container" alt={"Luminis Health AAMC | 21401 | " + weatherTemperature + "*F | " + weatherDescription} title={"Luminis Health AAMC | 21401 | " + weatherTemperature + "*F | " + weatherDescription}>
                        {weatherIcon}<span className="weatherInfo">{Math.round(this.state.aamc_WeatherInfo.main.temp * 2) / 2}<span ref="logoDegree" className="logoDegree"></span>F</span>
                    </div>
                );



                headerWeatherContent.push(
                    <div className="standardMenu">
                        <div className="hidden">Weather</div>
                        <div className="overlay_Weather_Content">
                            <table className="overlay_Weather_Table">
                                <tbody>
                                    <tr>
                                        <td className="weatherIcon_Container">
                                            {weatherIcon}
                                            <div className="weatherDescription">
                                                {weatherDescription}
                                            </div>
                                        </td>
                                        <td className="weatherAddress">
                                            <div><div className="luminisLogo_Black_Icon"></div>Luminis Health</div>
                                            <div className="weatherLocationAddress">Anne Arundel Medical Center</div>
                                            <div>2001 Medical Parkway</div>
                                            <div>Annapolis, Maryland 21401</div>
                                        </td>
                                        <td className="weatherTemp_Container">
                                            <span className="weatherCurrentTempInfo">{Math.round(this.state.aamc_WeatherInfo.main.temp * 2) / 2}<span ref="weatherCurrentTempDegree" className="weatherCurrentTempDegree"></span></span>
                                            <table className="weatherHighLowTempInfo">
                                                <tbody>
                                                    <tr>
                                                        <td className="weatherHighLowLabel">
                                                            High:
                                                        </td>
                                                        <td className="weatherHighLowValue">
                                                            {Math.round(this.state.aamc_WeatherInfo.main.temp_max * 2) / 2}<span ref="logoDegree" className="logoHighDegree"></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="weatherHighLowLabel">
                                                            Low:
                                                        </td>
                                                        <td className="weatherHighLowValue">
                                                            {Math.round(this.state.aamc_WeatherInfo.main.temp_min * 2) / 2}<span ref="logoDegree" className="logoLowDegree"></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                );


            }


            else if ((!this.state.isEpicUser || this.state.isHyperDriveUser) && Object.keys(this.state.dcmc_WeatherInfo).length > 0 && (this.state.user_AccountInfo.UserDomain == 'dcmc')) {

                var weatherIcon = [];

                if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "01d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "01n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-sun"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "02d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "02n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-sun-cloud"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "03d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "03n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-clouds"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "04d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "04n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-smoke"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "09d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "09n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-showers"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "10d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "10n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-rain"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "11d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "11n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-thunderstorm"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "13d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "13n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-cloud-snow"></i>);
                }
                else if ((this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "50d" || (this.state.dcmc_WeatherInfo.weather[0].icon).toString() == "50n") {
                    weatherIcon.push(<i className="weatherIcon fal fa-fog"></i>);
                }

                var weatherDescription = (this.state.dcmc_WeatherInfo.weather[0].description).toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                var weatherTemperature = (Math.round(this.state.dcmc_WeatherInfo.main.temp * 2) / 2);

                headerWeather.push(
                    <div className="logoWeather_Container" alt={"Luminis Health DCMC | 20706 | " + weatherTemperature + "*F | " + weatherDescription} title={"Luminis Health DCMC | 20706 | " + weatherTemperature + "*F | " + weatherDescription}>
                        {weatherIcon}<span className="weatherInfo">{Math.round(this.state.dcmc_WeatherInfo.main.temp * 2) / 2}<span ref="logoDegree" className="logoDegree"></span>F</span>
                    </div>
                );

            }

            else {

                headerWeather.push(
                );

            }

            headerWeatherOverlay.push(
                <div ref="weather_overlay" className="weather_hidden">
                    {headerWeatherContent}
                </div>
            );

            //THEME CHANGES
            var availableThemes = ["Classic", "Modern"];

            var themeOptions;
            themeOptions = [];

            var themeChangerContainer;
            themeChangerContainer = [];
            if (this.state.user_Theme == "Classic") {
                //themeOptions.push(<option value="Classic" selected>Classic</option>);
            }
            else {
                //themeOptions.push(<option value="Classic">Classic</option>);
            }
            if (this.state.user_Theme == "Modern") {
                themeOptions.push(<option value="Modern" selected>Modern</option>);
            }
            else {
                themeOptions.push(<option value="Modern">Modern</option>);
            }

            themeChangerContainer = <select defaultValue={this.state.user_LayoutInfo.theme} onChange={this._updateTheme.bind(this)} id="themeChanger" ref="themeChanger" className="themeChanger">
                <option value="" hidden>Select an option</option>
                {themeOptions}
            </select>


            var headerMenuContent;
            headerMenuContent = [];
            var headerMenuAdminContent;
            headerMenuAdminContent = [];
            headerMenuContent.push(
                <div className="standardMenu">
                    <div className="overlay_Menu_Header">Menu</div>
                    <div className="overlay_Menu_Content">
                        <div className="menuItem" >
                            <i className="menuIcon fal fa-laptop-code"></i> <span>Theme</span>{themeChangerContainer}
                        </div>
                        <div className="menuItem hidden" >
                            <i className="menuIcon far fa-sync-alt"></i> <span>Notifications<select><option>SMS and Email</option><option>SMS Only</option><option>Email Only</option></select></span>
                        </div>
                        <div className="menuItem hidden" >
                            <i className="menuIcon far fa-sync-alt"></i> <span>About this App</span>
                        </div>
                        <div className="menuItem selectableMenuItem" onClick={this._showModalOverlay.bind(this, 'feedback')}>
                            <i className="menuIcon fal fa-envelope-open-text"></i> <span>Send Feedback</span>
                        </div>
                        <div className="menuItem selectableMenuItem" onClick={this._showMyNotifications.bind(this)}>
                            <i className="menuIcon fa-light fa-bell-exclamation"></i> <span>My Notifications</span>
                        </div>
                    </div>
                </div>
            );


            var headerModeContent;
            headerModeContent = [];
            var headerModeDBPrd = [];
            var headerModeDBDev = [];
            var headerModeCCNPrd = [];
            var headerModeCCNDev = [];

            headerModeDBPrd.push(<div className="menuItem selectableMenuItem" onClick={this._changeMode.bind(this, 'databayprd')}>
                <i className="pennantModeIcon fas fa-pennant"></i><i className="databayModeIcon fas fa-signal-alt"></i><span className="modeText">Databay Production</span>
            </div>);

            if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") && !this.state.isEpicUser) {
                headerModeDBDev.push(<div className="menuItem selectableMenuItem" onClick={this._changeMode.bind(this, 'databaydev')}>
                    <i className="menuIcon fal fa-laptop-code"></i><span className="modeText">Databay Development</span>
                </div>);
            }

            headerModeCCNPrd.push(<div className="menuItem selectableMenuItem" onClick={this._changeMode.bind(this, 'databayccnprd')}>
                <i className="menuIcon fal fa-hospital-user"></i><span className="modeText">CCN Production</span>
            </div>);
            headerModeCCNDev.push(<div className="menuItem selectableMenuItem hidden" onClick={this._changeMode.bind(this, 'databayccndev')}>
                <i className="menuIcon fal fa-user-hard-hat"></i><span className="modeText">CCN Development</span>
            </div>);


            switch (this.state.siteMode) {
                case "databaydev":
                    headerModeDBDev = [];
                    break;
                case "databayccnprd":
                    headerModeCCNPrd = [];
                    break;
                case "databayccndev":
                    headerModeCCNDev = [];
                    break;
                default:
                    headerModeDBPrd = [];
            }

            headerModeContent.push(
                <div className="modeList">
                    <div className="overlay_Mode_Content">
                        {headerModeDBPrd}
                        {headerModeDBDev}
                        {headerModeCCNPrd}
                        {headerModeCCNDev}
                    </div>
                </div>
            );


            //JUMPING IN AS A USER
            var jumpList;
            jumpList = [];
            var jumpListContainer;
            jumpListContainer = [];

            var strippedUserList;

            strippedUserList = Object.values(user_ListInfo).filter(value => (value['idUser']).toString().toLowerCase() != user_AccountInfo["idUser"].toLowerCase())
            strippedUserList = Object.values(user_ListInfo).filter(value => (value["lastName"]).toString().toLowerCase() != "" && (value["firstName"]).toString().toLowerCase() != "")

            var totalStrippedUsers = strippedUserList.length;

            if (totalStrippedUsers > 0) {

                Object.values(strippedUserList).forEach(element => {
                    jumpList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>)
                });
                jumpListContainer.push(<select>{jumpList}</select>)

            }
            else {

                jumpListContainer.push(<select disabled={true} defaultValue=""><option value="" disabled>No Users Available</option></select>)

            }

            if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") && !this.state.isEpicUser) {

                var adminContent;
                adminContent = [];

                adminContent.push(
                    <div className="menuItem hidden">
                        <i className="menuIcon far fa-sync-alt"></i> <span>Log in as User</span>{jumpListContainer}
                    </div>
                );

                adminContent.push(
                    <div className="menuItem selectableMenuItem" onClick={this._showCreateResource.bind(this)}>
                        <i className="menuIcon fal fa-plus-square"></i> <span>Create Resource</span>
                    </div>
                );
                adminContent.push(
                    <div className="menuItem hidden" onClick={this._manualResyncAllResources.bind(this)}>
                        <i className="menuIcon fal fa-sync-alt"></i> <span>Sync All Resources</span>
                    </div>
                );

                if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' && !this.state.isEpicUser)) {

                    adminContent.push(
                        <div className="menuItem selectableMenuItem" onClick={this._showUserPermissions.bind(this)}>
                            <i className="menuIcon fal fa-users"></i> <span>User Permissions</span>
                        </div>
                    );

                    adminContent.push(
                        <div className="menuItem selectableMenuItem" onClick={this._showAccessGroups.bind(this)}>
                            <i className="menuIcon fal fa-user-group"></i> <span>Access Groups</span>
                        </div>
                    );

                    adminContent.push(
                        <div className="menuItem selectableMenuItem" onClick={this._showResourceRanking.bind(this)}>
                            <i className="menuIcon fal fa-trophy"></i> <span>Resource Ranks</span>
                        </div>
                    );

                }

                headerMenuAdminContent.push(
                    <div className="adminMenu">
                        <div className="overlay_Menu_Header">Admin Menu</div>
                        <div className="overlay_Menu_Content">
                            {adminContent}
                        </div>
                    </div>
                );
            }

            if (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {

                var adminContent;
                adminContent = [];

                adminContent.push(
                    <div className="menuItem selectableMenuItem" onClick={this._showCreateResource.bind(this)}>
                        <i className="menuIcon fal fa-plus-square"></i> <span>Create Resource</span>
                    </div>
                );

                headerMenuAdminContent.push(
                    <div className="adminMenu">
                        <div className="overlay_Menu_Header">Admin Menu</div>
                        <div className="overlay_Menu_Content">
                            {adminContent}
                        </div>
                    </div>
                );
            }


            headerMenuOverlay.push(
                <div ref="menu_overlay" className="menu_hidden">
                    {headerMenuContent}
                    {headerMenuAdminContent}
                </div>
            );

            headerModeOverlay.push(
                <div ref="mode_overlay" className="mode_hidden">
                    {headerModeContent}
                </div>
            );

            headerProfileOverlay.push(
                <div ref="profile_overlay" className="profile_hidden">
                    <div className="overlay_Header">My Profile</div>
                    <div className="overlay_Content">
                        <div className="overlay_input">
                            <div className="overlay_inputLabel">
                                First Name
                            </div>
                            <div className="overlay_inputFormField">
                                <input className="profile_inputFormField" type="text" defaultValue={user_AccountInfo.firstName} disabled={true} />
                            </div>
                        </div>
                        <div className="overlay_input">
                            <div className="overlay_inputLabel">
                                Last Name
                            </div>
                            <div className="overlay_inputFormField">
                                <input className="profile_inputFormField" type="text" defaultValue={user_AccountInfo.lastName} disabled={true} />
                            </div>
                        </div>
                        <div className="overlay_input">
                            <div className="overlay_inputLabel">
                                Email Address
                            </div>
                            <div className="overlay_inputFormField">
                                <input className="profile_inputFormField" type="text" defaultValue={user_AccountInfo.email} disabled={true} />
                            </div>
                        </div>
                        <div className="overlay_input hidden">
                            <div className="overlay_inputLabel">
                                Phone Number
                            </div>
                            <div className="overlay_inputFormField">
                                <input className="profile_inputFormField" type="text" defaultValue={user_AccountInfo.phoneNumber} disabled={true} />
                            </div>
                        </div>
                    </div>
                </div>
            );


            resource_TopReportsInfo = Object.values(resource_TopReportsInfo).reduce((temp, value) => {
                if (temp.length < 10)
                    temp.push(value);
                return temp;
            }, []);

            resource_TopTagsInfo = Object.values(resource_TopTagsInfo).reduce((temp, value) => {
                if (temp.length < 10)
                    temp.push(value);
                return temp;
            }, []);


            resource_TopRatedReportsInfo = Object.values(resource_TopRatedReportsInfo).reduce((temp, value) => {
                if (temp.length < 10)
                    temp.push(value);
                return temp;
            }, []);

            resource_NewestReportsInfo = Object.values(resource_NewestReportsInfo).reduce((temp, value) => {
                if (temp.length < 10)
                    temp.push(value);
                return temp;
            }, []);

            Object.values(user_FavoritesInfo).forEach(element => {
                favoritesList.push(<div className="favoriteInfo_HeaderElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
                favoritesBodyList.push(<div className="favoriteInfo_BodyElement bodyElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
            });

            Object.values(user_SharedInfo).forEach(element => {
                sharedReportsList.push(<div className="sharedInfo_HeaderElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
                sharedReportsBodyList.push(<div className="sharedInfo_BodyElement bodyElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
            });


            Object.values(resource_TopReportsInfo).forEach(element => {
                topReportsList.push(<div className="top10Info_HeaderElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
                topReportsBodyList.push(<div className="top10Info_BodyElement bodyElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
            });


            Object.values(resource_TopTagsInfo).forEach(element => {
                topTagsList.push(<div className="topTagsInfo_HeaderElement" onClick={this._handleSimilarMouseClick.bind(this, '#' + element.tag)}>#{element.tag}</div>);
                topTagsBodyList.push(<div className="topTagsInfo_BodyElement bodyElement" onClick={this._handleSimilarMouseClick.bind(this, '#' + element.tag)}>#{element.tag}</div>);
            });

            Object.values(resource_TopRatedReportsInfo).forEach(element => {
                topRatedReportsList.push(<div className="topRated10Info_HeaderElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
                topRatedReportsBodyList.push(<div className="topRated10Info_BodyElement bodyElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
            });
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._createJIRAMessage.bind(this, "Databay: Request a New Report / Dashboard")}>Request a New Report / Dashboard</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._createJIRAMessage.bind(this, "Databay: Modify an Existing Report / Dashboard")}>Modify an Existing Report / Dashboard</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._createJIRAMessage.bind(this, "Databay: Report a Data Validation / Integrity Issue")}>Report a Data Validation / Integrity Issue</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._createJIRAMessage.bind(this, "Databay: Request Databay Training")}>Request Databay Training</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._createJIRAMessage.bind(this, "Databay: Request Access for Employee")}>Request Access for Employee</div>);
            /*
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._openExternalURL.bind(this, "https://agilepm.aahs.org/servicedesk/customer/portal/1/create/65")}>Request a New Report / Dashboard</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._openExternalURL.bind(this, "https://agilepm.aahs.org/servicedesk/customer/portal/1/create/66")}>Modify an Existing Report / Dashboard</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._openExternalURL.bind(this, "https://agilepm.aahs.org/servicedesk/customer/portal/1/create/67")}>Report a Data Validation / Integrity Issue</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._openExternalURL.bind(this, "https://agilepm.aahs.org/servicedesk/customer/portal/1/create/30")}>Request Databay Training</div>);
            supportList.push(<div className="supportInfo_HeaderElement" onClick={this._openExternalURL.bind(this, "https://agilepm.aahs.org/servicedesk/customer/portal/1/create/122")}>Request Access for Employee</div>);
            */

            uploadList.push(
                <div className="uploadInfo_HeaderElement">
                    <FileUpload />
                </div>);


            Object.values(resource_NewestReportsInfo).forEach(element => {
                newestReportsList.push(<div className="newest10Info_HeaderElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
                newestReportsBodyList.push(<div className="newest10Info_BodyElement bodyElement" onClick={this._showSingleResult.bind(this, element.externalId, element.resourceName)}>{element.resourceName}</div>);
            });

            headerFavoritesOverlay.push(
                <div ref="favorites_overlay" className="favorites_hidden">
                    <div className="overlay_Header"><i title="My Favorites" alt="My Favorites" className="overlayFavoritesIcon fal fa-star"></i>My Favorites</div>
                    <div className="overlay_Content">
                        {favoritesList}
                    </div>
                </div>
            );

            headerTopRated10Overlay.push(
                <div ref="topRated10_overlay" className="topRated10_hidden">
                    <div className="overlay_Header"><i title="Top Rated Reports" alt="Top Rated Reports" className="overlayTopRated10Icon fal fa-thumbs-up"></i>Top Rated Reports</div>
                    <div className="overlay_Content">
                        {topRatedReportsList}
                    </div>
                </div>
            );

            headerSupportOverlay.push(
                <div ref="support_overlay" className="support_hidden">
                    <div className="overlay_Header"><i title="Support" alt="Support" className="overlaySupportIcon fal fa-question-circle"></i>Support Requests</div>
                    <div className="overlay_Content">
                        {supportList}
                    </div>
                </div>
            );

            headerUploadOverlay.push(
                <div ref="upload_overlay" className="upload_hidden">
                    <div className="overlay_Header"><i title="Create Asset" alt="Create Asset" className="overlayUploadIcon fal fa-cloud-arrow-up"></i>Create Asset</div>
                    <div className="overlay_Content">
                        {uploadList}
                    </div>
                </div>
            );

            headerSharedOverlay.push(
                <div ref="shared_overlay" className="shared_hidden">
                    <div className="overlay_Header"><i title="Shared Resources" alt="Shared Resources" className="overlaySharedIcon fal fa-handshake"></i>Shared Resources</div>
                    <div className="overlay_Content">
                        {sharedReportsList}
                    </div>
                </div>
            );

            headerTop10Overlay.push(
                <div ref="top10_overlay" className="top10_hidden">
                    <div className="overlay_Header"><i title="Most Viewed Reports" alt="Most Viewed Reports" className="overlayTop10Icon fal fa-file-chart-line"></i>Most Viewed Reports</div>
                    <div className="overlay_Content">
                        {topReportsList}
                    </div>
                </div>
            );

            headerTopTagsOverlay.push(
                <div ref="topTags_overlay" className="topTags_hidden">
                    <div className="overlay_Header"><i title="Top Resource Tags" alt="Top Resource Tags" className="overlayTopTagsIcon fal fa-hashtag"></i>Top Resource Tags</div>
                    <div className="overlay_Content">
                        {topTagsList}
                    </div>
                </div>
            );

            headerNewest10Overlay.push(
                <div ref="newest10_overlay" className="newest10_hidden">
                    <div className="overlay_Header"><i title="Latest Reports" alt="Latest Reports" className="overlayNewest10Icon fal fa-newspaper"></i>Latest Reports</div>
                    <div className="overlay_Content">
                        {newestReportsList}
                    </div>

                </div>
            );


            headerOverlay.push(
                <div ref="overlay" className="overlay_hidden" onClick={this._hideOverlays.bind(this)}>
                </div>
            );





            var partialArray;
            var reportCount = 0;
            var reportCategoryCount = 0;
            var qrsCount = 0;
            var actionPlanCount = 0;
            var stakeholderCount = 0;
            var metricCount = 0;
            var businessTermCount = 0;
            var componentCount = 0;
            var acronymCount = 0;
            var resourceCount = 0;
            var filteredCount = 0;
            var intellisenseCount = 0;
            var historyCount = 0;
            var bodyCount = 0;
            var similarCount = 0;
            var similarTagCount = 0;
            var ccnBusinessLeadCount = 0;
            var ccnCMEProgramCount = 0;
            var ccnEMRSystemCount = 0;
            var ccnValueBasedContractCount = 0;
            var ccnProviderCount = 0;
            var ccnProviderSpecialtyCount = 0;
            var ccnPracticeManagerCount = 0;
            var ccnPracticeCount = 0;



            intellisenseList.push(<div ref="intellisenseTop" className="intellisenseTop"></div>);

            //Display all history if no search text and not single result
            if (total_user_SearchHistoryInfo_Elements > 0 && searchText == "") {

                Object.values(user_SearchHistoryInfo)
                    .forEach(value => {
                        historyCount = historyCount + 1;
                        intellisenseCount = intellisenseCount + 1;
                        historyMatchListing.push(<div id={"historyMatchListing_" + intellisenseCount} ref={"resource_Intellisense_" + intellisenseCount} onClick={this._handleMouseClick.bind(this)} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value)} className="resource_Intellisense"><i className="intellisenseHistory fal fa-history"></i><span alt={value} title={value}>{value}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="history" /></div>)
                    });

                if (historyCount > 0) {
                    intellisenseList.push(historyMatchListing);
                    intellisenseList.push(historyStartsWithListing);
                    intellisenseList.push(historyExactListing);
                }
            }
            if (showGame) {

                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);

                //Load Top 5 Scores
                //Load Top 5 Scores for this person


                var userHighScore;
                userHighScore = [];

                var userTopUsersHighScore;
                userTopUsersHighScore = [];
                var userHighScoreCount = 0;
                var topUsersHighScoreCount = 0;
                var highScoreRank = [];
                Object.values(user_HighScoreInfo)
                    .forEach(value => {
                        userHighScoreCount = userHighScoreCount + 1;
                        userHighScore.push(<tr><td className="userHighScoreInfo_Rank">{userHighScoreCount}</td><td className="userHighScoreInfo_Info"><div className="userHighScoreInfo_Name">{value["firstName"]} {value["lastName"].charAt(0)}</div><div className="userHighScoreInfo_Score">{value["score"]}</div></td></tr>);
                    })

                userHighScoreCount = userHighScoreCount + 1;

                for (var i = userHighScoreCount; i <= 5; i++) {
                    userHighScore.push(<tr><td className="userHighScoreInfo_Rank">{i}</td><td className="userHighScoreInfo_Info"><div className="userHighScoreInfo_Name"></div><div className="userHighScoreInfo_Score"></div></td></tr>);
                }


                Object.values(user_TopUsersHighScoreInfo)
                    .forEach(value => {
                        topUsersHighScoreCount = topUsersHighScoreCount + 1;
                        highScoreRank = [];
                        if (topUsersHighScoreCount == 1) {
                            highScoreRank.push(<div className="rankHolder"><div className="goldRank"></div></div>);
                        }
                        else if (topUsersHighScoreCount == 2) {
                            highScoreRank.push(<div className="rankHolder"><div className="silverRank"></div></div>);
                        }
                        else if (topUsersHighScoreCount == 3) {
                            highScoreRank.push(<div className="rankHolder"><div className="bronzeRank"></div></div>);
                        }
                        userTopUsersHighScore.push(<tr><td className="userTopUsersHighScoreInfo_Rank">{topUsersHighScoreCount}{highScoreRank}</td><td className="userTopUsersHighScoreInfo_Info"><div className="userTopUsersHighScoreInfo_Name">{value["firstName"]} {value["lastName"].charAt(0)}</div><div className="userTopUsersHighScoreInfo_Score">{value["score"]}</div></td></tr>);
                    })

                topUsersHighScoreCount = topUsersHighScoreCount + 1;

                for (var i = topUsersHighScoreCount; i <= 5; i++) {
                    userTopUsersHighScore.push(<tr><td className="userTopUsersHighScoreInfo_Rank">{i}</td><td className="userTopUsersHighScoreInfo_Info"><div className="userTopUsersHighScoreInfo_Name"></div><div className="userTopUsersHighScoreInfo_Score"></div></td></tr>);
                }

                bodyList.push(
                    <div className="gameHolder">
                        <i className="gameSpinner fas fa-circle-notch fa-spin"></i>
                        <iframe ref="game" className="game" src={"game.html?domain=" + this.state.user_AccountInfo.UserDomain + "&username=" + this.state.user_AccountInfo.ADUsername}>
                        </iframe>
                        <div className="scoreHolder">
                            <table className="scoreListing">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="userTopUsersHighScore_Label">Top High Scores</div>
                                            <table className="userTopUsersHighScore"><tbody>{userTopUsersHighScore}</tbody></table>
                                        </td>
                                        <td>
                                            <div className="userHighScoreInfo_Label">My High Score</div>
                                            <table className="userHighScoreInfo"><tbody>{userHighScore}</tbody></table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>);
            }

            else if (showUserPermissions) {
                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);

                var permissionOptions;
                permissionOptions = [];

                Object.values(user_PermissionListInfo).forEach(element => {
                    permissionOptions.push(<option value={element["name"]}>{element["name"]}</option>);
                });


                var permissionListing = [];
                var userWithPermissions = [];
                var userCount = 0;
                Object.values(user_PermissionListInfo).forEach(element => {

                    userWithPermissions = [];
                    userCount = 0;
                    Object.values(user_UsersWithPermissionsListInfo)
                        .filter(value => (value['permissionLevel']).toString().toLowerCase() == (element["name"]).toString().toLowerCase())
                        .forEach(value => {
                            if (value["ADUsername"] == this.state.user_AccountInfo.ADUsername) {
                                userWithPermissions.push(
                                    <div ref={"user" + value["ADUsername"]} className={"permissionUser permissionSelf"}>
                                        {value["lastName"]},{value["firstName"]} ({value["email"]})
                                    </div>
                                );
                            }
                            else {
                                userWithPermissions.push(
                                    <div ref={"user" + value["ADUsername"]} className={"permissionUser"} title="Remove User" alt="Remove User" onClick={this._removeUserPermission.bind(this, value["ADUsername"], value["UserDomain"])}>
                                        {value["lastName"]},{value["firstName"]} ({value["email"]})<span className="removeUserPermission">+</span>
                                    </div>
                                );
                            }
                            userCount++;
                        });

                    if (userCount == 0) {

                        userWithPermissions.push(
                            <div className={"noPermissionUser"}>
                                None
                            </div>
                        );
                    }

                    permissionListing.push(
                        <div ref={"permissionListing_" + element["name"]} className="permissionListing">
                            <table className="permissionTableHeader">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="permissionNameHeader">
                                                {element["name"]}<span className="permissionUserCount">({userCount})</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="permissionAddUserHeader" title="Add User" alt="Add User" onClick={this._showModalPermission.bind(this, element["name"])}>
                                                +
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="permissionDescription">
                                {element["description"]}
                            </div>
                            <div ref={"permissionUserList_" + element["name"]} className={"permissionUserList"}>
                                {userWithPermissions}
                            </div>
                        </div>
                    );

                });

                var permissionBody = [];

                permissionBody.push(
                    <div ref="bodyPermissionsHeader" className="userpermissions_Header">
                        <span className="fal fa-users"></span> User Permissions
                    </div>
                );
                permissionBody.push(
                    <div ref="bodyPermissionsListing" className="userpermissions_Body">
                        {permissionListing}
                    </div>
                );

                bodyList.push(permissionBody);


            }



            else if (showAccessGroups) {
                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);
                bodyList.push(<div className="accessGroupsContainer"><AccessGroups user_AccountInfo={this.state.user_AccountInfo} /></div>);

            }



            else if (showResourceRanking) {
                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);


                var rankListing = [];
                var resourceRank = [];
                var rankCount = 0;
                Object.values(resource_RankListInfo).forEach(element => {

                    resourceRank.push(
                        <tr>
                            <td>
                                {element["rankName"]}
                            </td>
                            <td>
                                <div style={{ borderRight: "27px solid " + element["hexBackgroundColor"] }}>{element["hexBackgroundColor"]}</div>
                            </td>
                            <td>
                                {element["points"]}
                            </td>
                            <td>
                                {element["isFilterable"]}
                            </td>
                            <td>
                                {element["isInAllResults"]}
                            </td>
                            <td>
                                {element["description"]}
                            </td>
                        </tr>
                    );
                    /*

                            <td>
                                <span className="editRank" onClick={this._showEditModalRank.bind(this, element["idRank"], element["rankName"], element["hexBackgroundColor"], element["points"], element["isFilterable"], element["isInAllResults"], element["description"])}><i className="fa-light fa-pen-to-square"></i></span>
                            </td>
                            <td>
                                <span className="removeRank" onClick={this._removeRank.bind(this, element["idRank"])}>+</span>
                            </td>
                    */
                    rankCount++;
                });

                rankListing.push(
                    <div ref={"rankListing"} className="rankListing">
                        <table className="rankTableHeader">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="rankNameHeader">
                                            Resource Ranks<span className="rankCount">({rankCount})</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div ref={"rankList"} className={"rankList"}>
                            <div ref={"rank"} className={"resourceRank"}>
                                <table className="rankTableBody">
                                    <thead>
                                        <tr>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Color
                                            </th>
                                            <th>
                                                Points
                                            </th>
                                            <th>
                                                Filterable
                                            </th>
                                            <th>
                                                In All Results
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resourceRank}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                );

                /*
                                    <td>
                                        <div className="resourceAddRankHeader" title="Add Rank" alt="Add Rank" onClick={this._showAddModalRank.bind(this)}>
                                            +
                                        </div>
                                    </td>


                                    <th>
                                        Edit
                                    </th>
                                    <th>
                                        Remove
                                    </th>
                */

                var rankBody = [];

                rankBody.push(
                    <div ref="bodyRankHeader" className="resourceRank_Header">
                        <span className="fal fa-trophy"></span> Resource Ranks
                    </div>
                );
                rankBody.push(
                    <div ref="bodyRankListing" className="resourceRank_Body">
                        {rankListing}
                    </div>
                );

                bodyList.push(rankBody);


            }


            else if (showNotifications) {
                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);

                /*MY NOTIFICATIONS START HERE*/
                var notificationListing = [];
                var resourceNotification = [];
                var notificationCount = 0;
                Object.values(resource_NotificationListInfo).forEach(element => {
                    //TODO: needs to be corrected with actual data from the database
                    resourceNotification.push(
                        <div ref={"user" + element["ADUsername"]} className={"resourceNotification"} title="Remove Notification" alt="Remove Notification" onClick={this._removeNotification.bind(this, element["ADUsername"], element["UserDomain"], element["externalId"])}>
                            {element["resourceName"]}<span className="removeNotification">+</span>
                        </div>
                    );

                    notificationCount++;
                });


                if (notificationCount == 0) {

                    resourceNotification.push(
                        <div className={"noNotification"}>
                            None
                        </div>
                    );
                }

                notificationListing.push(
                    <div ref={"notificationListing"} className="notificationListing">
                        <table className="notificationTableHeader">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="notificationNameHeader">
                                            My Notifications<span className="notificationCount">({notificationCount})</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div ref={"notificationList"} className={"notificationList"}>
                            <div ref={"notification"} className={"resourceNotification"}>
                                <div className="notificationBody">
                                    {resourceNotification}
                                </div>
                            </div>
                        </div>
                    </div>
                );
                var notificationsBody = [];

                notificationsBody.push(
                    <div ref="bodyRankHeader" className="resourceRank_Header">
                        <span className="fa-light fa-bell-exclamation"></span> My Notifications
                    </div>
                );
                notificationsBody.push(
                    <div ref="bodyRankListing" className="resourceRank_Body">
                        {notificationListing}
                    </div>
                );

                bodyList.push(notificationsBody);


            }


            else if (showCreate) {

                var backToResults;
                backToResults = [];
                backToResults.push(<div className="backToHome" onClick={this._redirectHome.bind(this)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Return Home</span></div>)

                bodyList.push(backToResults);


                var resourceTypeOptions;
                resourceTypeOptions = [];

                Object.values(resource_ResourceTypeListInfo).forEach(element => {
                    resourceTypeOptions.push(<option value={element["resourceType"]}>{element["resourceType"]}</option>);
                });

                var createSingleResourceTypeContainer;
                createSingleResourceTypeContainer = [];

                createSingleResourceTypeContainer = <select defaultValue={""} id="create_singleResource_ResourceType" ref="create_singleResource_ResourceType" className="create_singleResource_ResourceType" onChange={this._updateCreateResourceType.bind(this)}>
                    <option value="" hidden>Select an option</option>
                    {resourceTypeOptions}
                </select>



                var reportTypeOptions;
                reportTypeOptions = [];

                Object.values(resource_ReportTypeListInfo).forEach(element => {
                    if (element["reportType"] !== "File") {
                        reportTypeOptions.push(<option value={element["reportType"]}>{element["reportType"]}</option>);
                    }
                });

                var createSingleResourceReportTypeContainer;
                createSingleResourceReportTypeContainer = [];

                createSingleResourceReportTypeContainer = <span ref="create_singleResource_ReportType_Container" className="create_singleResource_ReportType_Container"><span className="hidden" ref="create_singleResource_ReportType_dash">-</span><select defaultValue={""} onChange={this._updateCreateReportType.bind(this)} id="create_singleResource_ReportType" ref="create_singleResource_ReportType" className="hidden">
                    <option value="" hidden>Select an option</option>
                    {reportTypeOptions}
                </select>
                </span>;



                var qrsYearOptions;
                qrsYearOptions = [];

                Object.values(resource_QRSYearListInfo).forEach(element => {
                    qrsYearOptions.push(<option value={element["qrsYear"]}>{element["qrsYear"]}</option>);
                });

                var createSingleResourceQRSYearContainer;
                createSingleResourceQRSYearContainer = [];

                createSingleResourceQRSYearContainer = <span ref="create_singleResource_QRSYear_Container" className="create_singleResource_QRSYear_Container"><span className="hidden" ref="create_singleResource_QRSYear_dash">-</span><select defaultValue={""} onChange={this._updateCreateQRSYear.bind(this)} id="create_singleResource_QRSYear" ref="create_singleResource_QRSYear" className="hidden">
                    <option value="" hidden>Select an option</option>
                    {qrsYearOptions}
                </select>
                </span>;




                var createExternalStatusOptions;
                createExternalStatusOptions = [];

                createExternalStatusOptions.push(<option value="Accepted">Accepted</option>);
                createExternalStatusOptions.push(<option value="Candidate">Candidate</option>);
                createExternalStatusOptions.push(<option value="Disabled">Disabled</option>);
                createExternalStatusOptions.push(<option value="Obsolete">Obsolete</option>);
                createExternalStatusOptions.push(<option value="Relationship Ready">Relationship Ready</option>);
                createExternalStatusOptions.push(<option value="Under Development">Under Development</option>);
                createExternalStatusOptions.push(<option value="Under Review">Under Review</option>);


                var createExternalStatusChangerContainer;
                createExternalStatusChangerContainer = [];

                createExternalStatusChangerContainer = <select defaultValue={"Candidate"} id="create_externalStatusChanger" ref="create_externalStatusChanger" className="create_externalStatusChanger">
                    <option value="" hidden>Select an option</option>
                    {createExternalStatusOptions}
                </select>
                var createExternalStatus = [];
                createExternalStatus.push(createExternalStatusChangerContainer);


                var createReportLocationPlaceholder = "";

                var createReportLocationPlaceholder_HGR = "100083";
                var createReportLocationPlaceholder_HGT = "539096";
                var createReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";


                var reportLocationText = "Report Location";
                var isNotEpicMultiReport = "create_singleResource_ReportLocation";
                var isEpicMultiReport = "hidden";

                if (this.state.resource_createReportType == "Excel Dashboard") {
                    reportLocationText = "Network Location";
                    createReportLocationPlaceholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\junkview_reports\\AR_Report\\AR_Report.xlsm";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "File") {
                    reportLocationText = "Network Location";
                    createReportLocationPlaceholder = "\\\\aamcqlikview\\Tutorial\\Qlikview-Word-Basics.doc";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Website") {
                    reportLocationText = "Website URL";
                    createReportLocationPlaceholder = "https://webappstest.aahs.org/ProviderGeo/";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Microsoft Report") {
                    reportLocationText = "Network Location";
                    createReportLocationPlaceholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\Decision_Support\\AAMC_Summary_Shoulder_Replacement_Metrics.pdf";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Qlikview Dashboard") {
                    reportLocationText = "Website URL";
                    createReportLocationPlaceholder = "http://aamcqlikview/QvAJAXZfc/opendoc.htm?document=Outpatient.qvw&amp;host=QVS%40aamcqlikview";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Qliksense Application") {
                    reportLocationText = "Website URL";
                    createReportLocationPlaceholder = "https://dataviz.aahs.org/sense/app/eb9edb7c-a64f-4c66-abd1-35a48c39a728/overview";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Radar Dashboard") {
                    reportLocationText = "Epic IDM Number";
                    createReportLocationPlaceholder = "100022";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Epic-Slicer Dicer") {
                    reportLocationText = "Epic Record ID";
                    createReportLocationPlaceholder = "1";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }
                else if (this.state.resource_createReportType == "Epic-Crystal Report") {
                    reportLocationText = "HGR | HGT | Report Name";
                    createReportLocationPlaceholder = "";
                    createReportLocationPlaceholder_HGR = "100083";
                    createReportLocationPlaceholder_HGT = "539096";
                    createReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";
                    isNotEpicMultiReport = "hidden";
                    isEpicMultiReport = "";
                }
                else if (this.state.resource_createReportType == "Reporting Workbench") {
                    reportLocationText = "HGR | HGT | Report Name";
                    createReportLocationPlaceholder = "";
                    createReportLocationPlaceholder_HGR = "100083";
                    createReportLocationPlaceholder_HGT = "539096";
                    createReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";
                    isNotEpicMultiReport = "hidden";
                    isEpicMultiReport = "";
                }
                else {
                    reportLocationText = "Report Location";
                    createReportLocationPlaceholder = "";
                    createReportLocationPlaceholder_HGR = "";
                    createReportLocationPlaceholder_HGT = "";
                    createReportLocationPlaceholder_NAME = "";
                    isNotEpicMultiReport = "create_singleResource_ReportLocation";
                    isEpicMultiReport = "hidden";
                }


                var createEpicReports = [];

                for (var createEpicReportsIndex = 1; createEpicReportsIndex <= this.state.resource_createEpicReportsCount; createEpicReportsIndex++) {
                    createEpicReports.push(<input ref={"create_singleResource_ReportLocation_HGR_" + createEpicReportsIndex} className={"create_singleResource_ReportLocation_HGR " + isEpicMultiReport} placeholder={createReportLocationPlaceholder_HGR} defaultValue=""></input>);
                    createEpicReports.push(<input ref={"create_singleResource_ReportLocation_HGT_" + createEpicReportsIndex} className={"create_singleResource_ReportLocation_HGT " + isEpicMultiReport} placeholder={createReportLocationPlaceholder_HGT} defaultValue="" ></input >);
                    createEpicReports.push(<input ref={"create_singleResource_ReportLocation_NAME_" + createEpicReportsIndex} className={"create_singleResource_ReportLocation_NAME " + isEpicMultiReport} placeholder={createReportLocationPlaceholder_NAME} defaultValue=""></input>);

                    if (createEpicReportsIndex == this.state.resource_createEpicReportsCount && createEpicReportsIndex == 1) {
                        createEpicReports.push(<i className={"create_AddReport fal fa-plus-square" + isEpicMultiReport} title="Add" onClick={this._addEpicReport.bind(this)}></i>);
                    }
                    else if (createEpicReportsIndex == this.state.resource_createEpicReportsCount && createEpicReportsIndex != 1) {
                        createEpicReports.push(<i className={"create_RemoveReport fal fa-times-square" + isEpicMultiReport} title="Remove" onClick={this._removeEpicReport.bind(this)}></i>);
                        createEpicReports.push(<i className={"create_AddReport fal fa-plus-square" + isEpicMultiReport} title="Add" onClick={this._addEpicReport.bind(this)}></i>);
                    }
                }

                var createStatusChangerClass = "";
                if (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev') {
                    createStatusChangerClass = "hidden";
                }


                var createListing = [];
                var createHeaderRow = "";

                createHeaderRow = <div className="navTabs"><div ref="singleResource_NavTab_Description" className="navTab selectedTab" onClick={this._navigateToTab.bind(this, 'Description')}>Overview</div><div ref="singleResource_NavTab_Details" className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, 'Details')}>Details</div><div ref="singleResource_NavTab_Tags" className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, 'Tags')}>Tags</div></div>

                createListing.push(
                    <div id="bodyCreateListing" ref="bodyCreateListing" className="create_singleResource_Body">
                        <table className="singleResource_CreateHeader">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="singleResource_CreateContainer">
                                            <div>Resource Name</div>
                                            <div>Resource Type</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="singleResource_ResourceNameContainer">
                                            <div>
                                                <input className="create_singleResource_ResourceName" ref="create_singleResource_ResourceName" defaultValue=""></input>
                                            </div>
                                            <div>
                                                {createSingleResourceTypeContainer}
                                                {createSingleResourceReportTypeContainer}
                                                {createSingleResourceQRSYearContainer}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="singleResource_CreateMode_true">Create Mode</div>
                        <table className="createSingleResource_Content singleResource_Content Report_Body">
                            <tbody>
                                <tr>
                                    <td>
                                        <div ref="singleResource_ContentBody_Description" className="tabContentBody singleResource_ContentBody_Description">
                                            <table className="singleResource_ContentBody_DescriptionTable">
                                                <tbody>
                                                    <tr className="" ref="">
                                                        <td>
                                                            <span className="descriptionTable_Label">Description</span>
                                                        </td>
                                                        <td>
                                                            <div className="create_singleResource_ContentBody_Description_HTML">
                                                                <Editor
                                                                    id='singleResource_Creator'
                                                                    ref='singleResource_Creator'
                                                                    initialValue={""}
                                                                    init={{
                                                                        skin: false,
                                                                        content_style: "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900&display=swap'); body { font-family: Roboto, sans-serif; }",
                                                                        height: 300,
                                                                        menubar: false,
                                                                        plugins: [
                                                                            'link image',
                                                                            'table paste code link preview lists hr'
                                                                        ],
                                                                        toolbar: 'undo redo | fontsizeselect | ' +
                                                                            'bold italic underline forecolor | alignleft aligncenter ' +
                                                                            'alignright alignjustify | hr bullist numlist outdent indent | ' +
                                                                            'removeformat | link code preview',
                                                                        fontsize_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20x 22px 24px 26px 28px 36px 48px 72px"
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div ref="singleResource_ContentBody_Details" className="tabContentBody singleResource_ContentBody_Details">
                                            <div>
                                                <table className="singleResource_ContentBody_DetailsTable">
                                                    <tbody>
                                                        <tr className="hidden" ref="create_singleResource_ReportLocation_Container">
                                                            <td>
                                                                <span className="detailsTable_Label">{reportLocationText}</span>
                                                            </td>
                                                            <td>
                                                                <input ref="create_singleResource_ReportLocation" className={isNotEpicMultiReport} placeholder={createReportLocationPlaceholder} defaultValue=""></input>
                                                                {createEpicReports}
                                                            </td>
                                                        </tr>
                                                        <tr className="hidden">
                                                            <td>
                                                                <span className="detailsTable_Label">Resource Repository</span>
                                                            </td>
                                                            <td>
                                                                <span className="resourceRepository" alt="internal" title="internal">internal</span>
                                                            </td>
                                                        </tr>
                                                        <tr className={createStatusChangerClass}>
                                                            <td>
                                                                <span className="detailsTable_Label">Status</span>
                                                            </td>
                                                            <td>
                                                                {createExternalStatus}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="singleResource_Buttons">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="singleResultButton_Container">
                                            <div className="luminisLogo_White"></div>
                                            <div className="singleResultButtons">
                                                <button className="hidden" ref="singleResultButton_Create_Preview" onClick={this._showModalOverlay.bind(this, 'preview')}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <span className="singleResultIcon fal fa-eye"></span>
                                                                </td>
                                                                <td>
                                                                    <span className="footerText">
                                                                        <div className="topText">Preview</div>
                                                                        <div className="bottomText">Report</div>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </button>
                                                <button className="singleResultButton_Create singleButton" ref="singleResultButton_Create_SaveChanges" onClick={this._createResource.bind(this)}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <span className="singleResultIcon fal fa-cloud-upload"></span>
                                                                </td>
                                                                <td>
                                                                    <span className="footerText">
                                                                        <div className="topText">Save</div>
                                                                        <div className="bottomText">Changes</div>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </button>
                                                <button className="singleResultButton_Create" ref="singleResultButton_Create_Cancel" >
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <span className="singleResultIcon singleTextIcon fal fa-times"></span>
                                                                </td>
                                                                <td>
                                                                    <span className="footerText">
                                                                        <div className="singleText">Cancel</div>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );

                bodyList.push(
                    <div ref="bodyCreateHeader" className="create_singleResource_Header">
                        <span className="fal fa-plus-square"></span> Create Resource
                    </div>
                );
                bodyList.push(createListing);


            }
            //Single Result
            else if (singleResult != "") {
                var backToResults;
                backToResults = [];
                if (searchText != "") {
                    backToResults.push(<div className="backToResults" onClick={this._redirectToSearch.bind(this, searchText)}><i className="backToResultsIcon fal fa-arrow-alt-left"></i><span className="backToResultsText">Back to Results for "{searchText}"</span></div>)
                }



                Object.values(resource_IntellisenseInfo)
                    .filter(value => (value['externalId'])?.toString().toLowerCase() == singleResult.toLowerCase())
                    .forEach(value => {
                        bodyCount = bodyCount + 1;
                        resourceCount = resourceCount + 1;

                        //Favorites
                        var favoriteData;
                        favoriteData = [];
                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {

                            favoriteData.push(<i className="singleResource_BodyStar favorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                        }
                        else {
                            favoriteData.push(<i className="singleResource_BodyStar noFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                        }

                        //Add Thumbs and then replace with images.

                        //Images
                        var mainImageData;
                        mainImageData = [];
                        var subImageData;
                        subImageData = [];
                        var additionalImages;
                        additionalImages = [];
                        var imageCount = 0;
                        Object.values(resource_BuildImageInfo)
                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                            .forEach(imageValue => {
                                if (imageCount == 0) {
                                    mainImageData.push(<table ref="mainImage_SingleResource_Container" onClick={this._showMainImageModal.bind(this, imageValue['imageBase64'])} className="fill mainImage_SingleResource selectable"><tbody><tr><td><div className="imageLoader"><i className="spinningLoader fas fa-circle-notch fa-spin" title="Loading Image..." alt="Loading Image..."></i></div><img className="mainImage_SingleResource_Full" ref="mainImage_SingleResource" src={imageValue['imageBase64']} /></td></tr></tbody></table>);
                                }
                                if (imageCount >= 4) {
                                    additionalImages = <div alt="Click to View Additional Pictures" title="Click to View Additional Pictures" ref="subImage_SingleResource_Container" className="fill subImage_SingleResource additionalImages"><div className="additionalImages_Link"><div className="additionalImages_Count"><span className="countPlus">+</span>{(imageCount - 3)}</div><div className="additionalImages_Text">Additional<br />Pictures</div></div></div >;
                                }
                                else {
                                    var removeImage = "";
                                    if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) && !this.state.isEpicUser) {
                                        removeImage = <i alt="Remove Image" onClick={this._removeSubImage.bind(this, imageValue['imageBase64'], imageValue['externalId'])} title="Remove Image" className="removeImage fal fa-times"></i>;
                                    }
                                    subImageData.push(<div ref="subImage_SingleResource_Container" onMouseOver={this._showSubImage.bind(this, imageValue['imageBase64'], imageCount)} className="subImage_SingleResource_Container">{removeImage}<div className="fill subImage_SingleResource"><div className="imageThumbLoader"><i className="spinningLoader fas fa-circle-notch fa-spin" title="Loading Image..." alt="Loading Image..."></i></div><img className={"subImage_SingleResource_Full"} ref={"subImage_SingleResource" + imageCount} src={imageValue['imageBase64']} /></div></div>);
                                }
                                imageCount = imageCount + 1;
                            });

                        if (imageCount == 0) {
                            Object.values(resource_BuildThumbImageInfo)
                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                .forEach(imageValue => {
                                    if (imageCount == 0) {
                                        mainImageData.push(<table ref="mainImage_SingleResource_Container" onClick={this._showMainImageModal.bind(this, imageValue['imageBase64_thumb'])} className="fill mainImage_SingleResource selectable"><tbody><tr><td><div className="imageLoader"><i className="spinningLoader fas fa-circle-notch fa-spin" title="Loading Image..." alt="Loading Image..."></i></div><img className="mainImage_SingleResource_Full" ref="mainImage_SingleResource" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>);
                                    }
                                    if (imageCount >= 4) {
                                        additionalImages = <div alt="Click to View Additional Pictures" title="Click to View Additional Pictures" ref="subImage_SingleResource_Container" className="fill subImage_SingleResource additionalImages"><div className="additionalImages_Link"><div className="additionalImages_Count"><span className="countPlus">+</span>{(imageCount - 3)}</div><div className="additionalImages_Text">Additional<br />Pictures</div></div></div >;
                                    }
                                    else {
                                        var removeImage = "";
                                        if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) && !this.state.isEpicUser) {
                                            removeImage = <i alt="Remove Image" onClick={this._removeSubImage.bind(this, imageValue['imageBase64'], imageValue['externalId'])} title="Remove Image" className="removeImage fal fa-times"></i>;
                                        }
                                        subImageData.push(<div ref="subImage_SingleResource_Container" onMouseOver={this._showSubImage.bind(this, imageValue['imageBase64'], imageCount)} className="subImage_SingleResource_Container">{removeImage}<div className="fill subImage_SingleResource"><div className="imageThumbLoader"><i className="spinningLoader fas fa-circle-notch fa-spin" title="Loading Image..." alt="Loading Image..."></i></div><img className={"subImage_SingleResource_Full"} ref={"subImage_SingleResource" + imageCount} src={imageValue['imageBase64_thumb']} /></div></div>);
                                    }
                                    imageCount = imageCount + 1;
                                });

                        }

                        if (imageCount == 0) {
                            mainImageData.push(<table ref="mainImage_SingleResource_Container" className="fill mainImage_SingleResource noPhoto"><tbody><tr><td><i className="noPhotoIcon fal fa-chart-column"></i><div className="noPhotoText">No Picture Available</div></td></tr></tbody></table>);
                        }


                        //SUB-RESOURCES
                        var subResourceData;
                        subResourceData = [];
                        var resourceHeadersList;
                        resourceHeadersList = [];
                        var additionalResourceHeaders;
                        additionalResourceHeaders = [];
                        var additionalResourceBodies;
                        additionalResourceBodies = [];
                        var additionalResourceImages;
                        additionalResourceImages = [];
                        var resourceBody;
                        resourceBody = [];
                        var subResourceCount = 0;
                        var subResourcesAvailable = false;
                        var subResourcesReports = false;
                        var backToReportCategory;
                        backToReportCategory = [];
                        var myResult = resource_IntellisenseInfo;
                        var ccnAttributeList = [];
                        var numCCNAttributes = 0;
                        var APGoalsList = [];
                        var numAPGoals = 0;
                        var APActionsList = [];
                        var numAPActions = 0;
                        var APTeamList = [];
                        var numAPTeam = 0;
                        var metricOwnerList = [];
                        var addMetricOwner = [];
                        var numMetricOwner = 0;
                        var metricFutureGoalsList = [];
                        var metricCurrentGoalsList = [];
                        var metricPastGoalsList = [];

                        var metricGoalsHeader = [];
                        var metricGoalsCalendar = [];

                        var addMetricGoal = [];

                        var numMetricCurrentGoals = 0;
                        var currentGoalDate = "";
                        var currentStartDate = "";
                        var numMetricFutureGoals = 0;
                        var numMetricPastGoals = 0;
                        var APLogList = [];
                        var numAPLog = 0;

                        singleResourceType = value['resourceType'];

                        if (value['resourceType'] == "Action Plan") {


                            Object.values(resource_BuildAPGoalsInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                .forEach(resourceValue => {
                                    /*GOALS START*/
                                    var goalCurrentStatus = "Incomplete";
                                    var goalFeedback = [];
                                    if (resourceValue['dtGoalCompleted'] == null || resourceValue['dtGoalCompleted'] == "") {
                                        goalFeedback.push(
                                            <div className="goalFeedback_Hidden">
                                                <div className="goalFeedback_Title">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }
                                    else {
                                        goalCurrentStatus = "Completed";
                                        goalFeedback.push(
                                            <div className="goalFeedback">
                                                <div className="feedbackTitle">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }

                                    APGoalsList.push(
                                        <tr>
                                            <td>
                                                <div className="goalTitle_Container">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="goalTitle">
                                                                    {resourceValue['title']}
                                                                    <div className="goalCurrentStatus_Value">{goalCurrentStatus}</div>
                                                                </td>
                                                                <td className="goalProperties">
                                                                    <table className="goalProperties_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="goalField">
                                                                                    Date Created
                                                                                </td>
                                                                                <td className="goalFieldValue">
                                                                                    {resourceValue['dtCreated']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="goalField">
                                                                                    Date Last Modified
                                                                                </td>
                                                                                <td className="goalFieldValue">
                                                                                    {resourceValue['dtModified']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="goalField">
                                                                                    Start Date
                                                                                </td>
                                                                                <td className="goalFieldValue">
                                                                                    {resourceValue['dtStartDate']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="goalField">
                                                                                    Expected Completion Date
                                                                                </td>
                                                                                <td className="goalFieldValue">
                                                                                    {resourceValue['dtGoalExpectedCompletion']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="goalField">
                                                                                    Date Goal Completed
                                                                                </td>
                                                                                <td className="goalFieldValue">
                                                                                    {resourceValue['dtGoalCompleted']}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>

                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div className="goalDescription">{ReactHtmlParser(resourceValue['overviewFullText'])}
                                                </div>
                                                <div className="goalFeedback_Container">
                                                    {goalFeedback}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    numAPGoals++;

                                    /*GOALS END*/
                                });




                            Object.values(resource_BuildAPActionsInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                .forEach(resourceValue => {

                                    APActionsList.push(
                                        <tr>
                                            <td>
                                                <div className="actionTitle_Container">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="actionTitle">
                                                                    {resourceValue['title']}
                                                                    <div className="associatedGoal">
                                                                        Associated Goal {resourceValue['goalTitle']}
                                                                    </div>
                                                                    <div className="hoursRemaining">
                                                                        {resourceValue['numHoursExpected']}hrs.
                                                                    </div>
                                                                </td>
                                                                <td className="actionProperties">
                                                                    <table className="actionProperties_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="actionField">
                                                                                    Date Created
                                                                                </td>
                                                                                <td className="actionFieldValue">
                                                                                    {resourceValue['dtCreated']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="actionField">
                                                                                    Date Last Modified
                                                                                </td>
                                                                                <td className="actionFieldValue">
                                                                                    {resourceValue['dtModified']}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>

                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div className="actionDescription">
                                                    {ReactHtmlParser(resourceValue['overviewFullText'])}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    numAPActions++;

                                });




                            Object.values(resource_BuildAPTeamInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                .forEach(resourceValue => {

                                    APTeamList.push(
                                        <tr>
                                            <td>
                                                <div className="team_Container">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="teamInfo">
                                                                    <div>Name {resourceValue['lastName']}, {resourceValue['firstName']}</div>
                                                                    <div>Email {resourceValue['email']}</div>
                                                                    <div>Designation {resourceValue['designation']}</div>
                                                                </td>
                                                                <td className="teamProperties">
                                                                    <table className="teamProperties_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="teamField">
                                                                                    Date Created
                                                                                </td>
                                                                                <td className="teamFieldValue">
                                                                                    {resourceValue['dtCreated']}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    numAPTeam++;

                                });



                            Object.values(resource_BuildAPLogInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                .forEach(resourceValue => {

                                    APLogList.push(
                                        <tr>
                                            <td>
                                                <div className="log_Container">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="logInfo">
                                                                    <div>Associated Action {resourceValue['title']}</div>
                                                                    <div>Logged By {resourceValue['lastName']}, {resourceValue['firstName']} ({resourceValue['email']})</div>
                                                                    <div>Hours Used {resourceValue['numHoursUsed']}</div>
                                                                    <div>Work Done</div>
                                                                    <div>{ReactHtmlParser(resourceValue['overviewFullText'])}</div>
                                                                </td>
                                                                <td className="logProperties">
                                                                    <table className="actionProperties_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="logField">
                                                                                    Date Created
                                                                                </td>
                                                                                <td className="logFieldValue">
                                                                                    {resourceValue['dtCreated']}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="logField">
                                                                                    Date Last Modified
                                                                                </td>
                                                                                <td className="logFieldValue">
                                                                                    {resourceValue['dtModified']}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    numAPLog++;

                                });

                            //Needs to create manually, this will include summery information from Goals / Actions / Important Dates.
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Timeline"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Timeline")}>Timeline</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_Timeline hidden"} ref={"singleResource_ContentBody_Timeline"}>
                                    <div>
                                        <table className="singleResource_ContentBody_TimelineTable">
                                            <tbody>
                                                {APGoalsList}
                                                {APActionsList}
                                                {APLogList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );

                            //Needs to pull via API call and then it needs to build out the goals and what they look like. Also need to generate the number of Goals
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Goals"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Goals")}>Goals ({numAPGoals})</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_Goals hidden"} ref={"singleResource_ContentBody_Goals"}>
                                    <div>
                                        <table className="singleResource_ContentBody_GoalsTable">
                                            <tbody>
                                                {APGoalsList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );

                            //Needs to pull via API call and then it needs to build out the user list and what they look like. Also need to generate the # of team members.
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Team"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Team")}>Owners ({numAPTeam})</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_Team hidden"} ref={"singleResource_ContentBody_Team"}>
                                    <div>
                                        <table className="singleResource_ContentBody_TeamTable">
                                            <tbody>
                                                {APTeamList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );


                            //Needs to pull via API call and then it needs to build out the actions and what they look like. Also need to generate the # of actions.
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Actions"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Actions")}>Actions ({numAPActions})</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_Actions hidden"} ref={"singleResource_ContentBody_Actions"}>
                                    <div>
                                        <table className="singleResource_ContentBody_ActionsTable">
                                            <tbody>
                                                {APActionsList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );

                            //Needs to pull via API call and then it needs to build out the log list and what they look like. Also need to generate the # of logs.
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Log"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Log")}>Log ({numAPLog})</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_Log hidden"} ref={"singleResource_ContentBody_Log"}>
                                    <div>
                                        <table className="singleResource_ContentBody_LogTable">
                                            <tbody>
                                                {APLogList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );



                        }
                        else if (value['resourceType'] == "Metric") {
                            var removalButton;
                            removalButton = [];
                                Object.values(resource_BuildMetricOwnerInfo)
                                    .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(resourceValue => {

                                        removalButton = [];
                                        if (this.state.resource_editMode) {
                                            removalButton.push(<td>
                                                <div className="metricOwner_Removal" onClick={this._removeMetricOwner.bind(this, resourceValue['idExternalResource_MetricOwner'])}>
                                                    <i className="fa-light fa-xmark"></i>
                                                </div>
                                            </td>);
                                        }

                                        metricOwnerList.push(
                                            <tr>
                                                <td>
                                                    <div className="metricOwner_Container">
                                                        {resourceValue['lastName']}, {resourceValue['firstName']} (<a className="metricOwner_Email" href={"mailto:" + resourceValue['email'] + "?subject=Databay: " + value['resourceName'] + " (" + value['resourceType'] + ")" + "&body=" + value['resourceName'] + " (" + value['resourceType'] + ")" + "%0D%0A" + window.location.href} title={"Email " + resourceValue['firstName'] + " " + resourceValue['lastName'] + " about " + value['resourceName'] + " (" + value['resourceType'] +")"}><i className="fa-light fa-envelope"></i><span className="metricOwnerEmail">{resourceValue['email']}</span></a>)
                                                    </div>
                                                </td>
                                                {removalButton}
                                            </tr>
                                        );
                                        numMetricOwner++;

                                    });



                            if (numMetricOwner == 0) {

                                additionalResourceBodies.push(
                                    <div className={"tabContentBody singleResource_ContentBody_MetricOwner hidden"} ref={"singleResource_ContentBody_Metric_Owner"}>
                                        <div>
                                            <table className="singleResource_ContentBody_NoMetricOwnerTable">
                                                <tbody>
                                                    <tr><td><div className="noResources">No Metric Owners</div><div className="noResourcesIcon"><i title="To add a resource, you will need to have content administrator permissions or higher. Click the edit content button above. Next click the + to create and add a metric owner." className="fa-light fa-circle-info"></i></div></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                );
                            }
                            else {

                                additionalResourceBodies.push(
                                    <div className={"tabContentBody singleResource_ContentBody_MetricOwner hidden"} ref={"singleResource_ContentBody_Metric_Owner"}>
                                        <div>
                                            <table className="singleResource_ContentBody_MetricOwnerTable">
                                                <tbody>
                                                    {metricOwnerList}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                );
                            }
                            //Needs to pull via API call and then it needs to build out the user list and what they look like. Also need to generate the # of team members.
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Metric_Owner"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Metric_Owner")}>Owner ({numMetricOwner})</div>)




                            Object.values(resource_BuildMetricGoalsInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase() && ((new Date((resourceValue['dtGoalExpectedCompletion']).toString())) > new Date()))
                                .forEach(resourceValue => {
                                    /*GOALS START*/
                                    var goalCurrentStatus = "Incomplete";
                                    var goalFeedback = [];
                                    if (resourceValue['dtGoalCompleted'] == null || resourceValue['dtGoalCompleted'] == "") {
                                        goalFeedback.push(
                                            <div className="goalFeedback_Hidden">
                                                <div className="goalFeedback_Title">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }
                                    else {
                                        goalCurrentStatus = "Completed";
                                        goalFeedback.push(
                                            <div className="goalFeedback">
                                                <div className="feedbackTitle">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }

                                    var expectedCompletionDate = new Date(resourceValue['dtGoalExpectedCompletion']);

                                    var goalStartDate = new Date(resourceValue['dtStartDate']);

                                    var goalRemoval;
                                    goalRemoval = [];
                                    var goalEdit;
                                    goalEdit = [];
                                    if (this.state.resource_editMode) {
                                        goalEdit.push(<td className="goalEdit" title="Edit Goal" alt="Edit Goal" onClick={this._showEditGoal.bind(this, resourceValue['idExternalResource_MetricGoals'], resourceValue['title'], resourceValue['locationType'], resourceValue['goalValue'], resourceValue['goalType'], resourceValue['dtGoalExpectedCompletion'], resourceValue['dtStartDate'])}>
                                            <div className="metricGoal_Edit">
                                                <i className="fa-light fa-edit"></i>
                                            </div>
                                        </td>);
                                        goalRemoval.push(<td className="goalRemoval" title="Remove Goal" alt="Remove Goal" onClick={this._removeMetricGoal.bind(this, resourceValue['idExternalResource_MetricGoals'])}>
                                            <div className="metricGoal_Removal">
                                                <i className="fa-light fa-xmark"></i>
                                            </div>
                                        </td>);
                                    }
                                    if (numMetricCurrentGoals == 0) {
                                        currentGoalDate = expectedCompletionDate.toLocaleDateString();

                                        var startDateSection = [];
                                        if (resourceValue['dtStartDate'] != null && resourceValue['dtStartDate'] !== "") {

                                            goalStartDate = goalStartDate.toLocaleDateString();
                                            startDateSection.push(
                                                <td className="goalField_goalStartDate">
                                                    <div className="goalExpCompletion_Text">
                                                        <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Start Date
                                                    </div>
                                                    <div className="goalExpCompletion_Value">
                                                        {goalStartDate}
                                                    </div>
                                                </td>);
                                        }
                                        else {
                                            goalStartDate = "";
                                        }
                                        metricCurrentGoalsList.push(
                                            <tr>
                                                <td>
                                                    <div className="goalTitle_Container">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="goalTitle">
                                                                        <div className="goalTitle_Value"><i className="goalTitle_Icon fa-light fa-flag"></i>{resourceValue['title']}</div>
                                                                        <div className="goalLocation_Value"><i className="goalLocation_Icon fa-light fa-location-dot"></i><span className="goalLocation_Text">{resourceValue['locationType']}</span></div>
                                                                        <div className="goalCreatedBy_Value"><span className="createdByCircle">{resourceValue['createdByADUsername'].substring(0, 2)}</span>{resourceValue['createdByADUsername']} (<a href={"mailto:" + resourceValue['createdByADUsername'] + "@luminishealth.org"}><i className="goalCreatedBy_Text fa-light fa-envelope"></i></a>)</div>
                                                                    </td>
                                                                    <td className="goalProperties">
                                                                        <table className="goalProperties_Table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="goalField_goalValue">
                                                                                        <span className="goalValue_Value">{resourceValue['goalValue']}</span><span className="goalType_Value">{resourceValue['goalType']}</span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="goalField_goalDates">
                                                                                        <table className="goal_displayDates">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    {startDateSection}
                                                                                                    <td className="goalField_goalCompletionDate">
                                                                                                        <div className="goalExpCompletion_Text">
                                                                                                            <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Exp. Completion
                                                                                                        </div>
                                                                                                        <div className="goalExpCompletion_Value">
                                                                                                            {currentGoalDate}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    {goalEdit}
                                                                    {goalRemoval}
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                    <div className="goalFeedback_Container">
                                                        {goalFeedback}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                        numMetricCurrentGoals++;
                                    }
                                    else if (numMetricCurrentGoals != 0 && currentGoalDate != "" && currentGoalDate == expectedCompletionDate.toLocaleDateString()) {

                                        var startDateSection = [];
                                        if (resourceValue['dtStartDate'] != null && resourceValue['dtStartDate'] !== "") {

                                            goalStartDate = goalStartDate.toLocaleDateString();
                                            startDateSection.push(
                                                <td className="goalField_goalStartDate">
                                                    <div className="goalExpCompletion_Text">
                                                        <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Start Date
                                                    </div>
                                                    <div className="goalExpCompletion_Value">
                                                        {goalStartDate}
                                                    </div>
                                                </td>);
                                        }
                                        else {
                                            goalStartDate = "";
                                        }
                                        metricCurrentGoalsList.push(
                                            <tr>
                                                <td>
                                                    <div className="goalTitle_Container">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="goalTitle">
                                                                        <div className="goalTitle_Value"><i className="goalTitle_Icon fa-light fa-flag"></i>{resourceValue['title']}</div>
                                                                        <div className="goalLocation_Value"><i className="goalLocation_Icon fa-light fa-location-dot"></i><span className="goalLocation_Text">{resourceValue['locationType']}</span></div>
                                                                        <div className="goalCreatedBy_Value"><span className="createdByCircle">{resourceValue['createdByADUsername'].substring(0, 2)}</span>{resourceValue['createdByADUsername']} (<a href={"mailto:" + resourceValue['createdByADUsername'] + "@luminishealth.org"}><i className="goalCreatedBy_Text fa-light fa-envelope"></i></a>)</div>
                                                                    </td>
                                                                    <td className="goalProperties">
                                                                        <table className="goalProperties_Table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="goalField_goalValue">
                                                                                        <span className="goalValue_Value">{resourceValue['goalValue']}</span><span className="goalType_Value">{resourceValue['goalType']}</span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="goalField_goalDates">
                                                                                        <table className="goal_displayDates">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    {startDateSection}
                                                                                                    <td className="goalField_goalCompletionDate">
                                                                                                        <div className="goalExpCompletion_Text">
                                                                                                            <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Exp. Completion
                                                                                                        </div>
                                                                                                        <div className="goalExpCompletion_Value">
                                                                                                            {currentGoalDate}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    {goalEdit}
                                                                    {goalRemoval}
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                    <div className="goalFeedback_Container">
                                                        {goalFeedback}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                        numMetricCurrentGoals++;
                                    }
                                    else {

                                        var startDateSection = [];
                                        if (resourceValue['dtStartDate'] != null && resourceValue['dtStartDate'] !== "") {

                                            goalStartDate = goalStartDate.toLocaleDateString();
                                            startDateSection.push(
                                                <td className="goalField_goalStartDate">
                                                    <div className="goalExpCompletion_Text">
                                                        <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Start Date
                                                    </div>
                                                    <div className="goalExpCompletion_Value">
                                                        {goalStartDate}
                                                    </div>
                                                </td>);
                                        }
                                        else {
                                            goalStartDate = "";
                                        }
                                        metricFutureGoalsList.push(
                                            <tr>
                                                <td>
                                                    <div className="goalTitle_Container">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="goalTitle">
                                                                        <div className="goalTitle_Value"><i className="goalTitle_Icon fa-light fa-flag"></i>{resourceValue['title']}</div>
                                                                        <div className="goalLocation_Value"><i className="goalLocation_Icon fa-light fa-location-dot"></i><span className="goalLocation_Text">{resourceValue['locationType']}</span></div>
                                                                        <div className="goalCreatedBy_Value"><span className="createdByCircle">{resourceValue['createdByADUsername'].substring(0, 2)}</span>{resourceValue['createdByADUsername']} (<a href={"mailto:" + resourceValue['createdByADUsername'] + "@luminishealth.org" }><i className="goalCreatedBy_Text fa-light fa-envelope"></i></a>)</div>
                                                                    </td>
                                                                    <td className="goalProperties">
                                                                        <table className="goalProperties_Table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="goalField_goalValue">
                                                                                        <span className="goalValue_Value">{resourceValue['goalValue']}</span><span className="goalType_Value">{resourceValue['goalType']}</span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="goalField_goalDates">
                                                                                        <table className="goal_displayDates">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    {startDateSection}
                                                                                                    <td className="goalField_goalCompletionDate">
                                                                                                        <div className="goalExpCompletion_Text">
                                                                                                            <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Exp. Completion
                                                                                                        </div>
                                                                                                        <div className="goalExpCompletion_Value">
                                                                                                            {expectedCompletionDate.toLocaleDateString()}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    {goalEdit}
                                                                    {goalRemoval}
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                    <div className="goalFeedback_Container">
                                                        {goalFeedback}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                        numMetricFutureGoals++;

                                    }
                                    /*GOALS END*/
                                });




                            Object.values(resource_BuildMetricGoalsInfo)
                                .filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase() && ((new Date((resourceValue['dtGoalExpectedCompletion']).toString())) < new Date()))
                                .forEach(resourceValue => {
                                    /*GOALS START*/
                                    var goalCurrentStatus = "Incomplete";
                                    var goalFeedback = [];
                                    if (resourceValue['dtGoalCompleted'] == null || resourceValue['dtGoalCompleted'] == "") {
                                        goalFeedback.push(
                                            <div className="goalFeedback_Hidden">
                                                <div className="goalFeedback_Title">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }
                                    else {
                                        goalCurrentStatus = "Completed";
                                        goalFeedback.push(
                                            <div className="goalFeedback">
                                                <div className="feedbackTitle">Feedback :</div>
                                                <div className="goalFeedback_Value">{resourceValue['completionFeedback']}</div>
                                            </div>
                                        );
                                    }

                                    var expectedCompletionDate = new Date(resourceValue['dtGoalExpectedCompletion']);
                                    var goalStartDate = new Date(resourceValue['dtStartDate']);

                                    var goalRemoval;
                                    goalRemoval = [];
                                    var goalEdit;
                                    goalEdit = [];
                                    if (this.state.resource_editMode) {
                                        goalEdit.push(<td className="goalEdit" title="Edit Goal" alt="Edit Goal" onClick={this._showEditGoal.bind(this, resourceValue['idExternalResource_MetricGoals'], resourceValue['title'], resourceValue['locationType'], resourceValue['goalValue'], resourceValue['goalType'], resourceValue['dtGoalExpectedCompletion'], resourceValue['dtStartDate'])}>
                                            <div className="metricGoal_Edit">
                                                <i className="fa-light fa-edit"></i>
                                            </div>
                                        </td>);
                                        goalRemoval.push(<td className="goalRemoval" title="Remove Goal" alt="Remove Goal" onClick={this._removeMetricGoal.bind(this, resourceValue['idExternalResource_MetricGoals'])}>
                                            <div className="metricGoal_Removal">
                                                <i className="fa-light fa-xmark"></i>
                                            </div>
                                        </td>);
                                    }
                                    var startDateSection = [];
                                    if (resourceValue['dtStartDate'] != null && resourceValue['dtStartDate'] !== "") {

                                        goalStartDate = goalStartDate.toLocaleDateString();
                                        startDateSection.push(
                                            <td className="goalField_goalStartDate">
                                                <div className="goalExpCompletion_Text">
                                                    <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Start Date
                                                </div>
                                                <div className="goalExpCompletion_Value">
                                                    {goalStartDate}
                                                </div>
                                            </td>);
                                    }
                                    else {
                                        goalStartDate = "";
                                    }
                                    metricPastGoalsList.push(
                                        <tr>
                                            <td>
                                                <div className="goalTitle_Container">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="goalTitle">
                                                                    <div className="goalTitle_Value"><i className="goalTitle_Icon fa-light fa-flag"></i>{resourceValue['title']}</div>
                                                                    <div className="goalLocation_Value"><i className="goalLocation_Icon fa-light fa-location-dot"></i><span className="goalLocation_Text">{resourceValue['locationType']}</span></div>
                                                                    <div className="goalCreatedBy_Value"><span className="createdByCircle">{resourceValue['createdByADUsername'].substring(0, 2)}</span>{resourceValue['createdByADUsername']} (<a href={"mailto:" + resourceValue['createdByADUsername'] + "@luminishealth.org"}><i className="goalCreatedBy_Text fa-light fa-envelope"></i></a>)</div>
                                                                </td>
                                                                <td className="goalProperties">
                                                                    <table className="goalProperties_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="goalField_goalValue">
                                                                                    <span className="goalValue_Value">{resourceValue['goalValue']}</span><span className="goalType_Value">{resourceValue['goalType']}</span>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="goalField_goalDates">
                                                                                    <table className="goal_displayDates">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                {startDateSection}
                                                                                                <td className="goalField_goalCompletionDate">
                                                                                                    <div className="goalExpCompletion_Text">
                                                                                                        <i className="goalExpCompletion_Icon fa-light fa-calendar-check"></i> Exp. Completion
                                                                                                    </div>
                                                                                                    <div className="goalExpCompletion_Value">
                                                                                                        {expectedCompletionDate.toLocaleDateString()}
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                {goalEdit}
                                                                {goalRemoval}
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div className="goalFeedback_Container">
                                                    {goalFeedback}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    numMetricPastGoals++;

                                    /*GOALS END*/
                                });








                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_Metric_Goals"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "Metric_Goals")}>Goals ({numMetricCurrentGoals + numMetricFutureGoals + numMetricPastGoals})</div>)

                            if (numMetricCurrentGoals == 0 && numMetricPastGoals == 0) {

                                additionalResourceBodies.push(
                                    <div className={"tabContentBody singleResource_ContentBody_MetricGoals hidden"} ref={"singleResource_ContentBody_Metric_Goals"}>
                                        <div>
                                            <table className="singleResource_ContentBody_NoMetricGoals">
                                                <tbody>
                                                    <tr><td><div className="noResources">No Metric Goals</div><div className="noResourcesIcon"><i title="To add a resource, you will need to have content administrator permissions or higher. Click the edit content button above. Next click the + to create and add a metric goal." className="fa-light fa-circle-info"></i></div></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                );
                            }
                            else {
                                var currentMetricGoalContainer;
                                currentMetricGoalContainer = [];
                                var futureMetricGoalContainer;
                                futureMetricGoalContainer = [];
                                var pastMetricGoalContainer;
                                pastMetricGoalContainer = [];
                                if (numMetricCurrentGoals != 0) {
                                    currentMetricGoalContainer.push(
                                        <div className="currentMetricGoals">
                                            <div className="currentMetricGoalsHeader" onClick={this._showHideMetricList.bind(this, "Current")}>
                                                <i className="currentMetricGoalsIcon fa-light fa-chart-line"></i><span className="currentMetricGoalsText">Current Metric Goal</span><span className="metricGoalShowHide"><i ref="metricShowHideListIcon_Current" className={this.state.showMetricGoalsCurrent ? "metricGoalShowHideIcon fa-solid fa-chevron-down showList" : "metricGoalShowHideIcon fa-solid fa-chevron-down hideList"}></i></span>
                                            </div>
                                            <div className={this.state.showMetricGoalsCurrent ? "singleResource_ContentBody_MetricGoals_ShowHideList showTableList" : "singleResource_ContentBody_MetricGoals_ShowHideList hideTableList"} ref="singleResource_ContentBody_MetricGoals_ShowHideList_Current">
                                                <table className="singleResource_ContentBody_MetricGoals">
                                                    <tbody>
                                                        {metricCurrentGoalsList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                }
                                else {
                                    currentMetricGoalContainer.push(
                                        <div className="currentMetricGoals">
                                            <div className="noCurrentMetricGoalsHeader">
                                                <i className="currentMetricGoalsIcon fa-light fa-chart-line"></i><span className="currentMetricGoalsText">Current Metric Goal</span>
                                            </div>
                                            <div className="singleResource_ContentBody_MetricGoals_ShowHideList noTableList" ref="singleResource_ContentBody_MetricGoals_ShowHideList_Current">
                                                <table className="singleResource_ContentBody_MetricGoals">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                No Current Metric Goals
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );

                                }
                                if (numMetricFutureGoals != 0) {
                                    futureMetricGoalContainer.push(
                                        <div className="pastMetricGoals">
                                            <div className="futureMetricGoalsHeader" onClick={this._showHideMetricList.bind(this, "Future")}>
                                                <i className="futureMetricGoalsIcon fa-light fa-calendar-day"></i><span className="futureMetricGoalsText">Upcoming Metric Goals (<span className="futureMetricGoalsTextValue">{numMetricFutureGoals}</span>)</span><span className="metricGoalShowHide"><i ref="metricShowHideListIcon_Future" className={this.state.showMetricGoalsFuture ? "metricGoalShowHideIcon fa-solid fa-chevron-down showList" : "metricGoalShowHideIcon fa-solid fa-chevron-down hideList"}></i></span>
                                            </div>
                                            <div className={this.state.showMetricGoalsFuture ? "singleResource_ContentBody_MetricGoals_ShowHideList showTableList" : "singleResource_ContentBody_MetricGoals_ShowHideList hideTableList"} ref="singleResource_ContentBody_MetricGoals_ShowHideList_Future">
                                                <table className="singleResource_ContentBody_MetricGoals">
                                                    <tbody>
                                                        {metricFutureGoalsList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                }
                                else {
                                    futureMetricGoalContainer.push(
                                        <div className="pastMetricGoals">
                                            <div className="noFutureMetricGoalsHeader">
                                                <i className="futureMetricGoalsIcon fa-light fa-calendar-day"></i><span className="futureMetricGoalsText">Upcoming Metric Goals</span>
                                            </div>
                                            <div className="singleResource_ContentBody_MetricGoals_ShowHideList noTableList" ref="singleResource_ContentBody_MetricGoals_ShowHideList_Future">
                                                <table className="singleResource_ContentBody_MetricGoals">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                No Upcoming Metric Goals
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );

                                }
                                if (numMetricPastGoals != 0) {
                                    pastMetricGoalContainer.push(
                                        <div className="pastMetricGoals">
                                            <div className="pastMetricGoalsHeader" onClick={this._showHideMetricList.bind(this, "Past")}>
                                                <i className="pastMetricGoalsIcon fa-light fa-calendar-check"></i><span className="pastMetricGoalsText">Past Metric Goals (<span className="pastMetricGoalsTextValue">{numMetricPastGoals}</span>)</span><span className="metricGoalShowHide"><i ref="metricShowHideListIcon_Past" className={this.state.showMetricGoalsPast ? "metricGoalShowHideIcon fa-solid fa-chevron-down showList" : "metricGoalShowHideIcon fa-solid fa-chevron-down hideList"}></i></span>
                                            </div>
                                            <div className={this.state.showMetricGoalsPast ? "singleResource_ContentBody_MetricGoals_ShowHideList showTableList" : "singleResource_ContentBody_MetricGoals_ShowHideList hideTableList"} ref="singleResource_ContentBody_MetricGoals_ShowHideList_Past">
                                                <table className="singleResource_ContentBody_MetricGoals">
                                                    <tbody>
                                                        {metricPastGoalsList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                }
                                additionalResourceBodies.push(
                                    <div className={"tabContentBody singleResource_ContentBody_MetricGoals hidden"} ref={"singleResource_ContentBody_Metric_Goals"}>
                                        {currentMetricGoalContainer}
                                        {futureMetricGoalContainer}
                                        {pastMetricGoalContainer}
                                    </div>
                                );

                            }


                        }

                        if (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev') {
                            //CCN only resource headers

                            const ccn_BusinessLead_Resources = new Set(['firstName', 'lastName', 'title', 'email', 'phoneNumber']);
                            const ccn_CMEProgram_Resources = new Set(['']);
                            const ccn_EMRSystem_Resources = new Set(['']);
                            const ccn_ValueBasedContract_Resources = new Set(['']);
                            const ccn_CCNProvider_Resources = new Set(['firstName', 'lastName', 'title', 'email', 'phoneNumber', 'phoneNumber', 'cellPhoneNumber', 'address', 'city', 'state', 'zip', 'NPI', 'PCP', 'certificationStatus', 'haloStatus', 'MSOStatus', 'EVIPSPrimarySpecialty', 'FY18HCIPDateCompleted', 'FY19HCIPDateCompleted', 'FY20HCIPDateCompleted', 'FY20ECIPDateCompleted', 'PAReceivedDate', 'PAReturnedDate', 'CCNCredentialedDate', 'CCNTerminationDate']);
                            const ccn_CCNPracticeManager_Resources = new Set(['firstName', 'lastName', 'title', 'email', 'phoneNumber', 'phoneNumber', 'cellPhoneNumber', 'address', 'city', 'state', 'zip']);
                            const ccn_CCNPractice_Resources = new Set(['address', 'city', 'state', 'zip', 'MDPCP', 'MDPCPPracticeId', 'practiceId', 'practiceNPI', 'practicePhoneNumber', 'EPICDeptName', 'employedOrIndependent', 'PAReceivedDatePracticeLevel', 'CCNTerminationDate', 'CareFirstMedicareAdvantagePlanEnrollmentDate', 'CIGNAEnrollmentDate', 'ECIPEnrollmentDate', 'CRISPTier3', 'TIN', 'ACO']);
                            var selectedCCNResource = Object.values(resource_BuildCCNAttributeInfo).filter(resourceValue => (resourceValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase());
                            //getting the selected resource and if exists get the first child for all subsequent calls.
                            var tempDate = "";
                            var tempISODate = "";
                            if (selectedCCNResource.length > 0) {
                                selectedCCNResource = selectedCCNResource[0];
                            }
                            var ccn_selectedResource_Type_Attributes = new Set(['']);
                            switch (value['resourceType']) {
                                case "CCN Business Lead":
                                    ccn_selectedResource_Type_Attributes = ccn_BusinessLead_Resources;
                                    break;
                                case "CCN CME Program":
                                    ccn_selectedResource_Type_Attributes = ccn_CMEProgram_Resources;

                                    break;
                                case "CCN EMR System":
                                    ccn_selectedResource_Type_Attributes = ccn_EMRSystem_Resources;

                                    break;
                                case "CCN Practice":
                                    ccn_selectedResource_Type_Attributes = ccn_CCNPractice_Resources;

                                    break;
                                case "CCN Practice Manager":
                                    ccn_selectedResource_Type_Attributes = ccn_CCNPracticeManager_Resources;

                                    break;
                                case "CCN Provider":
                                    ccn_selectedResource_Type_Attributes = ccn_CCNProvider_Resources;

                                    break;
                                case "CCN Value Based Contract":
                                    ccn_selectedResource_Type_Attributes = ccn_ValueBasedContract_Resources;

                                    break;
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNFirstName_Container" className={ccn_selectedResource_Type_Attributes.has('firstName') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            First Name
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNFirstName' ref='singleResource_CCNFirstName'>
                                            {selectedCCNResource['firstName']}
                                        </span>
                                        <input ref="edit_singleResource_CCNFirstName" className="edit_singleResource_CCNFirstName" defaultValue={selectedCCNResource['firstName']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNLastName_Container" className={ccn_selectedResource_Type_Attributes.has('lastName') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Last Name
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNLastName' ref='singleResource_CCNLastName'>
                                            {selectedCCNResource['lastName']}
                                        </span>
                                        <input ref="edit_singleResource_CCNLastName" className="edit_singleResource_CCNLastName" defaultValue={selectedCCNResource['lastName']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNTitle_Container" className={ccn_selectedResource_Type_Attributes.has('title') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Title
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNTitle' ref='singleResource_CCNTitle'>
                                            {selectedCCNResource['title']}
                                        </span>
                                        <input ref="edit_singleResource_CCNTitle" className="edit_singleResource_CCNTitle" defaultValue={selectedCCNResource['title']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNEmail_Container" className={ccn_selectedResource_Type_Attributes.has('email') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Email
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNEmail' ref='singleResource_CCNEmail'>
                                            {selectedCCNResource['email']}
                                        </span>
                                        <input ref="edit_singleResource_CCNEmail" className="edit_singleResource_CCNEmail" defaultValue={selectedCCNResource['email']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNPhoneNumber_Container" className={ccn_selectedResource_Type_Attributes.has('phoneNumber') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Phone Number
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNPhoneNumber' ref='singleResource_CCNPhoneNumber'>
                                            {selectedCCNResource['phoneNumber']}
                                        </span>
                                        <input ref="edit_singleResource_CCNPhoneNumber" className="edit_singleResource_CCNPhoneNumber" defaultValue={selectedCCNResource['phoneNumber']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCellPhoneNumber_Container" className={ccn_selectedResource_Type_Attributes.has('cellPhoneNumber') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Cell Phone Number
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCellPhoneNumber' ref='singleResource_CCNCellPhoneNumber'>
                                            {selectedCCNResource['cellPhoneNumber']}
                                        </span>
                                        <input ref="edit_singleResource_CCNCellPhoneNumber" className="edit_singleResource_CCNCellPhoneNumber" defaultValue={selectedCCNResource['cellPhoneNumber']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNAddress_Container" className={ccn_selectedResource_Type_Attributes.has('address') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Address
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNAddress' ref='singleResource_CCNAddress'>
                                            {selectedCCNResource['address']}
                                        </span>
                                        <input ref="edit_singleResource_CCNAddress" className="edit_singleResource_CCNAddress" defaultValue={selectedCCNResource['address']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCity_Container" className={ccn_selectedResource_Type_Attributes.has('city') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            City
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCity' ref='singleResource_CCNCity'>
                                            {selectedCCNResource['city']}
                                        </span>
                                        <input ref="edit_singleResource_CCNCity" className="edit_singleResource_CCNCity" defaultValue={selectedCCNResource['city']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNState_Container" className={ccn_selectedResource_Type_Attributes.has('state') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            State
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNState' ref='singleResource_CCNState'>
                                            {selectedCCNResource['state']}
                                        </span>
                                        <input ref="edit_singleResource_CCNState" className="edit_singleResource_CCNState" defaultValue={selectedCCNResource['state']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNZipCode_Container" className={ccn_selectedResource_Type_Attributes.has('zip') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Zip Code
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNZipCode' ref='singleResource_CCNZipCode'>
                                            {selectedCCNResource['zip']}
                                        </span>
                                        <input ref="edit_singleResource_CCNZipCode" className="edit_singleResource_CCNZipCode" defaultValue={selectedCCNResource['zip']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNNPINumber_Container" className={ccn_selectedResource_Type_Attributes.has('NPI') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            NPI Number
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNNPINumber' ref='singleResource_CCNNPINumber'>
                                            {selectedCCNResource['NPI']}
                                        </span>
                                        <input ref="edit_singleResource_CCNNPINumber" className="edit_singleResource_CCNNPINumber" defaultValue={selectedCCNResource['NPI']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNPCP_Container" className={ccn_selectedResource_Type_Attributes.has('PCP') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            PCP
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNPCP' ref='singleResource_CCNPCP'>
                                            {selectedCCNResource['PCP']}
                                        </span>
                                        <input ref="edit_singleResource_CCNPCP" className="edit_singleResource_CCNPCP" defaultValue={selectedCCNResource['PCP']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCertificationStatus_Container" className={ccn_selectedResource_Type_Attributes.has('certificationStatus') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Certification Status
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCertificationStatus' ref='singleResource_CCNCertificationStatus'>
                                            {selectedCCNResource['certificationStatus']}
                                        </span>
                                        <input ref="edit_singleResource_CCNCertificationStatus" className="edit_singleResource_CCNCertificationStatus" defaultValue={selectedCCNResource['certificationStatus']} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNHaloStatus_Container" className={ccn_selectedResource_Type_Attributes.has('haloStatus') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Halo Status
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNHaloStatus' ref='singleResource_CCNHaloStatus'>
                                            {selectedCCNResource['haloStatus']}
                                        </span>
                                        <input ref="edit_singleResource_CCNHaloStatus" className="edit_singleResource_CCNHaloStatus" defaultValue={selectedCCNResource['haloStatus']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNMSOStatus_Container" className={ccn_selectedResource_Type_Attributes.has('MSOStatus') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            MSO Status
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNMSOStatus' ref='singleResource_CCNMSOStatus'>
                                            {selectedCCNResource['MSOStatus']}
                                        </span>
                                        <input ref="edit_singleResource_CCNMSOStatus" className="edit_singleResource_CCNMSOStatus" defaultValue={selectedCCNResource['MSOStatus']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNEVIPSPrimarySpecialty_Container" className={ccn_selectedResource_Type_Attributes.has('EVIPSPrimarySpecialty') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            EVIPS Primary Specialty
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNEVIPSPrimarySpecialty' ref='singleResource_CCNEVIPSPrimarySpecialty'>
                                            {selectedCCNResource['EVIPSPrimarySpecialty']}
                                        </span>
                                        <input ref="edit_singleResource_CCNEVIPSPrimarySpecialty" className="edit_singleResource_CCNEVIPSPrimarySpecialty" defaultValue={selectedCCNResource['EVIPSPrimarySpecialty']} />
                                    </td>
                                </tr>);


                            if (selectedCCNResource['FY18HCIPDateCompleted'] != undefined) {
                                if (selectedCCNResource['FY18HCIPDateCompleted'].toString().length > 0 && selectedCCNResource['FY18HCIPDateCompleted'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY18HCIPDateCompleted']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY18HCIPDateCompleted']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY18HCIPDateCompleted']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }


                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNFY18HCIPDateCompleted_Container" className={ccn_selectedResource_Type_Attributes.has('FY18HCIPDateCompleted') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            FY18 HCIP Date Completed
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNFY18HCIPDateCompleted' ref='singleResource_CCNFY18HCIPDateCompleted'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNFY18HCIPDateCompleted" className="edit_singleResource_CCNFY18HCIPDateCompleted" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['FY19HCIPDateCompleted'] != undefined) {
                                if (selectedCCNResource['FY19HCIPDateCompleted'].toString().length > 0 && selectedCCNResource['FY19HCIPDateCompleted'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY19HCIPDateCompleted']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY19HCIPDateCompleted']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY19HCIPDateCompleted']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNFY19HCIPDateCompleted_Container" className={ccn_selectedResource_Type_Attributes.has('FY19HCIPDateCompleted') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            FY19 HCIP Date Completed
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNFY19HCIPDateCompleted' ref='singleResource_CCNFY19HCIPDateCompleted'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNFY19HCIPDateCompleted" className="edit_singleResource_CCNFY19HCIPDateCompleted" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['FY20HCIPDateCompleted'] != undefined) {
                                if (selectedCCNResource['FY20HCIPDateCompleted'].toString().length > 0 && selectedCCNResource['FY20HCIPDateCompleted'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20HCIPDateCompleted']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20HCIPDateCompleted']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20HCIPDateCompleted']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNFY20HCIPDateCompleted_Container" className={ccn_selectedResource_Type_Attributes.has('FY20HCIPDateCompleted') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            FY20 HCIP Date Completed
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNFY20HCIPDateCompleted' ref='singleResource_CCNFY20HCIPDateCompleted'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNFY20HCIPDateCompleted" className="edit_singleResource_CCNFY20HCIPDateCompleted" defaultValue={tempISODate} />
                                    </td>
                                </tr>);


                            if (selectedCCNResource['FY20ECIPDateCompleted'] != undefined) {
                                if (selectedCCNResource['FY20ECIPDateCompleted'].toString().length > 0 && selectedCCNResource['FY20ECIPDateCompleted'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20ECIPDateCompleted']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20ECIPDateCompleted']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['FY20ECIPDateCompleted']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNFY20ECIPDateCompleted_Container" className={ccn_selectedResource_Type_Attributes.has('FY20ECIPDateCompleted') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            FY20 ECIP Date Completed
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNFY20ECIPDateCompleted' ref='singleResource_CCNFY20ECIPDateCompleted'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNFY20ECIPDateCompleted" className="edit_singleResource_CCNFY20ECIPDateCompleted" defaultValue={tempISODate} />
                                    </td>
                                </tr>);


                            if (selectedCCNResource['PAReceivedDate'] != undefined) {
                                if (selectedCCNResource['PAReceivedDate'].toString().length > 0 && selectedCCNResource['PAReceivedDate'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }


                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNPAReceivedDate_Container" className={ccn_selectedResource_Type_Attributes.has('PAReceivedDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            PA Received Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNPAReceivedDate' ref='singleResource_CCNPAReceivedDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNPAReceivedDate" className="edit_singleResource_CCNPAReceivedDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);



                            if (selectedCCNResource['PAReturnedDate'] != undefined) {
                                if (selectedCCNResource['PAReturnedDate'].toString().length > 0 && selectedCCNResource['PAReturnedDate'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReturnedDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReturnedDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReturnedDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }


                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNPAReturnedDate_Container" className={ccn_selectedResource_Type_Attributes.has('PAReturnedDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            PA Returned Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNPAReturnedDate' ref='singleResource_CCNPAReturnedDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNPAReturnedDate" className="edit_singleResource_CCNPAReturnedDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['CCNCredentialedDate'] != undefined) {
                                if (selectedCCNResource['CCNCredentialedDate'].toString().length > 0 && selectedCCNResource['CCNCredentialedDate'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNCredentialedDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNCredentialedDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNCredentialedDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }


                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCCNCredentialedDate_Container" className={ccn_selectedResource_Type_Attributes.has('CCNCredentialedDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            CCN Credentialed Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCCNCredentialedDate' ref='singleResource_CCNCCNCredentialedDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNCCNCredentialedDate" className="edit_singleResource_CCNCCNCredentialedDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['CCNTerminationDate'] != undefined) {
                                if (selectedCCNResource['CCNTerminationDate'].toString().length > 0 && selectedCCNResource['CCNTerminationDate'].toString() != "0") {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNTerminationDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNTerminationDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CCNTerminationDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                                else {
                                    tempDate = "";
                                    tempISODate = "";
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCCNTerminationDate_Container" className={ccn_selectedResource_Type_Attributes.has('CCNTerminationDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            CCN Termination Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCCNTerminationDate' ref='singleResource_CCNCCNTerminationDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNCCNTerminationDate" className="edit_singleResource_CCNCCNTerminationDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNMDPCP_Container" className={ccn_selectedResource_Type_Attributes.has('MDPCP') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            MD PCP
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNMDPCP' ref='singleResource_CCNMDPCP'>
                                            {selectedCCNResource['MDPCP']}
                                        </span>
                                        <input ref="edit_singleResource_CCNMDPCP" className="edit_singleResource_CCNMDPCP" defaultValue={selectedCCNResource['MDPCP']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNMDPCPPracticeId_Container" className={ccn_selectedResource_Type_Attributes.has('MDPCPPracticeId') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            MD PCP Practice Id
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNMDPCPPracticeId' ref='singleResource_CCNMDPCPPracticeId'>
                                            {selectedCCNResource['MDPCPPracticeId']}
                                        </span>
                                        <input ref="edit_singleResource_CCNMDPCPPracticeId" className="edit_singleResource_CCNMDPCPPracticeId" defaultValue={selectedCCNResource['MDPCPPracticeId']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNpracticeId_Container" className={ccn_selectedResource_Type_Attributes.has('practiceId') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Practice Id
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNpracticeId' ref='singleResource_CCNpracticeId'>
                                            {selectedCCNResource['practiceId']}
                                        </span>
                                        <input ref="edit_singleResource_CCNpracticeId" className="edit_singleResource_CCNpracticeId" defaultValue={selectedCCNResource['practiceId']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNpracticeNPI_Container" className={ccn_selectedResource_Type_Attributes.has('practiceNPI') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Practice NPI
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNpracticeNPI' ref='singleResource_CCNpracticeNPI'>
                                            {selectedCCNResource['practiceNPI']}
                                        </span>
                                        <input ref="edit_singleResource_CCNpracticeNPI" className="edit_singleResource_CCNpracticeNPI" defaultValue={selectedCCNResource['practiceNPI']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNpracticePhoneNumber_Container" className={ccn_selectedResource_Type_Attributes.has('practicePhoneNumber') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Practice Phone Number
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNpracticePhoneNumber' ref='singleResource_CCNpracticePhoneNumber'>
                                            {selectedCCNResource['practicePhoneNumber']}
                                        </span>
                                        <input ref="edit_singleResource_CCNpracticePhoneNumber" className="edit_singleResource_CCNpracticePhoneNumber" placeholder="XXXXXXXXXX" defaultValue={selectedCCNResource['practicePhoneNumber']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNEPICDeptName_Container" className={ccn_selectedResource_Type_Attributes.has('EPICDeptName') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            EPIC Dept Name
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNEPICDeptName' ref='singleResource_CCNEPICDeptName'>
                                            {selectedCCNResource['EPICDeptName']}
                                        </span>
                                        <input ref="edit_singleResource_CCNEPICDeptName" className="edit_singleResource_CCNEPICDeptName" defaultValue={selectedCCNResource['EPICDeptName']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNemployedOrIndependent_Container" className={ccn_selectedResource_Type_Attributes.has('employedOrIndependent') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            Employed or Independent
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNemployedOrIndependent' ref='singleResource_CCNemployedOrIndependent'>
                                            {selectedCCNResource['employedOrIndependent']}
                                        </span>
                                        <input ref="edit_singleResource_CCNemployedOrIndependent" className="edit_singleResource_CCNemployedOrIndependent" defaultValue={selectedCCNResource['employedOrIndependent']} />
                                    </td>
                                </tr>);



                            if (selectedCCNResource['PAReceivedDatePracticeLevel'] != undefined) {
                                if (selectedCCNResource['PAReceivedDatePracticeLevel'].toString().length > 0) {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDatePracticeLevel']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDatePracticeLevel']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['PAReceivedDatePracticeLevel']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNPAReceivedDatePracticeLevel_Container" className={ccn_selectedResource_Type_Attributes.has('PAReceivedDatePracticeLevel') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            PA Received Date Practice Level
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNPAReceivedDatePracticeLevel' ref='singleResource_CCNPAReceivedDatePracticeLevel'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNPAReceivedDatePracticeLevel" className="edit_singleResource_CCNPAReceivedDatePracticeLevel" defaultValue={tempISODate} />
                                    </td>
                                </tr>);


                            if (selectedCCNResource['CareFirstMedicareAdvantagePlanEnrollmentDate'] != undefined) {
                                if (selectedCCNResource['CareFirstMedicareAdvantagePlanEnrollmentDate'].toString().length > 0) {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CareFirstMedicareAdvantagePlanEnrollmentDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CareFirstMedicareAdvantagePlanEnrollmentDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CareFirstMedicareAdvantagePlanEnrollmentDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate_Container" className={ccn_selectedResource_Type_Attributes.has('CareFirstMedicareAdvantagePlanEnrollmentDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            CareFirst Medicare Advantage Plan Enrollment Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate' ref='singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate" className="edit_singleResource_CCNCareFirstMedicareAdvantagePlanEnrollmentDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['CIGNAEnrollmentDate'] != undefined) {
                                if (selectedCCNResource['CIGNAEnrollmentDate'].toString().length > 0) {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CIGNAEnrollmentDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CIGNAEnrollmentDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['CIGNAEnrollmentDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCIGNAEnrollmentDate_Container" className={ccn_selectedResource_Type_Attributes.has('CIGNAEnrollmentDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            CIGNA Enrollment Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCIGNAEnrollmentDate' ref='singleResource_CCNCIGNAEnrollmentDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNCIGNAEnrollmentDate" className="edit_singleResource_CCNCIGNAEnrollmentDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);

                            if (selectedCCNResource['ECIPEnrollmentDate'] != undefined) {
                                if (selectedCCNResource['ECIPEnrollmentDate'].toString().length > 0) {
                                    tempDate = ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['ECIPEnrollmentDate']))).getUTCMonth() + 1) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['ECIPEnrollmentDate']))).getUTCDate()) + "/" + ((new Date((new Date(0)).setMilliseconds(selectedCCNResource['ECIPEnrollmentDate']))).getUTCFullYear());
                                    tempISODate = new Date(tempDate);
                                    tempISODate = tempISODate.toISOString().substr(0, 10);
                                }
                            }
                            else {
                                tempDate = "";
                                tempISODate = "";
                            }

                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNECIPEnrollmentDate_Container" className={ccn_selectedResource_Type_Attributes.has('ECIPEnrollmentDate') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            ECIP Enrollment Date
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNECIPEnrollmentDate' ref='singleResource_CCNECIPEnrollmentDate'>
                                            {tempDate}
                                        </span>
                                        <input type="date" ref="edit_singleResource_CCNECIPEnrollmentDate" className="edit_singleResource_CCNECIPEnrollmentDate" defaultValue={tempISODate} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNCRISPTier3_Container" className={ccn_selectedResource_Type_Attributes.has('CRISPTier3') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            CRISP Tier 3
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNCRISPTier3' ref='singleResource_CCNCRISPTier3'>
                                            {selectedCCNResource['CRISPTier3']}
                                        </span>
                                        <input ref="edit_singleResource_CCNCRISPTier3" className="edit_singleResource_CCNCRISPTier3" defaultValue={selectedCCNResource['CRISPTier3']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNTIN_Container" className={ccn_selectedResource_Type_Attributes.has('TIN') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            TIN
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNTIN' ref='singleResource_CCNTIN'>
                                            {selectedCCNResource['TIN']}
                                        </span>
                                        <input ref="edit_singleResource_CCNTIN" className="edit_singleResource_CCNTIN" defaultValue={selectedCCNResource['TIN']} />
                                    </td>
                                </tr>);
                            ccnAttributeList.push(
                                <tr ref="singleResource_CCNACO_Container" className={ccn_selectedResource_Type_Attributes.has('ACO') ? "" : "hidden"}>
                                    <td>
                                        <span className="detailsTable_Label">
                                            ACO
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_CCNACO' ref='singleResource_CCNACO'>
                                            {selectedCCNResource['ACO']}
                                        </span>
                                        <input ref="edit_singleResource_CCNACO" className="edit_singleResource_CCNACO" defaultValue={selectedCCNResource['ACO']} />
                                    </td>
                                </tr>);


                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_CCNAttributes"} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, "CCNAttributes")}>CCN Info</div>)

                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_CCNAttributes hidden"} ref={"singleResource_ContentBody_CCNAttributes"}>
                                    <div>
                                        <table className="singleResource_ContentBody_CCNAttributesTable">
                                            <tbody>
                                                {ccnAttributeList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        }

                        Object.values(resource_BuildRelationshipInfo)
                            .filter(resourceValue => (resourceValue['sourceExternalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                            .forEach(resourceValue => {
                                //Need to get first image if exists for this.
                                //additionalResourceImages = <div alt="Click to View Additional Pictures" title="Click to View Additional Pictures" ref="subImage_SingleResource_Container" className="fill subImage_SingleResource additionalImages"><div className="additionalImages_Link"><div className="additionalImages_Count"><span className="countPlus">+</span>{(imageCount - 3)}</div><div className="additionalImages_Text">Additional<br />Pictures</div></div></div >;
                                //Need to get the detailed information for the sub-Record.
                                //.filter(subResourceValue => (subResourceValue['externalId']).toString().toLowerCase() == (resourceValue['relationshipExternalId']).toString().toLowerCase())
                                Object.values(resource_IntellisenseInfo)
                                    .filter(subResourceValue => (subResourceValue['externalId']).toString().toLowerCase() == (resourceValue['relationshipExternalId']).toString().toLowerCase())
                                    .forEach(subResourceValue => {

                                        if (Object.values(resourceHeadersList).some(e => e == subResourceValue['resourceType'])) {

                                        }
                                        else {

                                            resourceBody = [];
                                            var numSubElements = 0;
                                            Object.values(resource_BuildRelationshipInfo)
                                                .filter(resourceDetailedValue => (resourceDetailedValue['sourceExternalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase() && subResourceValue['resourceType'].toString().toLowerCase() == resourceDetailedValue['resourceType'].toString().toLowerCase())
                                                .forEach(subResourceDetailedValue => {
                                                    var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                                    var highlightedText = subResourceDetailedValue['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                    highlightedText = ReactHtmlParser(highlightedText);

                                                    var filterResourcesIcon = "";
                                                    var filterIcon = "";
                                                    switch (subResourceDetailedValue['resourceType']) {
                                                        case "Report":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                            break;
                                                        case "Report Category":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                            break;
                                                        case "Quality & Research Symposium":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                            break;
                                                        case "Action Plan":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                            break;
                                                        case "Stakeholder":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                            break;
                                                        case "Metric":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                            filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                            break;
                                                        case "Business Term":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                            break;
                                                        case "Component":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                            break;
                                                        case "Acronym":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                            break;
                                                        case "CCN Business Lead":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                            break;
                                                        case "CCN CME Program":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                            break;
                                                        case "CCN EMR System":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                            break;
                                                        case "CCN Value Based Contract":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                            break;
                                                        case "CCN Provider":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                            break;
                                                        case "CCN Provider Specialty":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                            break;
                                                        case "CCN Practice Manager":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                            break;
                                                        case "CCN Practice":
                                                            filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                            filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                            break;
                                                    }

                                                    var favoriteData;
                                                    favoriteData = [];
                                                    var favoriteDataIntellisense;
                                                    favoriteDataIntellisense = [];
                                                    if (Object.values(user_FavoritesInfo).some(e => e.externalId == subResourceDetailedValue['relationshipExternalId'])) {
                                                        favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                        favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, subResourceDetailedValue['relationshipExternalId'])} ></i>);
                                                    }
                                                    else {
                                                        favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                        favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, subResourceDetailedValue['relationshipExternalId'])}></i>)
                                                    }

                                                    var subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{subResourceDetailedValue['resourceType']}</div></td></tr></tbody></table>;


                                                    var imageCount = 0;

                                                    Object.values(resource_BuildImageInfo)
                                                        .filter(imageValue => (imageValue['externalId']) == (subResourceDetailedValue['relationshipExternalId']))
                                                        .forEach(imageValue => {
                                                            if (imageCount == 0) {
                                                                subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                            }
                                                            imageCount = imageCount + 1;
                                                        });

                                                    if (imageCount == 0) {

                                                        Object.values(resource_BuildThumbImageInfo)
                                                            .filter(imageValue => (imageValue['externalId']) == (subResourceDetailedValue['relationshipExternalId']))
                                                            .forEach(imageValue => {
                                                                if (imageCount == 0) {
                                                                    subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                                }
                                                                imageCount = imageCount + 1;
                                                            });
                                                    }

                                                    var overviewShortText = subResourceDetailedValue['overviewShortText'];
                                                    if (overviewShortText.length == 0) {
                                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                        overviewShortText = <span>Description not available.</span>;
                                                    }
                                                    var subResourceRank = subResourceDetailedValue['rankName'];
                                                    if (subResourceRank == "" || subResourceRank == null) {
                                                        subResourceRank = "None";
                                                    }
                                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                                        valueRankIcon = "";
                                                    }
                                                    if (this.state.resource_editMode) {


                                                        var qrsInfo;
                                                        qrsInfo = [];

                                                        if (subResourceDetailedValue['qrsYear'] == null) {

                                                        }
                                                        else {
                                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={subResourceDetailedValue['qrsYear']} title={subResourceDetailedValue['qrsYear']}>
                                                                {(subResourceDetailedValue['qrsYear'].length > 0) ? "(" : ""} {subResourceDetailedValue['qrsYear']} {(subResourceDetailedValue['qrsYear'].length > 0) ? ")" : ""}
                                                            </span>);
                                                        }
                                                        resourceBody.push(
                                                            <div ref={"subResource_body"} className="subResource_Body">
                                                                <table className="subResource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], subResourceDetailedValue['relationshipExternalId'], subResourceDetailedValue['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + subResourceRank} title={subResourceRank}><i className={valueRankIcon}></i></span>
                                                                                {subResourceMainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], subResourceDetailedValue['relationshipExternalId'], subResourceDetailedValue['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={subResourceDetailedValue['relationshipExternalId']} title={subResourceDetailedValue['relationshipExternalId']} className="hidden">{subResourceDetailedValue['relationshipExternalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={subResourceDetailedValue['resourceName']} title={subResourceDetailedValue['resourceName']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={subResourceDetailedValue['resourceType']} title={subResourceDetailedValue['resourceType']}>{filterIcon} {subResourceDetailedValue['resourceType']} <span className="resource_Body_ReportType" alt={subResourceDetailedValue['reportType']} title={subResourceDetailedValue['reportType']}>{(subResourceDetailedValue['reportType'].length > 0) ? "(" : ""} {subResourceDetailedValue['reportType']} {(subResourceDetailedValue['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={subResourceDetailedValue['dtExternallyCreated']} title={subResourceDetailedValue['dtExternallyCreated']} className="hidden">{subResourceDetailedValue['dtExternallyCreated']}</span>
                                                                                    <span alt={subResourceDetailedValue['dtExternallyModified']} title={subResourceDetailedValue['dtExternallyModified']} className="hidden">{subResourceDetailedValue['dtExternallyModified']}</span>
                                                                                    <span alt={subResourceDetailedValue['externalStatus']} title={subResourceDetailedValue['externalStatus']} className="hidden">{subResourceDetailedValue['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={subResourceDetailedValue['overviewShortText']} title={subResourceDetailedValue['overviewShortText']}>{overviewShortText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']} title={subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']}>{subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']} title={subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']}>{subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']}</span>
                                                                                </span>
                                                                            </td>
                                                                            <td className="resource_Body_Remove_Container" onClick={this._singleResultRemoveRelationship.bind(this, value['externalId'], value['resourceName'], value['resourceType'], subResourceDetailedValue['relationshipExternalId'], subResourceDetailedValue['resourceName'], searchText)}><i className="resource_Body_Remove_Button fas fa-times"></i></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>);
                                                    }
                                                    else {

                                                        var qrsInfo;
                                                        qrsInfo = [];

                                                        if (subResourceDetailedValue['qrsYear'] == null) {

                                                        }
                                                        else {
                                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={subResourceDetailedValue['qrsYear']} title={subResourceDetailedValue['qrsYear']}>
                                                                {(subResourceDetailedValue['qrsYear'].length > 0) ? "(" : ""} {subResourceDetailedValue['qrsYear']} {(subResourceDetailedValue['qrsYear'].length > 0) ? ")" : ""}
                                                            </span>);
                                                        }

                                                        resourceBody.push(
                                                            <div ref={"subResource_body"} className="subResource_Body">
                                                                <table className="subResource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], subResourceDetailedValue['relationshipExternalId'], subResourceDetailedValue['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + subResourceRank} title={subResourceRank}><i className={valueRankIcon}></i></span>
                                                                                {subResourceMainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], subResourceDetailedValue['relationshipExternalId'], subResourceDetailedValue['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={subResourceDetailedValue['relationshipExternalId']} title={subResourceDetailedValue['relationshipExternalId']} className="hidden">{subResourceDetailedValue['relationshipExternalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={subResourceDetailedValue['resourceName']} title={subResourceDetailedValue['resourceName']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={subResourceDetailedValue['resourceType']} title={subResourceDetailedValue['resourceType']}>{filterIcon} {subResourceDetailedValue['resourceType']} <span className="resource_Body_ReportType" alt={subResourceDetailedValue['reportType']} title={subResourceDetailedValue['reportType']}>{(subResourceDetailedValue['reportType'].length > 0) ? "(" : ""} {subResourceDetailedValue['reportType']} {(subResourceDetailedValue['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={subResourceDetailedValue['dtExternallyCreated']} title={subResourceDetailedValue['dtExternallyCreated']} className="hidden">{subResourceDetailedValue['dtExternallyCreated']}</span>
                                                                                    <span alt={subResourceDetailedValue['dtExternallyModified']} title={subResourceDetailedValue['dtExternallyModified']} className="hidden">{subResourceDetailedValue['dtExternallyModified']}</span>
                                                                                    <span alt={subResourceDetailedValue['externalStatus']} title={subResourceDetailedValue['externalStatus']} className="hidden">{subResourceDetailedValue['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={subResourceDetailedValue['overviewShortText']} title={subResourceDetailedValue['overviewShortText']}>{overviewShortText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']} title={subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']}>{subResourceDetailedValue['createdByFirstName'] + " " + subResourceDetailedValue['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']} title={subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']}>{subResourceDetailedValue['modifiedByFirstName'] + " " + subResourceDetailedValue['modifiedByLastName']}</span>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>);

                                                    }

                                                    numSubElements++;
                                                });
                                            if (numSubElements > 1) {
                                                resourceHeadersList.push(subResourceValue['resourceType']);
                                            }
                                            else {
                                                resourceHeadersList.push(subResourceValue['resourceType']);
                                            }
                                            if (subResourceValue['resourceType'] == "Report") {
                                                subResourcesReports = true;
                                            }

                                            const singleResource_search = ' ';
                                            const singleResource_replaceWith = '_';

                                            var addPrefilteredResource = [];

                                            var resourceContentBodyClass = "resourceContentBody";


                                            if (this.state.resource_editMode) {
                                                //not used code to create a button for adding additional resources
                                                addPrefilteredResource.push(
                                                    <div className="addPrefilteredResource" onClick={this._addRelationshipAndUpdateRelationshipResourceFilter.bind(this, subResourceValue['resourceType'])}>
                                                        <span className="addPrefilteredResourceText">
                                                            <span className="addPrefilteredPlus">+</span> Add {subResourceValue['resourceType']}
                                                        </span>
                                                    </div>);
                                            }

                                            subResourceData.push(<div className="subResource_SingleResource subResourceData"><div className="additionalResource_Link"><div className="additionalResource_Count">{(subResourceCount + 1)}</div><div className="additionalResource_Text">{subResourceValue['externalId']} {subResourceValue['resourceType']} {subResourceValue['resourceName']}</div></div></div >);
                                            additionalResourceBodies.push(
                                                <div className={"tabContentBody singleResource_ContentBody_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith) + " hidden"} ref={"singleResource_ContentBody_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith)}>
                                                    <div className={resourceContentBodyClass}>{resourceBody}</div>
                                                </div>
                                            )
                                            var subResourceType = subResourceValue['resourceType'];

                                            if (numSubElements > 1) {
                                                subResourceType = subResourceType + "s";
                                            }

                                            if (subResourceValue['resourceType'] == "Report" && value['resourceType'] == "Report Category") {
                                                additionalResourceBodies.push(
                                                    <div ref={"singleResource_NavTab_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith)} className="navTab reportCategoryReportTab">{subResourceType} (<span className={subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith) + "_count subResourceCount"}>{numSubElements}</span>)</div>);
                                                additionalResourceBodies.push(
                                                    <div className={"tabContentBody reportCategoryReportList singleResource_ContentBody_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith)} ref={"singleResource_ContentBody_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith)}>
                                                        <div>{resourceBody}</div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                additionalResourceHeaders.push(<div ref={"singleResource_NavTab_" + subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith)} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith))}>{subResourceType} (<span className={subResourceValue['resourceType'].split(singleResource_search).join(singleResource_replaceWith) + "_count subResourceCount"}>{numSubElements}</span>)</div>)
                                            }
                                        }

                                    });
                                subResourceCount = subResourceCount + 1;
                            });

                        if (subResourceCount == 0) {
                            subResourcesAvailable = false;
                        }
                        else {
                            subResourcesAvailable = true;
                        }





                        var numDisplaysInElements = 0;
                        /*
                        resourceBody = [];
                        numDisplaysInElements = 0;
                        Object.values(resource_BuildDisplaysInInfo)
                            .filter(resourceValue => (resourceValue['relationshipExternalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                            .forEach(resourceValue => {

                                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                                var highlightedText = resourceValue['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                highlightedText = ReactHtmlParser(highlightedText);

                                                var filterResourcesIcon = "";
                                                var filterIcon = "";
                                                switch (resourceValue['resourceType']) {
                                                    case "Report":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                        break;
                                                    case "Report Category":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                        break;
                                                    case "Quality & Research Symposium":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                        break;
                                                    case "Action Plan":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                        break;
                                                    case "Stakeholder":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "Metric":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                        break;
                                                    case "Business Term":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                        break;
                                                    case "Component":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                        break;
                                                    case "Acronym":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                        break;
                                                    case "CCN Business Lead":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                        break;
                                                    case "CCN CME Program":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "CCN EMR System":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                        break;
                                                    case "CCN Value Based Contract":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                        break;
                                                    case "CCN Provider":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                        break;
                                                    case "CCN Provider Specialty":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                        break;
                                                    case "CCN Practice Manager":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                        break;
                                                    case "CCN Practice":
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                        break;
                                                }

                                                var favoriteData;
                                                favoriteData = [];
                                                var favoriteDataIntellisense;
                                                favoriteDataIntellisense = [];
                                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == resourceValue['sourceExternalId'])) {
                                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, resourceValue['sourceExternalId'])} ></i>);
                                                }
                                                else {
                                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, resourceValue['sourceExternalId'])}></i>)
                                                }

                                                var subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{resourceValue['resourceType']}</div></td></tr></tbody></table>;

                                                var imageCount = 0;

                                                Object.values(resource_BuildImageInfo)
                                                    .filter(imageValue => (imageValue['externalId']) == (resourceValue['relationshipExternalId']))
                                                    .forEach(imageValue => {
                                                        if (imageCount == 0) {
                                                            subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                        }
                                                        imageCount = imageCount + 1;
                                                    });


                                                if (imageCount == 0) {

                                                    Object.values(resource_BuildThumbImageInfo)
                                                        .filter(imageValue => (imageValue['externalId']) == (resourceValue['relationshipExternalId']))
                                                        .forEach(imageValue => {
                                                            if (imageCount == 0) {
                                                                subResourceMainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                            }
                                                            imageCount = imageCount + 1;
                                                        });
                                                }

                                                var overviewShortText = resourceValue['overviewShortText'];
                                                if (overviewShortText.length == 0) {
                                                    //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                    overviewShortText = <span>Description not available.</span>;
                                                }
                                                var subResourceRank = resourceValue['rankName'];
                                                if (subResourceRank == "" || subResourceRank == null) {
                                                    subResourceRank = "None";
                                                }
                                                var valueRankIcon = value['rankFontAwesomeIcon'];
                                                if (valueRankIcon == "" || valueRankIcon == null) {
                                                    valueRankIcon = "";
                                                }

                                                var qrsInfo;
                                                qrsInfo = [];

                                                if (resourceValue['qrsYear'] == null) {

                                                }
                                                else {
                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={resourceValue['qrsYear']} title={resourceValue['qrsYear']}>
                                                        {(resourceValue['qrsYear'].length > 0) ? "(" : ""} {resourceValue['qrsYear']} {(resourceValue['qrsYear'].length > 0) ? ")" : ""}
                                                    </span>);
                                                }

                                                resourceBody.push(
                                                    <div ref={"subResource_body"} className="subResource_Body">
                                                        <table className="subResource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], resourceValue['sourceExternalId'], resourceValue['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + subResourceRank} title={subResourceRank}><i className={valueRankIcon}></i></span>
                                                                        {subResourceMainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithReportCategorySearch.bind(this, value['externalId'], value['resourceName'], value['resourceType'], resourceValue['sourceExternalId'], resourceValue['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={resourceValue['sourceExternalId']} title={resourceValue['sourceExternalId']} className="hidden">{resourceValue['sourceExternalId']}</span>
                                                                            <div className="resource_Body_Title" alt={resourceValue['resourceName']} title={resourceValue['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={resourceValue['resourceType']} title={resourceValue['resourceType']}>{filterIcon} {resourceValue['resourceType']} <span className="resource_Body_ReportType" alt={resourceValue['reportType']} title={resourceValue['reportType']}>{(resourceValue['reportType'].length > 0) ? "(" : ""} {resourceValue['reportType']} {(resourceValue['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={resourceValue['dtExternallyCreated']} title={resourceValue['dtExternallyCreated']} className="hidden">{resourceValue['dtExternallyCreated']}</span>
                                                                            <span alt={resourceValue['dtExternallyModified']} title={resourceValue['dtExternallyModified']} className="hidden">{resourceValue['dtExternallyModified']}</span>
                                                                            <span alt={resourceValue['externalStatus']} title={resourceValue['externalStatus']} className="hidden">{resourceValue['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={resourceValue['overviewShortText']} title={resourceValue['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={resourceValue['createdByFirstName'] + " " + resourceValue['createdByLastName']} title={resourceValue['createdByFirstName'] + " " + resourceValue['createdByLastName']}>{resourceValue['createdByFirstName'] + " " + resourceValue['createdByLastName']}</span>
                                                                            <span className="hidden" alt={resourceValue['modifiedByFirstName'] + " " + resourceValue['modifiedByLastName']} title={resourceValue['modifiedByFirstName'] + " " + resourceValue['modifiedByLastName']}>{resourceValue['modifiedByFirstName'] + " " + resourceValue['modifiedByLastName']}</span>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>);


                                                numDisplaysInElements++;
                                            });

                        */
                        //resourceHeadersList.push(subResourceValue['resourceType']);

                        //resourceHeadersList.push('Displays In');


                        const singleResource_search = ' ';
                        const singleResource_replaceWith = '_';

                        if (numDisplaysInElements > 0) {

                            //subResourceData.push(<div className="subResource_SingleResource subResourceData"><div className="additionalResource_Link"><div className="additionalResource_Count">{(subResourceCount + 1)}</div><div className="additionalResource_Text">{subResourceValue['externalId']} {subResourceValue['resourceType']} {subResourceValue['resourceName']}</div></div></div >);
                            additionalResourceBodies.push(
                                <div className={"tabContentBody singleResource_ContentBody_" + ("Displays In").split(singleResource_search).join(singleResource_replaceWith) + " hidden"} ref={"singleResource_ContentBody_" + ("Displays In").split(singleResource_search).join(singleResource_replaceWith)}>
                                    <div>{resourceBody}</div>
                                </div>
                            )
                            additionalResourceHeaders.push(<div ref={"singleResource_NavTab_" + ("Displays In").split(singleResource_search).join(singleResource_replaceWith)} className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, ("Displays In").split(singleResource_search).join(singleResource_replaceWith))}>Displays In (<span className={("Displays In").split(singleResource_search).join(singleResource_replaceWith) + "_count subResourceCount"}>{numDisplaysInElements}</span>)</div>)
                        }





                        //VOTES
                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                        }, 0);

                        var rankPoints = parseInt(value['rankPoints']);

                        var upvoteData;
                        upvoteData = [];

                        var downvoteData;
                        downvoteData = [];

                        upvoteData.push(<div className="votingContainer" onClick={this._upvoteResource.bind(this, value['externalId'])}><i className="bodyUpvote fal fa-thumbs-up" title="Upvote" alt="Upvote"></i></div>);
                        downvoteData.push(<div className="votingContainer" onClick={this._downvoteResource.bind(this, value['externalId'])}><i className="bodyDownvote fal fa-thumbs-down" title="Downvote" alt="Downvote"></i></div>);


                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                            Object.values(thisReportVotes)
                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                .forEach(value => {
                                    if (value['ratingPoints'] > 0) {

                                        upvoteData = [];
                                        downvoteData = [];
                                        upvoteData.push(<div className="votingContainer_Selected" onClick={this._removeResourceVote.bind(this, value['externalId'])}><i className="bodyUpvote fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote"></i></div>);
                                        downvoteData.push(<div className="votingContainer_NotSelected" onClick={this._downvoteResource.bind(this, value['externalId'])}><i className="bodyDownvote fal fa-thumbs-down" title="Downvote" alt="Downvote"></i></div>);
                                    }
                                    else if (value['ratingPoints'] < 0) {

                                        upvoteData = [];
                                        downvoteData = [];
                                        upvoteData.push(<div className="votingContainer_NotSelected" onClick={this._upvoteResource.bind(this, value['externalId'])}><i className="bodyUpvote fal fa-thumbs-up" title="Upvote" alt="Upvote" ></i></div>);
                                        downvoteData.push(<div className="votingContainer_Selected" onClick={this._removeResourceVote.bind(this, value['externalId'])}><i className="bodyDownvote fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote"></i></div>);
                                    }
                                });

                        }

                        var fullText = value['overviewFullText'];
                        while (fullText.indexOf("matched-expression=") != -1) {
                            var textSubString = fullText.substring(fullText.indexOf("matched-expression=") + 20)
                            var linkText = fullText.substring(fullText.indexOf("matched-expression=") + 20, fullText.indexOf("matched-expression=") + 20 + textSubString.indexOf('"'));
                            fullText = fullText.replace('matched-expression="' + linkText + '"', 'href="#/searchResult/' + linkText + '/"')
                        }

                        if (fullText.length == 0) {
                            //fullText = "<span className='notAvailableDescription'>Description not available.</span>";
                            fullText = "<span>Description not available.</span>";
                        }

                        var reportType = "";
                        var reportTypeDash = "";
                        if (value['resourceType'] == "Report") {
                            if (value['reportType'].length > 0) {
                                reportType = <span className="singleResource_ReportType" ref="singleResource_ReportType" alt={value['reportType']} title={value['reportType']}>{value['reportType']}</span>
                                reportTypeDash = <span className="singleResource_ReportTypeDash" ref="singleResource_ReportTypeDash">-</span>
                            }
                            else {
                                reportType = <span className="singleResource_ReportType" ref="singleResource_ReportType"></span>
                                reportTypeDash = <span className="singleResource_ReportTypeDash" ref="singleResource_ReportTypeDash"></span>
                            }
                        }
                        else {
                            reportType = <span className="singleResource_ReportType" ref="singleResource_ReportType"></span>
                            reportTypeDash = <span className="singleResource_ReportTypeDash" ref="singleResource_ReportTypeDash"></span>
                        }


                        var qrsYear = "";
                        var qrsYearDash = "";
                        if (value['resourceType'] == "Quality & Research Symposium") {
                            if (value['qrsYear'].length > 0) {
                                qrsYear = <span className="singleResource_QRSYear" ref="singleResource_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>{value['qrsYear']}</span>
                                qrsYearDash = <span className="singleResource_QRSYearDash" ref="singleResource_QRSYearDash">-</span>
                            }
                            else {
                                qrsYear = <span className="singleResource_QRSYear" ref="singleResource_QRSYear"></span>
                                qrsYearDash = <span className="singleResource_QRSYearDash" ref="singleResource_QRSYearDash"></span>
                            }
                        }
                        else {
                            qrsYear = <span className="singleResource_QRSYear" ref="singleResource_QRSYear"></span>
                            qrsYearDash = <span className="singleResource_QRSYearDash" ref="singleResource_QRSYearDash"></span>
                        }

                        var resourceImageData;
                        resourceImageData = [];

                        var adminImageUpload = "";
                        var adminSingleSync = "";

                        if ((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) && !this.state.isEpicUser) {

                            adminImageUpload = <div className="fill subImage_SingleResource canvasHolder" alt="Admin: Drop Image Here to Upload" title="Admin: Drop Image Here to Upload"><i className="dropIcon fal fa-download"></i><span className="dropText">Drop Image Here</span><canvas className="dropCanvas" ref="dragCanvas" id="dragCanvas" onDragStart={this._preventDragHandler} onDrop={this._dropCanvasDragOver.bind(this, value['externalId'])}></canvas></div>
                            adminSingleSync = <div className="fill subImage_SingleResource resyncHolder" alt="Admin: Click to ReSync Resource" title="Admin: Click to ReSync Resource" onClick={this._resyncSingleResource.bind(this, value['externalId'])}><i className="dropIcon far fa-sync-alt"></i><span className="dropText">Click to Sync Now</span><div className="resyncButton" ref="resyncButton"></div></div>

                        }

                        resourceImageData.push(
                            <td>
                                <div className="singleResource_ImageLibraryHolder">
                                    <div className="singleResource_Image_SubImage">
                                        {subImageData}{additionalImages}{adminImageUpload}{adminSingleSync}
                                    </div>
                                    <div className="singleResource_Image_MainImage">
                                        {mainImageData}
                                    </div>
                                </div>
                            </td>);



                        var headerRow = "";
                        var minimizedHeaders = [];

                        if (additionalResourceHeaders.length>0) {

                            minimizedHeaders =
                                <div className="minimizedAdditionalResourcesHeaderTab">
                                <div className={"viewAdditionalResourcesContainer"}>
                                    <i className={"viewAdditionalResourcesIcon fal fa-chevron-down"} title="More"></i>
                                </div>
                                <div className="additionalResourceHeadersDropdown">
                                    {additionalResourceHeaders}
                                    </div>
                                </div>
                        }

                        headerRow = <div className="navTabs">
                            <div ref="singleResource_NavTab_Description" className="navTab selectedTab" onClick={this._navigateToTab.bind(this, 'Description')}>Overview</div>
                            <div ref="singleResource_NavTab_Details" className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, 'Details')}>Details</div>
                            <div ref="singleResource_NavTab_Tags" className="navTab notSelectedTab" onClick={this._navigateToTab.bind(this, 'Tags')}>Tags</div>
                            <div className="additionalResourcesHeaderTabs">
                                {additionalResourceHeaders}
                            </div>
                                {minimizedHeaders}
                        </div>

                        bodySingleResultListing.push(backToResults);

                        if (this.state.parentResult != "" && this.state.singleResult == this.state.parentAssociatedChild) {
                            backToReportCategory.push(<div className="backToReportCategory Hidden" ref="backToReportCategory" onClick={this._showSingleResultWithSearch.bind(this, this.state.parentResult, value['resourceName'], searchText)}><i className="backToReportCategoryIcon fal fa-arrow-alt-up"></i><span className="backToReportCategoryText">Back to {this.state.parentType} "{this.state.parentName}"</span></div>)
                        }


                        bodySingleResultListing.push(backToReportCategory);

                        var viewButton;
                        viewButton = []

                        viewButton.push(
                            <button className="singleResultButton" onClick={this._showModalOverlay.bind(this, 'view')}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-eye"></span>
                                            </td>
                                            <td>
                                                <span className="footerText">
                                                    View
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>);
                        /*
                        viewButton.push(<a target="_blank" href={"https://dataviz.aahs.org/sense/app/" + value['externalId']} className="singleResultButton">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="singleResultIcon fal fa-eye"></span>
                                        </td>
                                        <td>
                                            <span className="footerText">View</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </a>);
                        */
                        var requestAccessButton;
                        requestAccessButton = []

                        if (value['secureResource']) {

                            requestAccessButton.push(
                                <button className="singleResultButton" onClick={this._createJIRARequest.bind(this, 'Databay: New Access Request', value['resourceName'], value['resourceType'], value['reportType'])}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span className="singleResultIcon fal fa-key"></span>
                                                </td>
                                                <td>
                                                    <span className="footerText">
                                                        <div className="topSecureText">Request Secure</div>
                                                        <div className="bottomText">Access</div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </button>);

                        }
                        else {

                            requestAccessButton.push(
                                <button className="singleResultButton" onClick={this._createJIRARequest.bind(this, 'Databay: New Access Request', value['resourceName'], value['resourceType'], value['reportType'])}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span className="singleResultIcon fal fa-key"></span>
                                                </td>
                                                <td>
                                                    <span className="footerText">
                                                        <div className="topText">Request</div>
                                                        <div className="bottomText">Access</div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </button>);

                        }
                        var shareButton;
                        shareButton = []

                        shareButton.push(
                            <button className="singleResultButton" onClick={this._showModalOverlay.bind(this, 'share')}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-share-square"></span>
                                            </td>
                                            <td>
                                                <span className="footerText">Share</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>
                        );

                        var helpButton;
                        helpButton = []

                        helpButton.push(
                            <button className="singleResultButton" onClick={this._showModalOverlay.bind(this, 'help')} >
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-question-circle"></span>
                                            </td>
                                            <td>
                                                <span className="footerText">Help</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>);


                        var notificationButton;
                        notificationButton = []

                        notificationButton.push(
                            <button className="singleResultButton" onClick={this._showModalOverlay.bind(this, 'notification')} >
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-bell-exclamation"></span>
                                            </td>
                                            <td>
                                                <span className="footerText">Alerts</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>);



                        var buttonList;
                        buttonList = []

                        var viewLink;
                        viewLink = [];
                        var reportLocation = value['reportLocation'];
                            
                        if (reportLocation.length > 0) {
                            if ((value['reportType'] == 'Excel Dashboard' || value['reportType'] == 'Microsoft Report' || value['reportType'] == 'File' || value['reportLocation'].toLowerCase().includes("aamcblob")) && !(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(reportLocation))) {
                                reportLocation = "file:///" + reportLocation.replace(/\\\\/g, "\\\\").toLowerCase();

                                viewButton = []

                                viewButton.push(
                                    <a className="singleResultButton" href={reportLocation} target="_blank" onClick={this._showModalOverlay.bind(this, 'view')}>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className="singleResultIcon fal fa-eye"></span>
                                                    </td>
                                                    <td>
                                                        <span className="footerText">
                                                            View
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </a>);
                                viewLink.push(viewButton)
                            }
                            else {
                                viewLink.push(viewButton)
                            }
                        }
                        else {
                            viewLink.push(viewButton)
                        }
                        



                        if (value['resourceType'] == "Report") {
                            buttonList.push(viewLink);
                            buttonList.push(requestAccessButton);
                            buttonList.push(shareButton);
                            buttonList.push(helpButton);
                        }
                        else if (value['resourceType'] == "Report Category" || value['resourceType'] == "Component" || value['resourceType'] == "Business Term" || value['resourceType'] == "Metric" || value['resourceType'] == "Stakeholder" || value['resourceType'] == "Acronym") {
                            resourceImageData = [];
                            buttonList.push(shareButton);
                            buttonList.push(helpButton);
                        }
                        else if (value['resourceType'] == "Quality & Research Symposium") {
                            buttonList.push(viewLink);
                            buttonList.push(shareButton);
                            buttonList.push(helpButton);
                        }
                        else if (value['resourceType'] == "Action Plan") {
                            resourceImageData = [];
                            buttonList.push(notificationButton);
                            buttonList.push(shareButton);
                            buttonList.push(helpButton);
                        }
                        else {
                            buttonList.push(shareButton);
                            buttonList.push(helpButton);
                        }


                        //We need to have a list of ranks appear here that we can then put in.



                        var rankOptions;
                        rankOptions = [];

                        Object.values(resource_RankListInfo).forEach(element => {
                            rankOptions.push(<option value={element["rankName"]}>{element["rankName"]}</option>);
                        });

                        var editSingleResourceRankContainer;
                        editSingleResourceRankContainer = [];

                        editSingleResourceRankContainer = <span ref="edit_singleResource_Rank_Container" className="edit_singleResource_Rank_Container"><select defaultValue={value["rankName"]} id="edit_singleResource_Rank" ref="edit_singleResource_Rank" className="edit_singleResource_Rank">
                            <option value="">None</option>
                            {rankOptions}
                        </select>
                        </span>;



                        var resourceRank;
                        resourceRank = [];

                        var rankName = value['rankName'];

                        if (rankName == "" || rankName == null) {
                            resourceRank.push(
                                <span ref="edit_detailsResourceRankLabel" className="edit_detailsResourceRankLabel">
                                    <span className="rankIconContainer"><span ref={"edit_detailsResourceRankLabel_Icon"} className={"rankIcon_None"} title={value['rankName']}></span></span> <em><span ref={"edit_detailsResourceRankLabel_Text"}>None</span></em>
                                </span>
                            );
                        }
                        else {
                            resourceRank.push(
                                <span ref="edit_detailsResourceRankLabel" className="edit_detailsResourceRankLabel">
                                    <span className="rankIconContainer"><span ref={"edit_detailsResourceRankLabel_Icon"} className={"rankIcon_" + value['rankName']} title={value['rankName']}></span></span> <em><span ref={"edit_detailsResourceRankLabel_Text"}>{value['rankName']}</span></em>
                                </span>
                            );
                        }

                        resourceRank.push(
                            editSingleResourceRankContainer
                        );



                        var syncsExternally;
                        syncsExternally = [];

                        if (value['syncResource'] == "True") {

                            syncsExternally.push(
                                <span ref="edit_detailsSyncResourcesLabel" className="edit_detailsSyncResourcesLabel ActiveSync">
                                    Active
                                </span>);
                        }
                        else {

                            syncsExternally.push(
                                <span ref="edit_detailsSyncResourcesLabel" className="edit_detailsSyncResourcesLabel DisabledSync">
                                    Disabled
                                </span>);
                        }

                        var syncsExternallyOptions;
                        syncsExternallyOptions = [];

                        syncsExternallyOptions.push(<option disabled value="True">Active</option>);
                        syncsExternallyOptions.push(<option value="False">Disabled</option>);


                        var syncsExternallyChangerContainer;
                        syncsExternallyChangerContainer = [];
                        //default is set to false because by you changing it you are killing the sync.
                        syncsExternallyChangerContainer = <select defaultValue={"False"} id="edit_syncsExternallyChanger" ref="edit_syncsExternallyChanger" className="edit_syncsExternallyChanger">
                            <option value="" hidden>Select an option</option>
                            {syncsExternallyOptions}
                        </select>

                        syncsExternally.push(syncsExternallyChangerContainer);


                        var externalStatus;
                        externalStatus = [];

                        externalStatus.push(
                            <span ref="edit_detailsExternalStatusLabel" className="edit_detailsExternalStatusLabel">
                                {value['externalStatus']}
                            </span>
                        );


                        var externalStatusOptions;
                        externalStatusOptions = [];

                        externalStatusOptions.push(<option value="Accepted">Accepted</option>);
                        externalStatusOptions.push(<option value="Candidate">Candidate</option>);
                        externalStatusOptions.push(<option value="Disabled">Disabled</option>);
                        externalStatusOptions.push(<option value="Obsolete">Obsolete</option>);
                        externalStatusOptions.push(<option value="Relationship Ready">Relationship Ready</option>);
                        externalStatusOptions.push(<option value="Under Development">Under Development</option>);
                        externalStatusOptions.push(<option value="Under Review">Under Review</option>);


                        var externalStatusChangerContainer;
                        externalStatusChangerContainer = [];

                        externalStatusChangerContainer = <select defaultValue={value['externalStatus']} id="edit_externalStatusChanger" ref="edit_externalStatusChanger" className="edit_externalStatusChanger">
                            <option value="" hidden>Select an option</option>
                            {externalStatusOptions}
                        </select>

                        externalStatus.push(externalStatusChangerContainer);

                        //TODO CREATE A CREATED BY DROPDOWN LIST

                        var userCreatorOptions;
                        userCreatorOptions = [];

                        Object.values(user_CreatorListInfo).forEach(element => {
                            userCreatorOptions.push(<option value={element["firstName"] + " " + element["lastName"]}>{element["firstName"]} {element["lastName"]}</option>);
                        });

                        var userCreatorChangerContainer;
                        userCreatorChangerContainer = [];

                        userCreatorChangerContainer = <select defaultValue={value['createdByFirstName'] + " " + value['createdByLastName']} id="userCreatorChanger" ref="userCreatorChanger" className="userCreatorChanger">
                            <option value="" hidden>Select an option</option>
                            {userCreatorOptions}
                        </select>




                        var createdByResource;
                        createdByResource = [];


                        if (value['createdByFirstName'] == "" && value['createdByLastName'] == "") {

                            createdByResource.push(
                                <span ref="detailsCreatedByLabel" className="detailsCreatedByLabel infoNotAvailable">
                                    Not Available
                                </span>);
                        }
                        else {

                            createdByResource.push(
                                <span ref="detailsCreatedByLabel" className="detailsCreatedByLabel" onClick={this._updateSearchTerm.bind(this, "@" + value['createdByFirstName'].slice(0, 1).toString().toLowerCase() + value['createdByLastName'].toString().toLowerCase())} alt={"Search all reports created by " + value['createdByFirstName'] + " " + value['createdByLastName']} title={"Search all reports created by " + value['createdByFirstName'] + " " + value['createdByLastName']}>
                                    {value['createdByFirstName'] + " " + value['createdByLastName']}
                                </span>);
                        }




                        var modifiedByResource;
                        modifiedByResource = [];

                        if (value['modifiedByFirstName'] == "" && value['modifiedByLastName'] == "") {

                            modifiedByResource.push(
                                <span className="infoNotAvailable">
                                    Not Available
                                </span>);
                        }
                        else {

                            modifiedByResource.push(
                                <span alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>
                                    {value['modifiedByFirstName'] + " " + value['modifiedByLastName']}
                                </span>);
                        }


                        var editButton;
                        editButton = []
                        if (value['resourceRepository'] == "fileUpload") {

                            editButton.push(
                                <button className="singleResultButton_Edit" onClick={this._editFileMode.bind(this, true)}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span className="singleResultIcon fal fa-edit"></span>
                                                </td>
                                                <td>
                                                    <span className="footerText">
                                                        <div className="topText">Edit</div>
                                                        <div className="bottomText">Content</div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </button>);
                        }
                        else {
                            editButton.push(
                                <button className="singleResultButton_Edit" onClick={this._editMode.bind(this, true)}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span className="singleResultIcon fal fa-edit"></span>
                                                </td>
                                                <td>
                                                    <span className="footerText">
                                                        <div className="topText">Edit</div>
                                                        <div className="bottomText">Content</div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </button>);
                        }

                        var updateButton;
                        updateButton = [];

                        updateButton.push(
                            <button className="singleResultButton_Edit" onClick={this._saveResourceChanges.bind(this)}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-cloud-upload"></span>
                                            </td>
                                            <td>
                                                <span className="footerText">
                                                    <div className="topText">Save</div>
                                                    <div className="bottomText">Changes</div>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>);

                        var cancelUpdateButton;
                        cancelUpdateButton = [];
                        cancelUpdateButton.push(
                            <button className="singleResultButton_CancelEdit singleResultButton_Edit " title="Cancel Changes" alt="Cancel Changes" onClick={this._cancelResourceChanges.bind(this)}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="singleResultIcon fal fa-times"></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </button>);


                        var rankComponent;
                        rankComponent = [];

                        var largeRankName = value['rankName'];

                        if (largeRankName == "" || largeRankName == null) {
                            rankComponent.push(
                                <td ref="singleResource_RankContainer" className="singleResource_NoRankContainer">
                                    <span className="noRankContainer">
                                        <span className="largeRankIconContainer">
                                            <span ref="largeRankIcon" className={"largeRankIcon_None"} title=""><i ref="rankFontAwesomeIcon" className=""></i></span>
                                        </span>
                                    </span>
                                </td>
                            );
                        }
                        else {
                            rankComponent.push(
                                <td ref="singleResource_RankContainer" className="singleResource_RankContainer">
                                    <span className="rankContainer">
                                        <span className="largeRankIconContainer">
                                            <span ref="largeRankIcon" className={"largeRankIcon_" + value['rankName']} title={value['rankName']}><i ref="rankFontAwesomeIcon" className={value['rankFontAwesomeIcon']}></i></span>
                                        </span>
                                    </span>
                                </td>

                            );
                        }





                        var editComponent;
                        editComponent = [];

                        if (((this.state.user_AccountInfo.permissionLevel == 'siteAdministrator' || this.state.user_AccountInfo.permissionLevel == "contentAdministrator") || (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev'))) && !this.state.isEpicUser) {

                            if (this.state.resource_editMode) {

                                editComponent.push(
                                    <div className="singleResource_UpdateContainer">
                                        <div className="singleResource_EditButtons">{updateButton}{cancelUpdateButton}</div>
                                    </div>
                                );

                                createdByResource = [];

                                if (value['createdByFirstName'] == "" && value['createdByLastName'] == "") {

                                    createdByResource.push(
                                        <span ref="detailsCreatedByLabel" className="detailsCreatedByLabel infoNotAvailable hidden">
                                            Not Available
                                        </span>);
                                }
                                else {

                                    createdByResource.push(
                                        <span ref="detailsCreatedByLabel" className="detailsCreatedByLabel hidden" onClick={this._updateSearchTerm.bind(this, "@" + value['createdByFirstName'].slice(0, 1).toString().toLowerCase() + value['createdByLastName'].toString().toLowerCase())} alt={"Search all reports created by " + value['createdByFirstName'] + " " + value['createdByLastName']} title={"Search all reports created by " + value['createdByFirstName'] + " " + value['createdByLastName']}>
                                            {value['createdByFirstName'] + " " + value['createdByLastName']}
                                        </span>);
                                }
                                createdByResource.push(
                                    userCreatorChangerContainer
                                );
                                if (value['resourceType'] == "Action Plan") {
                                    additionalResourceHeaders.push(<div ref={"singleResource_AddActionPlanItem"} className="navTab notSelectedTab singleResource_AddActionPlanItem" alt="Add Action Plan Item" title="Add Action Plan Item" onClick={this._showModalOverlay.bind(this, 'addActionPlanItem')}>+</div>);
                                }
                                else {
                                    additionalResourceHeaders.push(<div ref={"singleResource_AddRelationship"} className="navTab notSelectedTab singleResource_AddRelationship" alt="Add Relationship" title="Add Relationship" onClick={this._showModalOverlay.bind(this, 'addRelationship')}>+</div>);
                                }
                            }
                            else {

                                editComponent.push(
                                    <div className="singleResource_EditContainer">
                                        <div className="singleResource_EditButtons">{editButton}</div>
                                    </div>
                                );

                            }
                        }
                        if (this.state.loadingRelationships) {
                            additionalResourceHeaders.push(<div ref={"singleResource_LoadingRelationship"} className="navTab notSelectedTab singleResource_LoadingRelationship" alt="Loading Relationships" title="Loading Relationships"><i className="logoHome fas fa-circle-notch fa-spin"></i></div>);
                        }

                        var singleResult_Description;
                        singleResult_Description = [];



                        //TODO CREATE A REPORT TYPE DROPDOWN


                        var resourceTypeOptions;
                        resourceTypeOptions = [];

                        Object.values(resource_ResourceTypeListInfo).forEach(element => {
                            if (element["resourceType"] == value['resourceType']) {
                                resourceTypeOptions.push(<option selected value={element["resourceType"]}>{element["resourceType"]}</option>);
                            }
                            else {
                                resourceTypeOptions.push(<option value={element["resourceType"]}>{element["resourceType"]}</option>);
                            }
                        });

                        var editSingleResourceTypeContainer;
                        editSingleResourceTypeContainer = [];

                        editSingleResourceTypeContainer = <select onChange={this._updateResourceType.bind(this)} id="edit_singleResource_ResourceType" ref="edit_singleResource_ResourceType" className="edit_singleResource_ResourceType">
                            <option value="" hidden>Select an option</option>
                            {resourceTypeOptions}
                        </select>




                        var reportTypeOptions;
                        reportTypeOptions = [];

                        Object.values(resource_ReportTypeListInfo).forEach(element => {
                            reportTypeOptions.push(<option value={element["reportType"]}>{element["reportType"]}</option>);
                        });

                        var editSingleResourceReportSrcContainer = "hidden";
                        var editSingleResourceReportTypeContainer;
                        editSingleResourceReportTypeContainer = [];
                        if (value['resourceType'] == "Report" || value['resourceType'] == "Quality & Research Symposium") {
                            editSingleResourceReportSrcContainer = "edit_singleResource_ReportLocation_Container";
                            editSingleResourceReportTypeContainer = <span ref="edit_singleResource_ReportType_Container" className="edit_singleResource_ReportType_Container"><span className="singleResource_ReportType_dash" ref="singleResource_ReportType_dash">-</span><select defaultValue={value['reportType']} onChange={this._updateReportType.bind(this)} id="edit_singleResource_ReportType" ref="edit_singleResource_ReportType" className="edit_singleResource_ReportType">
                                <option value="" hidden>Select an option</option>
                                {reportTypeOptions}
                            </select>
                            </span>;

                        }
                        else {
                            editSingleResourceReportSrcContainer = "hidden";
                            editSingleResourceReportTypeContainer = <span ref="edit_singleResource_ReportType_Container" className="edit_singleResource_ReportType_Container"><span className="hidden" ref="singleResource_ReportType_dash">-</span><select defaultValue={value['reportType']} onChange={this._updateReportType.bind(this)} id="edit_singleResource_ReportType" ref="edit_singleResource_ReportType" className="hidden">
                                <option value="" hidden>Select an option</option>
                                {reportTypeOptions}
                            </select>
                            </span>;
                        }




                        var qrsYearOptions;
                        qrsYearOptions = [];

                        Object.values(resource_QRSYearListInfo).forEach(element => {
                            qrsYearOptions.push(<option value={element["qrsYear"]}>{element["qrsYear"]}</option>);
                        });

                        var editSingleResourceQRSYearContainer;
                        editSingleResourceQRSYearContainer = [];
                        if (value['resourceType'] == "Quality & Research Symposium") {
                            editSingleResourceQRSYearContainer = <span ref="edit_singleResource_QRSYear_Container" className="edit_singleResource_QRSYear_Container"><span className="singleResource_QRSYear_dash" ref="singleResource_QRSYear_dash">-</span><select defaultValue={value['qrsYear']} onChange={this._updateQRSYear.bind(this)} id="edit_singleResource_QRSYear" ref="edit_singleResource_QRSYear" className="edit_singleResource_QRSYear">
                                <option value="" hidden>Select a year</option>
                                {qrsYearOptions}
                            </select>
                            </span>;

                        }
                        else {
                            editSingleResourceQRSYearContainer = <span ref="edit_singleResource_QRSYear_Container" className="edit_singleResource_QRSYear_Container"><span className="hidden" ref="singleResource_QRSYear_dash">-</span><select defaultValue={value['qrsYear']} onChange={this._updateQRSYear.bind(this)} id="edit_singleResource_QRSYear" ref="edit_singleResource_QRSYear" className="hidden">
                                <option value="" hidden>Select a year</option>
                                {qrsYearOptions}
                            </select>
                            </span>;
                        }



                        var qrsYearOptions;
                        qrsYearOptions = [];

                        Object.values(resource_QRSYearListInfo).forEach(element => {
                            qrsYearOptions.push(<option value={element["qrsYear"]}>{element["qrsYear"]}</option>);
                        });

                        var createSingleResourceQRSYearContainer;
                        createSingleResourceQRSYearContainer = [];

                        createSingleResourceQRSYearContainer = <span ref="create_singleResource_QRSYear_Container" className="create_singleResource_QRSYear_Container"><span className="hidden" ref="create_singleResource_QRSYear_dash">-</span><select defaultValue={""} onChange={this._updateCreateQRSYear.bind(this)} id="create_singleResource_QRSYear" ref="create_singleResource_QRSYear" className="hidden">
                            <option value="" hidden>Select an option</option>
                            {qrsYearOptions}
                        </select>
                        </span>;





                        //TODO REMOVE VOTES
                        var reportLocation = [];



                        var editReportLocationPlaceholder = "";

                        var editReportLocationPlaceholder_HGR = "100083";
                        var editReportLocationPlaceholder_HGT = "539096";
                        var editReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";


                        var editReportLocationText = "Report Location";
                        var editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                        var editIsEpicMultiReport = "hidden";

                        if (value['reportType'] == "Excel Dashboard") {
                            editReportLocationText = "Network Location";
                            editReportLocationPlaceholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\junkview_reports\\AR_Report\\AR_Report.xlsm";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "File") {
                            editReportLocationText = "Network Location";
                            editReportLocationPlaceholder = "\\\\aamcqlikview\\Tutorial\\Qlikview-Word-Basics.doc";
                            if (value['resourceRepository'] == "fileUpload") {
                                editIsNotEpicMultiReport = "hidden";
                                editIsEpicMultiReport = "hidden";
                            }
                            else {
                                editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                                editIsEpicMultiReport = "hidden";
                            }
                        }
                        else if (value['reportType'] == "Website") {
                            editReportLocationText = "Website URL";
                            editReportLocationPlaceholder = "https://webappstest.aahs.org/ProviderGeo/";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Microsoft Report") {
                            editReportLocationText = "Network Location";
                            editReportLocationPlaceholder = "\\\\aamcvblob\\BlobShare\\DONOTDELETE\\Decision_Support\\AAMC_Summary_Shoulder_Replacement_Metrics.pdf";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Qlikview Dashboard") {
                            editReportLocationText = "Website URL";
                            editReportLocationPlaceholder = "http://aamcqlikview/QvAJAXZfc/opendoc.htm?document=Outpatient.qvw&amp;host=QVS%40aamcqlikview";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Qliksense Application") {
                            editReportLocationText = "Website URL";
                            editReportLocationPlaceholder = "https://dataviz.aahs.org/sense/app/eb9edb7c-a64f-4c66-abd1-35a48c39a728/overview";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Radar Dashboard") {
                            editReportLocationText = "Epic IDM Number";
                            editReportLocationPlaceholder = "100022";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Epic-Slicer Dicer") {
                            editReportLocationText = "Epic Record ID";
                            editReportLocationPlaceholder = "1";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }
                        else if (value['reportType'] == "Epic-Crystal Report") {
                            editReportLocationText = "HGR | HGT | Report Name";
                            editReportLocationPlaceholder = "";
                            editReportLocationPlaceholder_HGR = "100083";
                            editReportLocationPlaceholder_HGT = "539096";
                            editReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";
                            editIsNotEpicMultiReport = "hidden";
                            editIsEpicMultiReport = "edit_singleResource_ReportLocation_MultiReport";
                        }
                        else if (value['reportType'] == "Reporting Workbench") {
                            editReportLocationText = "HGR | HGT | Report Name";
                            editReportLocationPlaceholder = "";
                            editReportLocationPlaceholder_HGR = "100083";
                            editReportLocationPlaceholder_HGT = "539096";
                            editReportLocationPlaceholder_NAME = "AAMC Alternative Alerts";
                            editIsNotEpicMultiReport = "hidden";
                            editIsEpicMultiReport = "edit_singleResource_ReportLocation_MultiReport";
                        }
                        else {
                            editReportLocationText = "Report Location";
                            editReportLocationPlaceholder = "";
                            editReportLocationPlaceholder_HGR = "";
                            editReportLocationPlaceholder_HGT = "";
                            editReportLocationPlaceholder_NAME = "";
                            editIsNotEpicMultiReport = "edit_singleResource_ReportLocation";
                            editIsEpicMultiReport = "hidden";
                        }


                        var editReportLocation = value['reportLocation'];

                        var editSplitEpicReports = [];


                        var editEpicReports = [];

                        if (editReportLocation.length > 0 && (value['reportType'] == "Radar Dashboard") && editReportLocation.includes("IDM:")) {
                            editReportLocation = editReportLocation.substring(4);
                        }
                        var numEpicReports = 0;
                        if (editReportLocation.length > 0 && (value['reportType'] == "Reporting Workbench" || value['reportType'] == "Epic-Crystal Report")) {

                            if (value['reportLocation'].includes("~")) {

                                editSplitEpicReports = value['reportLocation'].split("~");


                                for (var editEpicReportsIndex = 0; editEpicReportsIndex < editSplitEpicReports.length; editEpicReportsIndex++) {
                                    editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGR_" + editEpicReportsIndex} className={"edit_singleResource_ReportLocation_HGR"} placeholder={editReportLocationPlaceholder_HGR} defaultValue={editSplitEpicReports[editEpicReportsIndex].split("|")[0].split(":")[1]}></input>);
                                    editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGT_" + editEpicReportsIndex} className={"edit_singleResource_ReportLocation_HGT"} placeholder={editReportLocationPlaceholder_HGT} defaultValue={editSplitEpicReports[editEpicReportsIndex].split("|")[1].split(":")[1]} ></input >);
                                    editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_NAME_" + editEpicReportsIndex} className={"edit_singleResource_ReportLocation_NAME"} placeholder={editReportLocationPlaceholder_NAME} defaultValue={editSplitEpicReports[editEpicReportsIndex].split("|")[2].split(":")[1]}></input>);
                                    /*
                                    if (editEpicReportsIndex == editSplitEpicReports.length && editEpicReportsIndex == 1) {
                                        editEpicReports.push(<i className={"edit_AddReport fal fa-plus-square" + editIsEpicMultiReport} title="Add" onClick={this._addEditEpicReport.bind(this)}></i>);
                                    }
                                    else if (editEpicReportsIndex == editSplitEpicReports.length && editEpicReportsIndex != 1) {
                                        editEpicReports.push(<i className={"edit_RemoveReport fal fa-times-square" + editIsEpicMultiReport} title="Remove" onClick={this._removeEditEpicReport.bind(this)}></i>);
                                        editEpicReports.push(<i className={"edit_AddReport fal fa-plus-square" + editIsEpicMultiReport} title="Add" onClick={this._addEditEpicReport.bind(this)}></i>);
                                    }
                                    */
                                    numEpicReports = numEpicReports + 1;
                                }
                            }
                            else {
                                editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGR_1"} className={"edit_singleResource_ReportLocation_HGR"} placeholder={editReportLocationPlaceholder_HGR} defaultValue={value['reportLocation'].split("|")[0].split(":")[1]}></input>);
                                editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGT_1"} className={"edit_singleResource_ReportLocation_HGT"} placeholder={editReportLocationPlaceholder_HGT} defaultValue={value['reportLocation'].split("|")[1].split(":")[1]} ></input >);
                                editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_NAME_1"} className={"edit_singleResource_ReportLocation_NAME"} placeholder={editReportLocationPlaceholder_NAME} defaultValue={value['reportLocation'].split("|")[2].split(":")[1]}></input>);

                                numEpicReports = numEpicReports + 1;

                                /*
                                editEpicReports.push(<i className={"edit_AddReport fal fa-plus-square" + editIsEpicMultiReport} title="Add" onClick={this._addEditEpicReport.bind(this)}></i>);
                                */

                            }

                        }
                        else {
                            editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGR_1"} className={"edit_singleResource_ReportLocation_HGR"} placeholder={editReportLocationPlaceholder_HGR} defaultValue=""></input>);
                            editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_HGT_1"} className={"edit_singleResource_ReportLocation_HGT"} placeholder={editReportLocationPlaceholder_HGT} defaultValue="" ></input >);
                            editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_NAME_1"} className={"edit_singleResource_ReportLocation_NAME"} placeholder={editReportLocationPlaceholder_NAME} defaultValue=""></input>);

                            numEpicReports = numEpicReports + 1;
                        }
                        editEpicReports.push(<input ref={"edit_singleResource_ReportLocation_Count"} className="hidden" placeholder="" defaultValue={numEpicReports}></input>);

                        var votingComponent;
                        votingComponent = [];

                        if (value['resourceType'] == "Quality & Research Symposium") {
                            votingComponent.push(
                                <td className="hidden">
                                    <div className="singleResource_VotingContainer">
                                        {upvoteData}
                                        <div className="voteTotal">{voteTotal}</div>
                                        {downvoteData}
                                    </div>
                                </td>
                            );
                        }
                        else {
                            votingComponent.push(
                                <td>
                                    <div className="singleResource_VotingContainer">
                                        {upvoteData}
                                        <div className="voteTotal">{voteTotal}</div>
                                        {downvoteData}
                                    </div>
                                </td>
                            );
                        }


                        if (this.state.permissionLevel != "" && !this.state.isEpicUser) {

                            reportLocation.push(
                                <tr className={editSingleResourceReportSrcContainer} ref="edit_singleResource_ReportLocation_Container">
                                    <td>
                                        <span ref="editReportLocationText" className="detailsTable_Label">
                                            {editReportLocationText}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_ReportLocation' ref='singleResource_ReportLocation'>
                                            {editReportLocation}
                                        </span>
                                        <input ref="edit_singleResource_ReportLocation" className={editIsNotEpicMultiReport} placeholder={editReportLocationPlaceholder} defaultValue={editReportLocation} />
                                        <div ref="edit_singleResource_ReportLocation_MultiReport" className={editIsEpicMultiReport}>
                                            {editEpicReports}
                                        </div>
                                    </td>
                                </tr>);

                        }
                        else {
                            reportLocation.push(
                                <tr className="hidden">
                                    <td>
                                        <span className="detailsTable_Label">
                                            {editReportLocationText}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='singleResource_ReportLocation'>
                                            {editReportLocation}
                                        </span>
                                        <input ref="edit_singleResource_ReportLocation" className="edit_singleResource_ReportLocation" defaultValue={editReportLocation} />
                                    </td>
                                </tr>);
                        }
                        var ccnHidden = "";
                        if (this.state.user_AccountInfo.permissionLevel == 'ccnAdministrator' && (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev') && !this.state.isEpicUser) {
                            ccnHidden = "hidden";
                        }

                        var tagCount = 0;
                        var multipleTags = '';

                        var resourceTags = [];
                        Object.values(resource_BuildTagInfo)
                            .filter(value => (value['externalId']).toString() == this.state.singleResult)
                            .forEach(value => {
                                tagCount = tagCount + 1;
                                if (tagCount > 1) {
                                    multipleTags = 's';
                                }
                                var hashTagRemoval = [];
                                if (this.state.resource_editMode) {
                                    hashTagRemoval.push(
                                        <td className="resource_Body_Remove_Container" onClick={this._singleResultRemoveTag.bind(this, value['externalId'], (value['tag']).toString())}><i className="resource_Body_Remove_Button fas fa-times"></i></td>
                                    );
                                }
                                resourceTags.push(
                                    <div className="tagResource_Body">
                                        <table className="tagResource_Body_Table">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <i className="searchResource_BodyStar searchNoFavorite fal fa-hashtag" alt="Tag" title="Tag"></i>
                                                    </td>
                                                    <td className="resource_Body_Content_Container" onClick={this._handleSimilarMouseClick.bind(this, '#' + (value['tag']).toString())}>
                                                        <span className="resource_Body_Content">
                                                            <div className="resource_Body_Title" alt={'Search: #' + (value['tag']).toString()} title={'Search:#' + (value['tag']).toString()}>
                                                                <b>#{(value['tag']).toString()}</b>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    {hashTagRemoval}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            });

                        if (tagCount == 0) {
                            resourceTags.push(
                                <table className="singleResource_ContentBody_NoTagsTable">
                                    <tbody>
                                        <tr><td><div className="noResources">No Tags</div><div className="noResourcesIcon"><i title="To add a resource, you will need to have content administrator permissions or higher. Click the edit content button above. Next click the + to create and add a tag." className="fa-light fa-circle-info"></i></div></td></tr>
                                    </tbody>
                                </table>
                            );
                        }


                        bodySingleResultListing.push(
                            <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_singleResult"} className="singleResource_Body">
                                <table className="singleResource_Header">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="singleResource_FavoriteContainer">
                                                    {favoriteData}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="singleResource_ResourceNameContainer">
                                                    <div>
                                                        <span ref="singleResource_ResourceName" className="singleResource_ResourceName" alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span>
                                                        <input ref="edit_singleResource_ResourceName" className="edit_singleResource_ResourceName" defaultValue={value['resourceName']} />
                                                    </div>
                                                    <div>
                                                        <span ref="singleResource_ResourceType" className="singleResource_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{value['resourceType']}</span>
                                                        {editSingleResourceTypeContainer}
                                                        {reportTypeDash}{reportType}
                                                        {qrsYearDash}{qrsYear}
                                                        {editSingleResourceReportTypeContainer}
                                                        {editSingleResourceQRSYearContainer}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="singleResource_AdminEditContainer">
                                                {editComponent}
                                            </td>
                                            {rankComponent}
                                            {votingComponent}
                                        </tr>
                                    </tbody>
                                </table>
                                <div className={"singleResource_EditMode_" + this.state.resource_editMode}>Edit Mode</div>
                                <table className={"singleResource_Content " + value['resourceType'].split(' ').join('_') + "_Body"}>
                                    <tbody>
                                        <tr>
                                            {resourceImageData}
                                            <td>
                                                <div className="singleResource_ContentHeader">
                                                    {headerRow}
                                                </div>
                                                <div className="tabContentBody singleResource_ContentBody_Description" ref="singleResource_ContentBody_Description">
                                                    <div ref="singleResource_ContentBody_Description_HTML" className="singleResource_ContentBody_Description_HTML">{ReactHtmlParser(fullText)}</div>
                                                    <div className="edit_singleResource_ContentBody_Description_HTML">
                                                        <Editor
                                                            id='singleResource_Editor'
                                                            ref='singleResource_Editor'
                                                            initialValue={fullText}
                                                            init={{
                                                                skin: false,
                                                                content_style: "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900&display=swap'); body { font-family: Roboto, sans-serif; }",
                                                                height: 435,
                                                                menubar: false,
                                                                plugins: [
                                                                    'link image',
                                                                    'table paste code link preview lists hr'
                                                                ],
                                                                toolbar: 'undo redo | fontsizeselect | ' +
                                                                    'bold italic underline forecolor | alignleft aligncenter ' +
                                                                    'alignright alignjustify | hr bullist numlist outdent indent | ' +
                                                                    'removeformat | link code preview',
                                                                fontsize_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20x 22px 24px 26px 28px 36px 48px 72px"
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="tabContentBody singleResource_ContentBody_Details hidden" ref="singleResource_ContentBody_Details">
                                                    <div>
                                                        <table className="singleResource_ContentBody_DetailsTable">
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            External Id
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span alt={value['externalId']} title={value['externalId']}>
                                                                            {value['externalId']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                {reportLocation}
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Resource Repository
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span className='resourceRepository' alt={value['resourceRepository']} title={value['resourceRepository']}>
                                                                            {value['resourceRepository']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr className={ccnHidden}>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Resource Rank
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {resourceRank}
                                                                    </td>
                                                                </tr>
                                                                <tr className={ccnHidden}>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Syncs Externally
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {syncsExternally}
                                                                    </td>
                                                                </tr>
                                                                <tr className={ccnHidden}>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Status
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {externalStatus}
                                                                    </td>
                                                                </tr>
                                                                <tr className={ccnHidden}>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Date Created Externally
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']}>
                                                                            {value['dtExternallyCreated']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Resource Created By
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {createdByResource}
                                                                    </td>
                                                                </tr>
                                                                <tr className={ccnHidden}>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Last Modified Externally
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']}>
                                                                            {value['dtExternallyModified']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Resource Modified By
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {modifiedByResource}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Date Created in Databay
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span alt={value['dtCreated']} title={value['dtCreated']}>
                                                                            {value['dtCreated']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="detailsTable_Label">
                                                                            Last Modified in Databay
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span alt={value['dtModified']} title={value['dtModified']}>
                                                                            {value['dtModified']}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="tabContentBody singleResource_ContentBody_Tags hidden" ref="singleResource_ContentBody_Tags">
                                                    <div>
                                                        {resourceTags}
                                                    </div>
                                                </div>
                                                {additionalResourceBodies}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="singleResource_Buttons">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="singleResultButton_Container">
                                                    <div className="luminisLogo_White"></div>
                                                    <div className="singleResultButtons">
                                                        {buttonList}
                                                    </div>
                                                </div>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <span className="hidden" alt={value['externalStatus']} title={value['externalStatus']}>{value['externalStatus']}</span>
                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                            </div>)

                    });

                bodyList.push(bodySingleResultListing);
            }

            //Searched
            else {

                const today = new Date();
                today.setHours(23, 59, 59, 998);

                if (total_user_SearchHistoryInfo_Elements > 0 && searchText != "") {

                    Object.values(user_SearchHistoryInfo)
                        .filter(value => (value).toString().toLowerCase() == searchText.toLowerCase())
                        .forEach(value => {
                            historyCount = historyCount + 1;
                            intellisenseCount = intellisenseCount + 1;
                            historyMatchListing.push(<div id={"historyMatchListing_" + intellisenseCount} ref={"resource_Intellisense_" + intellisenseCount} onClick={this._handleMouseClick.bind(this)} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value)} className="resource_Intellisense"><i className="intellisenseHistory fal fa-history"></i><span alt={value} title={value}>{value}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="history" /></div>)
                        });


                    Object.values(user_SearchHistoryInfo)
                        .filter(value => (value).toString().toLowerCase().indexOf(searchText.toLowerCase()) == 0)
                        .filter(value => (value).toString().toLowerCase() != searchText.toLowerCase())
                        .forEach(value => {
                            historyCount = historyCount + 1;
                            intellisenseCount = intellisenseCount + 1;
                            historyStartsWithListing.push(<div id={"historyStartsWithListing_" + intellisenseCount} ref={"resource_Intellisense_" + intellisenseCount} onClick={this._handleMouseClick.bind(this)} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value)} className="resource_Intellisense"><i className="intellisenseHistory fal fa-history"></i><span alt={value} title={value}>{value}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="history" /></div>)
                        });
                    Object.values(user_SearchHistoryInfo)
                        .filter(value => (value).toString().toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                        .filter(value => (value).toString().toLowerCase().indexOf(searchText.toLowerCase()) != 0)
                        .filter(value => (value).toString().toLowerCase() != searchText.toLowerCase())
                        .forEach(value => {
                            historyCount = historyCount + 1;
                            intellisenseCount = intellisenseCount + 1;
                            historyExactListing.push(<div id={"historyMatchListing_" + intellisenseCount} ref={"resource_Intellisense_" + intellisenseCount} onClick={this._handleMouseClick.bind(this)} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value)} className="resource_Intellisense"><i className="intellisenseHistory fal fa-history"></i><span alt={value} title={value}>{value}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="history" /></div>)
                        });

                    if (historyCount > 0) {
                        intellisenseList.push(historyMatchListing);
                        intellisenseList.push(historyStartsWithListing);
                        intellisenseList.push(historyExactListing);
                    }
                }
                if (total_Resource_IntellisenseInfo_Elements > 0 && searchText != "") {

                    if (searchTextLength > 2 && searchText.slice(0, 1) == '#') {
                        dateStartSearch = new Date();
                        //resource_IntellisenseTagInfo unique listing of tags
                        //resource_BuildTagInfo
                        var resourceExternalIdList = [];
                        Object.values(resource_BuildTagInfo)
                            .filter(value => (value['tag']).toString().toLowerCase() == searchText.substring(1).toLowerCase())
                            .forEach(value => {
                                resourceExternalIdList.push(value['externalId'].toString());
                            });

                        var check;
                        check = 1;

                        Object.values(resource_IntellisenseInfo)
                            .filter(value => (resourceExternalIdList.includes(value['externalId'].toString())))
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;
                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });

                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }
                                if (rankPoints > 0) {
                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }

                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;

                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {


                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }


                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }

                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {


                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }


                                        var qrsInfo;
                                        qrsInfo = [];

                                        if (value['qrsYear'] == null) {

                                        }
                                        else {
                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                            </span>);
                                        }

                                        bodyMatchListing.push({
                                            element:
                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td>{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })
                                    }
                                }
                            });

                    }
                    if (searchTextLength == 2 && searchText == '#~') {

                        var allTagListingA = [];
                        var allTagListingB = [];
                        var allTagListingC = [];
                        var allTagListingD = [];
                        var allTagListingE = [];
                        var allTagListingF = [];
                        var allTagListingG = [];
                        var allTagListingH = [];
                        var allTagListingI = [];
                        var allTagListingJ = [];
                        var allTagListingK = [];
                        var allTagListingL = [];
                        var allTagListingM = [];
                        var allTagListingN = [];
                        var allTagListingO = [];
                        var allTagListingP = [];
                        var allTagListingQ = [];
                        var allTagListingR = [];
                        var allTagListingS = [];
                        var allTagListingT = [];
                        var allTagListingU = [];
                        var allTagListingV = [];
                        var allTagListingW = [];
                        var allTagListingX = [];
                        var allTagListingY = [];
                        var allTagListingZ = [];

                        Object.values(resource_IntellisenseTagInfo)
                            .forEach(value => {
                                similarTagCount = similarTagCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                if (value.slice(0, 1).toString().toLowerCase() == 'a') {
                                    allTagListingA.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'b') {
                                    allTagListingB.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'c') {
                                    allTagListingC.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'd') {
                                    allTagListingD.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'e') {
                                    allTagListingE.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'f') {
                                    allTagListingF.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'g') {
                                    allTagListingG.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'h') {
                                    allTagListingH.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'i') {
                                    allTagListingI.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'j') {
                                    allTagListingJ.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'k') {
                                    allTagListingK.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'l') {
                                    allTagListingL.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'm') {
                                    allTagListingM.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'n') {
                                    allTagListingN.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'o') {
                                    allTagListingO.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'p') {
                                    allTagListingP.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'q') {
                                    allTagListingQ.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'r') {
                                    allTagListingR.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 's') {
                                    allTagListingS.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 't') {
                                    allTagListingT.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'u') {
                                    allTagListingU.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'v') {
                                    allTagListingV.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'w') {
                                    allTagListingW.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'x') {
                                    allTagListingX.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'y') {
                                    allTagListingY.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                                else if (value.slice(0, 1).toString().toLowerCase() == 'z') {
                                    allTagListingZ.push(<div id={"bodyAllTagListing_" + similarTagCount} onClick={this._handleSimilarMouseClick.bind(this, '#' + value)} ref={"resource_Body_" + similarTagCount} className="resource_AllTagListing"><span alt={"Search: " + '#' + value} title={"Search: " + '#' + value}>{'#' + value}</span><input ref={"resource_Body_Value_" + similarTagCount} className="hidden" defaultValue={'#' + value} /><i className="allTagLink fal fa-external-link-square"></i></div>)
                                }
                            });


                        if (allTagListingA.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        A
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingA}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingB.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        B
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingB}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingC.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        C
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingC}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingD.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        D
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingD}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingE.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        E
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingE}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingF.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        F
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingF}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingG.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        G
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingG}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingH.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        H
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingH}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingI.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        I
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingI}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingJ.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        J
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingJ}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingK.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        K
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingK}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingL.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        L
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingL}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingM.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        M
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingM}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingN.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        N
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingN}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingO.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        O
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingO}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingP.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        P
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingP}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingQ.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        Q
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingQ}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingR.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        R
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingR}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingS.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        S
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingS}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingT.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        T
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingT}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingU.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        U
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingU}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingV.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        V
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingV}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingW.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        W
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingW}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingX.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        X
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingX}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingY.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        Y
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingY}
                                    </div>
                                </div>
                            )
                        }

                        if (allTagListingZ.length > 0) {
                            bodyList.push(
                                <div className="bodyAllTagListing_Container">
                                    <div className="bodyAllTagListing_Header">
                                        Z
                                    </div>
                                    <div className="bodyAllTagListing_Body">
                                        {allTagListingZ}
                                    </div>
                                </div>
                            )
                        }

                    }
                    if (searchTextLength > 2 && searchText.slice(0, 1) == '^') {

                        //Report Only Metric Search
                        dateStartSearch = new Date();
                        var resource_ReportOnlyIntellisenseInfo = {}
                        var resource_IntellisenseReportAndMetricLinkInfo = this.state.resource_IntellisenseReportAndMetricLinkInfo;
                        var uniqueReportList = this.state.resource_IntellisenseReportAndMetricLink_UniqueReportsInfo;
                        resource_ReportOnlyIntellisenseInfo = Object.values(resource_IntellisenseInfo).filter(value => (value['resourceType'] == "Report"))
                            .filter(value => ((uniqueReportList).includes(value['externalId'])));

                        var removedCaratSearchText = searchText.substring(1);



                        Object.values(resource_ReportOnlyIntellisenseInfo)
                            .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase() == removedCaratSearchText.toLowerCase())
                            .forEach(sourceValue => {
                                Object.values(resource_IntellisenseReportAndMetricLinkInfo)
                                    .filter(relationshipValue => (sourceValue['externalId']).toString().toLowerCase() == (relationshipValue['sourceExternalId']).toString().toLowerCase())
                                    .forEach(relationshipValue => {
                                        Object.values(resource_IntellisenseInfo).filter(value => (value['resourceType'] == "Metric"))
                                            .filter(value => (value['externalId']).toString().toLowerCase() == (relationshipValue['relationshipExternalId']).toString().toLowerCase())
                                            .forEach(value => {

                                                intellisenseCount = intellisenseCount + 1;
                                                bodyCount = bodyCount + 1;
                                                resourceCount = resourceCount + 1;
                                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                highlightedText = ReactHtmlParser(highlightedText);
                                                var highlightedSubText = sourceValue['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                highlightedSubText = ReactHtmlParser(highlightedSubText);
                                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                                    resultResourceTypeFilterList.push(value['resourceType']);
                                                }

                                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                                    resultReportTypeFilterList.push(value['reportType']);
                                                }

                                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                                    resultQRSYearFilterList.push(value['qrsYear']);
                                                }

                                                if (!resultRankFilterList.includes(value['rankName'])) {
                                                    resultRankFilterList.push(value['rankName']);
                                                }

                                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                                }, 0);

                                                var rankPoints = parseInt(value['rankPoints']);

                                                var upvoteData;
                                                upvoteData = [];

                                                var downvoteData;
                                                downvoteData = [];

                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                                    Object.values(thisReportVotes)
                                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                        .forEach(value => {
                                                            if (value['ratingPoints'] > 0) {

                                                                upvoteData = [];
                                                                downvoteData = [];
                                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                            }
                                                            else if (value['ratingPoints'] < 0) {

                                                                upvoteData = [];
                                                                downvoteData = [];
                                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                            }
                                                        });

                                                }

                                                var favoriteData;
                                                favoriteData = [];
                                                var favoriteDataIntellisense;
                                                favoriteDataIntellisense = [];
                                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                                }
                                                else {
                                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                                }

                                                var mainImageData;

                                                var filterResourcesIcon = "";
                                                var filterIcon = "";
                                                switch (value['resourceType']) {
                                                    case "Report":
                                                        reportCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                        break;
                                                    case "Report Category":
                                                        reportCategoryCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                        break;
                                                    case "Quality & Research Symposium":
                                                        qrsCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                        break;
                                                    case "Action Plan":
                                                        actionPlanCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                        break;
                                                    case "Stakeholder":
                                                        stakeholderCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "Metric":
                                                        metricCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                        break;
                                                    case "Business Term":
                                                        businessTermCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                        break;
                                                    case "Component":
                                                        componentCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                        break;
                                                    case "Acronym":
                                                        acronymCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                        break;

                                                    case "CCN Business Lead":
                                                        ccnBusinessLeadCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                        break;
                                                    case "CCN CME Program":
                                                        ccnCMEProgramCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "CCN EMR System":
                                                        ccnEMRSystemCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                        break;
                                                    case "CCN Value Based Contract":
                                                        ccnValueBasedContractCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                        break;
                                                    case "CCN Provider":
                                                        ccnProviderCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                        break;
                                                    case "CCN Provider Specialty":
                                                        ccnProviderSpecialtyCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                        break;
                                                    case "CCN Practice Manager":
                                                        ccnPracticeManagerCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                        break;
                                                    case "CCN Practice":
                                                        ccnPracticeCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                        break;
                                                }
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                                var imageCount = 0;
                                                Object.values(resource_BuildImageInfo)
                                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                    .forEach(imageValue => {
                                                        if (imageCount == 0) {
                                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                        }
                                                        imageCount = imageCount + 1;
                                                    });



                                                if (imageCount == 0) {

                                                    Object.values(resource_BuildThumbImageInfo)
                                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                        .forEach(imageValue => {
                                                            if (imageCount == 0) {
                                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                            }
                                                            imageCount = imageCount + 1;
                                                        });

                                                }

                                                if (rankPoints > 0) {

                                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                    }
                                                    else {
                                                        intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                    }
                                                }
                                                else {
                                                    intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                }

                                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                                    var overviewShortText = value['overviewShortText'];
                                                    if (overviewShortText.length == 0) {
                                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                        overviewShortText = <span>Description not available.</span>;
                                                    }

                                                    var valueRank = value['rankName'];
                                                    if (valueRank == "" || valueRank == null) {
                                                        valueRank = "None";
                                                    }
                                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                                        valueRankIcon = "";
                                                    }
                                                    filteredCount = filteredCount + 1;

                                                    if (rankPoints > 0) {

                                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                        }
                                                        else {


                                                            var voteContainer = [];
                                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                            voteContainer.push(upvoteData);
                                                            voteContainer.push(downvoteData);
                                                            var voteTable = []
                                                            voteTable.push(
                                                                <td className="resource_Body_Voting_Container">
                                                                    <div className="result_VoteContainer">
                                                                        {voteContainer}
                                                                    </div>
                                                                </td>
                                                            );
                                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                                voteTable = [];
                                                            }



                                                            var qrsInfo;
                                                            qrsInfo = [];

                                                            if (value['qrsYear'] == null) {

                                                            }
                                                            else {
                                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                                </span>);
                                                            }


                                                            bodyRankListing.push({
                                                                element:
                                                                    <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                        <table className="resource_Body_Table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                        {mainImageData}
                                                                                    </td>
                                                                                    <td>{favoriteData}</td>
                                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                        <span className="resource_Body_Content" >
                                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                        </span>

                                                                                    </td>
                                                                                    {voteTable}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                    </div>,
                                                                rank: rankPoints,
                                                                score: voteTotal,
                                                                externalId: value['externalId']
                                                            })
                                                        }
                                                    }
                                                    else {


                                                        var voteContainer = [];
                                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                        voteContainer.push(upvoteData);
                                                        voteContainer.push(downvoteData);
                                                        var voteTable = []
                                                        voteTable.push(
                                                            <td className="resource_Body_Voting_Container">
                                                                <div className="result_VoteContainer">
                                                                    {voteContainer}
                                                                </div>
                                                            </td>
                                                        );
                                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                                            voteTable = [];
                                                        }

                                                        bodyMatchListing.push({
                                                            element:
                                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                    <table className="resource_Body_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                    {mainImageData}
                                                                                </td>
                                                                                <td>{favoriteData}</td>
                                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className="resource_Body_Content" >
                                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                    </span>

                                                                                </td>
                                                                                {voteTable}
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                </div>,
                                                            rank: rankPoints,
                                                            score: voteTotal,
                                                            externalId: value['externalId']
                                                        })

                                                    }
                                                }
                                            });
                                    });

                                Object.values(resource_ReportOnlyIntellisenseInfo)
                                    .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase().indexOf(removedCaratSearchText.toLowerCase()) == 0)
                                    .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase() != removedCaratSearchText.toLowerCase())
                                    .forEach(sourceValue => {
                                        Object.values(resource_IntellisenseReportAndMetricLinkInfo)
                                            .filter(relationshipValue => (sourceValue['externalId']).toString().toLowerCase() == (relationshipValue['sourceExternalId']).toString().toLowerCase())
                                            .forEach(relationshipValue => {
                                                Object.values(resource_IntellisenseInfo).filter(value => (value['resourceType'] == "Metric"))
                                                    .filter(value => (value['externalId']).toString().toLowerCase() == (relationshipValue['relationshipExternalId']).toString().toLowerCase())
                                                    .forEach(value => {
                                                        intellisenseCount = intellisenseCount + 1;
                                                        bodyCount = bodyCount + 1;
                                                        resourceCount = resourceCount + 1;

                                                        var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                                        var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                        highlightedText = ReactHtmlParser(highlightedText);
                                                        var highlightedSubText = sourceValue['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                        highlightedSubText = ReactHtmlParser(highlightedSubText);

                                                        if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                                            resultResourceTypeFilterList.push(value['resourceType']);
                                                        }

                                                        if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                                            resultReportTypeFilterList.push(value['reportType']);
                                                        }

                                                        if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                                            resultQRSYearFilterList.push(value['qrsYear']);
                                                        }

                                                        if (!resultRankFilterList.includes(value['rankName'])) {
                                                            resultRankFilterList.push(value['rankName']);
                                                        }

                                                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                                                        }, 0);

                                                        var rankPoints = parseInt(value['rankPoints']);

                                                        var upvoteData;
                                                        upvoteData = [];

                                                        var downvoteData;
                                                        downvoteData = [];

                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                                            Object.values(thisReportVotes)
                                                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                                .forEach(value => {
                                                                    if (value['ratingPoints'] > 0) {

                                                                        upvoteData = [];
                                                                        downvoteData = [];
                                                                        upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                                    }
                                                                    else if (value['ratingPoints'] < 0) {

                                                                        upvoteData = [];
                                                                        downvoteData = [];
                                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                                        downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                                    }
                                                                });

                                                        }

                                                        var favoriteData;
                                                        favoriteData = [];
                                                        var favoriteDataIntellisense;
                                                        favoriteDataIntellisense = [];
                                                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                                            favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                            favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                                        }
                                                        else {
                                                            favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                            favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                                        }

                                                        var mainImageData;

                                                        var filterResourcesIcon = "";
                                                        var filterIcon = "";
                                                        switch (value['resourceType']) {
                                                            case "Report":
                                                                reportCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                                break;
                                                            case "Report Category":
                                                                reportCategoryCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                                break;
                                                            case "Quality & Research Symposium":
                                                                qrsCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                                break;
                                                            case "Action Plan":
                                                                actionPlanCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                                break;
                                                            case "Stakeholder":
                                                                stakeholderCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                                break;
                                                            case "Metric":
                                                                metricCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                                filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                                break;
                                                            case "Business Term":
                                                                businessTermCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                                break;
                                                            case "Component":
                                                                componentCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                                break;
                                                            case "Acronym":
                                                                acronymCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                                break;

                                                            case "CCN Business Lead":
                                                                ccnBusinessLeadCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                                break;
                                                            case "CCN CME Program":
                                                                ccnCMEProgramCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                                break;
                                                            case "CCN EMR System":
                                                                ccnEMRSystemCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                                break;
                                                            case "CCN Value Based Contract":
                                                                ccnValueBasedContractCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                                break;
                                                            case "CCN Provider":
                                                                ccnProviderCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                                break;
                                                            case "CCN Provider Specialty":
                                                                ccnProviderSpecialtyCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                                break;
                                                            case "CCN Practice Manager":
                                                                ccnPracticeManagerCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                                break;
                                                            case "CCN Practice":
                                                                ccnPracticeCount++;
                                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                                filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                                break;
                                                        }
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                                        var imageCount = 0;
                                                        Object.values(resource_BuildImageInfo)
                                                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                            .forEach(imageValue => {
                                                                if (imageCount == 0) {
                                                                    mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                                }
                                                                imageCount = imageCount + 1;
                                                            });


                                                        if (imageCount == 0) {

                                                            Object.values(resource_BuildThumbImageInfo)
                                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                                .forEach(imageValue => {
                                                                    if (imageCount == 0) {
                                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                                    }
                                                                    imageCount = imageCount + 1;
                                                                });

                                                        }


                                                        if (rankPoints > 0) {
                                                            if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                            }
                                                            else {
                                                                intellisenseRankListing.push(<div id={"intellisenseStartsWithListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                            }
                                                        }
                                                        else {
                                                            intellisenseStartsWithListing.push(<div id={"intellisenseStartsWithListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                        }


                                                        if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                                            var overviewShortText = value['overviewShortText'];
                                                            if (overviewShortText.length == 0) {
                                                                //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                                overviewShortText = <span>Description not available.</span>;
                                                            }

                                                            var valueRank = value['rankName'];
                                                            if (valueRank == "" || valueRank == null) {
                                                                valueRank = "None";
                                                            }
                                                            var valueRankIcon = value['rankFontAwesomeIcon'];
                                                            if (valueRankIcon == "" || valueRankIcon == null) {
                                                                valueRankIcon = "";
                                                            }
                                                            filteredCount = filteredCount + 1;

                                                            if (rankPoints > 0) {

                                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                                }
                                                                else {

                                                                    var voteContainer = [];
                                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                                    voteContainer.push(upvoteData);
                                                                    voteContainer.push(downvoteData);
                                                                    var voteTable = []
                                                                    voteTable.push(
                                                                        <td className="resource_Body_Voting_Container">
                                                                            <div className="result_VoteContainer">
                                                                                {voteContainer}
                                                                            </div>
                                                                        </td>
                                                                    );
                                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                                        voteTable = [];
                                                                    }

                                                                    var qrsInfo;
                                                                    qrsInfo = [];

                                                                    if (value['qrsYear'] == null) {

                                                                    }
                                                                    else {
                                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                                        </span>);
                                                                    }


                                                                    bodyRankListing.push({
                                                                        element:
                                                                            <div id={"bodyStartsWithListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                                <table className="resource_Body_Table">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                                {mainImageData}
                                                                                            </td>
                                                                                            <td>{favoriteData}</td>
                                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                                <span className="resource_Body_Content" >
                                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                                </span>

                                                                                            </td>
                                                                                            {voteTable}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                            </div>,
                                                                        rank: rankPoints,
                                                                        score: voteTotal,
                                                                        externalId: value['externalId']
                                                                    })
                                                                }
                                                            }
                                                            else {

                                                                var voteContainer = [];
                                                                voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                                voteContainer.push(upvoteData);
                                                                voteContainer.push(downvoteData);
                                                                var voteTable = []
                                                                voteTable.push(
                                                                    <td className="resource_Body_Voting_Container">
                                                                        <div className="result_VoteContainer">
                                                                            {voteContainer}
                                                                        </div>
                                                                    </td>
                                                                );
                                                                if (value['resourceType'] == "Quality & Research Symposium") {
                                                                    voteTable = [];
                                                                }



                                                                var qrsInfo;
                                                                qrsInfo = [];

                                                                if (value['qrsYear'] == null) {

                                                                }
                                                                else {
                                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                        {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                                    </span>);
                                                                }

                                                                bodyStartsWithListing.push({
                                                                    element:
                                                                        <div id={"bodyStartsWithListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                            <table className="resource_Body_Table">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                            <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                            {mainImageData}
                                                                                        </td>
                                                                                        <td>{favoriteData}</td>
                                                                                        <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                            <span className="resource_Body_Content" >
                                                                                                <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                                <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                                <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                                <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                                <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                                <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                                <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                                <div className="resource_Body_Text_Overflow"></div>
                                                                                                <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                                <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                            </span>

                                                                                        </td>
                                                                                        {voteTable}
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                            <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                        </div>,
                                                                    rank: rankPoints,
                                                                    score: voteTotal,
                                                                    externalId: value['externalId']
                                                                })

                                                            }
                                                        }
                                                    });
                                            });

                                    });

                            });


                        Object.values(resource_ReportOnlyIntellisenseInfo)
                            .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase().indexOf(removedCaratSearchText.toLowerCase()) != -1)
                            .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase().indexOf(removedCaratSearchText.toLowerCase()) != 0)
                            .filter(sourceValue => (sourceValue['resourceName']).toString().toLowerCase() != removedCaratSearchText.toLowerCase())
                            .forEach(sourceValue => {
                                Object.values(resource_IntellisenseReportAndMetricLinkInfo)
                                    .filter(relationshipValue => (sourceValue['externalId']).toString().toLowerCase() == (relationshipValue['sourceExternalId']).toString().toLowerCase())
                                    .forEach(relationshipValue => {
                                        Object.values(resource_IntellisenseInfo).filter(value => (value['resourceType'] == "Metric"))
                                            .filter(value => (value['externalId']).toString().toLowerCase() == (relationshipValue['relationshipExternalId']).toString().toLowerCase())
                                            .forEach(value => {
                                                intellisenseCount = intellisenseCount + 1;
                                                resourceCount = resourceCount + 1;
                                                bodyCount = bodyCount + 1;
                                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                highlightedText = ReactHtmlParser(highlightedText);
                                                var highlightedSubText = sourceValue['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                                highlightedSubText = ReactHtmlParser(highlightedSubText);

                                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                                    resultResourceTypeFilterList.push(value['resourceType']);
                                                }

                                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                                    resultReportTypeFilterList.push(value['reportType']);
                                                }

                                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                                    resultQRSYearFilterList.push(value['qrsYear']);
                                                }

                                                if (!resultRankFilterList.includes(value['rankName'])) {
                                                    resultRankFilterList.push(value['rankName']);
                                                }

                                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                                }, 0);

                                                var rankPoints = parseInt(value['rankPoints']);

                                                var upvoteData;
                                                upvoteData = [];

                                                var downvoteData;
                                                downvoteData = [];

                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                                    Object.values(thisReportVotes)
                                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                        .forEach(value => {
                                                            if (value['ratingPoints'] > 0) {

                                                                upvoteData = [];
                                                                downvoteData = [];
                                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                            }
                                                            else if (value['ratingPoints'] < 0) {

                                                                upvoteData = [];
                                                                downvoteData = [];
                                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                            }
                                                        });

                                                }

                                                var favoriteData;
                                                favoriteData = [];
                                                var favoriteDataIntellisense;
                                                favoriteDataIntellisense = [];
                                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                                }
                                                else {
                                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                                }

                                                var mainImageData;

                                                var filterResourcesIcon = "";
                                                var filterIcon = "";
                                                switch (value['resourceType']) {
                                                    case "Report":
                                                        reportCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                        break;
                                                    case "Report Category":
                                                        reportCategoryCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                        break;
                                                    case "Quality & Research Symposium":
                                                        qrsCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                        break;
                                                    case "Action Plan":
                                                        actionPlanCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                        break;
                                                    case "Stakeholder":
                                                        stakeholderCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "Metric":
                                                        metricCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                        break;
                                                    case "Business Term":
                                                        businessTermCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                        break;
                                                    case "Component":
                                                        componentCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                        break;
                                                    case "Acronym":
                                                        acronymCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                        break;

                                                    case "CCN Business Lead":
                                                        ccnBusinessLeadCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                        break;
                                                    case "CCN CME Program":
                                                        ccnCMEProgramCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                        break;
                                                    case "CCN EMR System":
                                                        ccnEMRSystemCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                        break;
                                                    case "CCN Value Based Contract":
                                                        ccnValueBasedContractCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                        break;
                                                    case "CCN Provider":
                                                        ccnProviderCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                        break;
                                                    case "CCN Provider Specialty":
                                                        ccnProviderSpecialtyCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                        break;
                                                    case "CCN Practice Manager":
                                                        ccnPracticeManagerCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                        break;
                                                    case "CCN Practice":
                                                        ccnPracticeCount++;
                                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                        break;
                                                }
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                                var imageCount = 0;
                                                Object.values(resource_BuildImageInfo)
                                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                    .forEach(imageValue => {
                                                        if (imageCount == 0) {
                                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                        }
                                                        imageCount = imageCount + 1;
                                                    });


                                                if (imageCount == 0) {

                                                    Object.values(resource_BuildThumbImageInfo)
                                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                        .forEach(imageValue => {
                                                            if (imageCount == 0) {
                                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                            }
                                                            imageCount = imageCount + 1;
                                                        });

                                                }



                                                if (rankPoints > 0) {
                                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                    }
                                                    else {
                                                        intellisenseRankListing.push(<div id={"intellisenseExactMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                    }
                                                }
                                                else {
                                                    intellisenseExactListing.push(<div id={"intellisenseExactMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                }



                                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                                    var overviewShortText = value['overviewShortText'];
                                                    if (overviewShortText.length == 0) {
                                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                        overviewShortText = <span>Description not available.</span>;
                                                    }

                                                    var valueRank = value['rankName'];
                                                    if (valueRank == "" || valueRank == null) {
                                                        valueRank = "None";
                                                    }
                                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                                        valueRankIcon = "";
                                                    }
                                                    filteredCount = filteredCount + 1;

                                                    if (rankPoints > 0) {

                                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                        }
                                                        else {

                                                            var voteContainer = [];
                                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                            voteContainer.push(upvoteData);
                                                            voteContainer.push(downvoteData);
                                                            var voteTable = []
                                                            voteTable.push(
                                                                <td className="resource_Body_Voting_Container">
                                                                    <div className="result_VoteContainer">
                                                                        {voteContainer}
                                                                    </div>
                                                                </td>
                                                            );
                                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                                voteTable = [];
                                                            }


                                                            var qrsInfo;
                                                            qrsInfo = [];

                                                            if (value['qrsYear'] == null) {

                                                            }
                                                            else {
                                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                                </span>);
                                                            }

                                                            bodyRankListing.push({
                                                                element:
                                                                    <div id={"bodyExactListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                        <table className="resource_Body_Table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                        {mainImageData}
                                                                                    </td>
                                                                                    <td>{favoriteData}</td>
                                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                        <span className="resource_Body_Content" >
                                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                        </span>

                                                                                    </td>
                                                                                    {voteTable}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                    </div>,
                                                                rank: rankPoints,
                                                                score: voteTotal,
                                                                externalId: value['externalId']
                                                            })
                                                        }
                                                    }
                                                    else {

                                                        var voteContainer = [];
                                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                        voteContainer.push(upvoteData);
                                                        voteContainer.push(downvoteData);
                                                        var voteTable = []
                                                        voteTable.push(
                                                            <td className="resource_Body_Voting_Container">
                                                                <div className="result_VoteContainer">
                                                                    {voteContainer}
                                                                </div>
                                                            </td>
                                                        );
                                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                                            voteTable = [];
                                                        }


                                                        var qrsInfo;
                                                        qrsInfo = [];

                                                        if (value['qrsYear'] == null) {

                                                        }
                                                        else {
                                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                            </span>);
                                                        }


                                                        bodyExactListing.push({
                                                            element:
                                                                <div id={"bodyExactListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                    <table className="resource_Body_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                    {mainImageData}
                                                                                </td>
                                                                                <td>{favoriteData}</td>
                                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className="resource_Body_Content" >
                                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo} -> <span className="subresource_Body_ResourceType" alt={sourceValue['resourceType']} title={sourceValue['resourceType']}><i className="results_Icon fal fa-chart-column"></i> {sourceValue['resourceType']} <span className="subresource_Body_ReportType" alt={sourceValue['reportType']} title={sourceValue['reportType']}>{(sourceValue['reportType'].length > 0) ? "(" : ""} {highlightedSubText} - {sourceValue['reportType']} {(sourceValue['reportType'].length > 0) ? ")" : ""}</span></span></div>
                                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                    </span>

                                                                                </td>
                                                                                {voteTable}
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                </div>,
                                                            rank: rankPoints,
                                                            score: voteTotal,
                                                            externalId: value['externalId']
                                                        })

                                                    }
                                                }
                                            });
                                    });



















                                //End Report Only Metric Search

                            });
                    }

                    if (searchTextLength > 2 && searchText.slice(0, 1) == '@') {

                        dateStartSearch = new Date();

                        Object.values(resource_IntellisenseInfo)
                            .filter(value => ((value['createdByFirstName']).slice(0, 1).toString().toLowerCase() + (value['createdByLastName']).toString().toLowerCase()) == searchText.substring(1).toLowerCase())
                            .filter(value => (parseInt(value['rankPoints'])) > 0)
                            .filter(value => (new Date(value['rankDtEnd']) > today))
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;
                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });

                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }

                                intellisenseAllResultsRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)

                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;


                                    var voteContainer = [];
                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                    voteContainer.push(upvoteData);
                                    voteContainer.push(downvoteData);
                                    var voteTable = []
                                    voteTable.push(
                                        <td className="resource_Body_Voting_Container">
                                            <div className="result_VoteContainer">
                                                {voteContainer}
                                            </div>
                                        </td>
                                    );
                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                        voteTable = [];
                                    }


                                    var qrsInfo;
                                    qrsInfo = [];

                                    if (value['qrsYear'] == null) {

                                    }
                                    else {
                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                        </span>);
                                    }

                                    bodyAllResultsRankListing.push({
                                        element:
                                            <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                <table className="resource_Body_Table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                {mainImageData}
                                                            </td>
                                                            <td>{favoriteData}</td>
                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                <span className="resource_Body_Content" >
                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                </span>

                                                            </td>
                                                            {voteTable}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                            </div>,
                                        rank: rankPoints,
                                        score: voteTotal,
                                        externalId: value['externalId']
                                    });
                                }
                            });


                        Object.values(resource_IntellisenseInfo)
                            .filter(value => ((value['createdByFirstName']).slice(0, 1).toString().toLowerCase() + (value['createdByLastName']).toString().toLowerCase()) == searchText.substring(1).toLowerCase())
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;
                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });

                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }
                                if (rankPoints > 0) {
                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }

                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;

                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {


                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }


                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }

                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {


                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }


                                        var qrsInfo;
                                        qrsInfo = [];

                                        if (value['qrsYear'] == null) {

                                        }
                                        else {
                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                            </span>);
                                        }

                                        bodyMatchListing.push({
                                            element:
                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td>{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })
                                    }
                                }
                            });

                    }
                    if (searchText == "~") {

                        dateStartSearch = new Date();

                        Object.values(resource_IntellisenseInfo)
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }
                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;


                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;

                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        ccnProviderSpecialtyCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });


                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }


                                if (rankPoints > 0) {

                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }



                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;


                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {

                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }



                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }


                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td className="resource_Body_Favorite_Container">{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {

                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }



                                        var qrsInfo;
                                        qrsInfo = [];

                                        if (value['qrsYear'] == null) {

                                        }
                                        else {
                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                            </span>);
                                        }


                                        bodyMatchListing.push({
                                            element:
                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td className="resource_Body_Favorite_Container">{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })
                                    }

                                }
                            });
                    }
                    if (searchTextLength > 2) {

                        dateStartSearch = new Date();



                        Object.values(resource_IntellisenseInfo)
                            .filter(value => (parseInt(value['rankPoints'])) > 0)
                            .filter(value => (new Date(value['rankDtEnd']) > today))
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;

                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        ccnProviderSpecialtyCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });



                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }

                                intellisenseAllResultsRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)

                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;


                                    var voteContainer = [];
                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                    voteContainer.push(upvoteData);
                                    voteContainer.push(downvoteData);
                                    var voteTable = []
                                    voteTable.push(
                                        <td className="resource_Body_Voting_Container">
                                            <div className="result_VoteContainer">
                                                {voteContainer}
                                            </div>
                                        </td>
                                    );
                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                        voteTable = [];
                                    }


                                    var qrsInfo;
                                    qrsInfo = [];

                                    if (value['qrsYear'] == null) {

                                    }
                                    else {
                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                        </span>);
                                    }

                                    bodyAllResultsRankListing.push({
                                        element:
                                            <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                <table className="resource_Body_Table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                {mainImageData}
                                                            </td>
                                                            <td>{favoriteData}</td>
                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                <span className="resource_Body_Content" >
                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                </span>

                                                            </td>
                                                            {voteTable}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                            </div>,
                                        rank: rankPoints,
                                        score: voteTotal,
                                        externalId: value['externalId']
                                    })

                                }
                            });











                        Object.values(resource_IntellisenseInfo)
                            .filter(value => (value['resourceName']).toString().toLowerCase() == searchText.toLowerCase())
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;
                                //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;

                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        ccnProviderSpecialtyCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });



                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }

                                if (rankPoints > 0) {

                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }

                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;

                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {


                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }



                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }


                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {


                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }

                                        bodyMatchListing.push({
                                            element:
                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td>{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} {(value['reportType'].length > 0) ? "(" : ""}<span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{value['reportType']}</span>{(value['reportType'].length > 0) ? ")" : ""}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })

                                    }
                                }
                            });

                        Object.values(resource_IntellisenseInfo)
                            .filter(value => (value['resourceName']).toString().toLowerCase().indexOf(searchText.toLowerCase()) == 0)
                            .filter(value => (value['resourceName']).toString().toLowerCase() != searchText.toLowerCase())
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                bodyCount = bodyCount + 1;
                                resourceCount = resourceCount + 1;

                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;

                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        ccnProviderSpecialtyCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });


                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }


                                if (rankPoints > 0) {
                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseStartsWithListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseStartsWithListing.push(<div id={"intellisenseStartsWithListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }


                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText.length == 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;

                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {

                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }

                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }


                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyStartsWithListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {

                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }



                                        var qrsInfo;
                                        qrsInfo = [];

                                        if (value['qrsYear'] == null) {

                                        }
                                        else {
                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                            </span>);
                                        }

                                        bodyStartsWithListing.push({
                                            element:
                                                <div id={"bodyStartsWithListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td>{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })

                                    }
                                }
                            });
                        Object.values(resource_IntellisenseInfo)
                            .filter(value => (value['resourceName']).toString().toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                            .filter(value => (value['resourceName']).toString().toLowerCase().indexOf(searchText.toLowerCase()) != 0)
                            .filter(value => (value['resourceName']).toString().toLowerCase() != searchText.toLowerCase())
                            .forEach(value => {
                                intellisenseCount = intellisenseCount + 1;
                                resourceCount = resourceCount + 1;
                                bodyCount = bodyCount + 1;
                                var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                highlightedText = ReactHtmlParser(highlightedText);

                                if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                    resultResourceTypeFilterList.push(value['resourceType']);
                                }

                                if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                    resultReportTypeFilterList.push(value['reportType']);
                                }

                                if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                    resultQRSYearFilterList.push(value['qrsYear']);
                                }

                                if (!resultRankFilterList.includes(value['rankName'])) {
                                    resultRankFilterList.push(value['rankName']);
                                }

                                var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                    return parseInt(prev) + parseInt(cur['ratingPoints']);
                                }, 0);

                                var rankPoints = parseInt(value['rankPoints']);

                                var upvoteData;
                                upvoteData = [];

                                var downvoteData;
                                downvoteData = [];

                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                    Object.values(thisReportVotes)
                                        .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                        .forEach(value => {
                                            if (value['ratingPoints'] > 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                            }
                                            else if (value['ratingPoints'] < 0) {

                                                upvoteData = [];
                                                downvoteData = [];
                                                upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                            }
                                        });

                                }

                                var favoriteData;
                                favoriteData = [];
                                var favoriteDataIntellisense;
                                favoriteDataIntellisense = [];
                                if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                    favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                }
                                else {
                                    favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                    favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                }

                                var mainImageData;

                                var filterResourcesIcon = "";
                                var filterIcon = "";
                                switch (value['resourceType']) {
                                    case "Report":
                                        reportCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                        filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                        break;
                                    case "Report Category":
                                        reportCategoryCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                        filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                        break;
                                    case "Quality & Research Symposium":
                                        qrsCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                        break;
                                    case "Action Plan":
                                        actionPlanCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                        break;
                                    case "Stakeholder":
                                        stakeholderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "Metric":
                                        metricCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                        filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                        break;
                                    case "Business Term":
                                        businessTermCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                        break;
                                    case "Component":
                                        componentCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                        filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                        break;
                                    case "Acronym":
                                        acronymCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                        filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                        break;

                                    case "CCN Business Lead":
                                        ccnBusinessLeadCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                        break;
                                    case "CCN CME Program":
                                        ccnCMEProgramCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                        break;
                                    case "CCN EMR System":
                                        ccnEMRSystemCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                        break;
                                    case "CCN Value Based Contract":
                                        ccnValueBasedContractCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                        filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                        break;
                                    case "CCN Provider":
                                        ccnProviderCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                        filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                        break;
                                    case "CCN Provider Specialty":
                                        ccnProviderSpecialtyCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                        filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                        break;
                                    case "CCN Practice Manager":
                                        ccnPracticeManagerCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                        filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                        break;
                                    case "CCN Practice":
                                        ccnPracticeCount++;
                                        filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                        filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                        break;
                                }
                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                var imageCount = 0;
                                Object.values(resource_BuildImageInfo)
                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                    .forEach(imageValue => {
                                        if (imageCount == 0) {
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                        }
                                        imageCount = imageCount + 1;
                                    });


                                if (imageCount == 0) {

                                    Object.values(resource_BuildThumbImageInfo)
                                        .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                        .forEach(imageValue => {
                                            if (imageCount == 0) {
                                                mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                            }
                                            imageCount = imageCount + 1;
                                        });

                                }



                                if (rankPoints > 0) {
                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                    }
                                    else {
                                        intellisenseRankListing.push(<div id={"intellisenseExactMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                    }
                                }
                                else {
                                    intellisenseExactListing.push(<div id={"intellisenseExactMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                }



                                if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                    var overviewShortText = value['overviewShortText'];
                                    if (overviewShortText && overviewShortText.length === 0) {
                                        //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                        overviewShortText = <span>Description not available.</span>;
                                    }

                                    var valueRank = value['rankName'];
                                    if (valueRank == "" || valueRank == null) {
                                        valueRank = "None";
                                    }
                                    var valueRankIcon = value['rankFontAwesomeIcon'];
                                    if (valueRankIcon == "" || valueRankIcon == null) {
                                        valueRankIcon = "";
                                    }
                                    filteredCount = filteredCount + 1;

                                    if (rankPoints > 0) {

                                        if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                        }
                                        else {

                                            var voteContainer = [];
                                            voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                            voteContainer.push(upvoteData);
                                            voteContainer.push(downvoteData);
                                            var voteTable = []
                                            voteTable.push(
                                                <td className="resource_Body_Voting_Container">
                                                    <div className="result_VoteContainer">
                                                        {voteContainer}
                                                    </div>
                                                </td>
                                            );
                                            if (value['resourceType'] == "Quality & Research Symposium") {
                                                voteTable = [];
                                            }


                                            var qrsInfo;
                                            qrsInfo = [];

                                            if (value['qrsYear'] == null) {

                                            }
                                            else {
                                                qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                    {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                </span>);
                                            }

                                            bodyRankListing.push({
                                                element:
                                                    <div id={"bodyExactListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                        <table className="resource_Body_Table">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                        {mainImageData}
                                                                    </td>
                                                                    <td>{favoriteData}</td>
                                                                    <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                        <span className="resource_Body_Content" >
                                                                            <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                            <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                            <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                            <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                            <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                            <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                            <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                            <div className="resource_Body_Text_Overflow"></div>
                                                                            <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                            <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                        </span>

                                                                    </td>
                                                                    {voteTable}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                    </div>,
                                                rank: rankPoints,
                                                score: voteTotal,
                                                externalId: value['externalId']
                                            })
                                        }
                                    }
                                    else {

                                        var voteContainer = [];
                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                        voteContainer.push(upvoteData);
                                        voteContainer.push(downvoteData);
                                        var voteTable = []
                                        voteTable.push(
                                            <td className="resource_Body_Voting_Container">
                                                <div className="result_VoteContainer">
                                                    {voteContainer}
                                                </div>
                                            </td>
                                        );
                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                            voteTable = [];
                                        }


                                        var qrsInfo;
                                        qrsInfo = [];

                                        if (value['qrsYear'] == null) {

                                        }
                                        else {
                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                            </span>);
                                        }


                                        bodyExactListing.push({
                                            element:
                                                <div id={"bodyExactListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                    <table className="resource_Body_Table">
                                                        <tbody>
                                                            <tr>
                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                    {mainImageData}
                                                                </td>
                                                                <td>{favoriteData}</td>
                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                    <span className="resource_Body_Content" >
                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                    </span>

                                                                </td>
                                                                {voteTable}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                </div>,
                                            rank: rankPoints,
                                            score: voteTotal,
                                            externalId: value['externalId']
                                        })

                                    }
                                }

                            });

                        if (searchText.slice(0, 1) == '^' || searchText.slice(0, 1) == '~' || searchText.slice(0, 1) == '#') {
                            //no extended search
                        }
                        else {

                            //only go more indepth if nothing else comes up.
                            if (resourceCount <= 20) {


                                Object.values(resource_IntellisenseInfo)
                                    .filter(value => {
                                        const resourceName = value['resourceName'];
                                        if (resourceName) {
                                            const searchTextArray = searchText.toLowerCase().split(" ");
                                            return searchTextArray.every(element => resourceName.trim().toLowerCase().indexOf(element) !== -1);
                                        }
                                        return false;
                                    })
                                    .filter(value => (value['resourceName']).toString().toLowerCase().indexOf(searchText.toLowerCase()) == -1)
                                    .filter(value => (value['resourceName']).toString().toLowerCase() != searchText.toLowerCase())
                                    .forEach(value => {
                                        intellisenseCount = intellisenseCount + 1;
                                        resourceCount = resourceCount + 1;
                                        bodyCount = bodyCount + 1;
                                        var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                        var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                        highlightedText = ReactHtmlParser(highlightedText);

                                        if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                            resultResourceTypeFilterList.push(value['resourceType']);
                                        }

                                        if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                            resultReportTypeFilterList.push(value['reportType']);
                                        }

                                        if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                            resultQRSYearFilterList.push(value['qrsYear']);
                                        }

                                        if (!resultRankFilterList.includes(value['rankName'])) {
                                            resultRankFilterList.push(value['rankName']);
                                        }

                                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                                        }, 0);

                                        var rankPoints = parseInt(value['rankPoints']);

                                        var upvoteData;
                                        upvoteData = [];

                                        var downvoteData;
                                        downvoteData = [];

                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                            Object.values(thisReportVotes)
                                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                .forEach(value => {
                                                    if (value['ratingPoints'] > 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                    }
                                                    else if (value['ratingPoints'] < 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                    }
                                                });

                                        }

                                        var favoriteData;
                                        favoriteData = [];
                                        var favoriteDataIntellisense;
                                        favoriteDataIntellisense = [];
                                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                            favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                        }
                                        else {
                                            favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                        }

                                        var mainImageData;

                                        var filterResourcesIcon = "";
                                        var filterIcon = "";
                                        switch (value['resourceType']) {
                                            case "Report":
                                                reportCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                break;
                                            case "Report Category":
                                                reportCategoryCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                break;
                                            case "Quality & Research Symposium":
                                                qrsCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                break;
                                            case "Action Plan":
                                                actionPlanCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                break;
                                            case "Stakeholder":
                                                stakeholderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "Metric":
                                                metricCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                break;
                                            case "Business Term":
                                                businessTermCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                break;
                                            case "Component":
                                                componentCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                break;
                                            case "Acronym":
                                                acronymCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                break;

                                            case "CCN Business Lead":
                                                ccnBusinessLeadCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                break;
                                            case "CCN CME Program":
                                                ccnCMEProgramCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "CCN EMR System":
                                                ccnEMRSystemCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                break;
                                            case "CCN Value Based Contract":
                                                ccnValueBasedContractCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                break;
                                            case "CCN Provider":
                                                ccnProviderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                break;
                                            case "CCN Provider Specialty":
                                                ccnProviderSpecialtyCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                break;
                                            case "CCN Practice Manager":
                                                ccnPracticeManagerCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                break;
                                            case "CCN Practice":
                                                ccnPracticeCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                break;
                                        }
                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                        var imageCount = 0;
                                        Object.values(resource_BuildImageInfo)
                                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                            .forEach(imageValue => {
                                                if (imageCount == 0) {
                                                    mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                }
                                                imageCount = imageCount + 1;
                                            });


                                        if (imageCount == 0) {

                                            Object.values(resource_BuildThumbImageInfo)
                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                .forEach(imageValue => {
                                                    if (imageCount == 0) {
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                    }
                                                    imageCount = imageCount + 1;
                                                });

                                        }

                                        if (rankPoints > 0) {
                                            if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                            }
                                            else {
                                                intellisenseRankListing.push(<div id={"intellisenseAllPartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                            }
                                        }
                                        else {
                                            intellisenseAllPartialListing.push(<div id={"intellisenseAllPartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                        }


                                        if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                            var overviewShortText = value['overviewShortText'];
                                            if (overviewShortText.length == 0) {
                                                //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                overviewShortText = <span>Description not available.</span>;
                                            }

                                            var valueRank = value['rankName'];
                                            if (valueRank == "" || valueRank == null) {
                                                valueRank = "None";
                                            }
                                            var valueRankIcon = value['rankFontAwesomeIcon'];
                                            if (valueRankIcon == "" || valueRankIcon == null) {
                                                valueRankIcon = "";
                                            }
                                            filteredCount = filteredCount + 1;

                                            if (rankPoints > 0) {

                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                }
                                                else {

                                                    var voteContainer = [];
                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                    voteContainer.push(upvoteData);
                                                    voteContainer.push(downvoteData);
                                                    var voteTable = []
                                                    voteTable.push(
                                                        <td className="resource_Body_Voting_Container">
                                                            <div className="result_VoteContainer">
                                                                {voteContainer}
                                                            </div>
                                                        </td>
                                                    );
                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                        voteTable = [];
                                                    }


                                                    var qrsInfo;
                                                    qrsInfo = [];

                                                    if (value['qrsYear'] == null) {

                                                    }
                                                    else {
                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                        </span>);
                                                    }

                                                    bodyRankListing.push({
                                                        element:
                                                            <div id={"bodyAllPartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                <table className="resource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                {mainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                </span>

                                                                            </td>
                                                                            {voteTable}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                            </div>,
                                                        rank: rankPoints,
                                                        score: voteTotal,
                                                        externalId: value['externalId']
                                                    })
                                                }
                                            }
                                            else {

                                                var voteContainer = [];
                                                voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                voteContainer.push(upvoteData);
                                                voteContainer.push(downvoteData);
                                                var voteTable = []
                                                voteTable.push(
                                                    <td className="resource_Body_Voting_Container">
                                                        <div className="result_VoteContainer">
                                                            {voteContainer}
                                                        </div>
                                                    </td>
                                                );
                                                if (value['resourceType'] == "Quality & Research Symposium") {
                                                    voteTable = [];
                                                }



                                                var qrsInfo;
                                                qrsInfo = [];

                                                if (value['qrsYear'] == null) {

                                                }
                                                else {
                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                        {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                    </span>);
                                                }


                                                bodyAllPartialListing.push({
                                                    element:
                                                        <div id={"bodyAllPartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                            <table className="resource_Body_Table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                            {mainImageData}
                                                                        </td>
                                                                        <td>{favoriteData}</td>
                                                                        <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className="resource_Body_Content" >
                                                                                <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                <div className="resource_Body_Text_Overflow"></div>
                                                                                <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                            </span>

                                                                        </td>
                                                                        {voteTable}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                        </div>,
                                                    rank: rankPoints,
                                                    score: voteTotal,
                                                    externalId: value['externalId']
                                                })
                                            }

                                        }

                                    });

                                Object.values(resource_IntellisenseInfo)
                                    .filter(value => {
                                        const resourceName = value['resourceName'];
                                        if (resourceName) {
                                            const searchTextArray = searchText
                                                .toLowerCase()
                                                .split(" ")
                                                .filter(value => value.toString().toLowerCase().length > 2);

                                            return searchTextArray.some(element =>
                                                resourceName.trim().toLowerCase().indexOf(element) !== -1
                                            );
                                        }
                                        return false;
                                    })
                                    .filter(value => {
                                        const resourceName = value['resourceName'];
                                        if (resourceName) {
                                            const searchTextArray = searchText.toLowerCase().split(" ");

                                            return !searchTextArray.every(element =>
                                                resourceName.trim().toLowerCase().indexOf(element) !== -1
                                            );
                                        }
                                        return false;
                                    })
                                    .filter(value => (value['resourceName']).toString().toLowerCase().indexOf(searchText.toLowerCase()) == -1)
                                    .filter(value => (value['resourceName']).toString().toLowerCase() != searchText.toLowerCase())
                                    .forEach(value => {
                                        intellisenseCount = intellisenseCount + 1;
                                        resourceCount = resourceCount + 1;
                                        bodyCount = bodyCount + 1;
                                        var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                        var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                        highlightedText = ReactHtmlParser(highlightedText);


                                        if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                            resultResourceTypeFilterList.push(value['resourceType']);
                                        }

                                        if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                            resultReportTypeFilterList.push(value['reportType']);
                                        }

                                        if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                            resultQRSYearFilterList.push(value['qrsYear']);
                                        }

                                        if (!resultRankFilterList.includes(value['rankName'])) {
                                            resultRankFilterList.push(value['rankName']);
                                        }

                                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                                        }, 0);

                                        var rankPoints = parseInt(value['rankPoints']);

                                        var upvoteData;
                                        upvoteData = [];

                                        var downvoteData;
                                        downvoteData = [];

                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                            Object.values(thisReportVotes)
                                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                .forEach(value => {
                                                    if (value['ratingPoints'] > 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                    }
                                                    else if (value['ratingPoints'] < 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                    }
                                                });

                                        }

                                        var favoriteData;
                                        favoriteData = [];
                                        var favoriteDataIntellisense;
                                        favoriteDataIntellisense = [];
                                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                            favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                        }
                                        else {
                                            favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                        }

                                        var mainImageData;

                                        var filterResourcesIcon = "";
                                        var filterIcon = "";
                                        switch (value['resourceType']) {
                                            case "Report":
                                                reportCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                break;
                                            case "Report Category":
                                                reportCategoryCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                break;
                                            case "Quality & Research Symposium":
                                                qrsCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                break;
                                            case "Action Plan":
                                                actionPlanCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                break;
                                            case "Stakeholder":
                                                stakeholderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "Metric":
                                                metricCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                break;
                                            case "Business Term":
                                                businessTermCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                break;
                                            case "Component":
                                                componentCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                break;
                                            case "Acronym":
                                                acronymCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                break;

                                            case "CCN Business Lead":
                                                ccnBusinessLeadCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                break;
                                            case "CCN CME Program":
                                                ccnCMEProgramCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "CCN EMR System":
                                                ccnEMRSystemCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                break;
                                            case "CCN Value Based Contract":
                                                ccnValueBasedContractCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                break;
                                            case "CCN Provider":
                                                ccnProviderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                break;
                                            case "CCN Provider Specialty":
                                                ccnProviderSpecialtyCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                break;
                                            case "CCN Practice Manager":
                                                ccnPracticeManagerCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                break;
                                            case "CCN Practice":
                                                ccnPracticeCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                break;
                                        }
                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                        var imageCount = 0;
                                        Object.values(resource_BuildImageInfo)
                                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                            .forEach(imageValue => {
                                                if (imageCount == 0) {
                                                    mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                }
                                                imageCount = imageCount + 1;
                                            });


                                        if (imageCount == 0) {

                                            Object.values(resource_BuildThumbImageInfo)
                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                .forEach(imageValue => {
                                                    if (imageCount == 0) {
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                    }
                                                    imageCount = imageCount + 1;
                                                });

                                        }

                                        if (rankPoints > 0) {

                                            if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                            }
                                            else {
                                                intellisenseRankListing.push(<div id={"intellisenseSomePartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                            }
                                        }
                                        else {
                                            intellisenseSomePartialListing.push(<div id={"intellisenseSomePartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                        }



                                        if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                            var overviewShortText = value['overviewShortText'];
                                            if (overviewShortText.length == 0) {
                                                //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                overviewShortText = <span>Description not available.</span>;
                                            }

                                            var valueRank = value['rankName'];
                                            if (valueRank == "" || valueRank == null) {
                                                valueRank = "None";
                                            }
                                            var valueRankIcon = value['rankFontAwesomeIcon'];
                                            if (valueRankIcon == "" || valueRankIcon == null) {
                                                valueRankIcon = "";
                                            }
                                            filteredCount = filteredCount + 1;


                                            if (rankPoints > 0) {

                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                }
                                                else {

                                                    var voteContainer = [];
                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                    voteContainer.push(upvoteData);
                                                    voteContainer.push(downvoteData);
                                                    var voteTable = []
                                                    voteTable.push(
                                                        <td className="resource_Body_Voting_Container">
                                                            <div className="result_VoteContainer">
                                                                {voteContainer}
                                                            </div>
                                                        </td>
                                                    );
                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                        voteTable = [];
                                                    }


                                                    var qrsInfo;
                                                    qrsInfo = [];

                                                    if (value['qrsYear'] == null) {

                                                    }
                                                    else {
                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                        </span>);
                                                    }


                                                    bodySomePartialListing.push({
                                                        element:
                                                            <div id={"bodySomePartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                <table className="resource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                {mainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                </span>

                                                                            </td>
                                                                            {voteTable}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                            </div>,
                                                        rank: rankPoints,
                                                        score: voteTotal,
                                                        externalId: value['externalId']
                                                    })
                                                }
                                            }
                                            else {

                                                var voteContainer = [];
                                                voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                voteContainer.push(upvoteData);
                                                voteContainer.push(downvoteData);
                                                var voteTable = []
                                                voteTable.push(
                                                    <td className="resource_Body_Voting_Container">
                                                        <div className="result_VoteContainer">
                                                            {voteContainer}
                                                        </div>
                                                    </td>
                                                );
                                                if (value['resourceType'] == "Quality & Research Symposium") {
                                                    voteTable = [];
                                                }

                                                var qrsInfo;
                                                qrsInfo = [];

                                                if (value['qrsYear'] == null) {

                                                }
                                                else {
                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                        {(value['qrsYear'].length > 0)? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                    </span>);
                                                }

                                                bodySomePartialListing.push({
                                                    element:
                                                        <div id={"bodySomePartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                            <table className="resource_Body_Table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                            {mainImageData}
                                                                        </td>
                                                                        <td>{favoriteData}</td>
                                                                        <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className="resource_Body_Content" >
                                                                                <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{ qrsInfo}</div>
                                                                                <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                <div className="resource_Body_Text_Overflow"></div>
                                                                                <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                            </span>

                                                                        </td>
                                                                        {voteTable}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                        </div>,
                                                    rank: rankPoints,
                                                    score: voteTotal,
                                                    externalId: value['externalId']
                                                })
                                            }

                                        }

                                    });

                            }


                            //only go more indepth if still nothing else comes up.
                            if (resourceCount < 20) {

                                Object.values(resource_IntellisenseInfo)
                                    .filter(value => {
                                        const overviewShortText = value['overviewShortText'];
                                        if (overviewShortText && overviewShortText.trim) {
                                            const trimmedText = overviewShortText.trim().toLowerCase();
                                            return searchText.toLowerCase().split(" ").every(element => trimmedText.indexOf(element) !== -1);
                                        }
                                        return false;
                                    })
                                    .forEach(value => {
                                        intellisenseCount = intellisenseCount + 1;
                                        resourceCount = resourceCount + 1;
                                        bodyCount = bodyCount + 1;
                                        var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                        var highlightedText = value['overviewShortText'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                        highlightedText = ReactHtmlParser(highlightedText);

                                        if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                            resultResourceTypeFilterList.push(value['resourceType']);
                                        }

                                        if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                            resultReportTypeFilterList.push(value['reportType']);
                                        }

                                        if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                            resultQRSYearFilterList.push(value['qrsYear']);
                                        }

                                        if (!resultRankFilterList.includes(value['rankName'])) {
                                            resultRankFilterList.push(value['rankName']);
                                        }
                                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                                        }, 0);

                                        var rankPoints = parseInt(value['rankPoints']);

                                        var upvoteData;
                                        upvoteData = [];

                                        var downvoteData;
                                        downvoteData = [];

                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                            Object.values(thisReportVotes)
                                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                .forEach(value => {
                                                    if (value['ratingPoints'] > 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                    }
                                                    else if (value['ratingPoints'] < 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                    }
                                                });

                                        }

                                        var favoriteData;
                                        favoriteData = [];
                                        var favoriteDataIntellisense;
                                        favoriteDataIntellisense = [];
                                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                            favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                        }
                                        else {
                                            favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                        }

                                        var mainImageData;

                                        var filterResourcesIcon = "";
                                        var filterIcon = "";
                                        switch (value['resourceType']) {
                                            case "Report":
                                                reportCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                break;
                                            case "Report Category":
                                                reportCategoryCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                break;
                                            case "Quality & Research Symposium":
                                                qrsCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                break;
                                            case "Action Plan":
                                                actionPlanCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                break;
                                            case "Stakeholder":
                                                stakeholderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "Metric":
                                                metricCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                break;
                                            case "Business Term":
                                                businessTermCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                break;
                                            case "Component":
                                                componentCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                break;
                                            case "Acronym":
                                                acronymCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                break;

                                            case "CCN Business Lead":
                                                ccnBusinessLeadCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                break;
                                            case "CCN CME Program":
                                                ccnCMEProgramCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "CCN EMR System":
                                                ccnEMRSystemCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                break;
                                            case "CCN Value Based Contract":
                                                ccnValueBasedContractCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                break;
                                            case "CCN Provider":
                                                ccnProviderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                break;
                                            case "CCN Provider Specialty":
                                                ccnProviderSpecialtyCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                break;
                                            case "CCN Practice Manager":
                                                ccnPracticeManagerCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                break;
                                            case "CCN Practice":
                                                ccnPracticeCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                break;
                                        }
                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                        var imageCount = 0;
                                        Object.values(resource_BuildImageInfo)
                                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                            .forEach(imageValue => {
                                                if (imageCount == 0) {
                                                    mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                }
                                                imageCount = imageCount + 1;
                                            });


                                        if (imageCount == 0) {

                                            Object.values(resource_BuildThumbImageInfo)
                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                .forEach(imageValue => {
                                                    if (imageCount == 0) {
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                    }
                                                    imageCount = imageCount + 1;
                                                });

                                        }

                                        if (rankPoints > 0) {

                                            if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                            }
                                            else {
                                                intellisenseRankListing.push(<div id={"intellisenseAllPartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                            }
                                        }
                                        else {
                                            intellisenseAllPartialListing.push(<div id={"intellisenseAllPartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                        }


                                        if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                            var overviewShortText = value['overviewShortText'];
                                            if (overviewShortText.length == 0) {
                                                //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                overviewShortText = <span>Description not available.</span>;
                                            }

                                            var valueRank = value['rankName'];
                                            if (valueRank == "" || valueRank == null) {
                                                valueRank = "None";
                                            }
                                            var valueRankIcon = value['rankFontAwesomeIcon'];
                                            if (valueRankIcon == "" || valueRankIcon == null) {
                                                valueRankIcon = "";
                                            }
                                            filteredCount = filteredCount + 1;


                                            if (rankPoints > 0) {

                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                }
                                                else {

                                                    var voteContainer = [];
                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                    voteContainer.push(upvoteData);
                                                    voteContainer.push(downvoteData);
                                                    var voteTable = []
                                                    voteTable.push(
                                                        <td className="resource_Body_Voting_Container">
                                                            <div className="result_VoteContainer">
                                                                {voteContainer}
                                                            </div>
                                                        </td>
                                                    );
                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                        voteTable = [];
                                                    }



                                                    var qrsInfo;
                                                    qrsInfo = [];

                                                    if (value['qrsYear'] == null) {

                                                    }
                                                    else {
                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                        </span>);
                                                    }


                                                    bodyRankListing.push({
                                                        element:
                                                            <div id={"bodyAllPartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                <table className="resource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                {mainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                </span>

                                                                            </td>
                                                                            {voteTable}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                            </div>,
                                                        rank: rankPoints,
                                                        score: voteTotal,
                                                        externalId: value['externalId']
                                                    })
                                                }
                                            }
                                            else {

                                                var voteContainer = [];
                                                voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                voteContainer.push(upvoteData);
                                                voteContainer.push(downvoteData);
                                                var voteTable = []
                                                voteTable.push(
                                                    <td className="resource_Body_Voting_Container">
                                                        <div className="result_VoteContainer">
                                                            {voteContainer}
                                                        </div>
                                                    </td>
                                                );
                                                if (value['resourceType'] == "Quality & Research Symposium") {
                                                    voteTable = [];
                                                }


                                                var qrsInfo;
                                                qrsInfo = [];

                                                if (value['qrsYear'] == null) {

                                                }
                                                else {
                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                        {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                    </span>);
                                                }


                                                bodyAllPartialListing.push({
                                                    element:
                                                        <div id={"bodyAllPartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                            <table className="resource_Body_Table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                            {mainImageData}
                                                                        </td>
                                                                        <td>{favoriteData}</td>
                                                                        <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className="resource_Body_Content" >
                                                                                <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</div>
                                                                                <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{highlightedText}</div>
                                                                                <div className="resource_Body_Text_Overflow"></div>
                                                                                <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                            </span>

                                                                        </td>
                                                                        {voteTable}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                        </div>,
                                                    rank: rankPoints,
                                                    score: voteTotal,
                                                    externalId: value['externalId']
                                                })
                                            }
                                        }

                                    });

                            }


                            if (resourceCount == 0) {
                                Object.values(resource_IntellisenseInfo)
                                    .filter(value => {
                                        const overviewShortText = value['overviewShortText'];
                                        if (overviewShortText) {
                                            const trimmedText = overviewShortText.trim ? overviewShortText.trim().toLowerCase() : overviewShortText.toLowerCase();
                                            const filteredSearchText = searchText
                                                .toLowerCase()
                                                .split(" ")
                                                .filter(value => value.toString().toLowerCase().length > 2);
                                            return filteredSearchText.some(element => trimmedText.indexOf(element) !== -1);
                                        }
                                        return false;
                                    })
                                    .forEach(value => {
                                        intellisenseCount = intellisenseCount + 1;
                                        resourceCount = resourceCount + 1;
                                        bodyCount = bodyCount + 1;
                                        var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                        var highlightedText = value['overviewShortText'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                        highlightedText = ReactHtmlParser(highlightedText);


                                        if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                            resultResourceTypeFilterList.push(value['resourceType']);
                                        }

                                        if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                            resultReportTypeFilterList.push(value['reportType']);
                                        }

                                        if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                            resultQRSYearFilterList.push(value['qrsYear']);
                                        }

                                        if (!resultRankFilterList.includes(value['rankName'])) {
                                            resultRankFilterList.push(value['rankName']);
                                        }
                                        var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                        var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                            return parseInt(prev) + parseInt(cur['ratingPoints']);
                                        }, 0);

                                        var rankPoints = parseInt(value['rankPoints']);

                                        var upvoteData;
                                        upvoteData = [];

                                        var downvoteData;
                                        downvoteData = [];

                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                        if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                            Object.values(thisReportVotes)
                                                .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                .forEach(value => {
                                                    if (value['ratingPoints'] > 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                    }
                                                    else if (value['ratingPoints'] < 0) {

                                                        upvoteData = [];
                                                        downvoteData = [];
                                                        upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                        downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                    }
                                                });

                                        }

                                        var favoriteData;
                                        favoriteData = [];
                                        var favoriteDataIntellisense;
                                        favoriteDataIntellisense = [];
                                        if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                            favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                        }
                                        else {
                                            favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                            favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                        }

                                        var mainImageData;

                                        var filterResourcesIcon = "";
                                        var filterIcon = "";
                                        switch (value['resourceType']) {
                                            case "Report":
                                                reportCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                break;
                                            case "Report Category":
                                                reportCategoryCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                break;
                                            case "Quality & Research Symposium":
                                                qrsCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                break;
                                            case "Action Plan":
                                                actionPlanCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                break;
                                            case "Stakeholder":
                                                stakeholderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "Metric":
                                                metricCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                break;
                                            case "Business Term":
                                                businessTermCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                break;
                                            case "Component":
                                                componentCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                break;
                                            case "Acronym":
                                                acronymCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                break;

                                            case "CCN Business Lead":
                                                ccnBusinessLeadCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                break;
                                            case "CCN CME Program":
                                                ccnCMEProgramCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                break;
                                            case "CCN EMR System":
                                                ccnEMRSystemCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                break;
                                            case "CCN Value Based Contract":
                                                ccnValueBasedContractCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                break;
                                            case "CCN Provider":
                                                ccnProviderCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                break;
                                            case "CCN Provider Specialty":
                                                ccnProviderSpecialtyCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                break;
                                            case "CCN Practice Manager":
                                                ccnPracticeManagerCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                break;
                                            case "CCN Practice":
                                                ccnPracticeCount++;
                                                filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                break;
                                        }
                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                        var imageCount = 0;
                                        Object.values(resource_BuildImageInfo)
                                            .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                            .forEach(imageValue => {
                                                if (imageCount == 0) {
                                                    mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                }
                                                imageCount = imageCount + 1;
                                            });


                                        if (imageCount == 0) {

                                            Object.values(resource_BuildThumbImageInfo)
                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                .forEach(imageValue => {
                                                    if (imageCount == 0) {
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                    }
                                                    imageCount = imageCount + 1;
                                                });

                                        }


                                        if (rankPoints > 0) {

                                            if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                            }
                                            else {
                                                intellisenseRankListing.push(<div id={"intellisenseSomePartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                            }
                                        }
                                        else {
                                            intellisenseSomePartialListing.push(<div id={"intellisenseSomePartialListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                        }



                                        if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                            var overviewShortText = value['overviewShortText'];
                                            if (overviewShortText.length == 0) {
                                                //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                overviewShortText = <span>Description not available.</span>;
                                            }

                                            var valueRank = value['rankName'];
                                            if (valueRank == "" || valueRank == null) {
                                                valueRank = "None";
                                            }
                                            var valueRankIcon = value['rankFontAwesomeIcon'];
                                            if (valueRankIcon == "" || valueRankIcon == null) {
                                                valueRankIcon = "";
                                            }
                                            filteredCount = filteredCount + 1;


                                            if (rankPoints > 0) {

                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                }
                                                else {

                                                    var voteContainer = [];
                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                    voteContainer.push(upvoteData);
                                                    voteContainer.push(downvoteData);
                                                    var voteTable = []
                                                    voteTable.push(
                                                        <td className="resource_Body_Voting_Container">
                                                            <div className="result_VoteContainer">
                                                                {voteContainer}
                                                            </div>
                                                        </td>
                                                    );
                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                        voteTable = [];
                                                    }



                                                    var qrsInfo;
                                                    qrsInfo = [];

                                                    if (value['qrsYear'] == null) {

                                                    }
                                                    else {
                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                        </span>);
                                                    }


                                                    bodyRankListing.push({
                                                        element:
                                                            <div id={"bodySomePartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                <table className="resource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                {mainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                </span>

                                                                            </td>
                                                                            {voteTable}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                            </div>,
                                                        rank: rankPoints,
                                                        score: voteTotal,
                                                        externalId: value['externalId']
                                                    })
                                                }
                                            }
                                            else {

                                                var voteContainer = [];
                                                voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                voteContainer.push(upvoteData);
                                                voteContainer.push(downvoteData);
                                                var voteTable = []
                                                voteTable.push(
                                                    <td className="resource_Body_Voting_Container">
                                                        <div className="result_VoteContainer">
                                                            {voteContainer}
                                                        </div>
                                                    </td>
                                                );
                                                if (value['resourceType'] == "Quality & Research Symposium") {
                                                    voteTable = [];
                                                }


                                                var qrsInfo;
                                                qrsInfo = [];

                                                if (value['qrsYear'] == null) {

                                                }
                                                else {
                                                    qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                        {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                    </span>);
                                                }



                                                bodySomePartialListing.push({
                                                    element:
                                                        <div id={"bodySomePartialListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                            <table className="resource_Body_Table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                            {mainImageData}
                                                                        </td>
                                                                        <td>{favoriteData}</td>
                                                                        <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                            <span className="resource_Body_Content" >
                                                                                <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</div>
                                                                                <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{highlightedText}</div>
                                                                                <div className="resource_Body_Text_Overflow"></div>
                                                                                <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                            </span>

                                                                        </td>
                                                                        {voteTable}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                        </div>,
                                                    rank: rankPoints,
                                                    score: voteTotal,
                                                    externalId: value['externalId']
                                                })
                                            }
                                        }

                                    });

                            }


                        }

                        if (resourceCount == 0) {
                            //similarityTagCheck

                            Object.values(resource_IntellisenseTagInfo)
                                .forEach(value => {
                                    similarTagCount = similarTagCount + 1;
                                    similarTagListLowercase.push(value.toLowerCase());
                                    similarTagList.push(value);
                                });
                            if (similarTagCount > 0) {

                                var matches = stringSimilarity.findBestMatch(searchText.substring(1).toLowerCase(), similarTagListLowercase);
                                var matchSorted = matches.ratings.sort((a, b) => (a.rating < b.rating) ? 1 : -1);
                                for (var closeResultIndex = 0; closeResultIndex < 5 && closeResultIndex < similarTagCount; closeResultIndex++) {
                                    bodyTagList.push(<div id={"bodySimilarListing_" + closeResultIndex} onClick={this._handleSimilarMouseClick.bind(this, '#' + matchSorted[closeResultIndex].target)} ref={"resource_Body_" + closeResultIndex} className="resource_Similar"><span alt={"Search: " + '#' + matchSorted[closeResultIndex].target} title={"Search: " + '#' + matchSorted[closeResultIndex].target}>{'#' + matchSorted[closeResultIndex].target}</span><input ref={"resource_Body_Value_" + closeResultIndex} className="hidden" defaultValue={'#' + matchSorted[closeResultIndex].target} /><i className="similarLink fal fa-external-link-square"></i></div>)
                                }

                            }
                            //similarityCheck

                            Object.values(resource_IntellisenseInfo)
                                .forEach(value => {
                                    similarCount = similarCount + 1;
                                    similarListLowercase.push(value['resourceName'].toLowerCase());
                                    similarList.push(value['resourceName']);
                                });

                            if (similarCount > 0) {
                                var matches = stringSimilarity.findBestMatch(searchText.toLowerCase(), similarListLowercase);
                                var matchSorted = matches.ratings.sort((a, b) => (a.rating < b.rating) ? 1 : -1);
                                for (var closeResultIndex = 0; closeResultIndex < 5; closeResultIndex++) {
                                    bodySimilarList.push(<div id={"bodySimilarListing_" + closeResultIndex} onClick={this._handleSimilarMouseClick.bind(this, matchSorted[closeResultIndex].target)} ref={"resource_Body_" + closeResultIndex} className="resource_Similar"><span alt={"Search: " + matchSorted[closeResultIndex].target} title={"Search: " + matchSorted[closeResultIndex].target}>{matchSorted[closeResultIndex].target}</span><input ref={"resource_Body_Value_" + closeResultIndex} className="hidden" defaultValue={matchSorted[closeResultIndex].target} /><i className="similarLink fal fa-external-link-square"></i></div>)
                                }
                            }
                        }
                        dateEndSearch = new Date();

                    }

                    if (resourceCount > 0) {
                        if (historyCount > 0) {
                            intellisenseList.push(<div className="intellisenseSeparator"></div>);
                        }
                        intellisenseAllResultsRankListing = Object.entries(intellisenseAllResultsRankListing).sort((a, b) => a[1].rank - b[1].rank).reverse();
                        intellisenseRankListing = Object.entries(intellisenseRankListing).sort((a, b) => a[1].rank - b[1].rank).reverse();
                        intellisenseMatchListing = Object.entries(intellisenseMatchListing).sort((a, b) => a[1] - b[1]);
                        intellisenseStartsWithListing = Object.entries(intellisenseStartsWithListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        intellisenseExactListing = Object.entries(intellisenseExactListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        intellisenseAllPartialListing = Object.entries(intellisenseAllPartialListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        intellisenseSomePartialListing = Object.entries(intellisenseSomePartialListing).sort((a, b) => a[1].score - b[1].score).reverse();

                        var intellisenseAllResultsRankListing_Elements = [];
                        var intellisenseRankListing_Elements = [];
                        var intellisenseMatchListing_Elements = [];
                        var intellisenseStartsWithListing_Elements = [];
                        var intellisenseExactListing_Elements = [];
                        var intellisenseAllPartialListing_Elements = [];
                        var intellisenseSomePartialListing_Elements = [];
                        Object.values(intellisenseAllResultsRankListing)
                            .forEach(value => {
                                intellisenseAllResultsRankListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseRankListing)
                            .forEach(value => {
                                intellisenseRankListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseMatchListing)
                            .forEach(value => {
                                intellisenseMatchListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseStartsWithListing)
                            .forEach(value => {
                                intellisenseStartsWithListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseExactListing)
                            .forEach(value => {
                                intellisenseExactListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseAllPartialListing)
                            .forEach(value => {
                                intellisenseAllPartialListing_Elements.push(value[1]);
                            });
                        Object.values(intellisenseSomePartialListing)
                            .forEach(value => {
                                intellisenseSomePartialListing_Elements.push(value[1]);
                            });


                        intellisenseList.push(intellisenseAllResultsRankListing_Elements);
                        intellisenseList.push(intellisenseRankListing_Elements);
                        intellisenseList.push(intellisenseMatchListing_Elements);
                        intellisenseList.push(intellisenseStartsWithListing_Elements);
                        intellisenseList.push(intellisenseExactListing_Elements);
                        intellisenseList.push(intellisenseAllPartialListing_Elements);
                        intellisenseList.push(intellisenseSomePartialListing_Elements);

                        bodyAllResultsRankListing = Object.entries(bodyAllResultsRankListing).sort((a, b) => a[1].rank - b[1].rank).reverse();
                        bodyRankListing = Object.entries(bodyRankListing).sort((a, b) => a[1].rank - b[1].rank).reverse();
                        bodyMatchListing = Object.entries(bodyMatchListing).sort((a, b) => a[1] - b[1]);
                        bodyStartsWithListing = Object.entries(bodyStartsWithListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        bodyExactListing = Object.entries(bodyExactListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        bodyAllPartialListing = Object.entries(bodyAllPartialListing).sort((a, b) => a[1].score - b[1].score).reverse();
                        bodySomePartialListing = Object.entries(bodySomePartialListing).sort((a, b) => a[1].score - b[1].score).reverse();

                        var relationshipRankListing = [];
                        var relationshipRankListing_Elements = [];
                        var relationshipReportListing = [];
                        var relationshipReportListing_Elements = [];
                        var bodyAllResultsRankListing_Elements = [];
                        var bodyRankListing_Elements = [];
                        var bodyMatchListing_Elements = [];
                        var bodyStartsWithListing_Elements = [];
                        var bodyExactListing_Elements = [];
                        var bodyAllPartialListing_Elements = [];
                        var bodySomePartialListing_Elements = [];
                        var bodyResults_Elements = [];

                        var externalIdList = [];

                        Object.values(bodyAllResultsRankListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyAllResultsRankListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });

                        Object.values(bodyRankListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyRankListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });
                        Object.values(bodyMatchListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyMatchListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });
                        Object.values(bodyStartsWithListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyStartsWithListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });
                        Object.values(bodyExactListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyExactListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });
                        Object.values(bodyAllPartialListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodyAllPartialListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });
                        Object.values(bodySomePartialListing)
                            .forEach(value => {
                                if (!externalIdList.includes(value[1].externalId)) {
                                    externalIdList.push(value[1].externalId);
                                    bodySomePartialListing_Elements.push(value[1].element);
                                    bodyResults_Elements.push(value[1]);
                                }
                            });



                        if (reportCount == 0 && (metricCount > 0 || stakeholderCount > 0 || businessTermCount > 0 || componentCount > 0 || acronymCount > 0)) {

                            this.checkSearchRelationships(bodyResults_Elements);
                            var bodyExternalIdList = [];
                            for (var key in bodyResults_Elements) {
                                bodyExternalIdList.push(bodyResults_Elements[key]['externalId']);
                            }
                            if (bodyExternalIdList.length != 0) {

                                var displaysInReports = Object.values(this.state.resource_BuildDisplaysInInfo).filter(e => bodyExternalIdList.includes(e.relationshipExternalId));

                                if (Object.keys(displaysInReports).length > 0) {


                                    var displaysInReportsList = [];
                                    Object.values(displaysInReports).forEach(value => {
                                        displaysInReportsList.push(value['sourceExternalId']);
                                    });
                                    //NEED TO REPLACE OUT THE FILTER LIST TO BE A LIST OF THE SOURCE EXTERNAL ID'S FROM (displaysInReports);
                                    Object.values(resource_IntellisenseInfo)
                                        .filter(value => (displaysInReportsList.includes(value['externalId'])))
                                        .forEach(value => {
                                            intellisenseCount = intellisenseCount + 1;
                                            bodyCount = bodyCount + 1;
                                            resourceCount = resourceCount + 1;
                                            //var highlightedText = value['resourceName'].split(this.state.currentSearchText).join(<span className='highlight'>{this.state.currentSearchText}</span>);
                                            var highlightedRegex = new RegExp(this.state.currentSearchText.replace(/[^\w\s]/gi, ''), "ig");
                                            var highlightedText = value['resourceName'].replace(highlightedRegex, function (str) { return "<b>" + str + "</b>" });
                                            highlightedText = ReactHtmlParser(highlightedText);

                                            if (!resultResourceTypeFilterList.includes(value['resourceType'])) {
                                                resultResourceTypeFilterList.push(value['resourceType']);
                                            }

                                            if (!resultReportTypeFilterList.includes(value['reportType'])) {
                                                resultReportTypeFilterList.push(value['reportType']);
                                            }

                                            if (!resultQRSYearFilterList.includes(value['qrsYear'])) {
                                                resultQRSYearFilterList.push(value['qrsYear']);
                                            }

                                            if (!resultRankFilterList.includes(value['rankName'])) {
                                                resultRankFilterList.push(value['rankName']);
                                            }
                                            var thisReportVotes = Object.values(user_RatingsInfo).filter(vote => (vote['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())

                                            var voteTotal = thisReportVotes.reduce(function (prev, cur) {
                                                return parseInt(prev) + parseInt(cur['ratingPoints']);
                                            }, 0);

                                            var rankPoints = parseInt(value['rankPoints']);

                                            var upvoteData;
                                            upvoteData = [];

                                            var downvoteData;
                                            downvoteData = [];

                                            upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                            downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);


                                            if (Object.values(thisReportVotes).some(e => e.idUser == this.state.user_AccountInfo.idUser)) {
                                                Object.values(thisReportVotes)
                                                    .filter(value => (value['idUser']).toString() == this.state.user_AccountInfo.idUser)
                                                    .forEach(value => {
                                                        if (value['ratingPoints'] > 0) {

                                                            upvoteData = [];
                                                            downvoteData = [];
                                                            upvoteData.push(<i className="searchUpvote upvote_Selected fas fa-thumbs-up" title="Remove Upvote" alt="Remove Upvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                            downvoteData.push(<i className="searchDownvote downvote_NotSelected fal fa-thumbs-down" title="Downvote" alt="Downvote" onClick={this._downvoteResource.bind(this, value['externalId'])}></i>);
                                                        }
                                                        else if (value['ratingPoints'] < 0) {

                                                            upvoteData = [];
                                                            downvoteData = [];
                                                            upvoteData.push(<i className="searchUpvote upvote_NotSelected fal fa-thumbs-up" title="Upvote" alt="Upvote" onClick={this._upvoteResource.bind(this, value['externalId'])}></i>);
                                                            downvoteData.push(<i className="searchDownvote downvote_Selected fas fa-thumbs-down" title="Remove Downvote" alt="Remove Downvote" onClick={this._removeResourceVote.bind(this, value['externalId'])}></i>);
                                                        }
                                                    });

                                            }

                                            var favoriteData;
                                            favoriteData = [];
                                            var favoriteDataIntellisense;
                                            favoriteDataIntellisense = [];
                                            if (Object.values(user_FavoritesInfo).some(e => e.externalId == value['externalId'])) {
                                                favoriteDataIntellisense.push(<i className="searchFavorite intellisenseStar fas fa-star"></i>)
                                                favoriteData.push(<i className="searchResource_BodyStar searchFavorite fas fa-star" alt="Remove Favorite" title="Remove Favorite" onClick={this._removeUserFavorite.bind(this, value['externalId'])} ></i>);
                                            }
                                            else {
                                                favoriteDataIntellisense.push(<i className="searchNoFavorite intellisenseStar fal fa-star"></i>)
                                                favoriteData.push(<i className="searchResource_BodyStar searchNoFavorite fal fa-star" alt="Add Favorite" title="Add Favorite" onClick={this._addUserFavorite.bind(this, value['externalId'])}></i>)
                                            }

                                            var mainImageData;

                                            var filterResourcesIcon = "";
                                            var filterIcon = "";
                                            switch (value['resourceType']) {
                                                case "Report":
                                                    reportCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-chart-column"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-chart-column"></i>;
                                                    break;
                                                case "Report Category":
                                                    reportCategoryCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-layer-group"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-layer-group"></i>;
                                                    break;
                                                case "Quality & Research Symposium":
                                                    qrsCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-book-medical"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-book-medical"></i>;
                                                    break;
                                                case "Action Plan":
                                                    actionPlanCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-ballot-check"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-ballot-check"></i>;
                                                    break;
                                                case "Stakeholder":
                                                    stakeholderCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                    break;
                                                case "Metric":
                                                    metricCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon far fa-scrubber"></i>;
                                                    filterIcon = <i className="results_Icon far fa-scrubber"></i>;
                                                    break;
                                                case "Business Term":
                                                    businessTermCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-alt"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-file-alt"></i>;
                                                    break;
                                                case "Component":
                                                    componentCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-microchip"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-microchip"></i>;
                                                    break;
                                                case "Acronym":
                                                    acronymCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-comment-alt-check"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-comment-alt-check"></i>;
                                                    break;

                                                case "CCN Business Lead":
                                                    ccnBusinessLeadCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-tie"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-user-tie"></i>;
                                                    break;
                                                case "CCN CME Program":
                                                    ccnCMEProgramCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-chart"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-user-chart"></i>;
                                                    break;
                                                case "CCN EMR System":
                                                    ccnEMRSystemCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-medical"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-file-medical"></i>;
                                                    break;
                                                case "CCN Value Based Contract":
                                                    ccnValueBasedContractCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-file-contract"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-file-contract"></i>;
                                                    break;
                                                case "CCN Provider":
                                                    ccnProviderCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-user-md"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-user-md"></i>;
                                                    break;
                                                case "CCN Provider Specialty":
                                                    ccnProviderSpecialtyCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-trophy-star"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-trophy-star"></i>;
                                                    break;
                                                case "CCN Practice Manager":
                                                    ccnPracticeManagerCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-hospital-user"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-hospital-user"></i>;
                                                    break;
                                                case "CCN Practice":
                                                    ccnPracticeCount++;
                                                    filterResourcesIcon = <i className="results_noPhotoIcon fal fa-clinic-medical"></i>;
                                                    filterIcon = <i className="results_Icon fal fa-clinic-medical"></i>;
                                                    break;
                                            }
                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td>{filterResourcesIcon}<div className="results_noPhotoText">{value['resourceType']}</div></td></tr></tbody></table>;

                                            var imageCount = 0;
                                            Object.values(resource_BuildImageInfo)
                                                .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                .forEach(imageValue => {
                                                    if (imageCount == 0) {
                                                        mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64']} /></td></tr></tbody></table>;
                                                    }
                                                    imageCount = imageCount + 1;
                                                });

                                            if (imageCount == 0) {

                                                Object.values(resource_BuildThumbImageInfo)
                                                    .filter(imageValue => (imageValue['externalId']).toString().toLowerCase() == (value['externalId']).toString().toLowerCase())
                                                    .forEach(imageValue => {
                                                        if (imageCount == 0) {
                                                            mainImageData = <table ref="resultImage_Container" className="fill resultImage"><tbody><tr><td><img className="resultImageContent" src={imageValue['imageBase64_thumb']} /></td></tr></tbody></table>;
                                                        }
                                                        imageCount = imageCount + 1;
                                                    });

                                            }


                                            if (rankPoints > 0) {

                                                if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                }
                                                else {
                                                    intellisenseRankListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                                }
                                            }
                                            else {
                                                intellisenseMatchListing.push(<div id={"intellisenseMatchListing_" + intellisenseCount} onClick={this._handleSingleResultMouseClick.bind(this, value['externalId'], value['resourceName'])} onMouseOver={this._handleMouseOver.bind(this, intellisenseCount, value['resourceName'])} ref={"resource_Intellisense_" + intellisenseCount} className="resource_Intellisense">{favoriteDataIntellisense}<span alt={value['resourceName']} title={value['resourceName']}>{value['resourceName']}</span><input ref={"resource_Intellisense_Value_" + intellisenseCount} className={"hidden resource_Intellisense_Value_" + intellisenseCount} defaultValue={value['resourceName']} /><input ref={"resource_Intellisense_Type_" + intellisenseCount} className={"hidden resource_Intellisense_Type_" + intellisenseCount} defaultValue="singleResult" /><input ref={"resource_Intellisense_ExternalId_" + intellisenseCount} className={"hidden resource_Intellisense_ExternalId_" + intellisenseCount} defaultValue={value['externalId']} /></div>)
                                            }


                                            if ((value['resourceType'] == filterResourceType || filterResourceType == "All" || ("Report & Report Category" == filterResourceType && (value['resourceType'] == "Report" || value['resourceType'] == "Report Category"))) && (value['reportType'] == filterReportType || filterReportType == "") && (value['rankName'] == filterRankType || filterRankType == "") && (value['qrsYear'] == filterQRSYear || filterQRSYear == "")) {

                                                var overviewShortText = value['overviewShortText'];
                                                if (overviewShortText.length == 0) {
                                                    //overviewShortText = <span className="notAvailableDescription">Description not available.</span>;
                                                    overviewShortText = <span>Description not available.</span>;
                                                }

                                                var valueRank = value['rankName'];
                                                if (valueRank == "" || valueRank == null) {
                                                    valueRank = "None";
                                                }
                                                var valueRankIcon = value['rankFontAwesomeIcon'];
                                                if (valueRankIcon == "" || valueRankIcon == null) {
                                                    valueRankIcon = "";
                                                }
                                                filteredCount = filteredCount + 1;

                                                if (rankPoints > 0) {

                                                    if (value['rankIsInAllResults'] == true && (new Date(value['rankDtEnd']) > today)) {

                                                    }
                                                    else {

                                                        var voteContainer = [];
                                                        voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                        voteContainer.push(upvoteData);
                                                        voteContainer.push(downvoteData);
                                                        var voteTable = []
                                                        voteTable.push(
                                                            <td className="resource_Body_Voting_Container">
                                                                <div className="result_VoteContainer">
                                                                    {voteContainer}
                                                                </div>
                                                            </td>
                                                        );
                                                        if (value['resourceType'] == "Quality & Research Symposium") {
                                                            voteTable = [];
                                                        }



                                                        var qrsInfo;
                                                        qrsInfo = [];

                                                        if (value['qrsYear'] == null) {

                                                        }
                                                        else {
                                                            qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                                {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                            </span>);
                                                        }


                                                        relationshipRankListing.push({
                                                            element:
                                                                <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                    <table className="resource_Body_Table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                    {mainImageData}
                                                                                </td>
                                                                                <td>{favoriteData}</td>
                                                                                <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                    <span className="resource_Body_Content" >
                                                                                        <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                        <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                        <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                        <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                        <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                        <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                        <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                        <div className="resource_Body_Text_Overflow"></div>
                                                                                        <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                        <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                    </span>

                                                                                </td>
                                                                                {voteTable}
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                                </div>,
                                                            rank: rankPoints,
                                                            score: voteTotal,
                                                            externalId: value['externalId']
                                                        })
                                                    }
                                                }
                                                else {

                                                    var voteContainer = [];
                                                    voteContainer.push(<div className="result_VoteTotal">{voteTotal}</div>);
                                                    voteContainer.push(upvoteData);
                                                    voteContainer.push(downvoteData);
                                                    var voteTable = []
                                                    voteTable.push(
                                                        <td className="resource_Body_Voting_Container">
                                                            <div className="result_VoteContainer">
                                                                {voteContainer}
                                                            </div>
                                                        </td>
                                                    );
                                                    if (value['resourceType'] == "Quality & Research Symposium") {
                                                        voteTable = [];
                                                    }


                                                    var qrsInfo;
                                                    qrsInfo = [];

                                                    if (value['qrsYear'] == null) {

                                                    }
                                                    else {
                                                        qrsInfo.push(<span className="resource_Body_QRSYear" alt={value['qrsYear']} title={value['qrsYear']}>
                                                            {(value['qrsYear'].length > 0) ? "(" : ""} {value['qrsYear']} {(value['qrsYear'].length > 0) ? ")" : ""}
                                                        </span>);
                                                    }

                                                    relationshipReportListing.push({
                                                        element:
                                                            <div id={"bodyMatchListing_" + bodyCount} ref={"resource_body_" + bodyCount} className="resource_Body">
                                                                <table className="resource_Body_Table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="resource_Body_Image_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className={"searchResultIcon_" + valueRank} title={valueRank}><i className={valueRankIcon}></i></span>
                                                                                {mainImageData}
                                                                            </td>
                                                                            <td>{favoriteData}</td>
                                                                            <td className="resource_Body_Content_Container" onClick={this._showSingleResultWithSearch.bind(this, value['externalId'], value['resourceName'], searchText)}>
                                                                                <span className="resource_Body_Content" >
                                                                                    <span alt={value['externalId']} title={value['externalId']} className="hidden">{value['externalId']}</span>
                                                                                    <div className="resource_Body_Title" alt={value['resourceName']} title={value['resourceName']}>{highlightedText}</div>
                                                                                    <div className="resource_Body_ResourceType" alt={value['resourceType']} title={value['resourceType']}>{filterIcon} {value['resourceType']} <span className="resource_Body_ReportType" alt={value['reportType']} title={value['reportType']}>{(value['reportType'].length > 0) ? "(" : ""} {value['reportType']} {(value['reportType'].length > 0) ? ")" : ""}</span>{qrsInfo}</div>
                                                                                    <span alt={value['dtExternallyCreated']} title={value['dtExternallyCreated']} className="hidden">{value['dtExternallyCreated']}</span>
                                                                                    <span alt={value['dtExternallyModified']} title={value['dtExternallyModified']} className="hidden">{value['dtExternallyModified']}</span>
                                                                                    <span alt={value['externalStatus']} title={value['externalStatus']} className="hidden">{value['externalStatus']}</span>
                                                                                    <div className="resource_Body_Text" alt={value['overviewShortText']} title={value['overviewShortText']}>{overviewShortText}</div>
                                                                                    <div className="resource_Body_Text_Overflow"></div>
                                                                                    <span className="hidden" alt={value['createdByFirstName'] + " " + value['createdByLastName']} title={value['createdByFirstName'] + " " + value['createdByLastName']}>{value['createdByFirstName'] + " " + value['createdByLastName']}</span>
                                                                                    <span className="hidden" alt={value['modifiedByFirstName'] + " " + value['modifiedByLastName']} title={value['modifiedByFirstName'] + " " + value['modifiedByLastName']}>{value['modifiedByFirstName'] + " " + value['modifiedByLastName']}</span>
                                                                                </span>

                                                                            </td>
                                                                            {voteTable}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <input ref={"resource_Body_Value_" + bodyCount} className="hidden" defaultValue={value['resourceName']} />
                                                            </div>,
                                                        rank: rankPoints,
                                                        score: voteTotal,
                                                        externalId: value['externalId']
                                                    })
                                                }

                                            }
                                        });

                                    relationshipRankListing = Object.entries(relationshipRankListing).sort((a, b) => a[1].rank - b[1].rank).reverse();

                                    var externalIdList = [];
                                    Object.values(relationshipRankListing)
                                        .forEach(value => {
                                            if (!externalIdList.includes(value[1].externalId)) {
                                                externalIdList.push(value[1].externalId);
                                                relationshipRankListing_Elements.push(value.element);
                                                bodyResults_Elements.push(value);
                                            }
                                        });

                                    Object.values(relationshipReportListing)
                                        .forEach(value => {
                                            if (!externalIdList.includes(value[1].externalId)) {
                                                externalIdList.push(value[1].externalId);
                                                relationshipReportListing_Elements.push(value.element);
                                                bodyResults_Elements.push(value);
                                            }
                                        });

                                    bodyList.push(relationshipRankListing_Elements);
                                    bodyList.push(relationshipReportListing_Elements);

                                }
                            }
                        }

                        bodyList.push(bodyAllResultsRankListing_Elements);
                        bodyList.push(bodyRankListing_Elements);
                        bodyList.push(bodyMatchListing_Elements);
                        bodyList.push(bodyStartsWithListing_Elements);
                        bodyList.push(bodyExactListing_Elements);
                        bodyList.push(bodyAllPartialListing_Elements);
                        bodyList.push(bodySomePartialListing_Elements);
                    }

                }

            }

            //Universal Below

            intellisenseList.push(<input ref="intellisenseCount" className="hidden" defaultValue={intellisenseCount} />);
            bodyList.push(<input ref="bodyCount" className="hidden" defaultValue={bodyCount} />);
            bodyList.push(<input ref="similarCount" className="hidden" defaultValue={similarCount} />);
            bodyList.push(<input ref="similarTagCount" className="hidden" defaultValue={similarTagCount} />);
            var bodyTitle_siteMode = [];


            var mode = "";

            if (this.state.permissionLevel != "" && !this.state.isEpicUser) {

                switch (this.state.siteMode) {
                    case "databayprd":
                        mode = "Production";
                        break;
                    case "databaydev":
                        mode = "Development";
                        break;
                    case "databayccnprd":
                        mode = "CCN Production";
                        break;
                    case "databayccndev":
                        mode = "CCN Development";
                        break;
                    default:
                        mode = "Production";
                }

            }
            if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
                bodyTitle_siteMode.push(<div className="bodyTitle_siteMode">Express</div>);
            }
            else if (this.state.isEpicUser && this.state.isHyperDriveUser) {
                bodyTitle_siteMode.push(<div className="bodyTitle_siteMode">HyperDrive</div>);
            }
            else {
                bodyTitle_siteMode.push(<div className="bodyTitle_siteMode">{mode}</div>);
            }

            var gameBlock = "gameBlock";

            var gameDate = new Date();
            var gameHours = gameDate.getHours();

            if (gameHours > 8 && gameHours < 17) {
                gameBlock = "hiddenGameBlock";
            }

            bodyInfo.push(
                <div ref="logoBody" className="logoBody">
                    <div ref="gameBlock" className={gameBlock} onClick={this._showGameResource.bind(this)}>
                    </div>
                    <div><i className="logoBodyImageTop fas fa-pennant"></i></div>
                    <div className="bodyLogoBlock"><img className="databay3BodyLogo" src={databay3Logo} alt="Databay 3" /></div>
                    <div className="oldbodyLogoBlock"><i ref="logoBodyImage" className="logoBodyImage fas fa-signal-alt"></i></div>
                    <div className="classicbodyLogoBlock"><img ref="logoBodyClassicImage" className="logoBodyClassicImage" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyUAAAEqCAYAAAALXf9jAAAACXBIWXMAAAsTAAALEwEAmpwYAAA4HGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICAgICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPHhtcDpDcmVhdG9yVG9vbD5BZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpPC94bXA6Q3JlYXRvclRvb2w+CiAgICAgICAgIDx4bXA6Q3JlYXRlRGF0ZT4yMDIxLTAxLTExVDEyOjU5OjQxLTA1OjAwPC94bXA6Q3JlYXRlRGF0ZT4KICAgICAgICAgPHhtcDpNb2RpZnlEYXRlPjIwMjEtMDEtMTFUMTM6MDI6NDEtMDU6MDA8L3htcDpNb2RpZnlEYXRlPgogICAgICAgICA8eG1wOk1ldGFkYXRhRGF0ZT4yMDIxLTAxLTExVDEzOjAyOjQxLTA1OjAwPC94bXA6TWV0YWRhdGFEYXRlPgogICAgICAgICA8ZGM6Zm9ybWF0PmltYWdlL3BuZzwvZGM6Zm9ybWF0PgogICAgICAgICA8cGhvdG9zaG9wOkNvbG9yTW9kZT4zPC9waG90b3Nob3A6Q29sb3JNb2RlPgogICAgICAgICA8eG1wTU06SW5zdGFuY2VJRD54bXAuaWlkOmUzYmQzY2ZkLTgxYjgtNjI0Yy05OGVmLTYzYmFlMzE3ODQ0YzwveG1wTU06SW5zdGFuY2VJRD4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+eG1wLmRpZDplM2JkM2NmZC04MWI4LTYyNGMtOThlZi02M2JhZTMxNzg0NGM8L3htcE1NOkRvY3VtZW50SUQ+CiAgICAgICAgIDx4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ+eG1wLmRpZDplM2JkM2NmZC04MWI4LTYyNGMtOThlZi02M2JhZTMxNzg0NGM8L3htcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOkhpc3Rvcnk+CiAgICAgICAgICAgIDxyZGY6U2VxPgogICAgICAgICAgICAgICA8cmRmOmxpIHJkZjpwYXJzZVR5cGU9IlJlc291cmNlIj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmFjdGlvbj5jcmVhdGVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6ZTNiZDNjZmQtODFiOC02MjRjLTk4ZWYtNjNiYWUzMTc4NDRjPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6d2hlbj4yMDIxLTAxLTExVDEyOjU5OjQxLTA1OjAwPC9zdEV2dDp3aGVuPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpPC9zdEV2dDpzb2Z0d2FyZUFnZW50PgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAgICAgPC9yZGY6U2VxPgogICAgICAgICA8L3htcE1NOkhpc3Rvcnk+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOlhSZXNvbHV0aW9uPjcyMDAwMC8xMDAwMDwvdGlmZjpYUmVzb2x1dGlvbj4KICAgICAgICAgPHRpZmY6WVJlc29sdXRpb24+NzIwMDAwLzEwMDAwPC90aWZmOllSZXNvbHV0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjY1NTM1PC9leGlmOkNvbG9yU3BhY2U+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj44MDU8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+Mjk4PC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgCjw/eHBhY2tldCBlbmQ9InciPz4PUGRxAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAHKOSURBVHja7J13eFVV2rcXvUMSpEmR3jsIKEiToqgU6VWKhN57KCkEEgjpzQAi2Ms4jo46Mzo2dHR01Bnf+RynOY511FFfdMZX9nPWfs73x1o7Z52dfU5OKJITflzXfUWTEGNy9t7PvZ4m/H6/AAAAAAAAAIBLBX4IAAAAAAAAAEgJAAAAAAAAAFICAAAAAAAAAJASAAAAAAAAAKQEAAAAAAAAACAlAAAAAAAAAEgJAAAAAAAAAEBKAAAAAAAAAJASAAAAAAAAAICUAAAAAAAAACAlAAAAAAAAAAApAQAAAAAAAEBKAAAAAAAAAABSAgAAAAAAAICUAAAAAAAAAACkBAAAAAAAAAApAQAAAAAAAABICQAAAAAAAABSAgAAAAAAAACQEgAAiCbOxCf9GDQ5E5/0hH57Qb82focAAAAgJQAAEI03XePPjyAkNc7EJ/3iTHyS/0x80i/1v1+wrx/uD37XAAAAICUAAAApEWfikzK1kDhkQUoAAABASgAAAFLyY0nJYpeQOCyGlAAAAICUAAAApORiS8k1Z+KTrBBSYumPQ0oAAABASgAAAFJyUYSkzZn4pM9DCInDF/rzICUAAAAgJQAAACm5oNQ/E5/0VjlC4vC2/nxICQAAAEgJAABASi4I1c7EJz0UoZA4PKT/HqQEAAAApAQAACAl58c3yxP3VVBIHPZCSgAAAEBKAAAAUnK+TD0Tn8TnKCV8Jj5pGqQEAAAApAQAACAl50qfM/FJ/z1HIXH4Xn8dSAkAAABICQAAQEoqRLMz8UkfnKeQOHygvx6kBAAAAKQEAAAgJRFR+0x80ksXSEgcXtJfF1ICAAAAUgIAAJCScjl6gYXE4SikBAAAAKQEAAAgJeVN2lp3kYTEYR2kBAAAAKQEAAAgJaEYeyY+SV5kKZFn4pOuh5QAAACAlAAAAKTETecz8UlfX2Qhcfha//cgJQAAACAlAAAAKUkSZ+KTmpyJT3r3RxISh3f1fxdSAgAAAFICAACXuZTUOBOf9PMfWUgcntT/fUgJAACA6JQSKSUAAACDc5SSQ5dISBwOQ0oAAABASgAA4PKVkgWXWEgcFkBKAAAAVGUpqWbg9b5IPlYeCIYAANEoJUPPxCf9UEmk5Af9/UBKAAAARFlPydlm1ULB1tIaZaD06qGIQDyqa6r92PjPNhOgKtDcAD+Pc/v5VYKv+UMl+7m4vp8KSEmbM/FJn1YSIXH4VH9fkBIAAABVJlNSLaSEKEGp6c2mWkzptcNh08laQfhO13SQUtY4T6pHCCQHUgIpgZScq5TUPxOf9HolExKHN/T3F1ZKkBUDAIDQQEKiRUpcIuLIRUA6SuqYMKXX9WZ3vbLsa1CW9PrO3wl83fvq2r5n6ijerW373q0tpaylqXkBqYj8QG4gJZCSqi8l1c7EJ91XSYXE4f4z8UnVICUAAAApqRI9JV5CYvseq+ElJIpgGTGlxKaiemXJb2DTyfrB5DdQ5DYKB1N6Y6bkJkwJMUwpsYrdcQrn31NimdJjHGzKaaL+/vGGNh1vaPsebGD7nq5v+35bT/o+qCt9H9SVUtYJQ20XtVycq+ycc2YHUgIgJT+ulHyzPDGhkguJwy5ICQCXJdUqCZASSMnFlZLyMiXeYmKKiFtAtCBERG4jm0oaK7kojlEUxYUnq6lNWU2Z0q8IZn8zxb7mARJaBDDfn97cpqxmztey6c5Ym+6LsX2PNbF9zzS2fa81sn3vNpRS1ouAuppIpCeUAEWazfGSniiWGkgJpOSSS8nkM/FJdpRIiX0mPmny+UgJrplK9Br9AT+HSvW7qODv5AIH+9XPk3MpeQ/C9j1Ww024vmOm9Oq6Z/lH+11BSqqQlJT34vJ6QYbKlpTNlFRUSu5ppChpbNNJLSR3xioc+TjWtCwnr7CppJkiv3l4MlvYlNfSpsxWNuVeqchs7YYpvY0ita0iuZ1i71UBEtqrt87H1Ofqr9HKpuIWNp1obvseucL2/TrO9r0aK+WXjaSUDcPQQFPfwC06puyUJz+1zjOjcwnEBlICKbmkUtLnTHzSmSgREodvz8Qn9YGUQEpAhQPaCyUGXgeFNX9sbN/btRSP1bZ9j9UuG6MFvw3NzjrheoVdh9aeQ5EgJZCSCy4lIQWltHldv/CDXvz31Q1Gy4nvwQZBeEpJSeOAlJxsYtN9hpjcHRfg5BXB3NtMcaJ5MKdaKDkobmHT8ZY2Hb1SUdQ6QGFbb4rbKQquUuR3KEt2R8WRTpouDkzpnZkOdFHs78q0pytTQjfFju5MCT0C7O2uPn6gi/p6+R3Uf/ueK23fYy1t33PNbd/bV0j5TayUsokmxoMmUsrGUspGmlCiEwpTgNxyU1HBCRIbSAmkJAqkpNmZ+KS/RZmQOPz9THxSM0gJpOQyk4hIBSFSYXCXa4cq467lUelQ55zwfVDX9v22niozf7p+ID7yKmd3StodEmKCMT+W3IQpvbHx9xsGSue9Su2L6pliEqpU35Cc2o6glJdBuZjZE0hJFZIS/9lm1c5JTIKmapU18mA5MUq5QgqJWbZliokpJaaYOBkSU0q8hOSUISSmlJS0URxvG8zJdjYduyqYox0URR1tKukUzPHOiju62HSsq0253Wwq6F6W3B6KnF6KzN4e9LUpow9Tel/FwX5Mqf2ZEjV7BigSBjLtGqTYMZhptyZhoPq89L42ZfW06VhX2/dgB9v3WDvb99yVtu/dllKeuUJK2dTgCo35vjgpZawhOqbkhKOhS37CyU0o3HJTXWJgAKTkx5GS2mfik56LUiFxeO5MfFJtSAmkpBKLhFscKpoNcAuBV6BfN0RlgftjziGc+3CuQRhKP8/2vdvQ9j3fxPY9GWP7Ho61fQ+UVm6ocvDMFjZltmBKb8mU2oop6UpFQitFYssAqS0UgVJypvQrAuXkXjgVJGaM5JS8O+Q0CcRUjuCYcZcjKU6c5gjKfeVKiaI0DqwRgZhASiAlF0dKyjS/e0qJIyauHpOQUuIq4/I9HEJM3KVbDm4pOdE8kCVxxORkq4CYnGgdwEtKitsHhOTOjoqTnYI53tmmu7SQ3NnNpqPdFcU9bCrpGeCO3orivsGU9NMMsKnQoGCQTbmDy5J9tSJrqOYaRea1NmUMd2A6OJwp9Vqm/cOZkq9lShzOtPs6poSRTDtHMe0YzbRtDNOOsUy7xij2jmRKHsGUPsymzME2Ffaz6d6etu/xLrbvdHvp+3tbKf9zpZSyVRhaSCmba67wkJwmEWR6HMlpYMhNpKdO7pK1UrGBlEBKypGSoigXEociSAmk5AKKRPUQ8lArgiEwpkCYUlCeCNQP8/GGrsOwxuU8U1zPnQ9jbd/bV6jqg0daqJigpI2qjshuz5TekSm9M1v7uyr2KCixS4DdnZkSOylSOjKlt3ewKfMqF20D5LZxcWVZ8loqnJJzd0zjlKo7nLwiEA+5BUX3xdJ9MYHqk5LGKsZyxV2+B10DicxqlzBS4nustikl4cTkYj2HISVVcKO71w2pvKlc5ywldLJ+5P0lzoUUSkpMMfGSEnfWxMyWmGJiZk3c2ZIT7YPFxJQTJ1NyrKvCkRJHRo71UpzobdPRPoo7+yqO97fpxAAlJCUDbLpjkOLoYJuKr7apZIiieKjmGkXhtYri4Yqi6zSjFPmjbcrWZI7RXK84Mk6ROV5xZIJNR25QHL6RKX0SU9qNTKmaZE3iJKaEm5h23sK0YzLT1qlMW6YxbbtVsXWq+ljiJKa08TYdGW1T3nCb7hps+x7va/tOd5fyXx2llO0MrvKgnZSyjZSytUty3Nkcd7bH/PdYV4bHeaiF6sfxOlGrbTxYo0xqICUVlRIhRDXRa8UroscSv+g0wy/ajPWLK/r7ReNOftGwjV80aO0XDa6sBLRW30/jTur7azNWfb89lvhFrxV+0XuVX/Re9TKk5PKUkhASUV5WIVQJkikPbhlo7DpgcsqGG7sy641dshDrum83Mw6xTJppdCb/22bS914r23e6je174iqb7umonrcF3W3K7K0qC1L7MyUOZNo7SFcOXG0wMFBp4FQepPYPVCWk97Upo4/CqVxwqhqyeipye9iU1d2mrK6KQhd5XWwq6qzelnSyKa+Tqq4o6qgOOIvbB8cVxe1UvOFUbZS0UeXkTmxyspWKV5xD1fwQsc29zQIx0LGmgWoSt5Q4WRQPMQkqq3cOjx+rV7YUP3y2pLw+kxAlXdUgJZCSiB5KF1ZKPMTE3WNSprTL7C1x23+oHpPyxMSdLQlVyuUu4TrWoayYOELiJSVmpsQRE0dKHDEp6afExJGS4oEBKXGEpGSITSXDlIzccW2Ao8NtOj7CppLrbDo20qbi0Yo7xthUPNamonEBCsbbVDTBpuKJiqIbFIWTbCq82ab8WxS5k23KmaLImhpM5jSbDk+z6citNh2ZYdPhmZrZNh2ezZQ+hyltLtPBOYrUuUzJ85j2zWPaPY8pYa5i53ym7QuZNi9i2ryEadPtAXYsYUpYwJQ8i+nQZJvyJth0apTte3KI7ft9XynPdJNSdjHoKqXsZtBVv7+zlLKjlpy2UsorPbI4LaSULTVOlqelS4Li9IO0UQV6cszMTm0jW1MNUlKppaSG6LHML7rM9ou2E/yi2SC/aNLFLxq2rURCYopJW/X9NRukvt8us/2ixzK/6LVSiQmkJNpKm6obElHbdWgSarJjXY9SJEcgHCFwi0C4kl0T5/Oce2UrfR9to2nrQRuD1opP2tm+Nzvavme72b4He6tDuIKrbcq6hungdUxJY5j2jWNKmMi06wamHROZdk5Q7LqeKWEs054xTPtGMyWOUuwfxZQ6Uv399BEOZqWAqhzIvDZQSZA7zKbcIYFKg+yrA9UHTnVC3sAAxf01RlWDU+1Q0lM9353nfOkzv5vCiQXu6BKID5yY4UR7hRNXnGynMGMPJx5x4hOn9LxYH6yGkRLfA02D4yKvuClMtqRMWZdZzhWmrMvJlhhiEsmUrgvVawIpuYylxD0qOJL9JSGlJJSgBEmJIyZeF5dLTkrrOc3Gd7PX5JRHb4nT9O4WE+dmYWZNnFIur3IuR0yKjRKuo91tOt5D4RYTs3TLzJgcCyEmx4badOcwm45fq3DEpHikTSWjFI6UHB1r0x3XK0rG2XRsfEBIim+06Y5JNhXfrCi6xabiyTYVT1XcMc2m4lsVhdM1M23Kn2VT3myb8ubalD/Pptz5NuUvsClvkSJnkU1ZtwXIXGxTxlKbDi9jSr9dkbaMKW0508F4prQVTAdXMh1czZS2hil1rWYdU/I6pqQ1THvWMCVodq1h2r6Gact6pk0bmTZtYlq/jWntDs1Opg3bmbZtYtq9mungYptyZtl06mbb9+xo2/fuECm/6y+l7KPpq+kvpRxg0E9/vJcWnc5Syg5acNq4aOuR8XEezq30A72pITYNXSUIDT1KEZzPccSmVsWlBlJSQSmpLoRoKLrO84urbvSLFkP8IqarXzRsVwmFxBSTdur7bDFEfd9d5/lFz9v9ovdKSMmPIxI1XBLhzio0jGDQiFsgmuoMQQvjsORKHeRfaRywmIcoLYzDFUcc2kkp2+vDmc76sKablLK7gfsgp7OUspOUZ7pK39962r6X+tm+x4fadNdIm/ImMKXdwpQynWnPbHW4tEUfLm1ZyLR1AdPWeUzb5jJtn8O0YyZTwnSm3dOY9k5lStLsNzgwlSltGlP6VJsOT7HpyGSbjtysyLzJpiOTNDcEyJxoU/YEm3LH25Q9zqbc6xX5Y23KHaOqBPJHBw7pikeqKoKCEaqqoPBam45dow76SoYFqhBKhqjqhOKr1fP32ED1PD4xQD2f7+qnDhKd5/eJ3oFn+vEewc/8Ow0xOd45ECM4MYMTQ5QnJu6MiVPtcSqEnHiVczm4peRkk0A1SjgxMeM0U0pcYmJIidn4/mOND4aUXCZSErLfxFpaoyL7S0KPCvYQE88yLnMSl5mKdIuJV/O7uwG+2KOEy13KFTJbYpRyHXOJSajeEi8xOdE7UM51Z191wzPLuI4NVFJydLBNx68OSEnJMHVDdWdMnGxJySibjmoxcaSkeLxNJa4siSMmJTcZYjLVQEtJ8QzNbJuK5thUNM+m4vk2FS6wqXihTUW32VS4WLNUUbRMUXC7TbnxNuWutClnlU25qwPkrLEpZ51NWettytpoU/YmmzK3aLbadGSbTRlbbTq8jSlNc2Ab04EdTPt3MqUmMKXuZkrdy5SSqNifzJSUwrQvhWnvfqbdyUwJyUw7kpi2JTFtSWTalMS0IZlpQyrT2jS21hxia2UmWytyNNlMaw8zbU1mStphU9Yqm04tsH3PTpa+D0ZLKYdJKYdqhkkpr5VSDpdSXmcwXEp5jZTyai05vXUA0EU98GVHg06urI8TIDhZntY64Gjqmqxm0iTE9DVHbJxsTTVIiaeUVBNC1BdCXCXa3+wXLa/xi9geftHoqkosJIaYNLpKfb8tr/GL9jf7RbcFftFzuV//f0FKQmck6mgpaOhxHbnLkRp59DDE6IxCMy0EbfQ128G4ts3rvYOWBK+SVUccukkpexqHJQOllINdDNLvH6A/p1/ggOWbgbbvjRG278kJNp2calPeXKa0JUyJq5h2bGLatJ1pwy6m9QlM63apQ5yNW9UBz+YNTFvXMG1fpdixkmnXSqY9K5iSViqSVzHtX8WUulIdKKWtYEqPt+nwcqb0pfoQaon6b6bdxpS+yKbDC206PN+mjHmKzHk2Zc9V5MxRB105sxT5s2wqmGFTwa025U+zqWCqTUVTbCqcrDL5hTcrim9Sz7CiGwLPtZIJ+lk3LvDsu+N6XTkwWh/cXaeqC47qsmfnGVoqKfoA8PjV6tl7x6DAM7lkQKDs2qx4cDInppiYUuKIiTtj4hYTk1BSYmZMHMxsiVnG5RYTd4+JKSX3eDS/e0mJIyYe5Vylw46Cqmci2m+CnhJIyXk9lJzmt4jHBIccFRwqaxJqTLBbTCKVklAjgp0yLgdTTJyMSXG70GLiYEqJVxmXKSahekzcZVxOf4kjJk5fSenpzjVlpaTkumApKR5bVkyOTlQUT7TpjhsCGRN3tqRUShwxmRkQk+K5ATEpXKDEpFRODCkpXG5TwUqb8lbZlLfGpvy1ioJ1NuWvtyl/o015m2zK26rI3aHI2WlT9i7Nbpuy9igy99qUuc+mjGSbDqfYlLHfpiOpNh05aNORdJsyDtl0+LBNhzKY0o8wpR1hSs1k2p/JlKxJymZKzGHal8u0L58psYBpXyHTvjuY9pYw7TnGtOsY067jTDuOMm0tYdpUwrS+hK01JWytcjjK1qo72Yo/ydaS+9m67WG2Fj2iWPYAW2tOMCVkM6Un2XRyve17YYGUX98kpRwvpbxeSjlO//MEKeUNUspJUsqbNDfq94+VUo6QUg7RAYiTvemp6aXpbWR9nADFyfJ01MFSC9fAAQezVMPdk9NYB211zllqokNKagghYoQQfUXb8X7RfLAK8pt09otaDZ4TQjxciXlICPGAqN3456L5YL9oO94vOs/yix5L/fr/K+qlxBCJWrpEqaEhBF6lSGYJkvu13lRnL1vpTEInfWDQy7iG+hrXmnO99XBlGMy/M1AfUgyXUo7W17dzbU/Q1/r1Usox+uOjgg8xzo6Svr/cYPuenWnT3Uttyt3I1v49TDvSmDbksLWyiK3lJYoVxWytKGBrVS7Tuiym9YeZNhxi2nCQaWMq06ZUpi2pTNtSmbYfYEo4wLQnlWnvAaZ9B5mSUpn272dKTVGkJDKl7lOHO6m7mVJ3qYOf1O3qEOjgVqb0zUzpm206vEUdFB1xDo82qQOlrPXqgClnjT5wWmVT9kqbsuNtylluU+4ym/KW2pS/xKa8xTYV3GawUFG4QD1Tiuao50zxTJuKp2uMZ1HRNPV8KrpFPbfumKSeY6aYOHLiJSXHRqrnZPGIYCm5c5g69Ds21Ojj1FkTJ2NSojMmJf2CsyVOxsQp1XaLyV1dgqXEnTE50d5bSo63VbGIIyWhxMTJmJiVIV5i4i7lMpveHVxZE3ePiWfWpKheqGyJR4+JZ1kXpARSct4PJXcTvOeY4JCjgh0pKSdjElTK5RaTUGVcFZnI5Vzcbilxi0moMcHu5ne3lLjLuNzN75FIiSMmx68OLuM6NlSd7hx3mt11b0nx6ODekqNjA7gzJqHKuO6Y4irjmq7EpGiWemgUzFUZE0dKChcFZ0yKlgQyJYUrlJgUrrKpYLWicE2wmORvtqlgi5aT7VpOdtmUl2BT7m6bcvbYlLfPptxEm3JTbMpOtSnngE05aTZlp9uUedimrAybsjJtysyyKTPbpsxcmzJybcrIt+lQvk2HCm06VMiUXsyUdpQp9RjTwTuZ0k4wHbyL6eAppoP3MKXey7T/AUXK/UyJ9zPtvZ9p9wNMCQ8y7XqIaedDTDsfYdr1E6adjzHteJxp+8+Ztj3FtPVppi1PM21+imnDU2ytfoqtVT9na+UTbC1/nK2lP2dryZNsLX6KrSVPs7XoV2wteI6tOafZmvEqW9NfY2vWK2zd9gzTxkeYUktsOpVs+15dI+UPc6SUM6SU0/XbmVLK2VLKOVLK+VLKBVLKhfrtHCnlrVp2xuqAaahx0uqcul6tpWeozu5cqzNAV+tT2B6G2LR0NaA2C9OkeoUOBBvpQLJmpRgU4C0lNYUQTYUQ/UW7iX7RaoQqh2p+tV8IkRgl7BGtRvhFu4l+0XmmanpX/1+XTEoMkainXwdxRlmSm+ZhcMqYrtJZxN76NTxMv65H6LfXGpnMIfo17M4yXK1f5yO1ONysryfnGnKYq6+tmfrjt0opp0kpp0opp6i3/51h+16Nt+m+nTblHGJKOMa0/iF1fc9/hq25v2Zr7rNsLfwVW7c9ydayx9i6/SdsrXiYrfiH2Ip/gK0V97G16l621tzLtPZepg33MW28n2nL/Uzb7mfaeT9Twn1Me+5l2n0P0+67mXafZNpzF9OeO9Uhyt4Spn1F+nClkCkpn2l/niI1j+lgLlN6DlN6jk2Hsm06nGXT4SM2ZWSog5wj6fpgJ9WmIyk2ZSbbdCRJHQBl7lUHQ6WHRLvUoVHuDnWvztuq79+bbCrYYFPhen1vX6vv9avU/b8gXj0PCm7XGXXnWXGben44UlI8V0vJbPW8KZypD8VcUlI8WT2zSm7SzzAja+LOmBwdq56Fx0bq3suRgWyJWXFglnSZ2RK3lBzvH8iWOFLiFhOzz8SdLXGXcoXrMSlpExATd39JuD4Tt5h49Zi4p3GFkZJyxSS0lHgJijtrciGeDZCSy1xKvPpNPMcEh2yAD9P8HnKfSUWkxC0m7lKuULtLvEq5TrUJXcpl9pe495U43NktuJzLkZI7egengc3ekhMhxMQs5Tp2TXApl7uMq9ijjKvY7C3RYlJslHCFzJgY2ZLi2YFsSahSrlIxibcpf4XKljhSUrBaPbTy1gWyJfmbbcrZalPutkC2xJSS3L1KSnKSbcrab1PWAZuyDwbEJOtQQEyysm3KzLEpM8+mrHybMotsyiy2KbPEpoxjNmXcaVPGXTYdPmlTximbMu6xKeM+mw49wJT2MNPBR5jSfsJ08CdMBx9lSv0pU8rPmFIeZ0p5gin5Saakp5hSfsGU+CumxF8z7XuOae8LTPteVCS8xLTrNNOO00zbTjNtPc20+TTTxpeZNv6GacOrTOt/y7T+DaYNbzKte5ut1X9ga807bK1+h60V77B1+ztsLfk9W4veYmvBW2zNfYutWW+xNetttmb8ga0Z/8PWjD+ydeu7bN38V7YmfsDW9R+xNe5Dtqb+ma0lrzMlPm7TqWLpe2+3lHK1lHKFlDJev12p37dWSrleSrlRSrlZSrlJSrlOSrlcB2hTpZQTtdyM0gHdSP3PozVj9Wmww2gd/A3Qp8rtjWlqLcuhhQ5e4y641ITOlDQUQrQRnWf5RcdpftFhikKI0VHCKNFxmsqSdFuo+krOIVOisxI19c/cLRItK0ArLbIddaZhsJaHsUYGwWG8kU24Xn/OGCOz4PydW6SUs6SUS/TrdrOUcrtmm5Ryi34Nr9ev3zX681bq1/sKKeUqKT/ZavueOGJTzj1MW55ha/EbbE35M1sT/sHW+A/YmvQ+W5P/rK6rmX9ga/bbbM15U/M6W/N+y9aC19ha+Cpbt73K1tLX2Fr+GlsrXmdr9etMa99Q1/XG15k2vqau982nmTa9yLT5eabNv2ba8izT1l8xbfsF07anmXY8xbTzScXuJ5kSf65I+jlT8hPq/rP/MabUR5kOPMJ04CGm1AeYUu9nOnCPPlS5Sx2ypB1nSj/OlH6MKf2oTYfvUPe/I0U2ZRTalJmv7o2ZOepemZWp752HbMpKUwc+2ak2ZafYlJ2kD4T2qvtwzh51T87dpQ+PtunDpE36gGm9uq/nGWJSsFIdThUuV1JStEw/H24zsuyLdNbEzJZoMSmeEciY3GFIScktwWLiZEyOGmLiZEyKx5bNlnhlTI5dY9PRYTYdHRJ43jplXMUDA/0lTi+o0wBv9pi4S7mcbIk7YxKu+T1cGZc7YxJqOlckpVymmJilXB5SElJOXFISgZi4y7kuxB4ySAmk5DylxGx+dxOqx6SksU1HDTEJ1WNSnph4ZUvCSUkkPSbuMi7nJmSKSbhRwU7WxN307vSXOD0mZsbE3V/iJSVuMXGa3p1SLrOEK6iMy6vx3ciWuPtLnIxJgauMq+B2JSZmxqRIZ0vy19qUtyEgJu5sSZ4hJnlGtiRbZ0uyU5WYZKUFS0lmlpaSXP0ALtRScocSkyPHg8Xk8N02Hb7XpsP3M6U/qMQk7SdM6Y8ypT/GdPBxpgM/ZzrwFNPBp5lSf8mU+gxT6rNMqc8z7X+Raf9pppRXmFJ+w5T8G6ak15gSX2fa8zrT7t8xJbyp2PU2084/MO18h2nHH5l2vMu0/U9M2/7CtOVvTFv+zrT570yb3mda/w+mte+ztfrvbK14n63499la/g+2bv+AraUfsrX4I7aWfMLWbZ+xtehfbC34F1vzP2dr7udszfqCrZlfsDX9c7amfMbWTZ+ydeOnbE38jK3xn7E1/nO2xn7B1th/szX6K7ZGfuO3hn7nP9v3//xne/2f3xryLVtTPmba8pbte+BRKT/KllImSin3GOzT70uWUu6XUh6QUh7Ub5OllDt1YLhInzbfrEvVJpaDWbo28Bylprmn1ITuKaklhGggeixVWYbuixVCNIsG2rZt21L0WKLKtnre7he9VvjPnDnTsoIi0VL/jNvrn/lAnYFwpGBihNygSxAna4lYpkV3n5QyTUqZIaXMlFIe0f98WEqZrj/mvH72SylT9OsoRUqZbvvePGFTwfNsrfozW5O+9J8d8L3/bLez/rM9zvrP9vveb13zHVsjz7A16hu2Rn/N1piv2Br7JVvjv2BrwudsTfiMrUmfKiZ/ytatn7E1Q18r8z5na76+hhZ9xtbiz9ha/Im6xm7/J1vLP2Br+fts3f53tlb8la2Vf1bfx+r3mNa9x7TxPaZN7zFt1mz/k7q2d/5RXeu7fs+08y2mhDeYdr/OtPs1pt2vMu15mWnPaXWQkfgiU9LzTCnPMe1/VpH6jL7fPM108CmmtCeY0h9nSvsZU9pP1T0q7WGm9AdtOnQfU/q96n525KS6v2XcadORo/reV6wPaMJISXa6vqceUIc/2SnqnmuKSe5ufV8OkS1xxMTMlhSu0AdULjFxDrGcUq7CBcHZkiAxmaGGrhTfGiwmZrbEPHDzKuM6OtoYCmOUcjnDY44bGROnAd7MlpwY4C0m7lIup4fUKeM61TUQD4QSE+eA0xwb7M6WmOXmocq5Iukx8ZISr3Ku3EblN8A7PSZH6wSX7IcWkzJlXapH+bya3yElkJILICXuHhOvfhPzInBveg8nJ2a60hwX7JaScGLiNZHLPZXLKesK11viJSahJnKZ07jcpVxOjat7IpdTxnXHtWrKiDmN6+hoxfEwje/uMq4Sl5i4paRwdnAZl5kxcUq5im5TDx1HSvK1lJilXGa2JH+jTblaSpxsiVPGlaPFxMmWZOlsiVPGlX0w8mxJhpEtOXwiWEwO3ceUbmRL0h/VD/2fKTE5+KQKDlJ/YYjJc0z7X1BikmKKyWtMSa8zJf6Oad9bTPt+z7TvD0x7/odp97tMCX9iSvgzU8JfmRL+zrTzH0w7P2Da8QHT1n8ybf6QaaNmw0dMaz9ia/XHbK38mK0Vn7AV/wlbyz9la+mnWko+Y2vhv1RgNe9ztmZrKZnxBVvTv2Rr2r/ZmvxvtiZ/xdakr/jspK/ZuuEbtiZ8w9b1/8tnx/wvW6PPsHXdt35r+Ld+65rv/Naw//itIf/xW4P/67cGfq+CwH7/5z/b5//8Z3v/4D/b8wcVFHa1/Gc7Wf6zHch/thX7zzbz+882Z//Zft+zteoj2/fTl6T85pSUskBKmSOlzDLIdpGlA9Y0KeVeffK9RJer3ayD3Uik5notNYN0gH2VnkoUNijXOz5K0aVHNaWU1UQl/aNPGet4fO/jKiASjkw45UyLpZQb9O8gTf9OvH5fociVUhZL+cWDNt39O7YW/Eu9Rpr5A7Rg/9krbf/Z1tJ/tq30n23n85/t4POf7Uj+s53If7azpV5fPc/6z/b6wX+2zw9Kmvur16I1+L9+a+h/1Ov0mu/81vDv2LruW/U6HvO/bI39X7bGfaNe5zd+zdakr9m65Su2pvybrWlfsjXjS3V9zPxCify8z5WULPyXuqYWf8bWsk/ZWv6JuuZWfqKuvzUfM637SF2XGz9k2vShuma3/5Np+wdMO/6hrumEvzEl/EVd53v+xLT3j0x739H3grfVfSHxDXWvSHlV3zteVveS1OeZ9j+nDj4O/Erdcw48xXTw5/pe9DOmg4+pTG76I0pKDt+vD1fu1ve0k/oed0wfxjhi4mRLcvU9MitYTHLS9D1VZ0tyk3TpbKJNOftCZ0vyNwfu5XkbvLMlThlXabZkSXAZl/MsKZoXOPwqnm0MXLk1ICV3TAn0ljj9JaaYHJ0Yur/EKeUyMybuUi6nv8Sr6d0RE6/Gd7P53auMq7weE/dULrO3xAsnfilvKpd7j4m5v8QtJ2as5SEkZTImRrYkzESucvpNzqsBHlICKRHnv78klKAY2ZIyJVxmitFLTEI1vx9r6i0m5oXs1V8SSkxMOTFLucKVcbmb30M1vjtLFd1icmygTXcOKjuRy2x6Lx6h6mWPeYwJdm7MReOCG98jGRMcqum9TMbEJSX5y9TpWK5LTIKkRPeWFOgyLkdM8ncE95c42ZLsJJ0tSYk8W3KkQInJkTvUyaEjJkdO6FPFU+qBfugBpvSH9OnjI0zpP1HZkgM6W1IqJr/UwcKzWkwcKXmZaf8rTEmvMiX+VklJ4ls6CPm9Ckr2/D8lJrvfC4jJLi0m2//JtO2fTFv+qYIdR0rWfcTWmo/ZWvWxCo5WGFKy5LPgbMk8I1tSKiVfqmBs8r9VYDbpa7Zu+Jqtid+wNU4HcGPOsDXqDFsjvvVbw7/zW8O+U0HfkP/6rYH/DZaSPlpKepxVgWMnSwWSHch/tr3Pf7ad9J9tI/1nW9sq8GzFKght7g8OTMPRwcfW/H/Zvl+/JKV1SkpZqKWmvIA4S5+879NSs7iCmZrrdX9CH505aCSlrFnJpaSRznBcpzNTO/XPILsC5ChxtE7avteeY2vxZ+r32Mx/YWmupbWlIyW2eq20k/6zV2kxMaWkx1n1Wuv9g3rt9VNiUiolQ/+jXqvXfue3hn/L1khDTMb9r3qN3/BNQEom/5utqf9W14UjJnM+986WLP2UrdtdYrL6Y6a1HzGtN8Rki75uHTFJeF+LyV/VNb77T+q63/M/ATFJ1FKS9LoSk+TfMCW9wpTyElPqC0pMUn+tDz9+pbMlTzIdfEKR9jN9aPITpvSHbTr0gE2H7guIyaFTNh26y6bMO5WUZJZEli3J0WVcjpjkpgSkJDdRHw55ZEsKtuh7+MZAKZc7W1K4ItBbku8MRNFN8AWmmMx1ScnMsmJSNE1N5ioKUcblmTFxZUvcGZNwUnLnIO/+ErPx3cF5ppuN76aUmGJiSom7+d2UknBiYmZNIukxcU/jcje/O2JyNLSUBIlJ+btLIukzgZRASi6olJzb/pIIek3KjAl2pKSkcflSEqqcK9Smd7P53avxPeyCxQ5lFyp6lXKFWq5YXuO7e1Swu4zruHsal5EtcTe+O6VcpRkTl5SYGROn8d3MloSSkoKFwWVcQU3vy8s2voeaxpUTouk9d69NOYk2ZScrKcnZHxCTUNmSLKOMK8OVLXGXcTnZkvSHNT9RZRIHf6aDAV3GVZoteVadaO5/XgUT+7WYJP+GKfm3KuhwxCTx90z73lGByZ7/Z2RL/qKkZNf7TLs+UIGNO1uy3pUtWfmJCpRu12Ky2MyWfB7Ilsz6QgVe079UgdgUQ0pu1NmScSpbYoXKlgz9j98apLMl/b9Xp9V9/k+dXvfUUtJFS0lHUkHlVT51+t1aaimxtZTwhQ9yQ8PWjC9t37u/klLepTM1kQTnB6WUW6WU83TDdGspZb1KLCXV9WCBwWytOXXxfp7NL/DXasnqdeFIiZkt6URKdLtY/rPdzWyJlpJ+3/utgf9VYjJES8lwLSVOtmT0GfW6nvCNEpNJX7N181cqW+hkS6ZrKZmtsyXztZgs0qK/xMmWfKqykys+UQcD7mzJZlNMPlAHDLucbIkjJe8y7dHZkr06W5L4ps6W/FYdZCT9Rt0/Ul9UGdjU53UZ16+YDvxClXAd/Lm+Fz3uzpYwpWsxybgnkDHJuNOmzGPqMKbcbMkRNTjELOPKTtEDRpJsynYyJmGyJXmbAj0m7myJ2fTuTGksWqakpHCx6k00syUFcwNiYpZxmRkTr/4SM2NiSonT9O6UNpfKic6YOM3vx69Vh33F1wRP43J6PN3TuNzZErO/xCnhco8Jdje/u8XEq4zL7C+pqJTcGyJb4jUq2BQTjz0mnj0mIXaXRCgmkBJIyYWYvlKtYmISblSwV59JJGOC3WISwYJFz1HB7lIur3HBJ8op5wpVxhWqx8Qp5/Iq4zK3vZ8wtr2bG9+9Gt+LhwemcXktVTTFJFQZl7O7pEzGxNhb4ohJqDHBTuN7vpEtKYgP7i8pWB0YFVywTtcjbwxkS7z6S/L2BEq4IsqWGGVcma6m9yNHA/0lmXfZlHGKKf1eXcL1oD59fCS4hCvtiUC25MAvjGzJ8yqIKBUTV7Zk35sRZks+UEGNO1uy8UMlJaXZko+VlCz/VAVNpWKiS7jmu7IlM3QJ19RACVdptmSCzpZcr6Vk5LcqW3KtkS0ZHCZb0l2XcHUOkS1xpMTJlvx4UlKGHyr2+VJ+t1BnTJpU1geHlpIWqin8+306E+G/pD/niKSkBavXRFC2xKdeO+4SLjNb0leJiTXweyXLQ4xsiVPC5WRLnBKuiU4J11eBbMk0Q0xm6WyJIyZOCZcjJkHZko/LZks2aTEJKuN6X4vJX9R1vvtPTLv/H9Pe/1GHE6XZkt+pbEmKzpakvMyU+pLuVXueaf+vA70lB3W25IAjJk5vySM2HXpIZUvcZVyHzN6S8rIlHv0lThlXTnJk2RJHTLyyJe6mdydjkr/MyJYsKFvGVdpjMjPQ+O40vXuVcXmNCjbLuI57ZExKG99HBMTEzJiUDIm8jMtcrGhmS5yt7+VN5HLExGtEcLiMSXErbzHxGhccSkrKaX4Pufk9v4ETu6m9dC4xCSMokBJIyUUZCRnR/pKQY4JD9Jn4HqvnnS3JbeTdY1IcU76YeGVL8ssRk2NXKhwp8dr+bkpJqIxJqB4TJ1vinsbl1fhuZkyOXx3YXxKu6d0Uk2LXtvdI+kvc2ZJQGRP3mGCnjMvcXVKaxl8ZGBGcvzbE7hKjv6R0Gtc+dWKXk6xP8FJCZ0sys2zK1tmSLKPp3auM6/BJmw7fy5TuZEse1NmSR5kOmtmSJwNN7wed3pJf6wDixYCYlMmWvKkCkd1GtmT3n5h2v8dWwl/YcrIlOz9gy8mWmGKyzsiWrPpY95XobMkyQ0qc3pK5rt6SaU5vyVeBbMkkd7bEVcJl9pY42ZJ+RrakpztbYqmAsr1PBZhtzRIuW52ON+fKHTCbUvL9Ll0S1UxKWa2SSkk13RNzvZTfp1ZuEWnu6ikxpcSzt8RSwuuVLRmgsyVD3L0lWkpGGSVcE75RAj5Ji0lptkSXcc3U2ZI5Rm/JIqOMy8yWrFTZElqryippvZEt2WpkS3a5syXvqYOIvSGyJYk6W5Lyij7YeElnS54LzpYceErff3QJV9rPnGyJTYce0vcuLSYZp1QmOPNOda8Lly3JyrYpM9OmzCPB07jcYuJkTLL3BmdLHDHJ26r7Az2yJXlhxMQZFWxmS7z6S5yMibvp3RST4hAZEzNbcjxExiSUlDhlXKaYeDW+u8XEbHovb7Gi2fweqrfEJJyYmP0l+a4eE69sidlfosXE93DjYDEJISelGROPpYqehJ7IZUpJRSZyQUogJRXaX+KZNYmov0Q3vXtuenf3mNzTSF1E7sZ3s6zLXLDolhJ3KVdxq/KncjmTucL1lphE0vjuLuMKNSrYa+O7Wcbl7C4xpaTYaXofY5RxeUlJmGxJ4fTwZVylLAxM4spfZsypN8q48lZ5jwh2mt7du0tyd6uHYXaiejjmJIfOlmQeUQ/Z0qZ31zQuU0wydRmX6i1hSr9fl0I8pEojDj5qBABPBAKDA79QwcL+ZwNN757Zkje0lLytgpG976jgJChb8jddxvWPQLbELONa/1FATJzekngjW+KUcJm9JXMMMXEa3qeEyZaM+V8VzI30KOHy6i1xSri6Gw3vTglXO6OEy91bEipQrXRSkqp7TFpWcilppuTp+13RInyBvpJWdkBM2rqzJbqEy2l476mlpK9TwmVkS8yG9xGOlOgSrnFGX0lpb8lXgWyJ0/BeWsal5X7RvwJS4mRL4nUJ12pDTJyG9y3qmrW2/1NlPXe9z9auv7NlZkuc3pLdTrbkTX1oocu4kn9jSInOlji9JQd1tuTAU0Z/yc/UoUn6o/oQ5UEtJk5/yUl16JIRQkyy8tWhTbZH07s7W5LriIluejezJUEjgreWzZYUrnGNCNZiUlrGtSR4RHDpct4QUlJaxqWzJWYZl1fje8mE4G3vxWNd296NccFHPba9Fw/13l1SEkZMnP4Sr6WKoRrf3aOCTSkxy7gcnAPTcBO5vKQkVLbEpDgmoqlcjpT4HqsXkZiUs/3dlJJIxQRSAik5/6lcYcq5VPrPKeNyUoPh0odeDfDhNr+7d5e4m9+LyxETU07c/SXmQkWnlMtrKpd7uWKobe9OatidMXHEJNQkLicVbYqJ02MSbhqXMybY3fgetFRxetndJW4xKVyg0vGlJVwhxMTsLzGzJV5LFfNck7ic3SXhsiXuaVxeZVwZd6oyh+ARwbp5VIuJ2VviNL2bI4L3G9mS1JcCvSUpxiSuRGcS1zuqjGN3IFtS2luy430lJWZvySbd8L7eYxKXky1xGt5vM3pL5moxmWU0vE8zG96/UmUtE3W2ZKxRwnWdu+HdzJbowLC3q+G9s9Fb4mRLzrfh/dKd6kv5/T69K6OFlLJ6JS7haqLKzL5beDHL2S48TrbEEROn4b29T5UBOiVcpdkSPYXLnS0pncT1nd+6VkuJU8J1fZhsyVSdLXEa3me5e0v+FWh4d7Ily3UJl9NbsvajQInlJndvyQc6W/LX4GzJnv/nmsTliEmobMnzgUlcB34RaHpP070lquldl5s+rMtPH1AjgjNO6fLUO1W5argyrszssmLizpZkp6jy2dxEPXwkQZXXurMlzjSugg2BhYp5azymcelRwU4JV9Ft+kBrQfBSRc/9JTNCZ0vC9ZeU9laOKSsmxSMD+0uKh5fNlrh3lxQPLCsmZimX80w3RwSbYuK1w8Qp5TKlxBQTU068xgWHGxVsNr67FypG0vweos+kvG3vEZZzRTCRqxqkBFJy8aQk4u3voTa9e/WZRDqRy2upopeYeDW+O5hlXI6UFLf3FpNwo4KdrIlX07u7x8S98d0cE+w055VpevfImJjZkvL6S0rcvSUhyrjcY4KdbEn+kuDGRmdUsOc0ro1Gs+RmVxnXLmOhYmIgY+KUcWUZI4IzD6vGzXC7S5xsSaYzJlhLScY9RtP7g4FsyUG9t8Rpej/ozpbo3pLUF5WUJP1GBRnJIbIle/6oGmB3/yk4W7LzH8G9JZtDTOJa4cqWlE7i+iy4t2S21ySur1Tj7yQtJXo8cGmTsNPw7ojJEKO3pF+IbIlTwtXJlS1xxKS0hKuSNmC7G+XXnNKL/66o5FJSTzfkD9EN+lt1w34kjf0FUsq7bN+7v2Jrxpc/frakhZkt0SVcV7nGA3dxjwf+v9LxwKXZEncJlzke+Pow44HNSVyzdLZkntFb4jWJa6VHb4kjJmZvya4P9ACLvwfGAycY2ZJ976gBGE5viZktSXnZEBNjRHDqL10jgs3ekp8YQzqcaVxOw/tdxnCPY3rgh1HGlZUbfndJdqoeLJKiBo3kuHtLjDKuHI9sidemd6+lis7eEmehoiMmITMmYbIl7oyJmS0xxaR4tKvHxNX0Xrrt3egt8cqYmM3vXk3v4cYEh8qYHOtQdqFiKDHxanx3l3K5syVeSxUjaX6/p1HoMcGOkJRXxuVd0nUuo4IhJZCS8x8VHEpMQk7kCjUm2ORohM3v7sWK5yol7oyJ2VsSTkxCTeQysyXuMYOOlJhiEmpM8DHXmOAS1/4SJ2PijAouIyVGxqTE3Pg+RY1idIuJe0xwaeP7okC2xFmoGJQxcdL4HtkSZ0xwJNmS3EQtJkYZV86h0LtL3NmSzBJVwnXoLjVK08mWHNKb3tONhYpOCddBo+k99VeB3pLU59VIz5SX1IjPZHNvyRuBbMleV2+JubckwciWOGKy0Stb8klwtsScxLXA2Fsy5/NAw7sziStoPPA3gfHAY0qzJUpKzIZ33fR+tr/HzhJ3tsSZwuUeD+z0lVwMmWgn2Vr8me177TkprZPGbpSKjMZN1yN1F+l+kvZ65G61SiwlNfX32Fo35l+ry84quptkox6lnB7hXpIcNarZOmX7fv0SW/P/pX7v593w7sqWdHI1vPcJ11viUcI11hwP/HXweGD3JK5Zrr0li/4VaHhfqrMlKwK9JZ57S8wRwaWTuMrJlpSKic6W7Nd7S1JO6+yrubfkl4FsyYGfq5Hl6Y9pKXlEjzR3Gt91tuRIqDKuIj0yPczuEq9sibPt3cmWOFKS75rGVeDa9u6expW/Qo+M19kSrzIuz90lMz0mcXlkTEwpMXeXFI0ru7/ELOM6PiJ4THBxBGOCzVHBd/b1bno3+0tMMXG4o0v43hJ3xsSUk6LW3tvfvXaYuKdxRTqRq5zt72XGBEcoJq6sSUVHBUNKICUXaFRwRba/h9r0HsmCRa/liqaYlDQru3DIvcMk1OZ3R0y8ektMMfGayBVqTPAdvctKSXllXKGkJKi/5LrA4ij3/pIyu0tC7C8Jano3xSREf4nT9F46IniJ97Z3M1vibHo3p3F5ZUty9hlSkhRcxpUT4ab3I3rTe8YxtWysdPGYa9N7ULbEWahojAh2JnHtfy6w6T3lZb0U7VUlJolv6GWKxiSuvX9Uy9Wc8cAJf1NisuMfwWVcXntLVrrExOktcUq4zL0lM81JXF+GHg881j0e+Lvg3pLBuq+kdDzwD8HjgTu7xgO3c40Hdk/g6mSxteBfNt39Oym/eFAt3ZO5FZAI98LFDeewm8RknJaR/nrpYqyUsk4ll5JqWkzq6VKupnqrfSRb3K/U/5/d9bLJEVpoItnifqP+Gc/QSy43RrBw0VyeqXejfHPK9v30JbZWfaSycM4whFasxUSXcHXz2FkyQGdLBrt7SwLZkrNOtmSCypacNUu4JhsN72ZvyTyzt0RfU0td44HNbMkGj2zJDl3CtfMfwXtLEv6kxeR/1FLVfb/XyxR/F9hbkvIbfe/QUuI0vZdueTfKuAIlXHowhyMmHtmSwyeCsyVOGVdWBJvecw6o+2vW/kAJl5MtyTHExOwvyd1iLFX0yJY4YlI6KjiElLjHBBe6siXONC5n8W95/SVe07jcG9+Lrgs9icsZE+yMCvbKlpgZE7OMK1zju9eoYHcZV7hyrqLWoRcsem19N/tLTMItVwy3YNE9IthNZFJS0alckBJIScVGBVtLa0QsJu5eEzpaNlsSsrck1FQur3Iu9+4Sr1Ku8kYFu8cFe5VxmWLi1fh+VxebTnUNHhFsNr07pVzFfUM3vjvTuIqHBk/jOn5tAK+MydEQYlI80buUqyRE07t7THDxbJUtcXaXOHtL3LtLnFHB7myJs1SxYEPwUkV3tiRnj3oo5mk5yU7RD8wINr0HZUvuCPSWZNylThUP361qsg/dp6QkTU/iSvupDgCcEcFPBRYqpj6jyrj2P8uU8hxT0vNMiS8y7XuRac9ppj0vM+1+lWn3a0y7X2dKeINp51tMu37PtPMdpp1/ZNrxLtP2PzFtfk+x6T2mje8xrXuPrdXvsbXqz2yt/DNbK/7K1u1/Z2v5+2wt/4Ct2//J1uKP2Fr8iXe2ZNYXbM34nK1bP2Nr8qdsTdJM+IytCZ+zNf4LtsZ+ydaYr9ga/TVbo75ha+QZv3XNdypQdDIhA75na9KXbK36s00Fz9u+N0/ok/UUKWWyfrtfSnlAlxCl6Y8fllJmSCmP6IA1Q39sn5Ryk5RymZRylpRysg52KyITE6SUY6WUw6WUA3WA3V5nDlpGisdW9AZSytpSyhqi9ypRyXF/75E+kB2hqauzLXFaaFpE8DNrpX/G7fXPfKCWmrERSo2ZqVkkpVyjs1TJxuvngH49JUspE/XrZY9BopQfZdu+Bx5l2vIWW1M+9ltDvvWf7aVKvKyh37E18hu2Rn/F1th/szX2C7bGf87W+M/YmvgZWzd+ytZNn7I15TO2pmt5N3tLgrIln6hrbOmHbN3+AVvL/8FW/PtsrXifrdV/Z1r7PtP6fzBtep9p89+ZtvydacvfmLb9RV3TO95l2vFHfa3/gWnX20wJbyp2/45pz+tMia8zJTnjgX8T6C9xNr2nPhs8IvjAU7rHzcmW6IWKaQ97b3rPMPpLMkvUvS+STe9B2RKn8T0xkC1xyrjc/SUF5iSuDYGm9yJXGZe5v8SZxFXganp3Z0w8pcQQkzKjgm8IZEuOjQ9ufHfvLwnX9O5Iidn4bmZMTrjKuJznuJkxCdX8bpZymVJyor1rL1qIccGhpnKZYhJqqWKocq5QcnI0WEo8N717ASmBlPy4UhJyVLBrwkLNivWYuHeXuHpMItr+7iUl4Uq5Qo0K9tr+7pYSB+eGEm5UsJM18dr2bkqJl5h47S45OsSmo64xwc7+EjNjUtpjYvSWuDMm7jIuU0zucEq5pnvvLymYH1ioWDoi+LbQSxWDsiUeSxU9syWGmGQb2ZKcA2V3l7ilJKPQpiNaTA7fwZR+lCn9GFP6caa040xpJ5gO3sV08BTTgXuYUu9nSn2A6cBDTAceYUp9lGn/Y0wpP2NKfoIp6edMiZrdTzLt1Ox4imnb00zbfsG09VdMW55l2vxrps3PM216kWnzaaaNv2Ha+BrTxteZ1r/BtPYNtla/ztaK19la/hpbS19j67ZX2Vr4KlsLXmNr3m/ZmvM6W3PeVMx+m62Zf2Dr1nfZmvxntia9z9b4D9ia8A+2pvyZrcVvMG15xqace2zfE0ek/GSrlHKVlHKFZqWUcrUODNdJKdfrk+8tUsptUsrtms3685ZoibjFkILRUsoxmrH6xP16nX0Yrz/PZKwOYgdLKXtKKTtKKdvoYLdlBWihJ1DF6cC6rg60KzRS0h3YR4GIXAgpOa/7fwipaXaOUjNASnmNfh1db+C8tkZLKUdJKUdqRumPTZRSTpVSzpdSLtev3036tbpRv5bX6tftSv16j9dvV0vfe7ttOlXMlPg4W0teZ2vqn9ka9yFb13/E1sQP2Lr5r+q6mvFHtmb8D1sz/sDWrLfZmvUWW3PfYmvBW2wteoutJb9n6/Z32FrxDlur32FrzTtsrf4D07q3mTa8qa7r9b9l2vCqvt5fVtf+1tNM204z7TjNtOs0U8JL6iBj34tMe19g2vccU+KvmRJ/xZTyC6akp5iSn2RKeYIp5XF1/0n9qc7k/kRJicqWqBKuDL1QMeOUq7/kWHDTe3nZkpy0wFLFrP3G7pK9gYWKeQk25ewMZEtytgbvLgkq4VodGBXsZEvM3pLCxcGN76W9inM9dpeEKOMqFZObgrMlxRMDzzuvMq5QUhKu8T3UqGCz4uGO3t4TudwZE68yrqMdQovJqTaRS4lTxuXeXRJpn4nZAO+SkjJi4iUpkW1/h5RASi6qmHiNCa5YOZfXUsXyGuC9liy6RwSbSxUj7THxKucysyXmQkUvMQk1kSvctncza+KUcbn7S8wyrpJhZfeXOM3vx/VyRaeUK2hE8LjgjEnRDR6LFbWUuPtLCme6MibmUkWjjMsZFez0ljhN7+5N74VhsiU5O23K3mWw26bMvTZl7rPpSJJNmck2HUmx6UiqTUcO2nQk3aaMQzZlZNh0+IhNh7NsOpTNlJ6jOJjLlJrHtF+TlM+0r1BTxLS3hGnPMaY9dzLtuYtp90mm3Xcz7b6Hac+9TAn3Me28n2nb/Uxb7mfaeD/ThvuY1t7L1pp72Vp1L1sr7mMr/gG24h9ia8XDbN3+E7aWPcbWbU+ytfBXbM19lq25v2Zr/jNsLXmSaf1DTAnHVH/MfTtt36vxUv53hg7Apui306SUt+rT5plSytlSyrk6QHOYY5QzjdcB3TVSyqu1EJhcrRumh0oph+n+hOFaHobr9w2SUvaWUnbRpT+tdBDaPAwtPDBFop6UspaUsvrFvBdBSn78+38FpSZWDxbweg01c+GUqLXRQttDl91dbbx2r9Gv5SGu1/sg/Xaofl2PlVJO0tfSHCnlAinlQv3WuYZm62tshr6eZkj5wxzb9+oam04lM6WWMG18hK3bnmFr1itsTX+NrRmvsjXnNFsLnmNr0a/YWvI0W4ufYmvJk2wt/Tlbyx9na+UTbK36OVurn2La8BTT5qeYtjzNtPVppm1PMW3/OdOOx5l2Psa06ydMOx9h2vkQ066HmBIeZNr9ANPe+5kS72dKuZ9p/wOK1HuZDt6jDlUO3qUPWe5kSj3GlHaUKb3YpkOFmnybMvJtysjV2RLXJC5n03tOWqCMK9fIlphS4t5d4ixVNJveS0cEuzMmt3uLiXtMsFPGVZotmR6cMXEa34siKONymt7dG9+LRxtLFYcHl3GZpVxeYhJp47vZXxJquaK5UNErY+IeGezV+O7e+u4uVzeb300xiURKdG+J56Z3LzGpwPb3CPeXQEogJefVa2JKSbkb4Mvd9h6uAf6eEOVcXtO4QpVyOYLiiEmoci6ztyRUxiSSHhP3UkW3mLgb300pcWpcg8YED7XpzmHeGRMzW+JVxuU1Krh0d4lbSpyMyfTgxvfS8cALA6VcDnl6MlfeUptyl9mUs9ym7HibslfalLPKptzVNuWssSlnnU1Z623K2mhT5iabMrfYdGSLTRlbbTq8hSl9s+LgVqYD25hStzMd2MGUuospdTdT6l6m1H1MKYlMqSmK/fuZklKZ9h1k2nuAaU8qU8IBpu0HmLalMm1JZdqUyrQxlWnDQaYNh5jWH2Zal8XWqly2VhSwtaKYreUlipVFTBtymHaksbV/j025G226e6nte3am9P3lBinPjtK9Cg6jjMyCk01wMgjj9ftG64BpqC6N6Sul7KVPlU166ExDL00f/bl9XX+nk5SynZaI5rr3IE4Hgg5xBk01V2icz4+RUjbUgWQtvVW82qUKbCEl0SslQfxwXlJTR0pZX0rZWL+Om7qIC/Fab6oF2RGbbvp66Sul7GdcQ72N66uncb310RmeIa7StRullDdpJulSNefaHqev7/FSfn2T7XthgU0n1zOlJzElZLO15gRbyx5ga9EjitseZmvJ/WzFn2Rr1Z1srTrK1qoSxZoSpvUlTJtKmLaWMO04yrTrONOuY+oQZW8J07471OFKYgHTvnymfblMiTlMSdlMyZmK/ZlMqZlMaUeY0o/YdCjDpsOH1UHOkXR9sJNqU8Z+mw6n2JSRrA6AMvfalLVHkb07cEhUmi3Z4b27xJnG5YwKLl2saOwuccq4SntMQo0JdmdLQjS+m5vej7oa3937S0r7S64rmzEpviZw6Fc8NHgiV6RSEqrx3Wx+9+otCVfKVdzOW0zc44KLPaZxeZVzhWt+vy/GU0xCjgk28egxCTUqOML9JZASSMkFaYAP2voe0fZ388XsJSeh+kzcpVzuUcHhSrm8eky8xKS8Mi6v5vdIFyt6Nb87je8lYZrenYyJu4zLyZY4o4LdUuKVMTGzJsU32VR4syL/FpsKJ6vJXAVTbcqfZlPBrTYVzLApf5ZNOZq82TblzLEpe64ic55NGZrD8206vJApfRFT2m1MaUtsOrzEpoylTOlLbTq8nCk9niltBdPBlUypK5n2r2JKXsWUtFKxZwXTrpVMO1YybV+l2LqGafMGpk2bmDZuZdqwnWndLqb1CUwbdjFt2s60YxNT4ir138yba9PJqbbvyQm2740RUn4z0AhK+ulT2AFaEAZ5ZBkG6s/pq4OWblLKzjrYucqD9lLKDvrjHbU0dNL/3EF/Tht9GtzMEILG+lTZpLGmiSZG00S/v6EO2uroIC7qRQJSAinxn21+oTI1tXW2roFxHcV4XEeNXddajCE2rfU121FnEbtqumg6Gde6c7130QcGvfW95Wqd3RnuOsQYrjM/w/Qhhcpk+j4YbfuenWzTqQU2Za1iStrBtDWZae1htlZks7UiR7Eyk601h5jWpjFtSGXakMy0KYlpSyLTtiSmHUlMCclMu5OZ9u5n2pfClJTCtD9ZHeakJOrDnd1MqQlM+3eqg58D25jStjGlbbPp8DZ1UHRkm02ZW9XhUeYWm7I3qQOlrPXqgClnjTpwcshZZVPuSjWFqzRT4kjJ0tClXE5/SfFs194SU0qmBqTE3F1SdEPoxndTSrzKuMz+Eq+N7+7+krv6BU/jMsXE3fhu9pi4e0ucEcGhMiZePSahSrm8dpdUVEpMMfGQkohKuYrqqb10ZftMmNJre44JVj3KnjtMICWQknNvfg8hKGUyJiF3l3hlTSJZsOiVLTGlxBGTkmblT+VyJnN5SYmDu5TLayqXkzXxkhJHTEItVryrX/BErmMDA/tLnKyJ2QDvSEqhFpSCEWrKSPHIQMo6X5M7xqb8sTblXq/IHmdT7nibsifYlDnRpiM3GExSZN5k05GbNZNtOjyFKX0qU9o0pgNTmfYbJGn2TmXaPY0pYTrTjplM2+cwbZvLtHUe09YFTFsWMm1epN7unM+0ZzZTynSmtFtsyptg010jbd/jQ23fS/2k7289pTzTVT/wO2ucAKGbK8PQTX/MEYf2OpPQRk8lamX0LLQw6uBb6Y9fqQORK433O2VJTV0C0UBLgZsGmoYGzufW0xJRWwdONSASkBJIyYWTkvP9mlpqauiMYR1DbBq6Dg3c17f5OTHGxLRW+v7T1nWA0U6/r42Lq/QBRmcjy9NHH6IMMOhvHLD00cs2+9u+d4fYvmdH23TqZptyZjEdXMy0ezXTtk3qEGftTqa1OxTrt6kDnk0bmbasZ9q+hmnXGqYEzZ41TElrmJLXMaWuY0pdq0hbw3RwtTpQSlvBdDCeKW05U9oypvTbmdJvt+nwMpsyltqUudimrNsC5CyyKU+Tv8Cm3Pk25c9TB0h5s9XBV+FMNXSlcHpAStyN7+HKuNxN70fHei9VNHeXHL9WVSC4J3I52ZJjA723vRf3LX8il1nG5UiJKSZODOE1Lthr+7t7Ipe5v8QtJYaY+B5oGvmCxZLGnv0lYcXElJPz31+isyiQEkjJhZGSkDtNwu4ucZd0RbL53Snj8rq4jB4T3wNNQ/eYePWZeC1UDCUmoZrf7+gSvPHd3PruLF0yxwbf0TvQAF/c16bi/oq8gQEKByhyByuyrw6QO8Sm3GE2ZV2jyLxWkTHcgSl9RICD1zGljmTaP4opUbNvNNOeMUwJY5l2Xc+0c4Jix0SmXTcwJUxk2jeOKWkM08Hr1H+n4GqbTgywfQ/2tn3PdrN9b3aU8pN2OsBv7XrotvWgjUscnH6GK1ylGu4yJHcpkkNsCIGop0uUvKjnwnm/KRHISEBKICVVWEouUE9NDSNb44hN/QhpYIhNnNGP4z5EMYdCmH1ezgFLWyPL4z7IcTCzPl2kPNPN9v2+r+17cohNp0bZlDeB6dBkpuRZTAkLmHYsYdp0e4DNS9Th0nZ9uJQwV7F7HtO+eUzJ85hS5zIdnKNIm8uUPsemw7M1MxVHZth05FabDk+zKXOaTVlTg8mZosidrDL5+bfozP4klSExsyRFE2wq0HtLHIpdvSVOtuT4iLIZk2LXRC5TTIoHli3jMre9m2ISbrmie6GiKSfHOoTOlphi4rVc8VSI3hJ3j4l7VHAFmt7LDCKqQPN7BfeXQEogJRWSkkjFxLvHJJRFu2Zg+x6rF7753ZSS4pjgVKRbTI6VIyVe07nMjElR68ANwZGU4nauGtD2iqKOirxONpV0simvi01FndXbwq7BZDl0tym3h01ZPRU5vRSZvRUZfWzK6MOU3jdAan+mRM2eAYqEgUwJVwfYPZhp7yCmxIHq89P7qq9XoG+S93S0fU9cZftOt5G+91pJ+W0zI9A3G1C9mlSv8BABszTCXYpkliM18fi8hh4CUccQA5M6Hjgfq2VIRI3zFokfzjXAApdYSl6uIlLyCqQkOqTkAklNdeP+Zd7rvA5T3B9z5Ma578Z49ORc4dGjY37MFBznUKldiJLVdgH+1dH2ne5u+x7va9Ndg23KG27TkdFMaeOZEicx7byFaetUpm23KrZMU/++Y7L6WMJN6vOSb1SkatJuZEqfZNPhG41M/gSbMscrjoxTZF6vGaPIHq3IH21T0SjNdbqSYLii8FpdZXCNZmigr8TZXeLV9O5kTJyy61A9Jmbzu1dviZkxCdX87tX4fsIjW3KqReRi4q4m8ZISj03vnoRqfr8gUlINUgIpOe+JXGF7TcIuVfSSk/KWLJpiYi5WdNt/UZx3OVeosq58TV5LRe6VHrQJJrOtwVUmTOntA6R0ZErspNjdmSmxSynWnq6K/QpK78yU3tGm7PY2Feqb0slWtu+RFrbvuea27+0rpPww1hXox4TASwQauUoQwpUkeX3cSx5qucTAoZYH7s8plYhKk5GAlFxSPOQChOZlSEn0SskFlJoarvtuqIMcL+q5sjaNwjxX3M8dc+DAFR5ZnBD850rp+3tb23e6ve17vItN9/a0qbCfTZmDmdKHMSWPYNo7kmnXGMWOsUzbxjDtGM20cxRTwkim3dcxJQ5nSr6Waf9wptRrmQ4ONysFVOWAU0mQNVRRWmkwuCwFgwLVCYVOv6dRumXiVDs4MuLOlHj1lpi4y7mK23uLidcOE7Pp3b1UsbyJXG4p0b0lvocbRyQmnvtMIpcSr4lc5VFevwkkBFISbvt7sJiUmy0JVdblvODzG5Qt68ptFLxoMUdnTkzcglIUZ1NW01AwpV9hU1YzpvTmTPuaM6W2UCS2DJDQSpF0pSK1FVN6S5syW9iU2YIpvbkSHl3P6Xs41vY9GWP7nm9i+95tGCbwbxCBCNQLcWJWJ8xpWqisgpcclEcNQyBKJaJKljZBSi61lEA2KgCk5PKVkgu1h8xDbEIdKpm4szr1XM+3hh4DPRqFGPIR4yE5YUp2z1xh+95tafueu9L2PdbO9j3YQQlAVk9VVZDYX1UR7B6s2DGYadcgRcLAQKWBU3mQ2p/pYD+nKkFVKmT2DVQumDhVDbk9FAXdy5Lbrey+kpJOwRSF2V/i3vjuVcrl3l1SkYlc7lIup+ndnHaa2yiklJQRkxAb371GBUNKICWXqtfEbHxXkxjCSwlTel2H0NtElaQwpZfKCVN6Y6bkJsEkxARjfiy9MVN644DcODgX3NP1Fb+tJ30f1K3AiVMoEXALgfvGXjuCjIJbDsJR3YNqVVokICWQEkgJpARScp4/t+bnMiigmvGcqeEhN6EIJzf1KtCT4xagxuVner6JtX1vX6GqDx5radM9V6ry7PwONmV3ZDrQhWlPV6a93ZkSegTY0Z0poZtiT1em/V3V5x7owpTe2aYjXQw6KbI7KvI7lKXgKkVxO0VhW2+KWgdwT+EKNyLYa7miV4+Je0RwiDHBIXtMXKX4XqOCw4wJjgRICaTkQpZ0lekzYUqvXZadQWLixhEX823ZF//btWzf2+eSCbgQRCoI5UoDJAJSAikBkBJISWWWkguYqanmeh7WOAfBCVWyFqofJ5QAeU1UdPFlI9v3aqzt+3Wc7XvkisDKgcxWNmW2Zkptq0hup9h7FVNCe/XWwfmY87npbZjS29iU2bosTgl5ZitVXp7ZIlByHgqnVN2rp+RY00AFiSMmxTHBe0si6S853lAdFEc+KtgtJpEKCqQEUnLRxwebVCB4rx7m5lX9PKl2oahwAIxAGFICICWQEkjJZSQlF0FswsmNF+H6IGuHIZz81CsP2/duQ9v3WiPb90xj2/eYsXuttKTcKCV3SGgRwHz//maK9CtMAl/LkY9QOCXvOU3Clm1FJCXBYlKh/SXnMSoYElIJpaSSU62SIAAAlRuIBqQEUgIpuYRS4yU3kRyKVqSqolY5AhS6LNz3QV3p+6Cu7fttPVVmbg4Eym1kU04TpvSYACmxAXbHKZx/d0rbvcrZ3Tj9ve7pW/kNvErtQ2dKQu8vOddRwZAQSAkAAEBKICWQEkgJBgZU/IC0PME5V9mJSIZs37u1Fc/UsX3P1DH7QIyS+fpM+xqUZXe9soQuuXdnSc4xU4JGd0gJAABASiAlkBJICaikclPRzE4kJW1hsX2na5ZiTtUK2StssslLRBTW0hqQEkgJAABUNinBnpLIeQVSAimBlICLIDnnK0dhPy9s77G1tIYbZ4m3J5CQH1dKAADgsriRns9WdCGqb4jbtH1r0+0fRyn/bFC9YRshREMhRE0IKgCgCvYLh/u7Xh/DRndICQAARMGNN/hPzfVxGw9GsZR83LV2t3FCiFZCiHoIeAAAAFICKQEAgOiTktrr4jYUR7OUXF1vyHIhRCedLcHEQAAAgJRASgAAIMqkpM6GuI33RbOUjG0wbq8QoqcQookQojoCDgAAgJRASgAAILqkpO6GuE1PRLOU3NJoSpYQoo8QIk4IUUN4/MHvHQAAAKQEAAAqr5TU2xS35YVolpJZjeecEEIMFEJcIYSoCSkBAAAAKQEAgOiSkvqbm259O5qlZFGTxT8VQlwthGghhKgFKQEAAAApAQCA6JKSBluabvtrNEvJ8tgVzwshrhVCXCmEqAMpAQAAACkBAIAokpL2tTrERLOQbG26/eM1ceveFEJcJ4RoI4SoCykBAAAAKQEAgCiSkhsa3tgu2qVkU9yWvwohxgohrhJC1IeUAAAAgJQAAED0SEm1WY1n94l2KdnadPvHDas3vEkI0VEI0QBSAgAAAFICAABRJCWLmtw2oipISfc6PW4TQnR2FihCSgAAAEBKAAAgOqSk+pKYZTdVBSm5pt61m4UQ3YUQjSElAAAAICUAABA9UlJjeeyKuVVBSiY0mLhfCNFbCBErhKgOKQEAAAApAQCA6JCSmitiV62oClIyrdGtBUKIfkKIpl4LFPF7BwAAACkBAIBKKiWrYlfvqApSMq/J/HuFEIOFEM0gJQAAACAlAAAQPVJSa3Xs2gNVQUqWxCx7UggxVAjRUghRG1ICAAAAUgIAANEhJbXXxq3PrwpSsiJ21ctCiOFCiNZeW93xewcAAAApAQCAyiklddbHbTxZFaRkXdyGd4QQo4QQbYUQ9SAlAAAAICUAABAdUlJ3Q9zGn1YFKdnSdNsHQojrhRDtvba64/cOAAAAUgIAAJVTSuptjNv8bFWQkq1Nt3/cqmarGUKITnqBIqQEAAAApAQAAKJASupvarrlt1VFSvrW7RcvhOgqhGjkXqCI3zsAAABICQAAVE4pabCl6bZ3q4qUjKo/eqcQoocQool7gSJ+7wAAACAlAABQSaVka9Pt/6wqUnJTw5sPCSH6CCHihBA1ICUAAAAgJQAAUMmlZGT9US2qipBsbbr945mNZx0TQgwQQlzhXqCI3zsAAABICQAAVD4pqXZroxndq5KULGyy6GEhxNVCiOZCiFqQEgAAAJASAACo5FIyv8nCIVVJSpbFLH9GCHGNEKKVe6s7fu8AAAAgJQAAUPmkpPqSmGXjq5KUrI5d81shxHVCiDZCiLqQEgAAAJASAACo3FJSY1nM7TOrkpRsiNv0nhBijBCinXurO37vAAAAICUAAFD5pKTm8tgVy6qSlGxtuv2jOtXqTBRCdBBCNICUAAAAgJQAAEAll5KVsas3VTEp+bhT7U7zhBCd3Vvd8XsHAAAAKQEAgMonJbVWx67dV9Wk5Op6Q9YJIbq5t7rj9w4AAABSAgAAlU9Kaq+NW59Z1aRkXIPx+4QQvYQQMeZWd/zeAQAAQEoAAKASSsm6uA1Hq5qUTGk0NUcI0VcI0dTc6o7fOwAAAEgJAABceglx/6mzIW7jQ1VNSuY0nntSCDFICNHM3Oq+qGgQcOH+g2sFAAApAQAA8GNJSbVh866qNT93wFdrhiyxNrffYFclbhs63Zq0tduZGWn9vl6QN/Dfi4oGgaJB/56a2KuhEKIapAQAACAlAABQGaSk+vVrOjedlzPgq3X9llNVk5JlA+bTDZu7nZl+oO/X83MHfAUhUUxL7t1dCFEdUgIAAJASAACoDFJSc8yKTu3n5Qz4akOPVb6qJiWreyzzTdjY9cyt+/t8AykJkpIxQohakBIAAICUAABAZZCS2qOWd+w5L3vAV5s6rZNVTUo2dForx63r8u2tKb2/mZcDKSmVkpTec4UQtc0SLkgJAABASgAA4FJISTUhRO3xG7oOm5cz4KtbU3p/M259129H3Nb+u2Fz2v1n6OzoZtjcdv+5bkmH7yZu7Hrm1v2QEpMZB/tuFELUhZQAAACkBAAAKoOU1LlhS7dR83MHfDUjrd/XN+3s/r/j1nX5dsyKTtHPyk7fjlvX5dubdnb/3xnp/dBTYjDrcL9UIUQ9s68EUgIAAJASAAC4ZFIyaXv3CQvyB/57Xlb/r2ak9f16WnKvb6Ym9vpmSpQzNbHXN9OSe38zI63f1/Oy+n+1IB/TtxzmZPY/KoSoL4SoASkBAABICQAAXHIpuWVPz+kLCwf9e0H+wH/Pyxnw1bys/lWK+bkDvlqQP/DfCwshIw7zcgY8KoRoACkBAABICQAAVAYpqTtlX685CNQvL+bnDTwthGgohKgJKQEAAEgJAABcSimpLoSoOy259xIE6pcXCwsG/kkI0QhSAgAAkBIAAKgMUlJvemqfNQjULzMKB31eu16NGHNXCaQEAAAgJQAAcOmk5ECfTQjULz+Gzm7XSQhRG1ICAACQEgAAuNRSUn9mWt/dCNIvPyZu6joMUgIAAJASAAC41FJSQwhRf1Z63wMI0i8/btnd8xZzqzukBAAAICUAAHCppKTBrMP9DiFIv/yYntrndiFEHUgJAABASgAA4JJLyZwj/QsQpF9+zEzvu1MIUdfZ6g4pAQAASAkAAFw6KcnsfyeC9MuP2Rn9MoUQ9SAlAAAAKQEAgEspJTWFEA3nZvW/G0H65cfcrP53m1vdISUAAAApAQCASyUljeZlD/gpgvTLcKt77oCn9FZ3SAkAAEBKAADgEktJzoAnEaRffizIG/g7c6s7pAQAACAlAABwyaRkfu6AZxCkX34sLBz0vhCiMaQEAAAgJQAAcKmlpPH8vIGvIki/PGnbN6aZEKIWpAQAACAlAABwqaSklhCi8YK8gW8iQL88GR3fqZez1R1SAgAAkBIAALhUUtJkYcHAPyJAvzyZtL37aEgJAABASgAA4NJLSeGgvyNAvzyZmtRrjrPVHVICAACQEgAAuFRSErOocNBHCNAvT6Yf6LNGb3WHlAAAAKQEAAAuiZTUFkLEIDi/fJl1qF+ys9UdUgIAAJASAAC4JFLSaWjTVgjOL1/mZPYvFELUF0LUgJQAAACkBAAALomU9LvpyqsQnF++zMsZ8JAQogGkBAAAICUAAHDJpGTE4g69EJxfvszPG/iCEKKh3lkDKQEAAEgJAAD8+FJy/erOgxCcX8Zb3QsG/o8QohGkBAAAICUAAHAppKSaEKL2+A1dhyE4v4wpHPSpEKKxnsQGKQEAAEgJAAD86FJSZ9L27hMQnF/e9L/lynaQEgAAgJQAAMAlk5JbEnrejMD88mbcui6D9HhoSAkAAEBKAADgR5eSurfs6TkDgfnlzS17ek6ClAAAAKQEAAAumZRMTeq9GIH55c205N63CSHquLe641oBAEBKAAAAXGwpqS6EqDctufdyBOaXNzPS+m4VQtSFlAAAAKQEAAAuiZRMT+2zHoH55c3sjH6HhBD19GsCUgIAAJASAAD4UaWk/oyDfXchML+8mZPZ/4QQor57qzuuFQAApAQAAMDFlpIaQoj6M9P77kNgfnkzL2fAz4UQDSAlAAAAKQEAgEsiJbMO90tDYH55syBv4KteW91xrQAAICUAAAB+DClpMDujXy4C88ubhQUD/6K3ukNKAAAAUgIAAD++lMw50r8Igfllz5fNOzds6t7qjmsFAAApAQAA8GNIScM5mf1PISgHI25r39W9QBHXCgAAUgIAAOBiS0lNIUTDuVn9H0RQDiZt7z4CUgIAAJASAAC4FFLSaF72gJ8iKAdT9vW6VUtJNUgJAABASgAA4EeVkvm5A55BUA5u3d9nhRCiDqQEAAAgJQAA8GNLSeP5eQNfRFAOZh3qt9e91R3XCgAAUgIAAODHkpLXEJSD2Rn9cvVWd0gJAABASgAA4ILLR6g/tYQQjRcWDHwHQTmYm9X/AfdW91fi+v2onMsfXOcAAEgJAABEr5TUEEI0XFev9TVrUgbS8sxBNri82bZ5wA/PxPb56HRc33++EtfvkvJyXL/nzIwNpAQAACkBAICqJyXVdO9A6xX1Wi5adXCgD0E5WL93oPWr2N4fvVQ5pOQ99yJHSAkAAFICAABVS0pqCCHihBADl9ZtcTA+AwE5GGSvTB8kfxnb+6MX4vp+eKml5JW4fv/c26BdW0gJAABSAgAAVVdKagohWgkhxsbXa3nXIzE9PrmnSbdPTzTp+hm4/LirSdfP7mnS7dNHY3p8UlkyJa/E9ftncePO15rjiSElAABICQAAVC0pqS2EaCeEuGVr/TaPPRHT8+OHY3p88kCT7uAy5ZGYHp88EdPz41/H9vmwskjJPU26zY2krwTXOQAAUgIAANEpJXWEEB2EEFNSGl71y2dj+3z4y9jeHz0NLlt+Gdv7o2dj+3z4fFzfD09XAiF5Ja7fPx+J6bFFZ/UgJQAASAkAAFRBKaknhOgihJiR37jziy/F9f3nC3F9P3weXLa8ENf3w5fi+v7ztGoyrxRS8kRMr0yd1YOUAAAgJQAAUAWlpIEQorsQYs6pJt1ee6WSBKEAmPwytvf9WqAhJQAASAkAAFRRKeklhFjwSEyP3yMABpWR52L7PK9fq5ASAACkBAAAqqCUNBZC9BVCLPllbO/3EACDysjpuL7vCiEaQUoAAJASAAComlLSRAjRXwix/KW4vv9AAAwqK7fVa9EaUgIAgJQAAEDVlJJYIcTgVtVrb0LgCyozOY06DitvVwmucwAApAQAAKJPSqoJIZoKIYYNqtVwHwJfUJk51aTb9PJ2leA6BwBASgAAIDqlpJkQYsTE2rEZCHxBZebhmB4byttVguscAAApAQCA6JOSGkKIVkKI0fPrNi9C4AsqM4/H9DxU3q4SXOcAAEgJAABEn5TUFEK0FkKMX12/1SkEvqAy83Rs77uFEHUhJQAASAkAAFQtKakthGgnhLgxoUHbnyDwBZWZX8f2eba8XSW4zgEAkBIAAIg+KakjhOgghLglvWGHpxD4gsrMS3F93xFCNISUAAAgJQAAULWkpJ4QorMQYnpB407PI/AFlZ2pdZq2hJQAACAlAABQtaSkgRCiuxBizqkm3V5D0AsqO0cadRwcblcJrnMAAKQEAACiU0p6CSEWPBLT420EvaCyc1eTrlMgJQAASAkAAFQtKWkshOgrhFjydGzv9xD0gijYVbI63K4SXOcAAEgJAABEn5Q0EUL0F0Isfymu7/sIekFl57GYngeEELUgJQAASAkAAFQdKYkVQgxuXr3WRgS8IEp2lZwIt6sE1zkAAFICAADRJSXVhBBxQoihA2o13IeAF0QDz8b2+YUQoj6kBAAAKQEAgKojJc2EEMPH1Y45jIAXRAMvxvV9O9yuElznAABICQAARJeU1BBCtBRCjJ5ft3kRAl4QJXwwpFajppASAACkBAAAqoaU1BRCtBZCjF9dv9UpBLsgWkhv2KFvqLHAuM4BAJASAACILimpLYRoJ4S4cVeDtg8j2AXRwp2Nu94EKQEAQEoAAKBqSEkdIUQHIcQtaQ3bP4VgF0QLDzbpHq/LDyElAABICQAARLmU1BNCdBZCTM9r1Ol5BLsgWvhpTM/kULtKcJ0DACAlAAAQXVLSQAjRXQgx+1STbq8h2AXRwlOxvY7qTB+kBAAAKQEAgCogJT2FEPMfjunxNoJdEC08E9vnCZ3pg5QAACAlAAAQ5VLSSAjRVwix+KnYXn9CsAuihRfi+r6hpRpSAgCAlAAAQJRLSRMhRH8hxPIX4/q+j2AXRAsvx/V7v1vNenGQEgAApAQAAKJfSmKFEIPjqtfcgEAXRBtJDa/qBSkBAEBKAAAguqWkmhAiTggxtH/NBvsQ5IJo42jjLuO9dpXgOgcAQEoAACC6pKSZEGL4+NqxhxDkgmjj/ibdl3rtKsF1DgCAlAAAQPRISQ0hREshxOi5dZsVIsgFUbirZI8QoiakBAAAKQEAgOiVkppCiNZCiHGr6rc6iSAXRBtPxvYqFELUhpQAACAlAAAQvVJSWwjRTghx484GbR9GkAuijV/F9n7Ma1cJrnMAAKQEAACiR0rqCCE6CCFuSWvY/kkEuSDaeD6272teu0pwnQMAICUAABA9UlJPCNFZCDE9r1Gn5xDkgijcVfL35tVrxUBKAACQEgAAiF4paSCE6CaEmH2iSdfXEOSCaGR7gzZdISUAAEgJAABEt5T0FELMfzimx9sIcEE0Uty481j3rhJc5wAASAkAAESPlDQSQvQVQix+KrbXuwhwQTRyb5NuC927SnCdAwAgJQAAED1S0kQI0V8IsfyFuL7vI8AF0cijMT12uHeV4DoHAEBKAAAgeqQkVggxKLZ6zQ0IbkG08kRMrzz3rhJc5wAASAkAAESHlFQTQsQJIYb2q9lgD4JbEK38Mrb3w+5dJbjOAQCQEgAAiB4paSaEGD6udswhBLcgineVnHbvKsF1DgCAlAAAQHRISQ0hREshxKjZdZsVILgF0crpuH5/1kMbICUAAEgJAABU8v4R95+aQogrhRDjVtVvdReCWxDNrK1/ZQfzxT3lid9fMCL9g/sNAJASAAAAFZeSWkKIdkKIG9ZeO+WrX3QeIwGIVhan3/v1lMff/nzKE7+/GFwPKQEAQEoAAODCS0k13RjcSQhx685rpnyPwBZEM+u3556Z/PhbF0VKbnnsd7e7lzNCSgCAlAAAADh/KakuhGgshOhTu1FMfMrVt5xFYAuimd3Lk76b/NibF0dKHn09XZc7VoOUAADwQwAAgAsnJTWFEFcIIa5tfFWX/VkDbrQQ2IJoJn3mxv/e8ujrX1wUKfnJ6w8LIepASgAAkBIAALiwUlJb95Pc1LTXwFMlfSYSAlsQzRSNX/LDzY+8dnGk5KdvvKGne9WAlAAA8EMAAIALIyVOP0lXIcTcFoOG/+K+Htf7ENiCaObuYTPO3vTwby6KlEx5/O1PGl/VuZkeDgEpAQBSgh8CAABcIClpKIToI4S4/crh4157vAuCWhDdPN5zgu+mB1/54iJN3/q835o9A3WGEVICAKQEPwQAALgAUlJdCNFECDFACLGq/Q3T3+4yc+l/rpo4/ft2E6YBEDW0v2HG911n3f6fgRtTzozJe+jfF1NKrjt8cobuK4GUAAApwQ8BAAAugJTUEELECCEGCSFu77lo/R/7rdnzba8lm77ttXgjANHD0k3f9luz99thifnfjCt54suLVr71xO8/v774sc267LEapAQASAkAAIDzl5KaQog4IcRAIcTCa5IK/zQq676vRhw68fWIdACiiEMnvh6Vdd9X4+742b9vvP/FL2/56RsXTUomnnwmR5c9QkoAgJTghwAAABdASmoJIZrp8q15448/9dcb73/xyxvufQGAqOPG+1/88qaHXvnilkdf/+JiLU+c8sTvP5/0wOmf6rLH6pASACAlAAAAzl9KagshWujyrbmTH3vz04sVyAFQVbj5J799XQgRqzONkBIAICUAAADOU0rqCCFaCSGGNr6q8yoEnABENBb44zpNYpuHGwuM+w0AkBIAAACRS0ldIURrIcS1rUdMSEDACUBk9F25q3+4scC43wAAKQEAABC5lNTT29yv63Lr4gwEmwBExoi0O6eGGwuM+w0AkBIAAACRSUk1IUQDIUQHIcSYPvE7jiPYBCDiscAbw40Fxv0GAEgJAACAyKWkkRCikxBi/NU7Dj+EYBOAyJhw4peZ4cYC434DAKQEAABAZFLibHPvKoS4cXhqyS8RbAIQGTfe9+Ij4cYC434DAKQEAABAZFJSQ4817SmEuGV07kO/QbAJQMRjgV/T108NSAkAkBIAAADnLiU1hRBNhRB9hBC3jj/+9DsINgGIjMmPv/Vhjbr1moXaVYL7DQCQEgAAAJFJibPNvb8QYtakB19+H8EmAJHT+/atfUKNBcb9BgBICQAAgMikpLYQoqUQYnD12rUXTn78rX8h0AQgcoYfOHZzqLHAuN8AACkBAAAQmZSUbnOP6dJrHYJMACrG2MKfrtVjgSElAEBKAAAAnKOU1BNCtBFCXNt27C37EGQCUOGxwBmhxgLjfgMApAQAAEBkUlJfCHGVEGJk97krcxBkAlDhscAPCCEae40Fxv0GAEgJAACA8qWkmj7h7SiEGNtv9e4TCDIBqPBY4N8IIWK8xgLjfgMApAQAAEBkUtJYCNFZCDFhyK7MRxFkAlDhscAf6LHaNSElAEBKAAAAVFxKnG3u3YQQN41Iu/NZBJkAVJweC9f21uO1ISUAQEoAAABUUEpqGtvcJ48t+MlvEWACcC5jgY/e5DUWGPcbACAlAAAAypeSWkKIK/Q29+kTTz7z/xBgAnAuY4EfXeU1Fhj3GwAgJQAAACKTkuZCiAFCiNk3P/zqBwgwATiXscC/SBdCNHCPBcb9BgBICQAAgPKlpLZenHh1rYaNFyO4BOAcxwLf+8L9emgEpAQASAkAAIAKSkkdIcSVQoihzfoN2YzgEoBzHAv88Ksve40Fxv0GAEgJAACA8qXE2eY+vP0NM/YjuATgHMcC/+ytf3iNBcb9BgBICQAAgPBSUs3Y5j6qx8K1eQguATh3us5c1t09Fhj3GwAgJQAAAMqXktJt7gM3ptyDwBKAc+ea5KIb3WOBcb8BAFICAACgfClxtrlPHLYv73EElgCcO2PyH17hHguM+w0AkBIAAADhpaSG3ubeXQhx08iMu59HYAnAeY0FPugeC4z7DQCQEgAAAOGlpKYQIk4I0VsIMfX64sd+h8ASgPMaC3yveyww7jcAQEoAiOaJSBH9qTdmNQDnhGubez8hxIwb7v71nxFYAnBeY4Ff0NnHGlX9Pn2uf/CsB5ASAKJLSqoJIarVG7PaD8BFY9QKf90RS/x1Bs/01+45wT/+1Av+Gx98FQBwjow79YK/7oil/nqjV+L+Mma133mWQUoApASA6G0+ri6EqIGHGrjoUjJ8sb/OoBn+Wj3G+Wu2H+yv2aqHv0azTv4aV3QEAJRH887+mlf28tfsMMRfu9cEf53Bs/x1Ryzx1xsFKdFSUkM/z1DOBiAlAESplNQQQtTGQw1cfCm5TUlJz3H+mh2G+Gu26eOv2bK7v2aLbgCA8mjZXV0zHYf5a/ea6K8zeKaWkhW4vygpqa2fZ5ASACkBIAqlpLqu9W+Ahxr4Ucq3rp7lr937Bn+tLtepbEm7/v6abQEA5dJugL9m+6v9tbpe56/d50Z/natnQ0qCpaSBfp5Vh5QASAkA0SkldYQQjfFQAxdXSlb6645Y5q87bL6/zoCp/tq9JvprdR/jr9X1OgBApHQf46/de6K/zsBp/rrD5vvrjliG8q2AlDTWzzNICYCUABCluyPqCiFi8FADF5XRK/31Ri5X2ZKh8/x1Bs3w1xk4zV97wBQAQITUGThNlW0Nna+yJCOXo9E9ICUx+nlWA1ICICUARKeU1BNCxOKhBi6ulKxSJ7ojl/vrjljqrzv8Nn/daxf6616zAAAQKdcuVNfOiKVKSEatVNcW7jF+IUSsfp5BSgCkBABICQDliMnolaoGfmS8CqoAABUkXl1DoyEkkBIAKQEAUgIAAABASgCAlABwYXtKhBCthRCdhBDdhRC9AAAAgEpOd/3cao2eEgApAaCKTN8SQrQQQrTTN/guAAAAQCWnk35utcD0LQApAaCK7CkRQsTpG3trIURbAAAAoJLTWj+34rCnBEBKAKgiG931Db2xToHHAgAAAJWcGP3caoCN7gBSAkD0S0l1fSOvpVPfdXWzIAAAAFCZqaufW7X0c6w6pARASgCITilxxMSRE0dQAAAAgGiguiEj1cyHG571AFICAAAAAAAAAJASAAAAAAAAAKQEAAAAAAAAACAlAAAAAAAAAEgJAAAAAAAAAEBKAAAAAAAAAJASAAAAAAAAAICUAAAAAAAAACAlAAAAAAAAAAApAQAAAAAAAEBKAAAAAAAAAABSAgAAAAAAAICUAAAAAAAAAACkBAAAAAAAAAApAQAAAAAAAABICQAAAAAAAABSAgAAAAAAAACQEgAAAAAAAACkBAAAAAAAAAAgJQAAAAAAAIDKwv8fAH/7G6WUoF7+AAAAAElFTkSuQmCC" /></div>
                    <div className="bodyTitle_Container"><span className="bodyTitle" alt="Databay" title="Databay">Databay</span><span className="subBodyTitle">3.2</span>{bodyTitle_siteMode}</div>

                    <div className="betaBodyTitle_Container"><span className="betaBodyTitle" alt="Betabay" title="Betabay">Betabay</span><span className="betaSubBodyTitle">v.1</span></div>
                </div>
            );
            bodyInfo.push(
                <div id="fishContainer" ref="fishContainer" className="fish-container hidden">
                    <div id="fish" ref="fish" className="fish-fall">
                        <i className="fal fa-fish"></i>
                    </div>
                </div>
            )
            bodyInfo.push(
                <div className="waveContainer">
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                        </g>
                    </svg>

                </div>
            );

            if (showNotifications || showResourceRanking || showUserPermissions || showAccessGroups || showRanks || showCreate || showGame) {

                bodyInfo.push(
                    <div className="hidden"><span className="logoSearchContainer"><i className="logoBodySearch fal fa-search"></i>{searchBodyInput}<i className="logoBodySubmit fal fa-arrow-alt-right" onClick={this._bodySearchTermUpdated.bind(this)}></i></span></div>
                );
            }
            else {
                bodyInfo.push(
                    <div><span className="logoSearchContainer"><i className="logoBodySearch fal fa-search"></i>{searchBodyInput}<i className="logoBodySubmit fal fa-arrow-alt-right" onClick={this._bodySearchTermUpdated.bind(this)}></i></span></div>
                );
            }
            bodyContent.push(<div className={(isHomepage ? "homepage_bodyInfo" : "home_bodyInfo")}>{bodyInfo}</div>);

            //LAYOUT INFORMATION HERE!
            var layoutSelectorLeft = <i className="layoutIcon fal fa-sort" onClick={this._showLayoutSelectorLeft.bind(this)}></i>;
            var layoutSelectionLeft = <div ref="layoutSelectionLeft" className="layoutSelectionHidden">
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "favorite")}><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "top10")}><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "newest10")}><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "shared")}><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "topRated10")}><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorLeft.bind(this, "topTags")}><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div>
            </div>;

            var layoutSelectorMiddle = <i className="layoutIcon fal fa-sort" onClick={this._showLayoutSelectorMiddle.bind(this)}></i>;
            var layoutSelectionMiddle = <div ref="layoutSelectionMiddle" className="layoutSelectionHidden">
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "favorite")}><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "top10")}><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "newest10")}><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "shared")}><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "topRated10")}><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorMiddle.bind(this, "topTags")}><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div>
            </div>;

            var layoutSelectorRight = <i className="layoutIcon fal fa-sort" onClick={this._showLayoutSelectorRight.bind(this)}></i>;
            var layoutSelectionRight = <div ref="layoutSelectionRight" className="layoutSelectionHidden">
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "favorite")}><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "top10")}><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "newest10")}><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "shared")}><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "topRated10")}><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div>
                <div className="layoutSelection_Element" onClick={this._updateLayoutSelectorRight.bind(this, "topTags")}><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div>
            </div>;

            var favoriteHeaderLeft = <div className="home_favoriteInfo layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="favoriteInfo"><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div></div>;
            var top10HeaderLeft = <div className="home_top10Info layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="top10Info"><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div></div>;
            var newest10HeaderLeft = <div className="home_newest10Info layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="newest10Info"><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div></div>;
            var sharedHeaderLeft = <div className="home_sharedInfo layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="sharedInfo"><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div></div>;
            var topRated10HeaderLeft = <div className="home_topRated10Info layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="topRated10Info"><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div></div>;
            var topTagsHeaderLeft = <div className="home_topTagsInfo layoutHeader" onClick={this._showLayoutSelectorLeft.bind(this)}><div className="topTagsInfo"><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div></div>;

            var favoriteHeaderMiddle = <div className="home_favoriteInfo layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="favoriteInfo"><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div></div>;
            var top10HeaderMiddle = <div className="home_top10Info layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="top10Info"><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div></div>;
            var newest10HeaderMiddle = <div className="home_newest10Info layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="newest10Info"><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div></div>;
            var sharedHeaderMiddle = <div className="home_sharedInfo layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="sharedInfo"><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div></div>;
            var topRated10HeaderMiddle = <div className="home_topRated10Info layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="topRated10Info"><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div></div>;
            var topTagsHeaderMiddle = <div className="home_topTagsInfo layoutHeader" onClick={this._showLayoutSelectorMiddle.bind(this)}><div className="topTagsInfo"><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div></div>;

            var favoriteHeaderRight = <div className="home_favoriteInfo layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="favoriteInfo"><i className="logoFavoriteInfo fal fa-star"></i> My Favorites</div></div>;
            var top10HeaderRight = <div className="home_top10Info layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="top10Info"><i className="logoFavoriteInfo fal fa-file-chart-line"></i> Most Viewed Reports</div></div>;
            var newest10HeaderRight = <div className="home_newest10Info layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="newest10Info"><i className="logoFavoriteInfo fal fa-newspaper"></i> Latest Reports</div></div>;
            var sharedHeaderRight = <div className="home_sharedInfo layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="sharedInfo"><i className="logoFavoriteInfo fal fa-handshake"></i> Shared Resources</div></div>;
            var topRated10HeaderRight = <div className="home_topRated10Info layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="topRated10Info"><i className="logoFavoriteInfo fal fa-thumbs-up"></i> Top Rated Reports</div></div>;
            var topTagsHeaderRight = <div className="home_topTagsInfo layoutHeader" onClick={this._showLayoutSelectorRight.bind(this)}><div className="topTagsInfo"><i className="logoFavoriteInfo fal fa-hashtag"></i> Top Resource Tags</div></div>;

            var favoriteBody = <div className="home_favoriteInfo"><div className="favoriteInfo_Body">{favoritesBodyList}</div></div>;
            var top10Body = <div className="home_top10Info"><div className="top10Info_Body">{topReportsBodyList}</div></div>;
            var topTagsBody = <div className="home_topTagsInfo"><div className="topTagsInfo_Body">{topTagsBodyList}</div></div>;
            var newest10Body = <div className="home_newest10Info"><div className="newest10Info_Body">{newestReportsBodyList}</div></div>;
            var sharedBody = <div className="home_sharedInfo"><div className="sharedInfo_Body">{sharedReportsBodyList}</div></div>;
            var topRated10Body = <div className="home_topRated10Info"><div className="topRated10Info_Body">{topRatedReportsBodyList}</div></div>;
            var topTagsBody = <div className="home_topTagsInfo"><div className="topTagsInfo_Body">{topTagsBodyList}</div></div>;

            //default layout
            var layoutHeaderLeft = <div className="home_layoutHeaderLeft">{favoriteHeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
            var layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{top10HeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
            var layoutHeaderRight = <div className="home_layoutHeaderRight">{newest10HeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>

            var layoutBodyLeft = <div className="home_layoutBodyLeft"><div className="loadingLayout"><i className="logoHome fas fa-circle-notch fa-spin"></i></div></div>
            var layoutBodyMiddle = <div className="home_layoutBodyMiddle"><div className="loadingLayout"><i className="logoHome fas fa-circle-notch fa-spin"></i></div></div>
            var layoutBodyRight = <div className="home_layoutBodyRight"><div className="loadingLayout"><i className="logoHome fas fa-circle-notch fa-spin"></i></div></div>


            switch (user_LayoutLeft) {
                case "favorite":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft" >{favoriteHeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{favoriteBody}</div>
                    break;
                case "top10":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft">{top10HeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{top10Body}</div>
                    break;
                case "newest10":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft">{newest10HeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{newest10Body}</div>
                    break;
                case "shared":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft">{sharedHeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{sharedBody}</div>
                    break;
                case "topRated10":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft">{topRated10HeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{topRated10Body}</div>
                    break;
                case "topTags":
                    layoutHeaderLeft = <div className="home_layoutHeaderLeft">{topTagsHeaderLeft}{layoutSelectionLeft}{layoutSelectorLeft}</div>
                    layoutBodyLeft = <div className="home_layoutBodyLeft">{topTagsBody}</div>
                    break;

            }

            switch (user_LayoutMiddle) {
                case "favorite":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{favoriteHeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{favoriteBody}</div>
                    break;
                case "top10":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{top10HeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{top10Body}</div>
                    break;
                case "newest10":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{newest10HeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{newest10Body}</div>
                    break;
                case "shared":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{sharedHeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{sharedBody}</div>
                    break;
                case "topRated10":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{topRated10HeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{topRated10Body}</div>
                    break;
                case "topTags":
                    layoutHeaderMiddle = <div className="home_layoutHeaderMiddle">{topTagsHeaderMiddle}{layoutSelectionMiddle}{layoutSelectorMiddle}</div>
                    layoutBodyMiddle = <div className="home_layoutBodyMiddle">{topTagsBody}</div>
                    break;

            }

            switch (user_LayoutRight) {
                case "favorite":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{favoriteHeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{favoriteBody}</div>
                    break;
                case "top10":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{top10HeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{top10Body}</div>
                    break;
                case "newest10":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{newest10HeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{newest10Body}</div>
                    break;
                case "shared":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{sharedHeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{sharedBody}</div>
                    break;
                case "topRated10":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{topRated10HeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{topRated10Body}</div>
                    break;
                case "topTags":
                    layoutHeaderRight = <div className="home_layoutHeaderRight">{topTagsHeaderRight}{layoutSelectionRight}{layoutSelectorRight}</div>
                    layoutBodyRight = <div className="home_layoutBodyRight">{topTagsBody}</div>
                    break;

            }

            var columnLayout;
            columnLayout = [];

            var columnSelection;
            columnSelection = [];

            if (this.state.user_InterfaceColumns == "1") {
                columnSelection.push(
                    <div className="singleColumnLayout columnSelected" alt="1 Column Layout" title="1 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 1)}>
                        <div className="column"></div>
                    </div>
                );
            }
            else {
                columnSelection.push(
                    <div className="singleColumnLayout" alt="1 Column Layout" title="1 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 1)}>
                        <div className="column"></div>
                    </div>
                );
            }
            if (this.state.user_InterfaceColumns == "2") {
                columnSelection.push(
                    <div className="doubleColumnLayout columnSelected" alt="2 Column Layout" title="2 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 2)}>
                        <div className="column"></div>
                        <div className="column"></div>
                    </div>
                );
            }
            else {
                columnSelection.push(
                    <div className="doubleColumnLayout" alt="2 Column Layout" title="2 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 2)}>
                        <div className="column"></div>
                        <div className="column"></div>
                    </div>
                );
            }

            if (this.state.user_InterfaceColumns == "3") {
                columnSelection.push(
                    <div className="tripleColumnLayout columnSelected" alt="3 Column Layout" title="3 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 3)}>
                        <div className="column"></div>
                        <div className="column"></div>
                        <div className="column"></div>
                    </div>
                );
            }
            else {
                columnSelection.push(
                    <div className="tripleColumnLayout" alt="3 Column Layout" title="3 Column Layout" onClick={this._updateLayoutInterfaceColumns.bind(this, 3)}>
                        <div className="column"></div>
                        <div className="column"></div>
                        <div className="column"></div>
                    </div>
                );
            }

            columnLayout.push(
                <div className="columnLayout_Container">
                    <div className="columnLayout">
                        {columnSelection}
                    </div>
                </div>
            );

            if (this.state.siteMode == "databayprd") {
                homeExtras.push(columnLayout);


                if (this.state.user_InterfaceColumns == 1) {
                    homeExtras.push(<div className="home_Extras singleLayoutHeader">
                        {layoutHeaderLeft}
                    </div>);
                    homeExtras.push(<div className="home_Extras_Body singleLayoutBody">
                        {layoutBodyLeft}
                    </div>);
                }
                else if (this.state.user_InterfaceColumns == 2) {
                    homeExtras.push(<div className="home_Extras doubleLayoutHeader">
                        {layoutHeaderLeft}
                        {layoutHeaderMiddle}
                    </div>);
                    homeExtras.push(<div className="home_Extras_Body doubleLayoutBody">
                        {layoutBodyLeft}
                        {layoutBodyMiddle}
                    </div>);
                }
                else if (this.state.user_InterfaceColumns == 3) {
                    homeExtras.push(<div className="home_Extras tripleLayoutHeader">
                        {layoutHeaderLeft}
                        {layoutHeaderMiddle}
                        {layoutHeaderRight}
                    </div>);
                    homeExtras.push(<div className="home_Extras_Body tripleLayoutBody">
                        {layoutBodyLeft}
                        {layoutBodyMiddle}
                        {layoutBodyRight}
                    </div>);
                }
                else {
                    homeExtras.push(<div className="home_Extras singleLayoutHeader">
                        {layoutHeaderLeft}
                    </div>);

                    homeExtras.push(<div className="home_Extras_Body singleLayoutBody">
                        {layoutBodyLeft}
                    </div>);
                }
            }
            var teamsLinkURL = `https://teams.microsoft.com/l/meetup-join/19%3Ameeting_ZTYwN2UwZGMtYWRiMS00ODdjLTg3MjctMTQzYzNlMjIxNDJi%40thread.v2/0?context={"Tid"%3A"8cb7de09-a9b2-435c-b453-2c06a1cb5b6c"%2C"Oid"%3A"7af2554d-0314-474a-853d-bb794aff88c6"}`;
            /*
            homeExtras.push(<div className="home_Extras_Message">
                <div className="luminis_MessageText">
                    The IS-Analytics team holds virtual office hours every Tuesday and Wednesday from 1200 to 1300.  Anyone is welcome to attend for training and/or question-and-answer sessions, and can launch the Microsoft Teams meeting by clicking <a className="teamsLinkURL" href={teamsLinkURL} target="_blank">here</a>.
                </div>
            </div>);
            */
            const announcementDayCheck = new Date().getDay();
            var announcementStartTimeCheck = '11:58:00';
            var announcementEndTimeCheck = '13:00:00';

            var announcementCurrentDate = new Date()

            var announcementStartDateTimeCheck = new Date(announcementCurrentDate.getTime());
            announcementStartDateTimeCheck.setHours(announcementStartTimeCheck.split(":")[0]);
            announcementStartDateTimeCheck.setMinutes(announcementStartTimeCheck.split(":")[1]);
            announcementStartDateTimeCheck.setSeconds(announcementStartTimeCheck.split(":")[2]);

            var announcementEndDateTimeCheck = new Date(announcementCurrentDate.getTime());
            announcementEndDateTimeCheck.setHours(announcementEndTimeCheck.split(":")[0]);
            announcementEndDateTimeCheck.setMinutes(announcementEndTimeCheck.split(":")[1]);
            announcementEndDateTimeCheck.setSeconds(announcementEndTimeCheck.split(":")[2]);
            var announcementLink = "";

            if ((announcementDayCheck == 2 || announcementDayCheck == 3) && announcementStartDateTimeCheck < announcementCurrentDate && announcementEndDateTimeCheck > announcementCurrentDate) {
                announcementLink = <button onClick={this._openOfficeHours.bind(this)} className="teamsLinkURL"><table><tbody><tr><td><img className="announcement_TeamsIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAC8ElEQVRoge2ZT0hUURSHv3PnJY5moJtAqF1U87TN5KIgMgnaCBkhSLmshRZtbGEbUyhc1aYGW+e0aplGBWVS4KKWZRgtKxCpZZn67mkxozydP75xZpwnzgdvZs6bc8+7vznn3rn3PahSZXcj5QjaPfy5pm5h/pCnkThiY4K4KsSTD9ubS30tp5jG7cNTTvO8czAinqtG46jEAJeFhSMexiAKCAqkXkpPYAE9198318hyzKpxVTVuRGK6oC7Gq011sCzJ3JQMAZf63jU6suKqMTGr6goSBz2GrjRYFUARQLVMP2mBZAgwxvttEVBND5BwdDQXptIdKJaiBvFW6e17cxhjRoGzACivUTuYHOuYKzRWZTJgzAxwAWgAGhC6MGamp3/6QMGhSt65YDRmO+eI3is0UEVKKA/n/Mbla1OdggwBMWAWa0eSYx2Tfp+wDeK1KS/d+WdAG1APtGHMRO/1qS5/g7AJeLn6QZDb2RxE5ZbfDlxC+xr2UBd11h31dan3aNShPuoQjUaoizrcf/QpbyyB3wpNG07/UqMDPvtwtrYKR7ckIDF6MqjrpgiRE1a8UdH0NAov1OjAkwdnvvvc5oDjmW354rcrMogfJ059BS7mdbJ2GGMmMr+QEb8VWMD4028sr1j+/F3B85QbV1wkvX4bvPOBxX9e6lj0gobMS3KsY7K3702nGDOkEBOYBRkZT5x+viUBr6Z/rLNVFUkr+Dn/h0LWdr3X3ub0Tiba15a16SlzMpcvhG8WKpgdL6Akg7gcW4OgZbbjM1AVUOmdZTUDlWb3ClhaskDlb69s+X/g6s33ABizvTe0FGb8dtElZO22ZsCKtXf9J3bKGFgCPip6fuOeOFSben95+JcL+QhTBjLKIwhhEJCzPIJQkRIKWh5BCEMGimLHC8goIWsjTVkfcKRuxIaOwLWY9RGTqgvUBo1RytpfpaiAOR/ywRGylGfoBOSiu39qb62oq0grSgtiWkBbk4n2/eW4XpUqu5n/fnD99O15Nh8AAAAASUVORK5CYII=" /></td><td>Join Now!</td></tr></tbody></table></button>;
            }
            else {
                announcementLink = <button className="teamsLinkURL" onClick={this._saveCalInvite.bind(this)}><table><tbody><tr><td><i className="announcement_EnvelopeIcon fa-light fa-envelopes-bulk"></i></td><td><div className="announcement_EmailTopText">Send an Email</div><div className="announcement_EmailBottomText">Reminder</div></td></tr></tbody></table></button>;
            }

            homeExtras.push(<div className="home_Extras_Message">
                <div className="luminis_AnnouncementText">
                    <div className="luminis_AnnouncementHeader">
                        <i className="fa-light fa-bullhorn"></i> Announcement!
                    </div>
                    <table className="luminis_AnnouncementBody">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="announcementIcons">
                                        <span className="announcementIcon" title="Training"><i className="fa-light fa-chalkboard-user"></i></span>
                                        <span className="announcementIcon" title="Question & Answers"><i className="fa-light fa-messages-question"></i></span>
                                        <span className="announcementIcon" title="All are Welcome"><i className="fa-light fa-users-medical"></i></span>
                                    </div>
                                    <div className="announcementTextContainer">
                                        <span className="announcementText">Training</span><i className="announcementCircle fa-solid fa-circle"></i>
                                        <span className="announcementText">Q & A</span><i className="announcementCircle fa-solid fa-circle"></i>
                                        <span className="announcementText">All are Welcome</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="anouncementTextName">IS-Analytics</div>
                                    <div className="anouncementTextBody">Open Online Office Hours</div>
                                    <div className="announcementTime">Tues / Wed. <i className="fa-regular fa-clock-two"></i> 12-1pm</div>
                                </td>
                                <td>
                                    {announcementLink}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>);

            homeExtras.push(<div className="home_Extras_Luminis">
                <div className="luminisLogo_Black"></div>
            </div>);


            if (this.state.isEpicUser && !this.state.isHyperDriveUser) {
                homeExtras = [];
                homeExtras.push(<div className="home_Extras_Message">
                    <div className="luminis_AnnouncementText">
                        <div className="luminis_AnnouncementHeader">
                            <i className="fa-light fa-bullhorn"></i> Announcement!
                        </div>
                        <table className="luminis_AnnouncementBody">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="announcementIcons">
                                            <span className="announcementIcon" title="Training"><i className="fa-light fa-chalkboard-user"></i></span>
                                            <span className="announcementIcon" title="Question & Answers"><i className="fa-light fa-messages-question"></i></span>
                                            <span className="announcementIcon" title="All are Welcome"><i className="fa-light fa-users-medical"></i></span>
                                        </div>
                                        <div className="announcementTextContainer">
                                            <span className="announcementText">Training</span><i className="announcementCircle fa-solid fa-circle"></i>
                                            <span className="announcementText">Q & A</span><i className="announcementCircle fa-solid fa-circle"></i>
                                            <span className="announcementText">All are Welcome</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="anouncementTextName">IS-Analytics</div>
                                        <div className="anouncementTextBody">Open Online Office Hours</div>
                                        <div className="announcementTime">Tues / Wed. <i className="fa-regular fa-clock-two"></i> 12-1pm</div>
                                    </td>
                                    <td>
                                        {announcementLink}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>);
            }

            bodyContent.push(<div className={(isHomepage ? "homepage_ExtrasContainer" : "home_ExtrasContainer")}>{homeExtras}</div>);

            if (showNotifications || showResourceRanking || showUserPermissions || showAccessGroups || showRanks || showCreate || showGame) {
                bodyContent.push(<div className="home_BodyListContainer">{bodyList}</div>);
            }

            else if (singleResult != "") {
                bodyContent.push(<div className={(isHomepage ? "homepage_BodyListContainer" : "home_BodyListContainer")}>{bodyList}</div>);
            }

            if (searchTextLength > 2 && singleResult == "" || searchText == "~" && singleResult == "" || searchText == "#~" && singleResult == "") {

                // get total seconds between the times
                var delta = Math.abs(dateEndSearch - dateStartSearch) / 1000;

                // calculate (and subtract) whole days
                var searchDays = Math.floor(delta / 86400);
                delta -= searchDays * 86400;

                // calculate (and subtract) whole hours
                var searchHours = Math.floor(delta / 3600) % 24;
                delta -= searchHours * 3600;

                // calculate (and subtract) whole minutes
                var searchMinutes = Math.floor(delta / 60) % 60;
                delta -= searchMinutes * 60;

                // what's left is seconds
                var searchSeconds = delta % 60;  // in theory the modulus is not required
                var searchTime = "(" + searchSeconds + " seconds)";
                if (searchMinutes > 0) {
                    searchTime = "(" + searchMinutes + " minutes)";
                    if (searchHours > 0) {
                        searchTime = "(" + searchHours + " hours)";
                        if (searchDays > 0) {
                            searchTime = "(" + searchDays + " days)";
                        }
                    }
                }
                var resultsText = "Results";
                if (resourceCount == 1) {
                    resultsText = "Result";
                }
                if (this.state.filterResourceType == "Report & Report Category" && filteredCount == 0 && resourceCount != 0) {
                    this.updateFilterToAll("All");
                }
                if (this.state.filterResourceType == "Report & Report Category" && reportCount > 0 && reportCategoryCount == 0) {
                    this.updateFilterToReport("Report");
                }
                if (this.state.filterResourceType == "Report & Report Category" && searchText.slice(0, 1) == '^' && metricCount > 0) {
                    this.updateFilterToMetric("Metric");
                }


                if (filteredCount != resourceCount) {
                    resultHeader.push(<div className="totalResults">{filteredCount} of {resourceCount} {resultsText}<br />{searchTime}</div>);
                }
                else {
                    resultHeader.push(<div className="totalResults">{resourceCount} {resultsText}<br />{searchTime}</div>);
                }
                if (resourceCount == 0) {
                    bodyContent.push(
                        <div className={(isHomepage ? "homepage_BodyListContainer" : "home_BodyListContainer")}>
                            <div className="noResultsContainer">
                                <div className="headerNoResults">
                                    0 Results found for...
                                </div>
                                <div className="contentNoResults">
                                    "{searchText}"
                                </div>
                            </div >
                        </div >);
                    var bodyTagContent = [];
                    var bodySimilarContent = [];
                    if (similarTagCount > 0) {
                        bodyTagContent.push(<td><div className="similarTagHeader"><i className="fal fa-search"></i> Similar Tags</div><div>{bodyTagList}</div></td>);
                    }
                    if (similarCount > 0) {
                        bodySimilarContent.push(<td><div className="similarHeader"><i className="fal fa-search"></i> Similar Searches</div><div>{bodySimilarList}</div></td>);
                    }
                    if (similarTagCount > 0 || similarCount > 0) {
                        bodyContent.push(<div className={(isHomepage ? "homepage_BodyListContainer" : "home_BodyListContainer")}><table className="similarResultsTable"><tbody><tr>{bodyTagContent}{bodySimilarContent}</tr></tbody></table>{bodyList}</div>);
                    }
                }
                else {

                    if (resultResourceTypeFilterList.length > 1) {
                        resultResourceTypeFilterList = resultResourceTypeFilterList.sort().reverse();
                        displayResourceTypeFilterList.push(<div onClick={this._filterResources.bind(this, "All")} className="resource_Filter"><i className="filterIcon fal fa-chart-network"></i><span alt={"All"} title={"All"} className="filterText" >{"All"}</span></div>)

                        if (reportCategoryCount > 0) {

                            displayResourceTypeFilterList.push(<div onClick={this._filterResources.bind(this, "Report & Report Category")} className="resource_Filter"><i className="filterIcon fal fa-analytics"></i><span alt={"Report & Report Category"} title={"Report & Report Category"} className="filterText" >{"Report & Report Category"}</span></div>)

                        }

                        resultResourceTypeFilterList.forEach(value => {
                            var filterResourcesIcon = "";
                            switch (value) {
                                case "Report":
                                    filterResourcesIcon = <i className="filterIcon fal fa-chart-column"></i>;
                                    break;
                                case "Quality & Research Symposium":
                                    filterResourcesIcon = <i className="filterIcon fal fa-book-medical"></i>;
                                    break;
                                case "Action Plan":
                                    filterResourcesIcon = <i className="filterIcon fal fa-ballot-check"></i>;
                                    break;
                                case "Report Category":
                                    filterResourcesIcon = <i className="filterIcon fal fa-layer-group"></i>;
                                    break;
                                case "Stakeholder":
                                    filterResourcesIcon = <i className="filterIcon fal fa-user-chart"></i>;
                                    break;
                                case "Metric":
                                    filterResourcesIcon = <i className="filterIcon far fa-scrubber"></i>;
                                    break;
                                case "Business Term":
                                    filterResourcesIcon = <i className="filterIcon fal fa-file-alt"></i>;
                                    break;
                                case "Component":
                                    filterResourcesIcon = <i className="filterIcon fal fa-microchip"></i>;
                                    break;
                                case "Acronym":
                                    filterResourcesIcon = <i className="filterIcon fal fa-comment-alt-check"></i>;
                                    break;
                                case "CCN Business Lead":
                                    filterResourcesIcon = <i className="filterIcon fal fa-user-tie"></i>;
                                    break;
                                case "CCN CME Program":
                                    filterResourcesIcon = <i className="filterIcon fal fa-user-chart"></i>;
                                    break;
                                case "CCN EMR System":
                                    filterResourcesIcon = <i className="filterIcon fal fa-file-medical"></i>;
                                    break;
                                case "CCN Value Based Contract":
                                    filterResourcesIcon = <i className="filterIcon fal fa-file-contract"></i>;
                                    break;
                                case "CCN Provider":
                                    filterResourcesIcon = <i className="filterIcon fal fa-user-md"></i>;
                                    break;
                                case "CCN Provider Specialty":
                                    filterResourcesIcon = <i className="filterIcon fal fa-trophy-star"></i>;
                                    break;
                                case "CCN Practice Manager":
                                    filterResourcesIcon = <i className="filterIcon fal fa-hospital-user"></i>;
                                    break;
                                case "CCN Practice":
                                    filterResourcesIcon = <i className="filterIcon fal fa-clinic-medical"></i>;
                                    break;
                            }

                            displayResourceTypeFilterList.push(<div onClick={this._filterResources.bind(this, value)} className="resource_Filter">{filterResourcesIcon}<span alt={value} title={value} className="filterText" >{value}</span></div>)
                        });



                        var filterResourcesIcon = "";
                        var filterResourcesText = <span className="filterText" >{filterResourceType}</span>;
                        switch (filterResourceType) {
                            case "All":
                                filterResourcesIcon = <i className="filterIcon fal fa-chart-network"></i>;
                                filterResourcesText = <span className="filterText" >All</span>;
                                break;
                            case "Report & Report Category":
                                filterResourcesIcon = <i className="filterIcon fal fa-analytics"></i>;
                                break;
                            case "Report":
                                filterResourcesIcon = <i className="filterIcon fal fa-chart-column"></i>;
                                break;
                            case "Quality & Research Symposium":
                                filterResourcesIcon = <i className="filterIcon fal fa-book-medical"></i>;
                                break;
                            case "Action Plan":
                                filterResourcesIcon = <i className="filterIcon fal fa-ballot-check"></i>;
                                break;
                            case "Report Category":
                                filterResourcesIcon = <i className="filterIcon fal fa-layer-group"></i>;
                                break;
                            case "Stakeholder":
                                filterResourcesIcon = <i className="filterIcon fal fa-user-chart"></i>;
                                break;
                            case "Metric":
                                filterResourcesIcon = <i className="filterIcon far fa-scrubber"></i>;
                                break;
                            case "Business Term":
                                filterResourcesIcon = <i className="filterIcon fal fa-file-alt"></i>;
                                break;
                            case "Component":
                                filterResourcesIcon = <i className="filterIcon fal fa-microchip"></i>;
                                break;
                            case "Acronym":
                                filterResourcesIcon = <i className="filterIcon fal fa-comment-alt-check"></i>;
                                break;
                            case "CCN Business Lead":
                                filterResourcesIcon = <i className="filterIcon fal fa-user-tie"></i>;
                                break;
                            case "CCN CME Program":
                                filterResourcesIcon = <i className="filterIcon fal fa-user-chart"></i>;
                                break;
                            case "CCN EMR System":
                                filterResourcesIcon = <i className="filterIcon fal fa-file-medical"></i>;
                                break;
                            case "CCN Value Based Contract":
                                filterResourcesIcon = <i className="filterIcon fal fa-file-contract"></i>;
                                break;
                            case "CCN Provider":
                                filterResourcesIcon = <i className="filterIcon fal fa-user-md"></i>;
                                break;
                            case "CCN Provider Specialty":
                                filterResourcesIcon = <i className="filterIcon fal fa-trophy-star"></i>;
                                break;
                            case "CCN Practice Manager":
                                filterResourcesIcon = <i className="filterIcon fal fa-hospital-user"></i>;
                                break;
                            case "CCN Practice":
                                filterResourcesIcon = <i className="filterIcon fal fa-clinic-medical"></i>;
                                break;
                        }
                        displayResourceTypeFilterSelected.push(filterResourcesIcon);
                        displayResourceTypeFilterSelected.push(filterResourcesText);
                        displayResourceTypeFilterSelected.push(<i className="sortIcon fal fa-sort"></i>);
                        displayResourceTypeFilterSelected.push(<div className="displayResourceTypeFilterList">{displayResourceTypeFilterList}</div>);


                        resultHeader.push(<div className="resourceFilter"><span className="filterLabel"><i className="filterIcon fal fa-filter"></i><span className="filterText">Resources</span></span><div className="displayResourceTypeFilterSelected">{displayResourceTypeFilterSelected}</div></div>);

                    }
                    else {

                        var filterResourcesIcon = "";
                        var filterResourcesText = "";

                        filterResourcesIcon = <i className="filterIcon fal fa-chart-network"></i>;
                        filterResourcesText = <span className="filterText" >All</span>;

                        displayResourceTypeFilterSelected.push(filterResourcesIcon);
                        displayResourceTypeFilterSelected.push(filterResourcesText);

                        resultHeader.push(<div className="resourceFilter"><span className="filterLabel"><i className="filterIcon fal fa-filter"></i><span className="filterText">Resources</span></span><div className="displayResourceTypeFilterSelected_NoOptions">{displayResourceTypeFilterSelected}</div></div>);
                    }

                    if (resultReportTypeFilterList.length > 1) {
                        resultReportTypeFilterList = resultReportTypeFilterList.sort();
                        displayReportTypeFilterList.push(<div onClick={this._filterReports.bind(this, "")} className="report_Filter"><i className="filterIcon fal fa-chart-network"></i><span alt={"All"} title={"All"} className="filterText" >{"All"}</span></div>)

                        resultReportTypeFilterList = Object.values(resultReportTypeFilterList).filter(value => (value).toString().toLowerCase() != '');

                        Object.values(resultReportTypeFilterList)
                            .forEach(value => {
                                var filterReportTypeIcon = "";
                                switch (value) {
                                    case "Excel Dashboard":
                                        filterReportTypeIcon = <i className="filterIcon fal fa-file-excel"></i>;
                                        break;
                                    case "Microsoft Report":
                                        filterReportTypeIcon = <i className="filterIcon fab fa-windows"></i>;
                                        break;
                                    case "File":
                                        filterReportTypeIcon = <i className="filterIcon fal fa-file-chart-pie"></i>;
                                        break;
                                    case "Website":
                                        filterReportTypeIcon = <i className="filterIcon far fa-desktop-alt"></i>;
                                        break;
                                    case "Qlikview Dashboard":
                                        filterReportTypeIcon = <i className="filterIcon qlikSearch fas fa-search"><span className="qlikDot">V</span></i>;
                                        break;
                                    case "Qliksense Application":
                                        filterReportTypeIcon = <i className="filterIcon qlikSearch fas fa-search"><span className="qlikDot">S</span></i>;
                                        break;
                                    case "Epic-Slicer Dicer":
                                        filterReportTypeIcon = <i className="filterIcon fal fa-objects-column"></i>;
                                        break;
                                    case "Epic-Crystal Report":
                                        filterReportTypeIcon = <span className="report_Filter_Crystal"><span className="filterIcon crystalContainer"><span className="crystalTopDot"></span><span className="crystalLeftDot"></span><span className="crystalRightDot"></span><span className="crystalBottomDot"></span></span></span>;
                                        break;
                                    case "Radar Dashboard":
                                        filterReportTypeIcon = <i className="filterIcon fal fa-satellite-dish"></i>;
                                        break;
                                    case "Reporting Workbench":
                                        filterReportTypeIcon = <i className="filterIcon fal fa-object-group"></i>;
                                        break;
                                }

                                displayReportTypeFilterList.push(<div onClick={this._filterReports.bind(this, value)} className="report_Filter">{filterReportTypeIcon}<span className="filterText" alt={value} title={value}>{value}</span></div>)
                            });



                        var filterReportTypeIcon = "";
                        var filterReportTypeText = <span className="filterText" >{filterReportType}</span>;
                        switch (filterReportType) {
                            case "":
                                filterReportTypeIcon = <i className="filterIcon fal fa-chart-network"></i>;
                                filterReportTypeText = <span className="filterText" >All</span>;
                                break;
                            case "Excel Dashboard":
                                filterReportTypeIcon = <i className="filterIcon fal fa-file-excel"></i>;
                                break;
                            case "Microsoft Report":
                                filterReportTypeIcon = <i className="filterIcon fab fa-windows"></i>;
                                break;
                            case "File":
                                filterReportTypeIcon = <i className="filterIcon fal fa-file-chart-pie"></i>;
                                break;
                            case "Website":
                                filterReportTypeIcon = <i className="filterIcon far fa-desktop-alt"></i>;
                                break;
                            case "Qlikview Dashboard":
                                filterReportTypeIcon = <i className="filterIcon qlikSearch fas fa-search"><span className="qlikDot">V</span></i>;
                                break;
                            case "Qliksense Application":
                                filterReportTypeIcon = <i className="filterIcon qlikSearch fas fa-search"><span className="qlikDot">S</span></i>;
                                break;
                            case "Epic-Slicer Dicer":
                                filterReportTypeIcon = <i className="filterIcon fal fa-objects-column"></i>;
                                break;
                            case "Epic-Crystal Report":
                                filterReportTypeIcon = <span className="filterIcon crystalContainer"><span className="crystalTopDot"></span><span className="crystalLeftDot"></span><span className="crystalRightDot"></span><span className="crystalBottomDot"></span></span>;
                                break;
                            case "Radar Dashboard":
                                filterReportTypeIcon = <i className="filterIcon fal fa-satellite-dish"></i>;
                                break;
                            case "Reporting Workbench":
                                filterReportTypeIcon = <i className="filterIcon fal fa-object-group"></i>;
                                break;
                        }
                        displayReportTypeFilterSelected.push(filterReportTypeIcon);
                        displayReportTypeFilterSelected.push(filterReportTypeText);
                        displayReportTypeFilterSelected.push(<i className="sortIcon fal fa-sort"></i>);
                        displayReportTypeFilterSelected.push(<div className="displayReportTypeFilterList">{displayReportTypeFilterList}</div>);
                        if (!(this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {
                            resultHeader.push(<div className="reportFilter"><span className="filterLabel"><i className="filterIcon fal fa-filter"></i><span className="filterText">Report Type</span></span><div className="displayReportTypeFilterSelected">{displayReportTypeFilterSelected}</div></div>);
                        }
                    }
                    else {

                        var filterReportTypeIcon = "";
                        var filterReportTypeText = "";

                        filterReportTypeIcon = <i className="filterIcon fal fa-chart-network"></i>;
                        filterReportTypeText = <span className="filterText" >All</span>;

                        displayReportTypeFilterSelected.push(filterReportTypeIcon);
                        displayReportTypeFilterSelected.push(filterReportTypeText);
                        if (!(this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {
                            resultHeader.push(<div className="reportFilter"><span className="filterLabel"><i className="filterIcon fal fa-filter"></i><span className="filterText">Report Type</span></span><div className="displayReportTypeFilterSelected_NoOptions">{displayReportTypeFilterSelected}</div></div>);
                        }
                    }

                    /* QRS Year */


                    if (resultQRSYearFilterList.length > 1) {
                        resultQRSYearFilterList = resultQRSYearFilterList.sort();
                        displayQRSYearFilterList.push(<div onClick={this._filterQRSYears.bind(this, "")} className="qrs_Filter"><i className="filterIcon fal fa-chart-network"></i><span alt={"All"} title={"All"} className="filterText" >{"All"}</span></div>)
                        resultQRSYearFilterList = Object.values(resultQRSYearFilterList).filter(value => { return value; });
                        resultQRSYearFilterList = Object.values(resultQRSYearFilterList).filter(value => (value).toString().toLowerCase() != '');

                        Object.values(resultQRSYearFilterList)
                            .forEach(value => {
                                var filterQRSYearIcon = "";
                                var currentYear = new Date().getFullYear();
                                switch (parseInt(value)) {
                                    case currentYear:
                                        filterQRSYearIcon = <i className="filterIcon fal fa-book-bookmark"></i>;
                                        break;
                                    default:
                                        filterQRSYearIcon = <i className="filterIcon fal fa-book-blank"></i>;
                                        break;
                                }

                                displayQRSYearFilterList.push(<div onClick={this._filterQRSYears.bind(this, value)} className="qrs_Filter">{filterQRSYearIcon}<span className="filterText" alt={value} title={value}>{value}</span></div>)
                            });



                        var filterQRSYearIcon = "";
                        var filterQRSYearText = <span className="filterText" >{filterQRSYear}</span>;
                        var currentYear = new Date().getFullYear();
                        if (filterQRSYear.length == 0) {
                            filterQRSYearIcon = <i className="filterIcon fal fa-chart-network"></i>;
                            filterQRSYearText = <span className="filterText" >All</span>;
                        }
                        else {
                            switch (parseInt(filterQRSYear)) {
                                case currentYear:
                                    filterQRSYearIcon = <i className="filterIcon fal fa-book-bookmark"></i>;
                                    break;
                                default:
                                    filterQRSYearIcon = <i className="filterIcon fal fa-book-blank"></i>;
                                    break;
                            }

                        }
                        displayQRSYearFilterSelected.push(filterQRSYearIcon);
                        displayQRSYearFilterSelected.push(filterQRSYearText);
                        displayQRSYearFilterSelected.push(<i className="sortIcon fal fa-sort"></i>);
                        displayQRSYearFilterSelected.push(<div className="displayQRSYearFilterList">{displayQRSYearFilterList}</div>);
                        if (!(this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {
                            resultHeader.push(<div className="qrsFilter"><span className="filterLabel"><i className="filterIcon fal fa-filter"></i><span className="filterText">QRS Year</span></span><div className="displayQRSYearFilterSelected">{displayQRSYearFilterSelected}</div></div>);
                        }
                    }
                    else {

                    }



                    if (resultRankFilterList.length > 1) {

                        resultRankFilterList = resultRankFilterList.sort();
                        displayRankFilterList.push(<div onClick={this._filterRanks.bind(this, "")} className="rank_Filter"><span className="searchRankIcon_All"></span><span alt={"All"} title={"All"} className="filterText" >{"All"}</span></div>)
                        resultRankFilterList = Object.values(resultRankFilterList).filter(value => (value) != null && (value.length > 0));

                        Object.values(resultRankFilterList)
                            .forEach(value => {
                                displayRankFilterList.push(<div onClick={this._filterRanks.bind(this, value)} className="rank_Filter"><span className={"searchRankIcon_" + value}></span><span className="filterText" alt={value} title={value}>{value}</span></div>)
                            });



                        var filterRankIcon = "";
                        var filterRankText = <span className="filterText" >{filterRankType}</span>;
                        switch (filterRankType) {
                            case "":
                                filterRankIcon = <span className={"searchRankIcon_All"}></span>;
                                filterRankText = <span className="filterText" >All</span>;
                                break;
                            case "Platinum":
                                filterRankIcon = <span className={"searchRankIcon_Platinum"}></span>;
                                break;
                            case "Gold":
                                filterRankIcon = <span className={"searchRankIcon_Gold"}></span>;
                                break;
                            case "Silver":
                                filterRankIcon = <span className={"searchRankIcon_Silver"}></span>;
                                break;
                            case "Bronze":
                                filterRankIcon = <span className={"searchRankIcon_Bronze"}></span>;
                                break;
                        }
                        displayRankFilterSelected.push(filterRankIcon);
                        displayRankFilterSelected.push(filterRankText);
                        displayRankFilterSelected.push(<i className="sortIcon fal fa-sort"></i>);
                        displayRankFilterSelected.push(<div className="displayRankFilterList">{displayRankFilterList}</div>);
                        if (!(this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {
                            resultHeader.push(<div className="rankFilter"><span className="filterLabel"><i className="filterIcon fal fa-file-certificate"></i><span className="filterText">Rank</span></span><div className="displayRankFilterSelected">{displayRankFilterSelected}</div></div>);
                        }





                    }
                    else {

                        var filterRankIcon = "";
                        var filterRankText = "";

                        filterRankIcon = <span className={"searchRankIcon_All"}></span>;
                        filterRankText = <span className="filterText" >All</span>;

                        displayRankFilterSelected.push(filterRankIcon);
                        displayRankFilterSelected.push(filterRankText);
                        if (!(this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev')) {
                            resultHeader.push(<div className="rankFilter"><span className="filterLabel"><i className="filterIcon fal fa-file-certificate"></i><span className="filterText">Rank</span></span><div className="displayRankFilterSelected_NoOptions">{displayRankFilterSelected}</div></div>);
                        }
                    }

                    var resultHeaderContainer = [];

                    if (searchText == "#~" && singleResult == "") {

                    }
                    else {
                        resultHeaderContainer = <div className="resultHeader">{resultHeader}</div>
                    }

                    bodyContent.push(<div className={(isHomepage ? "homepage_BodyListContainer" : "home_BodyListContainer")}>{resultHeaderContainer}<div className="bodyList">{bodyList}</div></div>);
                }
            }
            else if (searchTextLength > 0 && singleResult == "") {

                bodyContent.push(
                    <div className={(isHomepage ? "homepage_BodyListContainer" : "home_BodyListContainer")}>
                        <div className="noResultsContainer">
                            <div className="headerNoResults">
                                Please enter atleast <b>3</b> characters to begin <i className="fal fa-search"></i> auto-search.
                            </div>
                        </div >
                    </div >);

            }

            headerSearch.push(
                <span className="logoSearchHeaderContainer"><i onClick={this._headerSearchFocus.bind(this)} ref="logoSearch" className="logoSearch fal fa-search" title="Search Databay" alt="Search Databay"></i>{searchInput}<i ref="logoSubmit" className="logoSubmit_Hidden fal fa-arrow-alt-right" onClick={this._headerSearchTermUpdated.bind(this)}></i><div ref="intellisenseHeaderListInfo_Container" className="intellisenseHeaderListInfo_Hidden"><div ref="intellisenseHeaderListInfo" className="intellisenseHeaderListInfo" onMouseOut={this._handleMouseOut.bind(this)}>{intellisenseList}</div></div></span>
            );

        }

        else {
            //We are still loading for some reason.
        }


        //Modal Resources

        var singleResourceExternalId = "this ExternalId";
        var singleResourceName = "this Resource";
        var singleResourceType = "this Resource Type";
        var singleResourceLocation = "this Resource Location";
        var singleResourceReportType = "this Report Type";
        var secureResource = "";

        Object.values(resource_IntellisenseInfo)
            .filter(value => (value['externalId']).toString().toLowerCase() == singleResult.toLowerCase())
            .forEach(value => {
                singleResourceName = value["resourceName"];
                singleResourceType = value["resourceType"];
                singleResourceLocation = value["reportLocation"]
                singleResourceReportType = value["reportType"];
                singleResourceExternalId = value["externalId"];
                if (value["secureResource"]) {
                    secureResource = "Secure "
                }
            });

        modalHeader.push(
            <div ref="modal_header_content">
                <div ref="modal_image_header" className="modal_image_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-images"></span> Images</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_feedback_header" className="modal_feedback_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-envelope-open-text"></span> Send Feedback</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_JIRA_header" className="modal_JIRA_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-question-circle"></span> Support Requests</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_view_header" className="modal_view_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-eye"></span> View</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_request_header" className="modal_request_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-key"></span> Request {secureResource}Access</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_help_header" className="modal_help_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-question-circle"></span> Help</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_share_header" className="modal_share_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-share-square"></span> Share</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_permission_header" className="modal_permission_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-users"></span> User Permissions</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_rank_header" className="modal_rank_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-trophy"></span> Resource Ranks</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_addRelationship_header" className="modal_addRelationship_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-project-diagram"></span> Add Relationship</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_editGoal_header" className="modal_editGoal_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fa-light fa-bullseye-arrow"></span> Edit Goal</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
                <div ref="modal_addActionPlanItem_header" className="modal_addActionPlanItem_header_hidden"><div ref="modal_header_content" className="modal_header_content"><span className="fal fa-ballot-check"></span> Add Action Plan Item</div><div className="closeModal" onClick={this._hideOverlays.bind(this)}><i className="fas fa-times"></i></div></div>
            </div>
        )



        var imageContentContainer;
        imageContentContainer = [];

        imageContentContainer.push(
            <div className="imageContainer">
                <div className="imageBodyContainer">
                    <img className="singleResultImage" src={this.state.singleResultImage}></img>
                </div>
            </div>);


        var feedbackContentContainer;
        feedbackContentContainer = [];

        feedbackContentContainer.push(
            <div>
                <div className="feedbackContainer">
                    <div className="feedbackHeaderContainer">
                        <span className="feedbackHeader">
                            Let's work together to make things better!
                        </span>
                    </div>
                    <div className="feedbackBodyContainer">
                        <div className="feedbackBodyText">We're always striving to provide thorough and helpful information. Please share your feedback on how we can make this application better suite your needs.</div>
                        <div className="feedbackBodyText">Also let us know how we are doing! Have a great idea or need for different data? Share your feedback</div>
                        <div>
                            <textarea ref="feedbackText" className="feedbackText"></textarea>
                        </div>
                        <div>
                            <button type="button" className="feedbackSubmit" onClick={this._submitFeedback.bind(this)}>Submit</button>
                            <button type="button" className="requestAccessClose" onClick={this._hideOverlays.bind(this)}>Close</button>

                        </div>
                    </div>
                </div>
            </div>);

        var JIRAContentContainer;
        JIRAContentContainer = [];

        JIRAContentContainer.push(
            <div>
                <div className="JIRAContainer">
                    <div className="JIRABodyContainer">
                        <div className="feedbackHeaderContainer">
                            <span className="feedbackHeader">
                                Let's create a JIRA ticket
                            </span>
                        </div>
                        <div>
                            <table className="JIRAMessageFields">
                                <tbody>
                                    <tr>
                                        <td>
                                            Subject
                                        </td>
                                        <td>
                                            {this.state.JIRAsubject}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Contact Name
                                        </td>
                                        <td>
                                            <input ref="JIRAFirstName" className="JIRAFirstName" type="input" placeholder="First Name" defaultValue={this.state.user_AccountInfo.firstName} /> <input ref="JIRALastName" className="JIRALastName" type="input" placeholder="Last Name" defaultValue={this.state.user_AccountInfo.lastName} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Contact Phone #
                                        </td>
                                        <td>
                                            <input ref="JIRAContactNumber" className="JIRAContactNumber" type="tel" placeholder="(123) 456-7890" defaultValue={this.state.JIRAContactNumber} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Message
                                        </td>
                                        <td>
                                            <textarea ref="JIRAMessageText" className="JIRAMessageText"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <button type="button" className="JIRASubmit" onClick={this._submitJIRAMessage.bind(this)}>Submit</button>
                            <button type="button" className="requestAccessClose" onClick={this._hideOverlays.bind(this)}>Close</button>

                        </div>
                    </div>
                </div>
            </div>);

        var viewContentContainer;
        viewContentContainer = [];

        var viewInstructions = <div className="viewInstructions"></div>;
        var link;
        link = [];
        if (singleResourceType == "Report") {

            switch (singleResourceReportType) {
                case "Excel Dashboard":
                    link.push();
                    viewInstructions = <div className="viewInstructions">Download a Chrome Extension to enable local links to view your report.</div>;
                    break;
                case "Microsoft Report":
                    viewInstructions = <div className="viewInstructions">Download a Chrome Extension to enable local links to view your report.</div>;
                    break;
                case "File":
                    viewInstructions = <div className="viewInstructions">Download a Chrome Extension to enable local links to view your report.</div>;
                    break;
                case "Website":
                    viewInstructions = <div className="viewInstructions">If you have not been automatically please try again.</div>;
                    break;
                case "Qlikview Dashboard":
                    viewInstructions = <div className="viewInstructions">If you have not been automatically please try again.</div>;
                    break;
                case "Qliksense Application":
                    viewInstructions = <div className="viewInstructions">If you have not been automatically please try again.</div>;
                    break;
                case "Epic-Slicer Dicer":
                    link.push(<div className="reportLink"><a onClick={this._launchEpicSlicerDicer.bind(this, singleResourceLocation)}>Open Slicer Dicer Report: {singleResourceLocation}</a></div>);
                    viewInstructions = <div className="viewInstructions">{link}</div>;
                    break;
                case "Epic-Crystal Report":
                    var splitLinks = singleResourceLocation.split(";");
                    for (var iterator = 0; iterator < splitLinks.length; iterator++) {
                        var ecr_RegEx1 = /(.*)/
                        if (splitLinks[iterator].includes("HGT:")) {
                            ecr_RegEx1 = /HGR:(\d+)\|HGT:(\d+)\|NAME:(.*)/
                        }
                        else if (splitLinks[iterator].includes("HRX:")) {
                            ecr_RegEx1 = /HGR:(\d+)\|HRX:(\d+)\|NAME:(.*)/
                        }
                        var ecr_Matches = ecr_RegEx1.exec(splitLinks[iterator])
                        if (ecr_Matches != null && ecr_Matches.length == 4) {
                            link.push(<div className="reportLink"><a onClick={this._launchEpicCrystalReport.bind(this, ecr_Matches[1], ecr_Matches[2], ecr_Matches[3])}>{ecr_Matches[3]}</a></div>);
                        }
                        else {
                            link.push(<div className="reportLink">There is a error with the link please report to the Analytics Team.</div>);
                        }
                    }
                    viewInstructions = <div className="viewInstructions">{link}</div>;
                    break;
                case "Radar Dashboard":

                    var splitLinks = singleResourceLocation.split(";");
                    for (var iterator = 0; iterator < splitLinks.length; iterator++) {

                        var rd_RegEx1 = /IDM:(\d+)/

                        var rd_Matches = rd_RegEx1.exec(splitLinks[iterator].replace(/\s+/g, ''))
                        link.push(<div className="reportLink"><a onClick={this._launchRadarDashboard.bind(this, rd_Matches[1], singleResourceName)}>{singleResourceName}</a></div>);

                    }
                    viewInstructions = <div className="viewInstructions">{link}</div>;
                    break;
                case "Reporting Workbench":

                    var splitLinks = singleResourceLocation.split("~");
                    for (var iterator = 0; iterator < splitLinks.length; iterator++) {

                        var rw_RegEx1 = /HGR:(\d+)\|HGT:(\d+)\|NAME:(.*)/

                        var rw_Matches = rw_RegEx1.exec(splitLinks[iterator])
                        link.push(<div className="reportLink"><a onClick={this._launchReportingWorkbench.bind(this, rw_Matches[1], rw_Matches[2], rw_Matches[3])}>{rw_Matches[3]}</a></div>);

                    }
                    viewInstructions = <div className="viewInstructions">{link}</div>;
                    break;
                case "":
                    viewInstructions = <div className="viewInstructions">If you have not been automatically redirected please try again.</div>;
                    break;
            }
        }
        viewContentContainer.push(
            <div>
                <div className="viewContainer">
                    <div className="viewHeaderContainer">
                        <span className="viewHeader">
                            <span className="viewIcon fal fa-eye"></span>
                            View - <span className="modalResourceName">{singleResourceName}</span>
                        </span>
                    </div>
                    <div className="viewBodyContainer">
                        {viewInstructions}
                    </div>
                </div>
            </div>);



        var requestContentContainer;
        requestContentContainer = [];



        requestContentContainer.push(
            <div>
                <div className="requestContainer">
                    <div className="requestHeaderContainer">
                        <span className="requestHeader">
                            <span className="requestIcon fal fa-key"></span>
                            Request Access - <span className="modalResourceName">{singleResourceName}</span>
                        </span>
                    </div>
                    <div className="requestBodyContainer">
                        <div className="requestBodyQuestion">
                            Reason For Requesting Access To (<span className="requestResourceName">{singleResourceName}</span>):
                        </div>
                        <div>
                            <textarea ref="requestAccessReasonText" className="requestAccessReasonText" placeholder="Reason" defaultValue={this.state.requestReason}></textarea>
                        </div>
                        <div>
                            <button type="button" className="requestAccessSubmit" onClick={this._submitRequestAccess.bind(this, singleResourceExternalId, singleResourceName, singleResourceType, singleResourceReportType)}>Submit</button>
                            <button type="button" className="requestAccessClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                        </div>
                    </div>
                </div>
            </div>);




        var shareList;
        shareList = [];

        var resourceList;
        resourceList = [];

        var shareDepartmentSort;
        shareDepartmentSort = [];

        var shareDepartmentList;
        shareDepartmentList = [];

        var shareSearchList;
        shareSearchList = [];

        var shareDepartmentListContainer;
        shareDepartmentListContainer = [];

        var shareListContainer;
        shareListContainer = [];

        var resourceListContainer;
        resourceListContainer = [];

        var shareContentContainer;
        shareContentContainer = [];

        var addRelationshipContentContainer;
        addRelationshipContentContainer = [];

        var editGoalContentContainer;
        editGoalContentContainer = [];

        var addActionPlanItemContentContainer;
        addActionPlanItemContentContainer = [];

        if (totalStrippedUsers > 0) {

            //shareList.push(<option value="" hidden>Select a Employee</option>);
            shareDepartmentList.push(<option value="">Select a Department</option>);

            Object.values(strippedUserList).forEach(element => {
                shareDepartmentSort.push(element["departmentName"]);
                //shareSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
            });
            shareDepartmentSort = [...new Set(shareDepartmentSort)];
            shareDepartmentSort = shareDepartmentSort.sort();

            Object.values(shareDepartmentSort).forEach(element => {
                shareDepartmentList.push(<option value={element}>{element}</option>);
            });


            shareList.push(<option value="" hidden>Select a Employee</option>);

            if (this.state.resource_shareFilter == "" && this.state.resource_shareDepartment == "") {
                Object.values(strippedUserList).forEach(element => {
                    shareList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                    //shareSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                });
            }
            else if (this.state.resource_shareFilter != "" && this.state.resource_shareDepartment == "") {
                Object.values(strippedUserList)
                    .filter(element => element["lastName"].toLowerCase().includes(this.state.resource_shareFilter.toLowerCase()) || element["firstName"].toLowerCase().includes(this.state.resource_shareFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase()).includes(this.state.resource_shareFilter.toLowerCase()) || (element["email"].toLowerCase()).includes(this.state.resource_shareFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase() + " (" + element["email"].toLowerCase() + ")").includes(this.state.resource_shareFilter.toLowerCase()))
                    .forEach(element => {
                        shareList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //shareSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }
            else if (this.state.resource_shareFilter == "" && this.state.resource_shareDepartment != "") {
                Object.values(strippedUserList)
                    .filter(element => element["departmentName"].toLowerCase() == this.state.resource_shareDepartment.toLowerCase())
                    .forEach(element => {
                        shareList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //shareSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }
            else if (this.state.resource_shareFilter != "" && this.state.resource_shareDepartment != "") {
                Object.values(strippedUserList)
                    .filter(element => (element["lastName"].toLowerCase().includes(this.state.resource_shareFilter.toLowerCase()) || element["firstName"].toLowerCase().includes(this.state.resource_shareFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase()).includes(this.state.resource_shareFilter.toLowerCase()) || (element["lastName"].toLowerCase() + "," + element["firstName"].toLowerCase()).includes(this.state.resource_shareFilter.toLowerCase()) || (element["email"].toLowerCase()).includes(this.state.resource_shareFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase() + " (" + element["email"].toLowerCase() + ")").includes(this.state.resource_shareFilter.toLowerCase())) && (element["departmentName"].toLowerCase() == this.state.resource_shareDepartment.toLowerCase()))
                    .forEach(element => {
                        shareList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //shareSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }



            shareListContainer.push(<select ref="modal_share_employee" className="modal_share_employee" multiple>{shareList}</select>);
            shareDepartmentListContainer.push(<select ref="shareFilterDepartment_Input" className="shareFilterDepartment_Input" onChange={this._shareDepartmentFilterUpdated.bind(this)}>{shareDepartmentList}</select>);
            //shareListContainer.push(<SelectSearch options={shareSearchList} value="" ref="modal_share_employee" className="modal_share_employee" placeholder="Select a Employee" />)
        }






        var permissionList;
        permissionList = [];

        var permissionDepartmentSort;
        permissionDepartmentSort = [];

        var permissionDepartmentList;
        permissionDepartmentList = [];

        var permissionSearchList;
        permissionSearchList = [];

        var permissionDepartmentListContainer;
        permissionDepartmentListContainer = [];

        var permissionListContainer;
        permissionListContainer = [];

        var permissionContentContainer;
        permissionContentContainer = [];

        var rankContentContainer;
        rankContentContainer = [];

        if (totalStrippedUsers > 0) {

            //permissionList.push(<option value="" hidden>Select a Employee</option>);
            permissionDepartmentList.push(<option value="">Select a Department</option>);

            Object.values(strippedUserList).forEach(element => {
                permissionDepartmentSort.push(element["departmentName"]);
                //permissionSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
            });
            permissionDepartmentSort = [...new Set(permissionDepartmentSort)];
            permissionDepartmentSort = permissionDepartmentSort.sort();

            Object.values(permissionDepartmentSort).forEach(element => {
                permissionDepartmentList.push(<option value={element}>{element}</option>);
            });


            permissionList.push(<option value="" hidden>Select a Employee</option>);

            if (this.state.user_permissionFilter == "" && this.state.user_permissionDepartment == "") {
                Object.values(strippedUserList).forEach(element => {
                    permissionList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                    //permissionSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                });
            }
            else if (this.state.user_permissionFilter != "" && this.state.user_permissionDepartment == "") {
                Object.values(strippedUserList)
                    .filter(element => element["lastName"].toLowerCase().includes(this.state.user_permissionFilter.toLowerCase()) || element["firstName"].toLowerCase().includes(this.state.user_permissionFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase()).includes(this.state.user_permissionFilter.toLowerCase()) || (element["email"].toLowerCase()).includes(this.state.user_permissionFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase() + " (" + element["email"].toLowerCase() + ")").includes(this.state.user_permissionFilter.toLowerCase()))
                    .forEach(element => {
                        permissionList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //permissionSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }
            else if (this.state.user_permissionFilter == "" && this.state.user_permissionDepartment != "") {
                Object.values(strippedUserList)
                    .filter(element => element["departmentName"].toLowerCase() == this.state.user_permissionDepartment.toLowerCase())
                    .forEach(element => {
                        permissionList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //permissionSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }
            else if (this.state.user_permissionFilter != "" && this.state.user_permissionDepartment != "") {
                Object.values(strippedUserList)
                    .filter(element => (element["lastName"].toLowerCase().includes(this.state.user_permissionFilter.toLowerCase()) || element["firstName"].toLowerCase().includes(this.state.user_permissionFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase()).includes(this.state.user_permissionFilter.toLowerCase()) || (element["lastName"].toLowerCase() + "," + element["firstName"].toLowerCase()).includes(this.state.user_permissionFilter.toLowerCase()) || (element["email"].toLowerCase()).includes(this.state.user_permissionFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase() + " (" + element["email"].toLowerCase() + ")").includes(this.state.user_permissionFilter.toLowerCase())) && (element["departmentName"].toLowerCase() == this.state.user_permissionDepartment.toLowerCase()))
                    .forEach(element => {
                        permissionList.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                        //permissionSearchList.push({ name: element["lastName"] +", "+ element["firstName"] , value: element["idUser"] });
                    });
            }

            permissionListContainer.push(<select ref="modal_permission_employee" className="modal_permission_employee" multiple>{permissionList}</select>);
            permissionDepartmentListContainer.push(<select ref="permissionFilterDepartment_Input" className="permissionFilterDepartment_Input" onChange={this._permissionDepartmentFilterUpdated.bind(this)}>{permissionDepartmentList}</select>);
        }











        var resourceTypeOptions;
        resourceTypeOptions = [];

        Object.values(resource_ResourceTypeListInfo).forEach(element => {
            resourceTypeOptions.push(<option value={element["resourceType"]}>{element["resourceType"]}</option>);
        });

        //Add only if we are looking at a metric.
        if (singleResourceType == "Metric") {

        resourceTypeOptions.push(<option value="Metric Owner">Metric Owner</option>);
        resourceTypeOptions.push(<option value="Metric Goals">Metric Goals</option>);

        }

        resourceTypeOptions.push(<option value="Tags">Tags</option>);

        var resourceTypeFilterContainer;
        resourceTypeFilterContainer = [];

        resourceTypeFilterContainer = <select defaultValue={this.state.resource_addRelationship_ResourceTypeFilter} id="resourceTypeFilter" ref="resourceTypeFilter" className="resourceTypeFilter" onChange={this._relationshipResourceFilterUpdated.bind(this)}>
            <option value="" hidden>Select an option</option>
            {resourceTypeOptions}
        </select>




        var reportTypeOptions;
        reportTypeOptions = [];

        Object.values(resource_ReportTypeListInfo).forEach(element => {
            reportTypeOptions.push(<option value={element["reportType"]}>{element["reportType"]}</option>);
        });

        var reportTypeFilterContainer;
        reportTypeFilterContainer = [];

        if (this.state.siteMode == 'databayccnprd' || this.state.siteMode == 'databayccndev' || this.state.resource_addRelationship_ResourceTypeFilter != 'Report') {
            reportTypeFilterContainer = <div className="hidden"><span className="resourceFilterReportType"><i className="filterList_icon fal fa-file-chart-line"></i> Report Type</span><select id="reportTypeFilter" ref="reportTypeFilter" className="reportTypeFilter" onChange={this._relationshipReportFilterUpdated.bind(this)}>
                <option value="" hidden>Select an option</option>
                {reportTypeOptions}
            </select></div>
        }
        else {
            reportTypeFilterContainer = <div className="resourceFilterReportType_Container"><span className="resourceFilterReportType"><i className="filterList_icon fal fa-file-chart-line"></i> Report Type</span><select id="reportTypeFilter" ref="reportTypeFilter" className="reportTypeFilter" onChange={this._relationshipReportFilterUpdated.bind(this)}>
                <option value="" hidden>Select an option</option>
                {reportTypeOptions}
            </select></div>
        }


        var strippedRelationshipResourcesList = Object.values(resource_addRelationship_ResourceList).filter(value => (value['externalId']).toString().toLowerCase() != this.state.singleResult.toLowerCase())
        Object.values(strippedRelationshipResourcesList).forEach(element => {
            resourceList.push(<option value={element["externalId"]}>{element["resourceName"]}</option>);
        });



        resourceList.push(<option value="" hidden>Select a Resource</option>);

        var ownerRelationshipUser;
        ownerRelationshipUser = [];

        var relationshipResourceLabel;
        relationshipResourceLabel = [];


        var resourceFilterNameContainer;

        resourceFilterNameContainer = [];
        resourceFilterNameContainer = <div className="resourceFilterName_Container"><span className="resourceFilterName"><i className="filterList_icon fal fa-search"></i> Resource Name</span><input ref="resourceFilterName_Input" className="resourceFilterName_Input" type="text" defaultValue="" placeholder="" onChange={this._resourceFilterUpdated.bind(this)} /></div>



        if (this.state.resource_addRelationship_ResourceTypeFilter == "Metric Owner") {
            relationshipResourceLabel = <span className="resourceList_Label"><i className="resourceList_icon fal fa-users"></i> Users</span>
            if (this.state.resource_relationshipNameFilter.length < 3) {

                resourceListContainer = <div className="modal_relationship_noresources">Please enter atleast 3 characters of the person's name in your filter to begin your search.</div>;

            }
            else {
                var strippedUserList;

                strippedUserList = Object.values(user_ListInfo).filter(value => (value['idUser']).toString().toLowerCase() != user_AccountInfo["idUser"].toLowerCase())
                strippedUserList = Object.values(strippedUserList).filter(value => (value["lastName"]).toString().toLowerCase() != "" && (value["firstName"]).toString().toLowerCase() != "")
                strippedUserList = Object.values(strippedUserList).filter(element => (element["lastName"].toLowerCase().includes(this.state.resource_relationshipNameFilter.toLowerCase()) || element["firstName"].toLowerCase().includes(this.state.resource_relationshipNameFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase()).includes(this.state.resource_relationshipNameFilter.toLowerCase()) || (element["lastName"].toLowerCase() + "," + element["firstName"].toLowerCase()).includes(this.state.resource_relationshipNameFilter.toLowerCase()) || (element["email"].toLowerCase()).includes(this.state.resource_relationshipNameFilter.toLowerCase()) || (element["lastName"].toLowerCase() + ", " + element["firstName"].toLowerCase() + " (" + element["email"].toLowerCase() + ")").includes(this.state.resource_relationshipNameFilter.toLowerCase())))

                Object.values(strippedUserList).forEach(element => {
                    ownerRelationshipUser.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
                });

                resourceListContainer.push(<select ref="modal_user_relationship_resources" className="modal_user_relationship_resources" multiple>{ownerRelationshipUser}</select>);

            }
        }
        else if (this.state.resource_addRelationship_ResourceTypeFilter == "Metric Goals") {

            relationshipResourceLabel = <span className="resourceList_Label"><i className="resourceList_icon fal fa-flag"></i> Goals</span>


            resourceListContainer.push(
                <div className="modal_relationship_goalresources">
                    <table className="modal_goalresources_table">
                        <tbody>
                            <tr>
                                <td>
                                    Goal Name
                                </td>
                                <td>
                                    <input ref="modal_relationship_GoalName" className="addRelationship_goalValues" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Location
                                </td>
                                <td>
                                    <select ref="modal_relationship_GoalLocation" className="addRelationship_goalSelectboxValues">
                                        <option value="Luminis Health">Luminis Health</option>
                                        <option value="AAMC">AAMC</option>
                                        <option value="DCH">DCH</option>
                                        <option value="McNew">McNew</option>
                                        <option value="Pathways">Pathways</option>
                                        <option value="LHCE">LHCE</option>
                                        <option value="LHSS">LHSS</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Goal Value
                                </td>
                                <td>
                                    <input ref="modal_relationship_GoalValue" className="addRelationship_goalValues" step="any" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Value Type
                                </td>
                                <td>
                                    <input ref="modal_relationship_GoalValueType" className="addRelationship_goalValues" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Start Date
                                </td>
                                <td>
                                    <input ref="modal_relationship_GoalStartDate" className="addRelationship_goalValues" type="date" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Expected Completion
                                </td>
                                <td>
                                    <input ref="modal_relationship_GoalExpectedCompletionDate" className="addRelationship_goalValues" type="date" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
            resourceFilterNameContainer = <div className="hidden"><span className="resourceFilterName"><i className="filterList_icon fal fa-search"></i> Resource Name</span><input ref="resourceFilterName_Input" className="resourceFilterName_Input" type="text" defaultValue="" placeholder="" onChange={this._resourceFilterUpdated.bind(this)} /></div>
        }
        else if (this.state.resource_addRelationship_ResourceTypeFilter == "Tags") {

            relationshipResourceLabel = <span className="resourceList_Label"><i className="resourceList_icon fal fa-hashtag"></i> Tags</span>
            var tagList = [];

            var tagListOptions = [];

            Object.values(resource_IntellisenseTagInfo).forEach(element => {
                tagList.push(element);
            });

            (resource_CustomTagInfo).forEach(element => {
                tagList.push(element);
            });

            var currentResourceTags = this.state.resource_BuildTagInfo;
            currentResourceTags = Object.values(this.state.resource_BuildTagInfo).filter(value => (value['externalId']).toString().toLowerCase() == singleResult.toLowerCase());


            Object.values(currentResourceTags).forEach(element => {

                for (var i = 0; i < tagList.length; i++) {

                    if (tagList[i].toLowerCase() === element.tag.toLowerCase()) {
                        tagList.splice(i, 1);
                    }

                }
            });


            tagList = tagList.sort();


            (tagList).forEach(element => {
                tagListOptions.push(<option value={element}>#{element}</option>);
            });

            resourceListContainer.push(
                <div className="modal_relationship_tagresources">
                    <table className="modal_tagresources_table">
                        <tbody>
                            <tr>
                                <td>
                                    Add Tag to List
                                </td>
                                <td>
                                    <span className="addHashtag">#</span><input ref="modal_relationship_TagName" className="addRelationship_tagValues" type="text" /> <button className="addTagToListButton" onClick={this._addCustomTagToList.bind(this)}>Add To List</button>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Tag List
                                </td>
                                <td>
                                    <select ref="modal_relationship_TagSelectboxValues" multiple className="addRelationship_tagSelectboxValues">
                                        {tagListOptions}
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
            resourceFilterNameContainer = <div className="hidden"><span className="resourceFilterName"><i className="filterList_icon fal fa-search"></i> Resource Name</span><input ref="resourceFilterName_Input" className="resourceFilterName_Input" type="text" defaultValue="" placeholder="" onChange={this._resourceFilterUpdated.bind(this)} /></div>
        }
        else {
            relationshipResourceLabel = <span className="resourceList_Label"><i className="resourceList_icon fal fa-chart-network"></i> Resources</span>
            if (this.state.resource_relationshipNameFilter.length < 3) {

                resourceListContainer = <div className="modal_relationship_noresources">Please enter atleast 3 characters in your filter to begin your search.</div>;

            }
            else {

                resourceListContainer.push(<select ref="modal_relationship_resources" className="modal_relationship_resources" multiple>{resourceList}</select>);

            }
        }

        var relationshipAddInstructions;
        relationshipAddInstructions = [];


        if (this.state.resource_addRelationship_ResourceTypeFilter == "Report") {
            relationshipAddInstructions.push(
                <div>
                    <span>Please select a Resource Type / Report Type to filter the list below.</span>
                </div>
            );
        }
        else {
            relationshipAddInstructions.push(
                <div>
                    <span>Please select a Resource Type you would like to add.</span>
                </div>
            );
        }

        addRelationshipContentContainer.push(
            <div>
                <div className="addRelationshipContainer">
                    <div className="shareHeaderContainer">
                        <span className="addRelationshipHeader">
                            <span className="addRelationshipIcon fal fa-project-diagram"></span>
                            Add Relationship
                        </span>
                    </div>
                    <div className="addRelationshipBodyContainer">
                        <div>
                            <div>
                                {relationshipAddInstructions}
                                <table className="resourceList_Header">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="resourceList_Label_Container">{relationshipResourceLabel}</div>
                                            </td>
                                            <td className="resourceFilters">
                                                {resourceFilterNameContainer}
                                                <div className="resourceFilterResourceType_Container"><span className="resourceFilterResourceType"><i className="filterList_icon fal fa-vector-square"></i> Resource Type</span>{resourceTypeFilterContainer}</div>
                                                {reportTypeFilterContainer}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {resourceListContainer}
                            <div>
                                <button type="button" className="addRelationshipSubmit" onClick={this._addRelationship.bind(this, singleResourceExternalId, singleResourceName, singleResourceType)}>Submit</button>
                                <button type="button" className="addRelationshipClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);



        var editGoalListContainer;
        editGoalListContainer = [];

        var editGoalLocations;
        editGoalLocations = [];
        if (this.state.resource_editGoal_GoalLocation == "Luminis Health") {

            editGoalLocations.push(<option value="Luminis Health" selected>Luminis Health</option>);

        }
        else {
            editGoalLocations.push(<option value="Luminis Health">Luminis Health</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "AAMC") {

            editGoalLocations.push(<option value="AAMC" selected>AAMC</option>);

        }
        else {
            editGoalLocations.push(<option value="AAMC">AAMC</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "DCH") {

            editGoalLocations.push(<option value="DCH" selected>DCH</option>);

        }
        else {
            editGoalLocations.push(<option value="DCH">DCH</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "McNew") {

            editGoalLocations.push(<option value="McNew" selected>McNew</option>);

        }
        else {
            editGoalLocations.push(<option value="McNew">McNew</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "Pathways") {

            editGoalLocations.push(<option value="Pathways" selected>Pathways</option>);

        }
        else {
            editGoalLocations.push(<option value="Pathways">Pathways</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "LHCE") {

            editGoalLocations.push(<option value="LHCE" selected>LHCE</option>);

        }
        else {
            editGoalLocations.push(<option value="LHCE">LHCE</option>);

        }
        if (this.state.resource_editGoal_GoalLocation == "LHSS") {

            editGoalLocations.push(<option value="LHSS" selected>LHSS</option>);

        }
        else {
            editGoalLocations.push(<option value="LHSS">LHSS</option>);
        }

        editGoalListContainer.push(
            <div className="modal_relationship_goalresources">
                <table className="modal_goalresources_table">
                    <tbody>
                        <tr>
                            <td>
                                Goal Name
                            </td>
                            <td>
                                <input ref="modal_editGoal_GoalName" className="addRelationship_goalValues" type="text" defaultValue={this.state.resource_editGoal_GoalName} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Location
                            </td>
                            <td>
                                <select ref="modal_editGoal_GoalLocation" className="addRelationship_goalSelectboxValues" defaultValue={this.state.resource_editGoal_GoalLocation}>
                                    {editGoalLocations}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Goal Value
                            </td>
                            <td>
                                <input ref="modal_editGoal_GoalValue" className="addRelationship_goalValues" step="any" defaultValue={this.state.resource_editGoal_GoalValue} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Value Type
                            </td>
                            <td>
                                <input ref="modal_editGoal_GoalValueType" className="addRelationship_goalValues" type="text" defaultValue={this.state.resource_editGoal_GoalValueType} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Start Date
                            </td>
                            <td>
                                <input ref="modal_editGoal_GoalStartDate" className="addRelationship_goalValues" type="date" defaultValue={this.state.resource_editGoal_StartDate} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Expected Completion
                            </td>
                            <td>
                                <input ref="modal_editGoal_GoalExpectedCompletionDate" className="addRelationship_goalValues" type="date" defaultValue={this.state.resource_editGoal_ExpectedCompletion} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );

        editGoalContentContainer.push(
            <div>
                <div className="addRelationshipContainer">
                    <div className="shareHeaderContainer">
                        <span className="addRelationshipHeader">
                            <span className="addRelationshipIcon fa-light fa-bullseye-arrow"></span>
                            Edit Goal
                        </span>
                    </div>
                    <div className="addRelationshipBodyContainer">
                        <div>
                            {editGoalListContainer}
                            <div>
                                <button type="button" className="addRelationshipSubmit" onClick={this._updateGoal.bind(this)}>Update</button>
                                <button type="button" className="addRelationshipClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);


        var actionPlanItemOptions;
        actionPlanItemOptions = [];

        var actionPlanItemChangerContainer;
        actionPlanItemChangerContainer = [];
        if (this.state.resource_addActionPlanItem_ItemType == "LinkedResource") {
            actionPlanItemOptions.push(<option value="LinkedResource" selected>Linked Resource</option>);
        }
        else {
            actionPlanItemOptions.push(<option value="LinkedResource">Linked Resource</option>);
        }
        /*
        if (this.state.resource_addActionPlanItem_ItemType == "Goal") {
            actionPlanItemOptions.push(<option value="Goal" selected>Goal</option>);
        }
        else {
            actionPlanItemOptions.push(<option value="Goal">Goal</option>);
        }
        */
        if (this.state.resource_addActionPlanItem_ItemType == "Action") {
            actionPlanItemOptions.push(<option value="Action" selected>Action</option>);
        }
        else {
            actionPlanItemOptions.push(<option value="Action">Action</option>);
        }
        if (this.state.resource_addActionPlanItem_ItemType == "Log") {
            actionPlanItemOptions.push(<option value="Log" selected>Log</option>);
        }
        else {
            actionPlanItemOptions.push(<option value="Log">Log</option>);
        }
        if (this.state.resource_addActionPlanItem_ItemType == "Team") {
            actionPlanItemOptions.push(<option value="Team" selected>Team</option>);
        }
        else {
            actionPlanItemOptions.push(<option value="Team">Team</option>);
        }

        actionPlanItemChangerContainer = <select defaultValue={this.state.resource_addActionPlanItem_ItemType} onChange={this._updateActionPlanItem.bind(this)} id="actionPlanItemChanger" ref="actionPlanItemChanger" className="actionPlanItemChanger">
            <option value="" hidden>Select an option</option>
            {actionPlanItemOptions}
        </select>

        var actionPlanItemFormContainer;
        actionPlanItemFormContainer = [];
        /*
            title: title,
            overviewFullText: overviewFullText,
            dtGoalExpectedCompletion: dtGoalExpectedCompletion
         */
        var actionPlanTeamList;
        actionPlanTeamList = [];
        var actionPlanTeamListOptions;
        actionPlanTeamListOptions = [];

        var strippedUserList;

        strippedUserList = Object.values(user_ListInfo).filter(value => (value['idUser']).toString().toLowerCase() != user_AccountInfo["idUser"].toLowerCase())
        strippedUserList = Object.values(user_ListInfo).filter(value => (value["lastName"]).toString().toLowerCase() != "" && (value["firstName"]).toString().toLowerCase() != "")
        Object.values(strippedUserList).forEach(element => {
            actionPlanTeamListOptions.push(<option value={element["idUser"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>);
        });
        actionPlanTeamList.push(<select ref="actionPlanItemTeamForm_Employee_Input" className="actionPlanItemTeamForm_Employee_Input">{actionPlanTeamListOptions}</select>);

        actionPlanItemFormContainer.push(
            <div className="actionPlanItemFormContainer">
                <div>
                    <table className="actionPlanItemForm">
                        <tbody>
                            <tr>
                                <td>Item Type</td>
                                <td>
                                    {actionPlanItemChangerContainer}
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Goal_Title">
                                <td>Title</td>
                                <td>
                                    <input className="actionPlanItemGoalForm_Title_Input" ref="actionPlanItemGoalForm_Title_Input" type="text" />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Goal_Description">
                                <td>Description</td>
                                <td>
                                    <Editor
                                        id='actionPlanItemGoalForm_Description_Input'
                                        ref='actionPlanItemGoalForm_Description_Input'
                                        initialValue={""}
                                        init={{
                                            skin: false,
                                            content_style: "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900&display=swap'); body { font-family: Roboto, sans-serif; }",
                                            height: 300,
                                            menubar: false,
                                            plugins: [
                                                'link image',
                                                'table paste code link preview lists hr'
                                            ],
                                            toolbar: 'undo redo | fontsizeselect | ' +
                                                'bold italic underline forecolor | alignleft aligncenter ' +
                                                'alignright alignjustify | hr bullist numlist outdent indent | ' +
                                                'removeformat | link code preview',
                                            fontsize_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20x 22px 24px 26px 28px 36px 48px 72px"
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Goal_EstCompletionDate">
                                <td>Est. Completion Date</td>
                                <td>
                                    <input type="date" ref="actionPlanItemGoalForm_ExpectedCompletionDate_Input" className="actionPlanItemGoalForm_ExpectedCompletionDate_Input" />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Action_LinkedGoal">
                                <td>Goal</td>
                                <td>


                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Action_Title">
                                <td>Title</td>
                                <td>
                                    <input className="actionPlanItemActionForm_Title_Input" ref="actionPlanItemActionForm_Title_Input" type="text" />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Action_Description">
                                <td>Description</td>
                                <td>
                                    <Editor
                                        id='actionPlanItemActionForm_Description_Input'
                                        ref='actionPlanItemActionForm_Description_Input'
                                        initialValue={""}
                                        init={{
                                            skin: false,
                                            content_style: "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900&display=swap'); body { font-family: Roboto, sans-serif; }",
                                            height: 300,
                                            menubar: false,
                                            plugins: [
                                                'link image',
                                                'table paste code link preview lists hr'
                                            ],
                                            toolbar: 'undo redo | fontsizeselect | ' +
                                                'bold italic underline forecolor | alignleft aligncenter ' +
                                                'alignright alignjustify | hr bullist numlist outdent indent | ' +
                                                'removeformat | link code preview',
                                            fontsize_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20x 22px 24px 26px 28px 36px 48px 72px"
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Action_NumHoursExpected">
                                <td>Est. Number of Hours</td>
                                <td>
                                    <input className="actionPlanItemActionForm_NumHoursExpected_Input" ref="actionPlanItemActionForm_NumHoursExpected_Input" type="number" min="0" max="100000" />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Log_LinkedGoal">
                                <td>Goal</td>
                                <td>


                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Log_LinkedAction">
                                <td>Action</td>
                                <td>


                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Log_NumHoursExpected">
                                <td>Number of Hours Spent</td>
                                <td>
                                    <input className="actionPlanItemLogForm_NumHoursExpected_Input" ref="actionPlanItemLogForm_NumHoursExpected_Input" type="number" min="0" max="100000" />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Log_Description">
                                <td>Description</td>
                                <td>
                                    <Editor
                                        id='actionPlanItemLogForm_Description_Input'
                                        ref='actionPlanItemLogForm_Description_Input'
                                        initialValue={""}
                                        init={{
                                            skin: false,
                                            content_style: "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900&display=swap'); body { font-family: Roboto, sans-serif; }",
                                            height: 300,
                                            menubar: false,
                                            plugins: [
                                                'link image',
                                                'table paste code link preview lists hr'
                                            ],
                                            toolbar: 'undo redo | fontsizeselect | ' +
                                                'bold italic underline forecolor | alignleft aligncenter ' +
                                                'alignright alignjustify | hr bullist numlist outdent indent | ' +
                                                'removeformat | link code preview',
                                            fontsize_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20x 22px 24px 26px 28px 36px 48px 72px"
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Team_LinkedUser">
                                <td>Employee</td>
                                <td>
                                    {actionPlanTeamList}
                                </td>
                            </tr>
                            <tr ref="actionPlanItem_Team_Designation">
                                <td>Designation</td>
                                <td>
                                    <input className="actionPlanItemTeamForm_Designation_Input" ref="actionPlanItemTeamForm_Designation_Input" type="text" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
        /*
            idExternalResource_APGoals: idExternalResource_APGoals,
            externalId: externalId,
            title: title,
            overviewFullText: overviewFullText,
            numHoursExpected: numHoursExpected,
            createdByUserDomain: createdByUserDomain,
            createdByADUsername: createdByADUsername
         */





        /*
            idExternalResource_APActions: idExternalResource_APActions,
            numHoursUsed: numHoursUsed,
            overviewFullText: overviewFullText
        */



        /*
            idUser: idUser,
            designation: designation
         */






        addActionPlanItemContentContainer.push(
            <div>
                <div className="addActionPlanItemContainer">
                    <div className="shareHeaderContainer">
                        <span className="addActionPlanItemHeader">
                            <span className="addActionPlanItemIcon fal fa-ballot-check"></span>
                            Add Action Plan Item
                        </span>
                    </div>
                    <div className="addActionPlanItemBodyContainer">
                        <div>
                            <div>
                                <div><span>Create your action plan item by completing the form below.</span></div>
                                <div>

                                </div>
                            </div>
                            <div>
                                {actionPlanItemFormContainer}
                            </div>
                            <div>
                                <button type="button" className="addActionPlanItemSubmit" onClick={this._addRelationship.bind(this, singleResourceExternalId, singleResourceName, singleResourceType)}>Submit</button>
                                <button type="button" className="addActionPlanItemClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);




        shareContentContainer.push(
            <div>
                <div className="shareContainer">
                    <div className="shareHeaderContainer">
                        <span className="shareHeader">
                            <span className="shareIcon fal fa-share-square"></span>
                            Share - <span className="modalResourceName">{singleResourceName}</span>
                        </span>
                    </div>
                    <div className="shareBodyContainer">
                        <span>Please select a employee from the drop-down and click send to share this resource with others.</span>
                        <div>
                            <div>
                                <table className="employeeList_Header">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="employeeList_Label_Container"><span className="employeeList_Label"><i className="employeeList_icon fal fa-user-md"></i> Employees</span></div>
                                            </td>
                                            <td className="shareFilters">
                                                <div className="shareFilterName_Container"><span className="shareFilterName"><i className="filterList_icon fal fa-search"></i> Name</span><input ref="shareFilterName_Input" className="shareFilterName_Input" type="text" defaultValue="" placeholder="Last Name, First Name (Email)" onChange={this._shareFilterUpdated.bind(this)} /></div>
                                                <div className="shareFilterDepartment_Container"><span className="shareFilterDepartment"><i className="filterList_icon fal fa-users"></i> Department</span>{shareDepartmentListContainer}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {shareListContainer}
                            <div>
                                <button type="button" className="shareSubmit" onClick={this._shareResource.bind(this, singleResourceExternalId, singleResourceName, singleResourceType)}>Submit</button>
                                <button type="button" className="shareClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);



        rankContentContainer.push(
            <div>
                <div className="rankModalContainer">
                    <div className="rankHeaderContainer">
                        <span className="rankHeader">
                            <span className="rankIcon fal fa-trophy"></span>
                            Resource Ranks
                        </span>
                    </div>
                    <div className="rankBodyContainer">
                        <span>Please enter in all of the Rank's information.</span>
                        <div>
                            <div>
                                <table className="rankBodyTable">
                                    <tbody>
                                        <tr className="hidden">
                                            <td>
                                                Rank Id
                                            </td>
                                            <td>
                                                <input ref="modal_rank_idRank" type="text" defaultValue={this.state.resource_modalRank_idRank} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Rank Name
                                            </td>
                                            <td>
                                                <input ref="modal_rank_rankName" type="text" defaultValue={this.state.resource_modalRank_rankName} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Hex Background Color
                                            </td>
                                            <td>
                                                <input ref="modal_rank_hexBackgroundColor" type="color" defaultValue={this.state.resource_modalRank_hexBackgroundColor} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Points
                                            </td>
                                            <td>
                                                <input ref="modal_rank_points" type="number" defaultValue={this.state.resource_modalRank_points} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Is Filterable
                                            </td>
                                            <td>
                                                <input ref="modal_rank_isFilterable" type="text" defaultValue={this.state.resource_modalRank_isFilterable} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Is In All Search Results
                                            </td>
                                            <td>
                                                <input ref="modal_rank_isInAllResults" type="text" defaultValue={this.state.resource_modalRank_isInAllResults} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Description
                                            </td>
                                            <td>
                                                <input ref="modal_rank_description" type="text" defaultValue={this.state.resource_modalRank_description} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <button type="button" className="rankSubmit" onClick={this._addRank.bind(this)}>Apply</button>
                                <button type="button" className="rankClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);


        permissionContentContainer.push(
            <div>
                <div className="permissionContainer">
                    <div className="permissionHeaderContainer">
                        <span className="permissionHeader">
                            <span className="permissionIcon fal fa-users"></span>
                            User Permissions
                        </span>
                    </div>
                    <div className="permissionBodyContainer">
                        <span>Please select a employee from the drop-down and click apply to grant these permissions.</span>
                        <div>
                            <div>
                                <table className="employeeList_Header">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="employeeList_Label_Container"><span className="employeeList_Label"><i className="employeeList_icon fal fa-user-md"></i> Employees</span></div>
                                            </td>
                                            <td className="permissionFilters">
                                                <div className="permissionFilterName_Container"><span className="permissionFilterName"><i className="filterList_icon fal fa-search"></i> Name</span><input ref="permissionFilterName_Input" className="permissionFilterName_Input" type="text" defaultValue="" placeholder="Last Name, First Name (Email)" onChange={this._permissionFilterUpdated.bind(this)} /></div>
                                                <div className="permissionFilterDepartment_Container"><span className="permissionFilterDepartment"><i className="filterList_icon fal fa-users"></i> Department</span>{permissionDepartmentListContainer}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {permissionListContainer}
                            <div>
                                <button type="button" className="permissionSubmit" onClick={this._addUserPermission.bind(this)}>Apply</button>
                                <button type="button" className="permissionClose" onClick={this._hideOverlays.bind(this)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);


        var helpContentContainer;
        helpContentContainer = [];
        helpContentContainer.push(
            <div>
                <div className="walkthroughContainer">
                    <div className="walkthroughHeaderContainer">
                        <span className="walkthroughHeader">
                            <span className="aboutIcon fa fa-info"></span>
                            About
                        </span>
                    </div>
                    <div className="walkthroughBodyContainer">
                        <span>This application was created by the <span className="luminisLogo_Black_Static"></span> Luminis Health: Analytics Team to provide real-time access to data and reporting information at the finger-tips of our providers and administrators.</span>
                    </div>
                </div>
                <div className="walkthroughContainer">
                    <div className="walkthroughHeaderContainer">
                        <span className="walkthroughHeader">
                            <span className="walkthroughIcon fal fa-map-marker-check"></span>
                            Walkthrough
                        </span>
                    </div>
                    <div className="walkthroughBodyContainer">
                        Enter a search query in the <span className="falseButton"><span className="fal fa-search"></span> search bar</span> to filter and explore our entire collection of reporting information, including our comprehensive terminology dictionary. Results are then displayed, categorized, and prioritized to give you the most relavent information based on your search query. Once you have selected a report you will be able to do the following:
                        <ul className="walkthroughSteps">
                            <li>
                                Access sample report images, report details, and other overview useful information
                            </li>
                            <li>
                                <span className="falseButton"><span className="fal fa-eye"></span> View Report</span> to quickly launch reports in Hyperspace or access them from your chosen web browser
                            </li>
                            <li>
                                <span className="falseButton"><span className="fal fa-key"></span> Request Access</span> If you do not already have permissions to access a report, and we will forward your request to the appropriate people
                            </li>
                            <li>
                                <span className="falseButton"><span className="fal fa-star"></span> Favorite</span> icon to add reports to your favorites and get even quicker future access
                            </li>
                            <li>
                                Rate a report with <span className="falseButton"><span className="fal fa-thumbs-up"></span> Thumbs Up</span> or <span className="falseButton"><span className="fal fa-thumbs-down"></span> Thumbs Down</span> to let others know if you found it particularly useful
                            </li>
                        </ul>
                        Now you are good to go! Click the <span className="fal fa-times" ></span> in the upper corner of this window to close it and get started today!
                    </div>
                </div>
                <div className="walkthroughLogoContainer">
                    <span className="logo_Small_Black_Images">
                        <i className="logoFlag_Small_Black fas fa-pennant"></i>
                        <i className="logoImage_Small_Black fas fa-signal-alt" title="Databay" alt="Databay"></i>
                    </span>
                    <div className="revision_History">
                        <div>Release Version: 2.0.0</div>
                        <div>Originally Created by Evan Fischell</div>
                        <div>Rereleased Version by Joshua Sparks</div>
                        <div>Maintained by the Luminis Health Analytics Team</div>
                    </div>
                </div>
            </div>);


        modalContent.push(
            <div ref="modal_overlay_content">
                <div ref="modal_image_overlay" className="modal_image_hidden">
                    <div className="modal_content" >
                        {imageContentContainer}
                    </div>
                </div>
                <div ref="modal_JIRA_overlay" className="modal_JIRA_hidden">
                    <div className="modal_content" >
                        {JIRAContentContainer}
                    </div>
                </div>
                <div ref="modal_feedback_overlay" className="modal_feedback_hidden">
                    <div className="modal_content" >
                        {feedbackContentContainer}
                    </div>
                </div>
                <div ref="modal_view_overlay" className="modal_view_hidden">
                    <div className="modal_content" >
                        {viewContentContainer}
                    </div>
                </div>
                <div ref="modal_request_overlay" className="modal_request_hidden">
                    <div className="modal_content" >
                        {requestContentContainer}
                    </div>
                </div>
                <div ref="modal_help_overlay" className="modal_help_hidden">
                    <div className="modal_content" >
                        {helpContentContainer}
                    </div>
                </div>
                <div ref="modal_share_overlay" className="modal_share_hidden">
                    <div className="modal_content" >
                        {shareContentContainer}
                    </div>
                </div>
                <div ref="modal_permission_overlay" className="modal_permission_hidden">
                    <div className="modal_content" >
                        {permissionContentContainer}
                    </div>
                </div>
                <div ref="modal_rank_overlay" className="modal_rank_hidden">
                    <div className="modal_content" >
                        {rankContentContainer}
                    </div>
                </div>
                <div ref="modal_addRelationship_overlay" className="modal_addRelationship_hidden">
                    <div className="modal_content" >
                        {addRelationshipContentContainer}
                    </div>
                </div>
                <div ref="modal_editGoal_overlay" className="modal_editGoal_hidden">
                    <div className="modal_content" >
                        {editGoalContentContainer}
                    </div>
                </div>
                <div ref="modal_addActionPlanItem_overlay" className="modal_addActionPlanItem_hidden">
                    <div className="modal_content" >
                        {addActionPlanItemContentContainer}
                    </div>
                </div>
            </div>);


        modalOverLay.push(
            <div ref="modal_container_overlay" className="modal_container_hidden">

                <div ref="modal_overlay" className="modal_hidden" onClick={this._hideOverlays.bind(this)}>
                </div>

            </div>
        );

        var isEpicHeader = "";
        if (this.state.isEpicUser) {
            isEpicHeader = "isEpicHeader";
        }

        var loadingFile = [];
        /*
        if (this.state.loadingFile) {
            loadingFile.push(
                <div className="loadingFile_Container">
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                </div>
            );
        }
        else {
            loadingFile.push(
                <div className="loadingFile_ContainerHidden">
                    <i className="logoHome fas fa-circle-notch fa-spin"></i>
                </div>
            );

        }
        */
        return (

            <div ref="Home" className="Home">
                <table className={"Header_Table " + isEpicHeader} >
                    <tbody>
                        <tr>
                            <td className="Header_Logo">
                                {headerLogoInfo}
                            </td>
                            <td ref="Header_Weather" className="Header_Weather" onClick={this._hideOverlays.bind(this)}>
                                {headerWeather}
                            </td>
                            <td ref="Header_Search" className="Header_Search" onClick={this._hideOverlays.bind(this)}>
                                {headerSearch}
                            </td>
                            <td className="Header_PersonInfo">
                                {headerProfileInfo}
                            </td>
                            <td className="Header_Menu">
                                {headerMenu}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table ref="Home_Layout_Container" className='Home_Layout_Container'>
                    <tbody>
                        <tr className="Layout_Row">
                            <td className="Layout_Body">
                                <div className="BodyContent_Container">
                                    <span className="Body_Content">
                                        {bodyContent}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {headerModeOverlay}
                {headerMenuOverlay}
                {headerWeatherOverlay}
                {headerProfileOverlay}
                {headerFavoritesOverlay}
                {headerSharedOverlay}
                {headerTop10Overlay}
                {headerTopTagsOverlay}
                {headerTopRated10Overlay}
                {headerSupportOverlay}
                {headerUploadOverlay}
                {headerNewest10Overlay}
                {headerAddRelationshipOverlay}
                {headerOverlay}
                {modalHeader}
                {modalContent}
                {modalOverLay}
                {loadingFile}

            </div>
        );
    }
}
